module.exports = [
	{
		"id": "88678",
		"imdbID": "tt0088678",
		"title": "The Adventures of Mark Twain",
		"year": "1985",
		"rating": "G",
		"runtime": "86 min",
		"genre": "Animation, Adventure, Family",
		"released": "2015-09-30",
		"director": "Will Vinton",
		"writer": "Susan Shadburne, Mark Twain (segment)",
		"cast": "James Whitmore, Michele Mariana, Gary Krug, Chris Ritchie",
		"metacritic": "",
		"imdbRating": "7.6",
		"imdbVotes": "1766",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgyMTU5NjI4OF5BMl5BanBnXkFtZTcwNDU0NzA3OA@@._V1_SX300.jpg",
		"plot": "Tom Sawyer, Becky Thatcher and Huck Finn join Mark Twain on his airship to meet Halley's Comet.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "109227",
		"imdbID": "tt0109227",
		"title": "Beanstalk",
		"year": "1994",
		"rating": "PG",
		"runtime": "78 min",
		"genre": "Comedy, Family, Fantasy",
		"released": "2015-08-01",
		"director": "Michael Davis",
		"writer": "Michael Davis",
		"cast": "J.D. Daniels, Amy Stoch, Patrick Renna, Richard Moll",
		"metacritic": "",
		"imdbRating": "4.5",
		"imdbVotes": "263",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY0OTM4NzkyOV5BMl5BanBnXkFtZTcwNzUzMzkyMQ@@._V1_SX300.jpg",
		"plot": "A young boy finds a crate of green beans. When they're planted, they grow a beanstalk to the clouds, where a castle of giants are habited.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "118214",
		"imdbID": "tt0118214",
		"title": "Zarkorr! The Invader",
		"year": "1996",
		"rating": "PG",
		"runtime": "80 min",
		"genre": "Sci-Fi",
		"released": "2015-07-04",
		"director": "Michael Deak, Aaron Osborne",
		"writer": "Neal Marshall Stevens (screenplay)",
		"cast": "Franklin A. Vallette, Don Yanan, Peter Looney, Dyer McHenry",
		"metacritic": "",
		"imdbRating": "3.6",
		"imdbVotes": "229",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUyOTk5MDk3NV5BMl5BanBnXkFtZTcwNzMxNTUyMQ@@._V1_SX300.jpg",
		"plot": "An \"average\" postal worker is informed by a tiny alien hologram which looks like a teenage girl that he is the \"choosen one\" to destroy a giant reptile to save the Earth.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "183717",
		"imdbID": "tt0183717",
		"title": "Rock 'n' Roll Frankenstein",
		"year": "1999",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Comedy, Horror",
		"released": "2015-11-10",
		"director": "Brian O'Hara",
		"writer": "Brian O'Hara (story), Vito Cannella (story), John Klann (story), Brian O'Hara (screenplay)",
		"cast": "Graig Guggenheim, Jayson Spence, Barry Feterman, Hiram Jacob Segarra",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "234",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzIxMTExNTUyMF5BMl5BanBnXkFtZTcwMTM2MzMyMQ@@._V1_SX300.jpg",
		"plot": "Music agent Bernie Stein, his scientist nephew Frankie, and a drugged out roadie named Iggy team to create a superstar by putting together the remains of dead rockers. All goes according to...",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "249516",
		"imdbID": "tt0249516",
		"title": "Foodfight!",
		"year": "2012",
		"rating": "PG",
		"runtime": "91 min",
		"genre": "Animation, Action, Comedy",
		"released": "2013-02-12",
		"director": "Lawrence Kasanoff",
		"writer": "Lawrence Kasanoff (story), Joshua Wexler (story), Brent V. Friedman, Rebecca Swanson, Sean Catherine Derek",
		"cast": "Charlie Sheen, Hilary Duff, Eva Longoria, Wayne Brady",
		"metacritic": "",
		"imdbRating": "1.7",
		"imdbVotes": "3372",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMzNzI3MzMyN15BMl5BanBnXkFtZTgwMzU0OTk1MDE@._V1_SX300.jpg",
		"plot": "The evil Brand X joins a supermarket that becomes a city after closing time.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "369610",
		"imdbID": "tt0369610",
		"title": "Jurassic World",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "124 min",
		"genre": "Action, Adventure, Sci-Fi",
		"released": "2015-06-12",
		"director": "Colin Trevorrow",
		"writer": "Rick Jaffa (screenplay), Amanda Silver (screenplay), Colin Trevorrow (screenplay), Derek Connolly (screenplay), Rick Jaffa (story), Amanda Silver (story), Michael Crichton (characters)",
		"cast": "Chris Pratt, Bryce Dallas Howard, Irrfan Khan, Vincent D'Onofrio",
		"metacritic": "59",
		"imdbRating": "7.1",
		"imdbVotes": "356747",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ5MTE0MTk3Nl5BMl5BanBnXkFtZTgwMjczMzk2NTE@._V1_SX300.jpg",
		"plot": "A new theme park is built on the original site of Jurassic Park. Everything is going well until the park's newest attraction--a genetically modified giant stealth killing machine--escapes containment and goes on a killing spree.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 21 nominations."
	},
	{
		"id": "395561",
		"imdbID": "tt0395561",
		"title": "States of Grace",
		"year": "2005",
		"rating": "PG-13",
		"runtime": "128 min",
		"genre": "Drama",
		"released": "2014-04-23",
		"director": "Richard Dutcher",
		"writer": "Richard Dutcher",
		"cast": "Ignacio Serricchio, Lucas Fleischer, Lamont Stephens, Rachel Emmers",
		"metacritic": "",
		"imdbRating": "7.2",
		"imdbVotes": "418",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEwNjg3NTE3OV5BMl5BanBnXkFtZTcwOTk1MzIzMQ@@._V1_SX300.jpg",
		"plot": "The lives of a street preacher, an aspiring actress, a Mormon missionary, and a young gang banger intersect in this ensemble drama set in present-day Santa Monica, California.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "420293",
		"imdbID": "tt0420293",
		"title": "The Stanford Prison Experiment",
		"year": "2015",
		"rating": "R",
		"runtime": "122 min",
		"genre": "Drama, Thriller",
		"released": "2015-07-17",
		"director": "Kyle Patrick Alvarez",
		"writer": "Tim Talbott",
		"cast": "Billy Crudup, Michael Angarano, Moises Arias, Nicholas Braun",
		"metacritic": "67",
		"imdbRating": "7.0",
		"imdbVotes": "7683",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUyNDIyMTA4NV5BMl5BanBnXkFtZTgwODM2MDMxNjE@._V1_SX300.jpg",
		"plot": "Twenty-four male students out of seventy-five were selected to take on randomly assigned roles of prisoners and guards in a mock prison situated in the basement of the Stanford psychology building.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 3 nominations."
	},
	{
		"id": "453562",
		"imdbID": "tt0453562",
		"title": "42",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "128 min",
		"genre": "Biography, Drama, Sport",
		"released": "2013-04-12",
		"director": "Brian Helgeland",
		"writer": "Brian Helgeland",
		"cast": "Chadwick Boseman, Harrison Ford, Nicole Beharie, Christopher Meloni",
		"metacritic": "62",
		"imdbRating": "7.5",
		"imdbVotes": "63269",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQwMDU4MDI3MV5BMl5BanBnXkFtZTcwMjU1NDgyOQ@@._V1_SX300.jpg",
		"plot": "The story of Jackie Robinson from his signing with the Brooklyn Dodgers organization in 1945 to his historic 1947 rookie season when he broke the color barrier in Major League Baseball.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 17 nominations."
	},
	{
		"id": "455944",
		"imdbID": "tt0455944",
		"title": "The Equalizer",
		"year": "2014",
		"rating": "R",
		"runtime": "132 min",
		"genre": "Action, Crime, Thriller",
		"released": "2014-09-26",
		"director": "Antoine Fuqua",
		"writer": "Richard Wenk, Michael Sloan (television series), Richard Lindheim (television series)",
		"cast": "Denzel Washington, Marton Csokas, Chloë Grace Moretz, David Harbour",
		"metacritic": "57",
		"imdbRating": "7.2",
		"imdbVotes": "209694",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ2MzE2NTk0NF5BMl5BanBnXkFtZTgwOTM3NTk1MjE@._V1_SX300.jpg",
		"plot": "A man believes he has put his mysterious past behind him and has dedicated himself to beginning a new, quiet life. But when he meets a young girl under the control of ultra-violent Russian gangsters, he can't stand idly by - he has to help her.",
		"language": "English, Russian, Spanish",
		"country": "USA",
		"awards": "1 win & 6 nominations."
	},
	{
		"id": "458481",
		"imdbID": "tt0458481",
		"title": "Sin City: A Dame to Kill For",
		"year": "2014",
		"rating": "R",
		"runtime": "102 min",
		"genre": "Crime, Thriller",
		"released": "2014-08-22",
		"director": "Frank Miller, Robert Rodriguez",
		"writer": "Frank Miller, Frank Miller (graphic novels)",
		"cast": "Mickey Rourke, Jessica Alba, Josh Brolin, Joseph Gordon-Levitt",
		"metacritic": "46",
		"imdbRating": "6.6",
		"imdbVotes": "99380",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA5ODYwNjgxMF5BMl5BanBnXkFtZTgwMTcwNzAyMjE@._V1_SX300.jpg",
		"plot": "Some of Sin City's most hard-boiled citizens cross paths with a few of its more reviled inhabitants.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 6 nominations."
	},
	{
		"id": "478970",
		"imdbID": "tt0478970",
		"title": "Ant-Man",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "117 min",
		"genre": "Action, Adventure, Sci-Fi",
		"released": "2015-07-17",
		"director": "Peyton Reed",
		"writer": "Edgar Wright (screenplay), Joe Cornish (screenplay), Adam McKay (screenplay), Paul Rudd (screenplay), Edgar Wright (story), Joe Cornish (story), Stan Lee (comic book), Larry Lieber (comic book), Jack Kirby (comic book)",
		"cast": "Paul Rudd, Michael Douglas, Evangeline Lilly, Corey Stoll",
		"metacritic": "64",
		"imdbRating": "7.5",
		"imdbVotes": "215264",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM2NTQ5Mzc2M15BMl5BanBnXkFtZTgwNTcxMDI2NTE@._V1_SX300.jpg",
		"plot": "Armed with a super-suit with the astonishing ability to shrink in scale but increase in strength, cat burglar Scott Lang must embrace his inner hero and help his mentor, Dr. Hank Pym, plan and pull off a heist that will save the world.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 1 BAFTA Film Award. Another 7 nominations."
	},
	{
		"id": "780495",
		"imdbID": "tt0780495",
		"title": "Cool Air",
		"year": "2006",
		"rating": "PG-13",
		"runtime": "78 min",
		"genre": "Horror",
		"released": "2013-05-21",
		"director": "Albert Pyun",
		"writer": "Cynthia Curnan (adaptation), H.P. Lovecraft (short story)",
		"cast": "Morgan Weisser, Crystal Laws Green, Jenny Dare Paulin, Norbert Weisser",
		"metacritic": "",
		"imdbRating": "6.3",
		"imdbVotes": "735",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA5OTQzMTE0NV5BMl5BanBnXkFtZTgwOTkwMTA2MDE@._V1_SX300.jpg",
		"plot": "Charlie Baxter, a struggling screenwriter, is searching for accommodation in a rundown mansion somewhere in the isolated mountains above Malibu. An expressionless and creatively bankrupt ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "790736",
		"imdbID": "tt0790736",
		"title": "R.I.P.D.",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "96 min",
		"genre": "Action, Comedy, Fantasy",
		"released": "2013-07-19",
		"director": "Robert Schwentke",
		"writer": "Phil Hay (screenplay), Matt Manfredi (screenplay), David Dobkin (story), Phil Hay (story), Matt Manfredi (story), Peter M. Lenkov (Dark Horse comic)",
		"cast": "Jeff Bridges, Ryan Reynolds, Kevin Bacon, Mary-Louise Parker",
		"metacritic": "25",
		"imdbRating": "5.6",
		"imdbVotes": "85614",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM5OTYxNzE5N15BMl5BanBnXkFtZTcwMDU1MTQ4OQ@@._V1_SX300.jpg",
		"plot": "A recently slain cop joins a team of undead police officers working for the Rest in Peace Department and tries to find the man who murdered him.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "795461",
		"imdbID": "tt0795461",
		"title": "Scary Movie 5",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "86 min",
		"genre": "Comedy",
		"released": "2013-04-12",
		"director": "Malcolm D. Lee, David Zucker",
		"writer": "David Zucker, Pat Proft",
		"cast": "Ashley Tisdale, Simon Rex, Gracie Whitton, Ava Kolker",
		"metacritic": "11",
		"imdbRating": "3.5",
		"imdbVotes": "47165",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc5OTIxMjQ4NF5BMl5BanBnXkFtZTcwOTAyNDcyOQ@@._V1_SX300.jpg",
		"plot": "A couple begin to experience some unusual activity after bringing their lost nieces and nephew home. With the help of home-surveillance cameras, they learn they're being stalked by a nefarious demon.",
		"language": "English, Spanish, Latin",
		"country": "USA",
		"awards": "5 nominations."
	},
	{
		"id": "803096",
		"imdbID": "tt0803096",
		"title": "Warcraft",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "",
		"genre": "Action, Adventure, Fantasy",
		"released": "2016-06-10",
		"director": "Duncan Jones",
		"writer": "Duncan Jones (screenplay), Charles Leavitt (screenplay), Chris Metzen (story)",
		"cast": "Travis Fimmel, Paula Patton, Robert Kazinsky, Toby Kebbell",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgxMDAzNzMyMV5BMl5BanBnXkFtZTgwNjIwMTgxNzE@._V1_SX300.jpg",
		"plot": "An epic fantasy/adventure based on the popular video game series.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "817545",
		"imdbID": "tt0817545",
		"title": "The Power of Few",
		"year": "2013",
		"rating": "R",
		"runtime": "96 min",
		"genre": "Action, Crime, Drama",
		"released": "2013-02-15",
		"director": "Leone Marucci",
		"writer": "Leone Marucci",
		"cast": "Christopher Walken, Q'orianka Kilcher, Christian Slater, Anthony Anderson",
		"metacritic": "",
		"imdbRating": "5.3",
		"imdbVotes": "3282",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIzMzI0MjYxM15BMl5BanBnXkFtZTcwNjU0NTY5OA@@._V1_SX300.jpg",
		"plot": "Religious conspiracy collides with urban crime in a story told from multiple perspectives.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "837559",
		"imdbID": "tt0837559",
		"title": "Approaching Midnight",
		"year": "2013",
		"rating": "PG",
		"runtime": "86 min",
		"genre": "Crime, Drama, Romance",
		"released": "2013-08-30",
		"director": "Sam Logan Khaleghi",
		"writer": "Sam Logan Khaleghi",
		"cast": "Jana Kramer, Sam Logan Khaleghi, Brandon T. Jackson, Mia Serafino",
		"metacritic": "",
		"imdbRating": "4.8",
		"imdbVotes": "218",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY1MTAyNTM0NF5BMl5BanBnXkFtZTcwNTMwMDA5OQ@@._V1_SX300.jpg",
		"plot": "US Army Staff Sergeant Wesley Kent returns from the war abroad and must now fight the threat of corruption and deception in his hometown at all personal costs.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "903657",
		"imdbID": "tt0903657",
		"title": "Love & Mercy",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "121 min",
		"genre": "Biography, Drama, Music",
		"released": "2015-06-19",
		"director": "Bill Pohlad",
		"writer": "Oren Moverman, Michael A. Lerner, Brian Wilson (based on the life of)",
		"cast": "Paul Dano, John Cusack, Elizabeth Banks, Paul Giamatti",
		"metacritic": "80",
		"imdbRating": "7.4",
		"imdbVotes": "16278",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk1MTkwMzU4Nl5BMl5BanBnXkFtZTgwNjY0MDE1NTE@._V1_SX300.jpg",
		"plot": "In the 1960s, Beach Boys leader Brian Wilson struggles with emerging psychosis as he attempts to craft his avant-garde pop masterpiece. In the 1980s, he is a broken, confused man under the 24-hour watch of shady therapist Dr. Eugene Landy.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 2 Golden Globes. Another 11 wins & 44 nominations."
	},
	{
		"id": "910885",
		"imdbID": "tt0910885",
		"title": "A Merry Friggin' Christmas",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "88 min",
		"genre": "Comedy",
		"released": "2014-11-22",
		"director": "Tristram Shapeero",
		"writer": "Michael Brown",
		"cast": "Joel McHale, Lauren Graham, Clark Duke, Oliver Platt",
		"metacritic": "28",
		"imdbRating": "5.1",
		"imdbVotes": "3662",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk1NDQ4MzE4Nl5BMl5BanBnXkFtZTgwNTU2NjY5MjE@._V1_SX300.jpg",
		"plot": "Boyd Mitchler and his family must spend Christmas with his estranged family of misfits. Upon realizing that he left all his son's gifts at home, he hits the road with his dad in an attempt to make the 8-hour round trip before sunrise.",
		"language": "English, Dari",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "955386",
		"imdbID": "tt0955386",
		"title": "Aura, IL",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "97 min",
		"genre": "Drama, Romance",
		"released": "2015-08-15",
		"director": "Yu Hasegawa-Johnson",
		"writer": "Yu Hasegawa-Johnson",
		"cast": "Avalon Barrie, Jason Van Eman, Troy Xu, Brian Yang",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE5NDAyMzUzMV5BMl5BanBnXkFtZTgwMjYzODIxMDE@._V1_SX300.jpg",
		"plot": "Suppose you knew the date of your death; would that solve anything?",
		"language": "Japanese, English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "959306",
		"imdbID": "tt0959306",
		"title": "Reach Me",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "95 min",
		"genre": "Drama",
		"released": "2014-11-21",
		"director": "John Herzfeld",
		"writer": "John Herzfeld",
		"cast": "Lauren Cohan, Kyra Sedgwick, Thomas Jane, Kevin Connolly",
		"metacritic": "21",
		"imdbRating": "4.9",
		"imdbVotes": "1488",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU4ODEwMjAzOF5BMl5BanBnXkFtZTgwMjk4ODY3MjE@._V1_SX300.jpg",
		"plot": "A motivational book written by a mysterious man quickly gains popularity, inspiring a group of people that includes a journalist, his editor, a former inmate, a hip-hop mogul, an actor and an undercover cop to re-evaluate their choices and decisions by confronting their fears in hopes of creating more positive lives.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1043726",
		"imdbID": "tt1043726",
		"title": "The Legend of Hercules",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "99 min",
		"genre": "Action, Adventure, Fantasy",
		"released": "2014-01-10",
		"director": "Renny Harlin",
		"writer": "Sean Hood, Daniel Giat, Renny Harlin, Giulio Steve",
		"cast": "Kellan Lutz, Gaia Weiss, Scott Adkins, Roxanne McKee",
		"metacritic": "22",
		"imdbRating": "4.2",
		"imdbVotes": "42695",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQwMjEyODQxMV5BMl5BanBnXkFtZTgwMDQxMjE3MDE@._V1_SX300.jpg",
		"plot": "The origin story of the the mythical Greek hero. Betrayed by his stepfather, the King, and exiled and sold into slavery because of a forbidden love, Hercules must use his formidable powers to fight his way back to his rightful kingdom.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 7 nominations."
	},
	{
		"id": "1047011",
		"imdbID": "tt1047011",
		"title": "Unfinished Song",
		"year": "2012",
		"rating": "PG-13",
		"runtime": "93 min",
		"genre": "Comedy, Drama, Music",
		"released": "2013-02-22",
		"director": "Paul Andrew Williams",
		"writer": "Paul Andrew Williams",
		"cast": "Terence Stamp, Vanessa Redgrave, Gemma Arterton, Barry Martin",
		"metacritic": "57",
		"imdbRating": "7.0",
		"imdbVotes": "5232",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY5MjA5NzExM15BMl5BanBnXkFtZTcwMDE5NzU2OQ@@._V1_SX300.jpg",
		"plot": "Grumpy pensioner Arthur honors his recently deceased wife's passion for performing by joining the unconventional local choir to which she used to belong, a process that helps him build bridges with his estranged son, James.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1065073",
		"imdbID": "tt1065073",
		"title": "Boyhood",
		"year": "2014",
		"rating": "R",
		"runtime": "165 min",
		"genre": "Drama",
		"released": "2014-08-15",
		"director": "Richard Linklater",
		"writer": "Richard Linklater",
		"cast": "Ellar Coltrane, Patricia Arquette, Elijah Smith, Lorelei Linklater",
		"metacritic": "100",
		"imdbRating": "8.0",
		"imdbVotes": "244553",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYzNDc2MDc0N15BMl5BanBnXkFtZTgwOTcwMDQ5MTE@._V1_SX300.jpg",
		"plot": "The life of Mason, from early childhood to his arrival at college.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "Won 1 Oscar. Another 166 wins & 196 nominations."
	},
	{
		"id": "1068678",
		"imdbID": "tt1068678",
		"title": "Veronika Decides to Die",
		"year": "2009",
		"rating": "R",
		"runtime": "103 min",
		"genre": "Drama, Romance",
		"released": "2015-01-20",
		"director": "Emily Young",
		"writer": "Paulo Coelho (book), Larry Gross, Roberta Hanley (screenplay)",
		"cast": "Sarah Michelle Gellar, Jonathan Tucker, Erika Christensen, Florencia Lozano",
		"metacritic": "",
		"imdbRating": "6.5",
		"imdbVotes": "9632",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzNTk4NTUwM15BMl5BanBnXkFtZTgwODE0NTA4MzE@._V1_SX300.jpg",
		"plot": "After a frantic suicide attempt, Veronika awakens inside a mysterious mental asylum. Under the supervision of an unorthodox psychiatrist who specializes in controversial treatment, Veronika learns that she has only weeks to live.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1171222",
		"imdbID": "tt1171222",
		"title": "Baggage Claim",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "96 min",
		"genre": "Comedy",
		"released": "2013-09-27",
		"director": "David E. Talbert",
		"writer": "David E. Talbert (screenplay), David E. Talbert (based on the novel entitled \"Baggage Claim\" by)",
		"cast": "Paula Patton, Derek Luke, Taye Diggs, Boris Kodjoe",
		"metacritic": "34",
		"imdbRating": "5.0",
		"imdbVotes": "6680",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIyNDU4NTY3M15BMl5BanBnXkFtZTcwOTA3MDA1OQ@@._V1_SX300.jpg",
		"plot": "Pledging to keep herself from being the oldest and the only woman in her entire family never to wed, Montana embarks on a thirty-day, thirty-thousand-mile expedition to charm a potential suitor into becoming her fiancé.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1172049",
		"imdbID": "tt1172049",
		"title": "Demolition",
		"year": "2015",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Comedy, Drama",
		"released": "2016-04-08",
		"director": "Jean-Marc Vallée",
		"writer": "Bryan Sipe (screenplay)",
		"cast": "Jake Gyllenhaal, Naomi Watts, Chris Cooper, Heather Lind",
		"metacritic": "51",
		"imdbRating": "7.7",
		"imdbVotes": "394",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODQxMzMxMTM1N15BMl5BanBnXkFtZTgwNzA0MzU3NjE@._V1_SX300.jpg",
		"plot": "A successful investment banker struggles after losing his wife in a tragic car crash.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1198156",
		"imdbID": "tt1198156",
		"title": "You're Not You",
		"year": "2014",
		"rating": "R",
		"runtime": "102 min",
		"genre": "Drama",
		"released": "2014-11-26",
		"director": "George C. Wolfe",
		"writer": "Shana Feste (screenplay), Jordan Roberts (screenplay), Michelle Wildgen (based on the book by), Jordan Roberts",
		"cast": "Hilary Swank, Emmy Rossum, Josh Duhamel, Stephanie Beatriz",
		"metacritic": "56",
		"imdbRating": "7.3",
		"imdbVotes": "13975",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTczNDkyODA1N15BMl5BanBnXkFtZTgwNjIwOTI4MjE@._V1_SX300.jpg",
		"plot": "A drama centered on a classical pianist who has been diagnosed with ALS and the brash college student who becomes her caregiver.",
		"language": "English, American Sign Language",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1204975",
		"imdbID": "tt1204975",
		"title": "Last Vegas",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "105 min",
		"genre": "Comedy",
		"released": "2013-11-01",
		"director": "Jon Turteltaub",
		"writer": "Dan Fogelman",
		"cast": "Michael Douglas, Robert De Niro, Morgan Freeman, Kevin Kline",
		"metacritic": "48",
		"imdbRating": "6.6",
		"imdbVotes": "100867",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ2ODg2MTIyNF5BMl5BanBnXkFtZTgwMzU2NjgwMDE@._V1_SX300.jpg",
		"plot": "Three friends take a break from their day-to-day lives to throw a bachelor party in Las Vegas for their last remaining single pal.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "1204977",
		"imdbID": "tt1204977",
		"title": "Ouija",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "89 min",
		"genre": "Horror",
		"released": "2014-10-24",
		"director": "Stiles White",
		"writer": "Juliet Snowden, Stiles White",
		"cast": "Olivia Cooke, Ana Coto, Daren Kagasoff, Bianca A. Santos",
		"metacritic": "38",
		"imdbRating": "4.4",
		"imdbVotes": "28626",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ1NzcwMTU5MF5BMl5BanBnXkFtZTgwOTE5MzEyMjE@._V1_SX300.jpg",
		"plot": "A group of friends must confront their most terrifying fears when they awaken the dark powers of an ancient spirit board.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "1216491",
		"imdbID": "tt1216491",
		"title": "Kill the Messenger",
		"year": "2014",
		"rating": "R",
		"runtime": "112 min",
		"genre": "Biography, Crime, Drama",
		"released": "2014-10-09",
		"director": "Michael Cuesta",
		"writer": "Peter Landesman, Gary Webb (book), Nick Schou (book)",
		"cast": "Jeremy Renner, Robert Patrick, Jena Sims, Robert Pralgo",
		"metacritic": "60",
		"imdbRating": "7.0",
		"imdbVotes": "28557",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDM5MDIxNzYyNV5BMl5BanBnXkFtZTgwMDUzMTk4MTE@._V1_SX300.jpg",
		"plot": "A reporter becomes the target of a vicious smear campaign that drives him to the point of suicide after he exposes the CIA's role in arming Contra rebels in Nicaragua and importing cocaine ...",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 4 nominations."
	},
	{
		"id": "1222816",
		"imdbID": "tt1222816",
		"title": "Disneynature: Wings of Life",
		"year": "2011",
		"rating": "G",
		"runtime": "77 min",
		"genre": "Documentary",
		"released": "2013-04-16",
		"director": "Louie Schwartzberg",
		"writer": "Louie Schwartzberg (story)",
		"cast": "Meryl Streep",
		"metacritic": "",
		"imdbRating": "7.6",
		"imdbVotes": "236",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzOTg0MzkyNF5BMl5BanBnXkFtZTgwODM1MjA2MDE@._V1_SX300.jpg",
		"plot": "A documentary that delves into the realm of flowers and their pollinators.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1226274",
		"imdbID": "tt1226274",
		"title": "Happy New Year",
		"year": "2011",
		"rating": "R",
		"runtime": "104 min",
		"genre": "Drama, War",
		"released": "2013-05-21",
		"director": "K. Lorrel Manning",
		"writer": "Michael Cuomo (story), K. Lorrel Manning (screenplay), K. Lorrel Manning (story)",
		"cast": "Michael Cuomo, J.D. Williams, Monique Gabriela Curnen, Victoria Gates",
		"metacritic": "51",
		"imdbRating": "5.1",
		"imdbVotes": "107",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODI2MTQzODgxNl5BMl5BanBnXkFtZTcwOTgzMDE4OA@@._V1_SX300.jpg",
		"plot": "A war-torn marine returns home to face his fiercest battle yet - the one against himself.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 1 nomination."
	},
	{
		"id": "1230215",
		"imdbID": "tt1230215",
		"title": "Not Fade Away",
		"year": "2012",
		"rating": "R",
		"runtime": "112 min",
		"genre": "Drama",
		"released": "2013-07-19",
		"director": "David Chase",
		"writer": "David Chase",
		"cast": "John Magaro, Jack Huston, Will Brill, Dominique McElligott",
		"metacritic": "65",
		"imdbRating": "6.0",
		"imdbVotes": "3595",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzU2NDU2MzIyMl5BMl5BanBnXkFtZTcwMDk2NTY1OA@@._V1_SX300.jpg",
		"plot": "Set in suburban New Jersey the 1960s, a group of friends form a rock band and try to make it big.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 3 nominations."
	},
	{
		"id": "1234721",
		"imdbID": "tt1234721",
		"title": "RoboCop",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "117 min",
		"genre": "Action, Sci-Fi, Thriller",
		"released": "2014-02-12",
		"director": "José Padilha",
		"writer": "Joshua Zetumer, Edward Neumeier, Michael Miner, Edward Neumeier, Michael Miner",
		"cast": "Joel Kinnaman, Gary Oldman, Michael Keaton, Abbie Cornish",
		"metacritic": "52",
		"imdbRating": "6.2",
		"imdbVotes": "173857",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAyOTUzMTcxN15BMl5BanBnXkFtZTgwMjkyOTc1MDE@._V1_SX300.jpg",
		"plot": "In 2028 Detroit, when Alex Murphy - a loving husband, father and good cop - is critically injured in the line of duty, the multinational conglomerate OmniCorp sees their chance for a part-man, part-robot police officer.",
		"language": "English, Persian",
		"country": "USA",
		"awards": "2 wins & 1 nomination."
	},
	{
		"id": "1235522",
		"imdbID": "tt1235522",
		"title": "Broken City",
		"year": "2013",
		"rating": "R",
		"runtime": "109 min",
		"genre": "Crime, Drama, Thriller",
		"released": "2013-01-18",
		"director": "Allen Hughes",
		"writer": "Brian Tucker",
		"cast": "Mark Wahlberg, Russell Crowe, Catherine Zeta-Jones, Jeffrey Wright",
		"metacritic": "49",
		"imdbRating": "6.2",
		"imdbVotes": "61236",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY4OTIwODg4Ml5BMl5BanBnXkFtZTcwNjg0MDY1OA@@._V1_SX300.jpg",
		"plot": "In a city rife with injustice, ex-cop Billy Taggart seeks redemption and revenge after being double-crossed and then framed by its most powerful figure: Mayor Nicholas Hostetler.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1236254",
		"imdbID": "tt1236254",
		"title": "Wind Walkers",
		"year": "2015",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Action, Horror, Thriller",
		"released": "2015-10-16",
		"director": "Russell Friedenberg",
		"writer": "Russell Friedenberg (screenplay)",
		"cast": "Glen Powell, Zane Holtz, Rudy Youngblood, Kiowa Gordon",
		"metacritic": "",
		"imdbRating": "3.9",
		"imdbVotes": "102",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE1NjYyMjQwMF5BMl5BanBnXkFtZTgwNTEzMzc5NjE@._V1_SX300.jpg",
		"plot": "With one of their own missing, a group of friends travel to the remote Florida everglades where they discover that an ancient, malevolent curse is tracking them.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1243974",
		"imdbID": "tt1243974",
		"title": "Aloha",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "105 min",
		"genre": "Comedy, Drama, Romance",
		"released": "2015-05-29",
		"director": "Cameron Crowe",
		"writer": "Cameron Crowe",
		"cast": "Bradley Cooper, Emma Stone, Rachel McAdams, Bill Murray",
		"metacritic": "40",
		"imdbRating": "5.5",
		"imdbVotes": "30155",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg4Mjc0NTE1NV5BMl5BanBnXkFtZTgwNzcwNTQ3NTE@._V1_SX300.jpg",
		"plot": "A celebrated military contractor returns to the site of his greatest career triumphs and reconnects with a long-ago love while unexpectedly falling for the hard-charging Air Force watch-dog assigned to him.",
		"language": "English",
		"country": "USA",
		"awards": "7 nominations."
	},
	{
		"id": "1261954",
		"imdbID": "tt1261954",
		"title": "Take Me Home",
		"year": "2011",
		"rating": "PG-13",
		"runtime": "97 min",
		"genre": "Comedy, Romance",
		"released": "2013-10-04",
		"director": "Sam Jaeger",
		"writer": "Sam Jaeger",
		"cast": "Amber Jaeger, Sam Jaeger, Victor Garber, Cristine Rose",
		"metacritic": "",
		"imdbRating": "6.9",
		"imdbVotes": "5158",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjM4NjI1NzQ2OF5BMl5BanBnXkFtZTcwMTU3NzY4NA@@._V1_SX300.jpg",
		"plot": "Soon after Thom starts operating as an illegal taxi driver in New York City, Claire hires him to drive her to California after her estranged father suffers a heart attack.",
		"language": "English",
		"country": "USA",
		"awards": "4 wins."
	},
	{
		"id": "1270087",
		"imdbID": "tt1270087",
		"title": "Behind the Door",
		"year": "2014",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Horror, Mystery, Thriller",
		"released": "2014-11-25",
		"director": "Kevin Hicks",
		"writer": "Kevin Hicks",
		"cast": "Chris Cusano, Bianca Giancoli, Pamela Price, Debbie Cady",
		"metacritic": "",
		"imdbRating": "5.6",
		"imdbVotes": "32",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEzNjY2MTM3M15BMl5BanBnXkFtZTgwMzY5MDkzMzE@._V1_SX300.jpg",
		"plot": "Coming off of a devastating broken engagement, Daniel Mays looks to start a new life in a new upstate home. No sooner does he move into his \"dream house,\" than strange occurrences begin ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1272878",
		"imdbID": "tt1272878",
		"title": "2 Guns",
		"year": "2013",
		"rating": "R",
		"runtime": "109 min",
		"genre": "Action, Comedy, Crime",
		"released": "2013-08-02",
		"director": "Baltasar Kormákur",
		"writer": "Blake Masters (screenplay), Steven Grant (based on the Boom! Studios graphic novels by)",
		"cast": "Denzel Washington, Mark Wahlberg, Paula Patton, Edward James Olmos",
		"metacritic": "55",
		"imdbRating": "6.8",
		"imdbVotes": "148877",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTQ5MTgzNDg4OF5BMl5BanBnXkFtZTcwMjAyODEzOQ@@._V1_SX300.jpg",
		"plot": "Two hardened criminals get into trouble with the US border patrol after meeting with a Mexican drug lord, and then revelations start to unfold.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "1272886",
		"imdbID": "tt1272886",
		"title": "Small Apartments",
		"year": "2012",
		"rating": "R",
		"runtime": "96 min",
		"genre": "Comedy, Crime, Drama",
		"released": "2013-03-01",
		"director": "Jonas Åkerlund",
		"writer": "Chris Millis (novel), Chris Millis (screenplay)",
		"cast": "Matt Lucas, James Caan, Nugget, Juno Temple",
		"metacritic": "",
		"imdbRating": "6.1",
		"imdbVotes": "5509",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA2MjU3MjgyMV5BMl5BanBnXkFtZTcwMzY4MDk4OA@@._V1_SX300.jpg",
		"plot": "A man is surrounded by strange events and odd neighbors in this adaptation of Chris Millis' novel.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1276953",
		"imdbID": "tt1276953",
		"title": "Extremely Used Cars: There Is No Hope",
		"year": "2015",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Comedy, Crime, Drama",
		"released": "2015-01-30",
		"director": "Craig Richards",
		"writer": "Mark Donnell",
		"cast": "Mark Donnell, Ian Reed Kesler, Aaron Kissinger, Kim Woods",
		"metacritic": "",
		"imdbRating": "6.6",
		"imdbVotes": "30",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ4Nzc1OTQ3OF5BMl5BanBnXkFtZTcwNzQwMzA3NQ@@._V1_SX300.jpg",
		"plot": "Chip Douglas is a washed-out alcoholic car salesman at a used car lot. With the endless availability of information over the Internet, customers can now get any information about any car ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1282046",
		"imdbID": "tt1282046",
		"title": "Fort McCoy",
		"year": "2011",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Drama, History, War",
		"released": "2014-08-15",
		"director": "Kate Connor, Michael Worth",
		"writer": "Kate Connor",
		"cast": "Eric Stoltz, Kate Connor, Lyndsy Fonseca, Andy Hirsch",
		"metacritic": "47",
		"imdbRating": "5.5",
		"imdbVotes": "261",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzQ3MTkyNDAwMF5BMl5BanBnXkFtZTgwOTIyOTcxMjE@._V1_SX300.jpg",
		"plot": "A drama based on a true story when the Stirn family lived next to a Nazi POW camp in Wisconsin during W.W.II.",
		"language": "English",
		"country": "USA",
		"awards": "11 wins & 4 nominations."
	},
	{
		"id": "1288558",
		"imdbID": "tt1288558",
		"title": "Evil Dead",
		"year": "2013",
		"rating": "R",
		"runtime": "91 min",
		"genre": "Horror",
		"released": "2013-04-05",
		"director": "Fede Alvarez",
		"writer": "Fede Alvarez (screenplay), Rodo Sayagues (screenplay), Sam Raimi (based on the motion picture \"The Evil Dead\",  written by)",
		"cast": "Jane Levy, Shiloh Fernandez, Lou Taylor Pucci, Jessica Lucas",
		"metacritic": "57",
		"imdbRating": "6.5",
		"imdbVotes": "118967",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTQ3OTkwNTgyN15BMl5BanBnXkFtZTcwNTAzOTAzOQ@@._V1_SX300.jpg",
		"plot": "Five friends head to a remote cabin, where the discovery of a Book of the Dead leads them to unwittingly summon up demons living in the nearby woods. The evil presence possesses them until only one is left to fight for survival.",
		"language": "English",
		"country": "USA",
		"awards": "6 wins & 16 nominations."
	},
	{
		"id": "1291150",
		"imdbID": "tt1291150",
		"title": "Teenage Mutant Ninja Turtles",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "101 min",
		"genre": "Action, Adventure, Comedy",
		"released": "2014-08-08",
		"director": "Jonathan Liebesman",
		"writer": "Josh Appelbaum, André Nemec, Evan Daugherty, Peter Laird (Teenage Mutant Ninja Turtles characters), Kevin Eastman (Teenage Mutant Ninja Turtles characters)",
		"cast": "Megan Fox, Will Arnett, William Fichtner, Alan Ritchson",
		"metacritic": "31",
		"imdbRating": "5.9",
		"imdbVotes": "153590",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjUzODQ5MDY5NV5BMl5BanBnXkFtZTgwOTc1NzcyMjE@._V1_SX300.jpg",
		"plot": "When a kingpin threatens New York City, a group of mutated turtle warriors must emerge from the shadows to protect their home.",
		"language": "English, Japanese",
		"country": "USA",
		"awards": "1 win & 10 nominations."
	},
	{
		"id": "1292566",
		"imdbID": "tt1292566",
		"title": "How to Be Single",
		"year": "2016",
		"rating": "R",
		"runtime": "",
		"genre": "Comedy, Romance",
		"released": "2016-02-12",
		"director": "Christian Ditter",
		"writer": "Dana Fox (screenplay), Abby Kohn (screenplay), Marc Silverstein (screenplay), Liz Tuccillo (novel)",
		"cast": "Dakota Johnson, Alison Brie, Leslie Mann, Rebel Wilson",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzI4MDMwMzUwNF5BMl5BanBnXkFtZTgwMDgyNzkyNzE@._V1_SX300.jpg",
		"plot": "New York City is full of lonely hearts seeking the right match, and what Alice, Robin, Lucy, Meg, Tom and David all have in common is the need to learn how to be single in a world filled with ever-evolving definitions of love.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1309374",
		"imdbID": "tt1309374",
		"title": "House of Dust",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Horror, Thriller",
		"released": "2013-11-01",
		"director": "A.D. Calvo",
		"writer": "Alyssa Alexandria (screenplay), A.D. Calvo (story), Nevada Grey (screenplay), Scott Kittredge (additional writing)",
		"cast": "Inbar Lavi, Steven Grayhm, Eddie Hassell, Holland Roden",
		"metacritic": "",
		"imdbRating": "3.7",
		"imdbVotes": "446",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMzNTIyNzA2OV5BMl5BanBnXkFtZTgwMDY0NzM0MTE@._V1_SX300.jpg",
		"plot": "College students exploring an abandoned insane asylum accidentally shatter canisters holding the cremains of former mental patients. Inhaling the dusty ash filling the air, they're soon possessed by the souls once held within them. One is a convicted serial killer from 1950.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1321870",
		"imdbID": "tt1321870",
		"title": "Gangster Squad",
		"year": "2013",
		"rating": "R",
		"runtime": "113 min",
		"genre": "Action, Crime, Drama",
		"released": "2013-01-11",
		"director": "Ruben Fleischer",
		"writer": "Will Beall, Paul Lieberman (book)",
		"cast": "Sean Penn, Holt McCallany, Wade Williams, James Landry Hébert",
		"metacritic": "40",
		"imdbRating": "6.8",
		"imdbVotes": "166753",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTcwMjAyMTUzMl5BMl5BanBnXkFtZTcwODgxNzk1OA@@._V1_SX300.jpg",
		"plot": "It's 1949 Los Angeles, the city is run by gangsters and a malicious mobster, Mickey Cohen. Determined to end the corruption, John O'Mara assembles a team of cops, ready to take down the ruthless leader and restore peace to the city.",
		"language": "English",
		"country": "USA",
		"awards": "4 nominations."
	},
	{
		"id": "1322269",
		"imdbID": "tt1322269",
		"title": "August: Osage County",
		"year": "2013",
		"rating": "R",
		"runtime": "121 min",
		"genre": "Drama",
		"released": "2014-01-10",
		"director": "John Wells",
		"writer": "Tracy Letts (screenplay), Tracy Letts (play)",
		"cast": "Meryl Streep, Julia Roberts, Chris Cooper, Ewan McGregor",
		"metacritic": "58",
		"imdbRating": "7.3",
		"imdbVotes": "63727",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzQ5ODE4NTcxNV5BMl5BanBnXkFtZTgwNjkyNDQ0MDE@._V1_SX300.jpg",
		"plot": "A look at the lives of the strong-willed women of the Weston family, whose paths have diverged until a family crisis brings them back to the Oklahoma house they grew up in, and to the dysfunctional woman who raised them.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 2 Oscars. Another 14 wins & 53 nominations."
	},
	{
		"id": "1327773",
		"imdbID": "tt1327773",
		"title": "Lee Daniels' The Butler",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "132 min",
		"genre": "Biography, Drama",
		"released": "2013-08-16",
		"director": "Lee Daniels",
		"writer": "Danny Strong, Wil Haygood (article)",
		"cast": "Forest Whitaker, David Banner, Michael Rainey Jr., LaJessie Smith",
		"metacritic": "66",
		"imdbRating": "7.1",
		"imdbVotes": "82171",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM2NDY3MjkyMF5BMl5BanBnXkFtZTcwMDM5Nzg5OQ@@._V1_SX300.jpg",
		"plot": "As Cecil Gaines serves eight presidents during his tenure as a butler at the White House, the civil rights movement, Vietnam, and other major events affect this man's life, family, and American society.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 2 BAFTA Film Awards. Another 16 wins & 47 nominations."
	},
	{
		"id": "1340138",
		"imdbID": "tt1340138",
		"title": "Terminator Genisys",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "126 min",
		"genre": "Action, Adventure, Sci-Fi",
		"released": "2015-07-01",
		"director": "Alan Taylor",
		"writer": "Laeta Kalogridis, Patrick Lussier, James Cameron (characters), Gale Anne Hurd (characters)",
		"cast": "Arnold Schwarzenegger, Jason Clarke, Emilia Clarke, Jai Courtney",
		"metacritic": "38",
		"imdbRating": "6.6",
		"imdbVotes": "159987",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM1NTc0NzE4OF5BMl5BanBnXkFtZTgwNDkyNjQ1NTE@._V1_SX300.jpg",
		"plot": "When John Connor, leader of the human resistance, sends Sgt. Kyle Reese back to 1984 to protect Sarah Connor and safeguard the future, an unexpected turn of events creates a fractured timeline.",
		"language": "English",
		"country": "USA",
		"awards": "3 nominations."
	},
	{
		"id": "1351186",
		"imdbID": "tt1351186",
		"title": "Luster",
		"year": "2010",
		"rating": "R",
		"runtime": "",
		"genre": "Horror, Thriller",
		"released": "2013-04-09",
		"director": "Adam Mason",
		"writer": "Simon Boyes, Adam Mason",
		"cast": "Andrew Howard, Tess Panzer, Matthew Rhys, Ian Duncan",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "271",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg3MzM3NDQzN15BMl5BanBnXkFtZTcwMjUyOTY3Mw@@._V1_SX300.jpg",
		"plot": "Thomas Luster is a troubled businessman who tries to make sense of a life being driven out-of-control by a force closer to home than he first realizes. When he discovers that the man ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1371124",
		"imdbID": "tt1371124",
		"title": "Electric Slide",
		"year": "2014",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Action, Biography, Crime",
		"released": "2015-04-03",
		"director": "Tristan Patterson",
		"writer": "Timothy Ford (article), Tristan Patterson (screenplay), Tristan Patterson",
		"cast": "Isabel Lucas, Chloë Sevigny, Patricia Arquette, Vinessa Shaw",
		"metacritic": "37",
		"imdbRating": "4.7",
		"imdbVotes": "383",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTExMzM5ODUxODReQTJeQWpwZ15BbWU4MDIxOTA2MTUx._V1_SX300.jpg",
		"plot": "A chronicle of the life of furniture salesman turned bank robber Eddie Dodson.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1371150",
		"imdbID": "tt1371150",
		"title": "This Is Where I Leave You",
		"year": "2014",
		"rating": "R",
		"runtime": "103 min",
		"genre": "Comedy, Drama",
		"released": "2014-09-19",
		"director": "Shawn Levy",
		"writer": "Jonathan Tropper (screenplay), Jonathan Tropper (novel)",
		"cast": "Jason Bateman, Tina Fey, Jane Fonda, Adam Driver",
		"metacritic": "44",
		"imdbRating": "6.6",
		"imdbVotes": "47817",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjkzNzQ2NDMyNl5BMl5BanBnXkFtZTgwMTY3MTcxMjE@._V1_SX300.jpg",
		"plot": "When their father passes away, four grown siblings are forced to return to their childhood home and live under the same roof together for a week, along with their over-sharing mother and an assortment of spouses, exes and might-have-beens.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1374989",
		"imdbID": "tt1374989",
		"title": "Pride and Prejudice and Zombies",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "",
		"genre": "Action, Horror, Romance",
		"released": "2016-02-05",
		"director": "Burr Steers",
		"writer": "Burr Steers (screenplay), Jane Austen (Quirk Books novel), Seth Grahame-Smith (Quirk Books novel)",
		"cast": "Lily James, Lena Headey, Douglas Booth, Charles Dance",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTE5MTg0ODk4M15BMl5BanBnXkFtZTgwNzMxNTAzNzE@._V1_SX300.jpg",
		"plot": "Jane Austen's classic tale of the tangled relationships between lovers from different social classes in 19th century England is faced with a new challenge -- an army of undead zombies.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1391087",
		"imdbID": "tt1391087",
		"title": "Perfect Sunday",
		"year": "2010",
		"rating": "R",
		"runtime": "87 min",
		"genre": "Comedy",
		"released": "2013-09-17",
		"director": "Demetrius Navarro",
		"writer": "Down aka Kilo (story), Enrico Natale (revisions), Demetrius Navarro (screenplay), Demetrius Navarro (story)",
		"cast": "Valente Rodriguez, Erlinda Navarro, Demetrius Navarro, Tommy 'Tiny' Lister",
		"metacritic": "",
		"imdbRating": "5.4",
		"imdbVotes": "45",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk2MTkxNTE1N15BMl5BanBnXkFtZTgwODUxMDUwMTE@._V1_SX300.jpg",
		"plot": "Hector and Lefty are two brothers hanging out on Sunday, getting their prized lowrider ready to cruise the boulevard. They are challenged by Crazy Loc, the neighborhood bully, to a hop off ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1392214",
		"imdbID": "tt1392214",
		"title": "Prisoners",
		"year": "2013",
		"rating": "R",
		"runtime": "153 min",
		"genre": "Crime, Drama, Mystery",
		"released": "2013-09-20",
		"director": "Denis Villeneuve",
		"writer": "Aaron Guzikowski",
		"cast": "Hugh Jackman, Jake Gyllenhaal, Viola Davis, Maria Bello",
		"metacritic": "74",
		"imdbRating": "8.1",
		"imdbVotes": "341803",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg0NTIzMjQ1NV5BMl5BanBnXkFtZTcwNDc3MzM5OQ@@._V1_SX300.jpg",
		"plot": "When Keller Dover's daughter and her friend go missing, he takes matters into his own hands as the police pursue multiple leads and the pressure mounts. But just how far will this desperate father go to protect his family?",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 1 Oscar. Another 10 wins & 32 nominations."
	},
	{
		"id": "1403862",
		"imdbID": "tt1403862",
		"title": "Sinbad: The Fifth Voyage",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "89 min",
		"genre": "Action, Adventure, Fantasy",
		"released": "2014-02-07",
		"director": "Shahin Sean Solimon",
		"writer": "Shahin Sean Solimon, Evelyn Gabai",
		"cast": "Patrick Stewart, Isaac C. Singleton Jr., Sadie Alexandru, Lorna Raver",
		"metacritic": "",
		"imdbRating": "6.0",
		"imdbVotes": "5461",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk2MTc5ODM0Nl5BMl5BanBnXkFtZTgwMDkwMTA5MjE@._V1_SX300.jpg",
		"plot": "When the Sultan's first born is taken by an evil sorcerer, Sinbad is tasked with traveling to a desert of magic and creatures to save her.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1408101",
		"imdbID": "tt1408101",
		"title": "Star Trek Into Darkness",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "132 min",
		"genre": "Action, Adventure, Sci-Fi",
		"released": "2013-05-16",
		"director": "J.J. Abrams",
		"writer": "Roberto Orci, Alex Kurtzman, Damon Lindelof, Gene Roddenberry (television series \"Star Trek\")",
		"cast": "Chris Pine, Zachary Quinto, Zoe Saldana, Karl Urban",
		"metacritic": "72",
		"imdbRating": "7.8",
		"imdbVotes": "375566",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk2NzczOTgxNF5BMl5BanBnXkFtZTcwODQ5ODczOQ@@._V1_SX300.jpg",
		"plot": "After the crew of the Enterprise find an unstoppable force of terror from within their own organization, Captain Kirk leads a manhunt to a war-zone world to capture a one-man weapon of mass destruction.",
		"language": "English, Klingon",
		"country": "USA",
		"awards": "Nominated for 1 Oscar. Another 6 wins & 44 nominations."
	},
	{
		"id": "1408253",
		"imdbID": "tt1408253",
		"title": "Ride Along",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "99 min",
		"genre": "Action, Comedy",
		"released": "2014-01-17",
		"director": "Tim Story",
		"writer": "Greg Coolidge (screenplay), Jason Mantzoukas (screenplay), Phil Hay (screenplay), Matt Manfredi (screenplay), Greg Coolidge (story)",
		"cast": "Ice Cube, Kevin Hart, John Leguizamo, Bruce McGill",
		"metacritic": "41",
		"imdbRating": "6.1",
		"imdbVotes": "62123",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjU4NzYzOTY1MF5BMl5BanBnXkFtZTgwMTAyNTc1MDE@._V1_SX300.jpg",
		"plot": "Security guard Ben must prove himself to his girlfriend's brother, top cop James. He rides along James on a 24-hour patrol of Atlanta.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 7 nominations."
	},
	{
		"id": "1425252",
		"imdbID": "tt1425252",
		"title": "The Crypt",
		"year": "2009",
		"rating": "R",
		"runtime": "84 min",
		"genre": "Crime, Horror, Mystery",
		"released": "2015-01-29",
		"director": "Craig McMahon",
		"writer": "Craig McMahon (creator)",
		"cast": "Sarah Oh, Mike Ranallo, Abra May, Cristen Irene",
		"metacritic": "",
		"imdbRating": "3.4",
		"imdbVotes": "1054",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg3NjE0MDQ3NF5BMl5BanBnXkFtZTcwMzUzNTc2Mg@@._V1_SX300.jpg",
		"plot": "Six young criminals break into hidden catacombs and attempt to steal jewels, but some inhabitants are guarding the precious belongings. After being trapped in this dark maze of crypts, the group tries to escape alive.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1425922",
		"imdbID": "tt1425922",
		"title": "Black Nativity",
		"year": "2013",
		"rating": "PG",
		"runtime": "93 min",
		"genre": "Drama, Musical",
		"released": "2013-11-27",
		"director": "Kasi Lemmons",
		"writer": "Langston Hughes (based on the play by), Kasi Lemmons (written for the screen by)",
		"cast": "Forest Whitaker, Angela Bassett, Jennifer Hudson, Tyrese Gibson",
		"metacritic": "48",
		"imdbRating": "4.3",
		"imdbVotes": "1553",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg3OTkxNzkwMl5BMl5BanBnXkFtZTgwOTcyNTE2MDE@._V1_SX300.jpg",
		"plot": "A street-wise teen from Baltimore who has been raised by a single mother travels to New York City to spend the Christmas holiday with his estranged relatives, where he embarks on a surprising and inspirational journey.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 5 nominations."
	},
	{
		"id": "1426329",
		"imdbID": "tt1426329",
		"title": "Lovelace",
		"year": "2013",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Biography, Drama",
		"released": "2013-08-08",
		"director": "Rob Epstein, Jeffrey Friedman",
		"writer": "Andy Bellin",
		"cast": "Amanda Seyfried, Peter Sarsgaard, Sharon Stone, Robert Patrick",
		"metacritic": "51",
		"imdbRating": "6.2",
		"imdbVotes": "28799",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTM0Mzc2MjgyN15BMl5BanBnXkFtZTcwOTIzNDQ4OQ@@._V1_SX300.jpg",
		"plot": "The story of Linda Lovelace, who is used and abused by the porn industry at the behest of her coercive husband, before taking control of her life.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 3 nominations."
	},
	{
		"id": "1426363",
		"imdbID": "tt1426363",
		"title": "HairBrained",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "97 min",
		"genre": "Comedy",
		"released": "2013-05-31",
		"director": "Billy Kent",
		"writer": "Sarah Bird (story), Billy Kent (story), Adam Wierzbianski (story)",
		"cast": "Alex Wolff, Brendan Fraser, Julia Garner, Michael Oberholtzer",
		"metacritic": "48",
		"imdbRating": "5.4",
		"imdbVotes": "1306",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMzMzQzOTUyM15BMl5BanBnXkFtZTgwNzQ1ODUxMTE@._V1_SX300.jpg",
		"plot": "When 14-year old genius/outcast Eli Pettifog is rejected from Harvard, he ends up at Ivy League wannabe Whittman College. It's hate at first sight. At Whittman, Eli meets 41- year-old ...",
		"language": "English",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "1433811",
		"imdbID": "tt1433811",
		"title": "Disconnect",
		"year": "2012",
		"rating": "R",
		"runtime": "115 min",
		"genre": "Drama, Thriller",
		"released": "2013-07-05",
		"director": "Henry Alex Rubin",
		"writer": "Andrew Stern",
		"cast": "Jason Bateman, Hope Davis, Frank Grillo, Michael Nyqvist",
		"metacritic": "64",
		"imdbRating": "7.6",
		"imdbVotes": "57794",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA2MTEzMDkyOF5BMl5BanBnXkFtZTcwNzc4NTgxOQ@@._V1_SX300.jpg",
		"plot": "A drama centered on a group of people searching for human connections in today's wired world.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1445208",
		"imdbID": "tt1445208",
		"title": "The Letters",
		"year": "2014",
		"rating": "PG",
		"runtime": "114 min",
		"genre": "Drama",
		"released": "2015-12-04",
		"director": "William Riead",
		"writer": "William Riead",
		"cast": "Juliet Stevenson, Rutger Hauer, Max von Sydow, Priya Darshini",
		"metacritic": "25",
		"imdbRating": "5.1",
		"imdbVotes": "245",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYyMzg0Njg5MV5BMl5BanBnXkFtZTgwOTQ3MTkwNjE@._V1_SX300.jpg",
		"plot": "A drama that explores the life of Mother Teresa through letters she wrote to her longtime friend and spiritual advisor, Father Celeste van Exem over a nearly 50-year period.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "1457765",
		"imdbID": "tt1457765",
		"title": "The Haunting in Connecticut 2: Ghosts of Georgia",
		"year": "2013",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Drama, Horror, Mystery",
		"released": "2013-03-14",
		"director": "Tom Elkins",
		"writer": "David Coggeshall, Sarai Givaty (performance art piece)",
		"cast": "Abigail Spencer, Morgana Shaw, Emily Alyn Lind, Chad Michael Murray",
		"metacritic": "26",
		"imdbRating": "5.2",
		"imdbVotes": "12551",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk0MTA0NDAwOF5BMl5BanBnXkFtZTcwMDQ0NzQ4OA@@._V1_SX300.jpg",
		"plot": "A young family moves into a historic home in Georgia, only to learn they are not the house's only inhabitants. Soon they find themselves in the presence of a secret rising from underground and threatening to bring down anyone in its path.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1457767",
		"imdbID": "tt1457767",
		"title": "The Conjuring",
		"year": "2013",
		"rating": "R",
		"runtime": "112 min",
		"genre": "Horror",
		"released": "2013-07-19",
		"director": "James Wan",
		"writer": "Chad Hayes, Carey Hayes",
		"cast": "Vera Farmiga, Patrick Wilson, Lili Taylor, Ron Livingston",
		"metacritic": "68",
		"imdbRating": "7.5",
		"imdbVotes": "267513",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM3NjA1NDMyMV5BMl5BanBnXkFtZTcwMDQzNDMzOQ@@._V1_SX300.jpg",
		"plot": "Paranormal investigators Ed and Lorraine Warren work to help a family terrorized by a dark presence in their farmhouse.",
		"language": "English, Latin",
		"country": "USA",
		"awards": "14 wins & 21 nominations."
	},
	{
		"id": "1482461",
		"imdbID": "tt1482461",
		"title": "The Mulberry Tree",
		"year": "2010",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Drama",
		"released": "2013-01-01",
		"director": "Mark Heller",
		"writer": "Louis Crugnali (screenplay)",
		"cast": "Louis Crugnali, Daniella Alonso, Lucas Ardagna, Larry Dacosta",
		"metacritic": "",
		"imdbRating": "8.0",
		"imdbVotes": "61",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTAyMjc4ODc1OTNeQTJeQWpwZ15BbWU3MDQ4OTExOTg@._V1_SX300.jpg",
		"plot": "A drama centered on a young man working in Rhode Island's state corrections system and his relationship with a convicted murderer who is dying of AIDS and spending his remaining days on hospital detail.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 5 nominations."
	},
	{
		"id": "1485141",
		"imdbID": "tt1485141",
		"title": "Vengeance",
		"year": "2006",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Action, Crime, Drama",
		"released": "2016-05-05",
		"director": "Gil Medina",
		"writer": "Jeff Hawker, Gil Medina (screenplay), Gil Medina",
		"cast": "Danny Trejo, 50 Cent, Houston Alexander, Rocky Anderson",
		"metacritic": "",
		"imdbRating": "3.8",
		"imdbVotes": "115",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUzMTMxNjQ2NF5BMl5BanBnXkFtZTgwMzYzNDE0MDE@._V1_SX300.jpg",
		"plot": "An undercover cop, accused of a crime he did not commit, regains his freedom and decides to take revenge.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1485761",
		"imdbID": "tt1485761",
		"title": "No God, No Master",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "94 min",
		"genre": "Crime, Drama, History",
		"released": "2015-08-19",
		"director": "Terry Green",
		"writer": "Terry Green",
		"cast": "David Strathairn, Ray Wise, Sam Witwer, Alessandro Mario",
		"metacritic": "48",
		"imdbRating": "5.9",
		"imdbVotes": "517",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM4NDgxNzEzOV5BMl5BanBnXkFtZTgwMDIxODMyMTE@._V1_SX300.jpg",
		"plot": "When a series of package bombs show up on the doorsteps of prominent politicians and businessmen in the summer of 1919, U.S. Bureau of Investigation Agent William Flynn (Strathairn) is ...",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "1490785",
		"imdbID": "tt1490785",
		"title": "I Saw the Light",
		"year": "2015",
		"rating": "R",
		"runtime": "123 min",
		"genre": "Biography, Drama, Music",
		"released": "2016-03-25",
		"director": "Marc Abraham",
		"writer": "Marc Abraham, Colin Escott (book), George Merritt (book), William MacEwen (book)",
		"cast": "Elizabeth Olsen, Tom Hiddleston, David Krumholtz, Cherry Jones",
		"metacritic": "45",
		"imdbRating": "6.5",
		"imdbVotes": "295",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU4NzQ1NjU2Ml5BMl5BanBnXkFtZTgwMzAwNjQ0NzE@._V1_SX300.jpg",
		"plot": "The story of the country-western singer Hank Williams, who in his brief life created one of the greatest bodies of work in American music. The film chronicles his rise to fame and its tragic effect on his health and personal life.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1491044",
		"imdbID": "tt1491044",
		"title": "The Iceman",
		"year": "2012",
		"rating": "R",
		"runtime": "106 min",
		"genre": "Biography, Crime, Drama",
		"released": "2013-05-02",
		"director": "Ariel Vromen",
		"writer": "Morgan Land (screenplay), Ariel Vromen (screenplay), Anthony Bruno (book), Jim Thebaut (documentary \"The Iceman Tapes: Conversations with a Killer\")",
		"cast": "Michael Shannon, Winona Ryder, Chris Evans, Ray Liotta",
		"metacritic": "60",
		"imdbRating": "6.9",
		"imdbVotes": "52388",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDQyMjM5MTc2OF5BMl5BanBnXkFtZTgwMzg1NTMxMjE@._V1_SX300.jpg",
		"plot": "The story of Richard Kuklinski, the notorious contract killer and family man. When finally arrested in 1986, neither his wife nor daughters have any clue about his real profession.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "1524575",
		"imdbID": "tt1524575",
		"title": "The Vatican Tapes",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "91 min",
		"genre": "Horror, Thriller",
		"released": "2015-07-24",
		"director": "Mark Neveldine",
		"writer": "Chris Morgan (based on a story by), Christopher Borrelli (based on a story by), Christopher Borrelli (screenplay), Michael C. Martin (screenplay)",
		"cast": "Michael Peña, Olivia Taylor Dudley, Alison Lohman, Kathleen Robertson",
		"metacritic": "37",
		"imdbRating": "4.5",
		"imdbVotes": "4716",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMwNzgzNTI0M15BMl5BanBnXkFtZTgwODU0MTk4NTE@._V1_SX300.jpg",
		"plot": "A priest and two Vatican exorcists must do battle with an ancient satanic force to save the soul of a young woman.",
		"language": "English, Aramaic",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1524930",
		"imdbID": "tt1524930",
		"title": "Vacation",
		"year": "2015",
		"rating": "R",
		"runtime": "99 min",
		"genre": "Adventure, Comedy",
		"released": "2015-07-29",
		"director": "John Francis Daley, Jonathan M. Goldstein",
		"writer": "Jonathan M. Goldstein, John Francis Daley, John Hughes (characters)",
		"cast": "Ed Helms, Christina Applegate, Skyler Gisondo, Steele Stebbins",
		"metacritic": "34",
		"imdbRating": "6.2",
		"imdbVotes": "41596",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUwNTM0ODMxM15BMl5BanBnXkFtZTgwNjM4Nzk4NTE@._V1_SX300.jpg",
		"plot": "Rusty Griswold takes his own family on a road trip to \"Walley World\" in order to spice things up with his wife and reconnect with his sons.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1535108",
		"imdbID": "tt1535108",
		"title": "Elysium",
		"year": "2013",
		"rating": "R",
		"runtime": "109 min",
		"genre": "Action, Drama, Sci-Fi",
		"released": "2013-08-09",
		"director": "Neill Blomkamp",
		"writer": "Neill Blomkamp",
		"cast": "Matt Damon, Jodie Foster, Sharlto Copley, Alice Braga",
		"metacritic": "61",
		"imdbRating": "6.6",
		"imdbVotes": "313386",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDc2NjU0MTcwNV5BMl5BanBnXkFtZTcwMjg4MDg2OQ@@._V1_SX300.jpg",
		"plot": "In the year 2154, the very wealthy live on a man-made space station while the rest of the population resides on a ruined Earth. A man takes on a mission that could bring equality to the polarized worlds.",
		"language": "English, Spanish, French, Afrikaans",
		"country": "USA",
		"awards": "1 win & 9 nominations."
	},
	{
		"id": "1535109",
		"imdbID": "tt1535109",
		"title": "Captain Phillips",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "134 min",
		"genre": "Biography, Drama, Thriller",
		"released": "2013-10-11",
		"director": "Paul Greengrass",
		"writer": "Billy Ray (screenplay), Richard Phillips (based upon the book \"A Captain's Duty: Somali Pirates,  Navy SEALS,  and Dangerous Days at Sea\" by), Stephan Talty (based upon the book \"A Captain's Duty: Somali Pirates,  Navy SEALS,  and Dangerous Days at Sea\" by)",
		"cast": "Tom Hanks, Catherine Keener, Barkhad Abdi, Barkhad Abdirahman",
		"metacritic": "83",
		"imdbRating": "7.9",
		"imdbVotes": "304257",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzNzExMDg3Ml5BMl5BanBnXkFtZTgwODU1NzEzMDE@._V1_SX300.jpg",
		"plot": "The true story of Captain Richard Phillips and the 2009 hijacking by Somali pirates of the US-flagged MV Maersk Alabama, the first American cargo ship to be hijacked in two hundred years.",
		"language": "English, Somali",
		"country": "USA",
		"awards": "Nominated for 6 Oscars. Another 16 wins & 129 nominations."
	},
	{
		"id": "1536051",
		"imdbID": "tt1536051",
		"title": "Five Thirteen",
		"year": "2013",
		"rating": "R",
		"runtime": "110 min",
		"genre": "Drama",
		"released": "2014-06-11",
		"director": "Kader Ayd",
		"writer": "Kader Ayd, Renee Topper",
		"cast": "Malik Barnhardt, Avelawance Phillips, Tom Sizemore, Gary Dourdan",
		"metacritic": "",
		"imdbRating": "4.0",
		"imdbVotes": "508",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc3NDY0ODYzN15BMl5BanBnXkFtZTcwNTUxNTMxNg@@._V1_SX300.jpg",
		"plot": "In this tension-packed thriller, brothers Mike and Tre set out in search of better lives, trying to leave their demons behind for good. After being released from prison for a crime he ...",
		"language": "English, French",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1545660",
		"imdbID": "tt1545660",
		"title": "Knights of Badassdom",
		"year": "2013",
		"rating": "R",
		"runtime": "86 min",
		"genre": "Adventure, Comedy, Fantasy",
		"released": "2014-08-18",
		"director": "Joe Lynch",
		"writer": "Kevin Dreyfuss (screenplay), Matt Wall (screenplay)",
		"cast": "D.R. Anderson, W. Earl Brown, Michael Carpenter, Kevin Connell",
		"metacritic": "",
		"imdbRating": "5.7",
		"imdbVotes": "15141",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMyNzAyNzUzMF5BMl5BanBnXkFtZTgwOTQ0NDMyMTE@._V1_SX300.jpg",
		"plot": "Live-action role players conjure up a demon from Hell by mistake and they must deal with the consequences.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "1545754",
		"imdbID": "tt1545754",
		"title": "Are You Here",
		"year": "2013",
		"rating": "R",
		"runtime": "114 min",
		"genre": "Comedy, Drama",
		"released": "2014-08-22",
		"director": "Matthew Weiner",
		"writer": "Matthew Weiner",
		"cast": "Owen Wilson, Jay Gates, Jason Davis, Melissa Rauch",
		"metacritic": "37",
		"imdbRating": "5.3",
		"imdbVotes": "10013",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjY3NzM2NDg0MV5BMl5BanBnXkFtZTgwOTE2MjU5MTE@._V1_SX300.jpg",
		"plot": "Two childhood best friends, one a superficial womanizer and the other a barely functioning bipolar, embark on a road trip back to their hometown after one of them learns his estranged father has died.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1560954",
		"imdbID": "tt1560954",
		"title": "Gun",
		"year": "2010",
		"rating": "R",
		"runtime": "82 min",
		"genre": "Action, Crime, Thriller",
		"released": "2015-09-05",
		"director": "Jessy Terrero",
		"writer": "50 Cent",
		"cast": "50 Cent, Val Kilmer, AnnaLynne McCord, James Remar",
		"metacritic": "",
		"imdbRating": "3.7",
		"imdbVotes": "3061",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc0MDk3MjI1OV5BMl5BanBnXkFtZTcwNzg0MjIyMw@@._V1_SX300.jpg",
		"plot": "A drama set in the world of gun-running.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1568929",
		"imdbID": "tt1568929",
		"title": "The Mooring",
		"year": "2012",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Horror, Thriller",
		"released": "2013-02-19",
		"director": "Glenn Withrow",
		"writer": "Ivy Withrow, Hallie Todd, Glenn Withrow",
		"cast": "Hallie Todd, Thomas Wilson Brown, Karli Blalock, Anna Goodwin",
		"metacritic": "",
		"imdbRating": "4.3",
		"imdbVotes": "964",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDUzOTc0MjY1M15BMl5BanBnXkFtZTcwNjUwOTg4OA@@._V1_SX300.jpg",
		"plot": "Every 40 seconds a person goes missing. In northern Idaho, a group of teenage girls attended a summer camp. They were told it would be a summer of change. It was.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1571249",
		"imdbID": "tt1571249",
		"title": "The Skeleton Twins",
		"year": "2014",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Comedy, Drama",
		"released": "2014-09-11",
		"director": "Craig Johnson",
		"writer": "Craig Johnson, Mark Heyman",
		"cast": "Bill Hader, Kristen Wiig, Luke Wilson, Ty Burrell",
		"metacritic": "74",
		"imdbRating": "6.9",
		"imdbVotes": "28675",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzk5MjM3NDEwN15BMl5BanBnXkFtZTgwMDIxNjYzMjE@._V1_SX300.jpg",
		"plot": "Having both coincidentally cheated death on the same day, estranged twins reunite with the possibility of mending their relationship.",
		"language": "English",
		"country": "USA",
		"awards": "4 wins & 10 nominations."
	},
	{
		"id": "1572315",
		"imdbID": "tt1572315",
		"title": "Texas Chainsaw 3D",
		"year": "2013",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Horror, Thriller",
		"released": "2013-01-04",
		"director": "John Luessenhop",
		"writer": "Adam Marcus (screenplay), Debra Sullivan (screenplay), Kirsten McCallion (screenplay), Stephen Susco (story), Adam Marcus (story), Debra Sullivan (story), Kim Henkel (characters), Tobe Hooper (characters)",
		"cast": "Alexandra Daddario, Dan Yeager, Trey Songz, Scott Eastwood",
		"metacritic": "",
		"imdbRating": "4.8",
		"imdbVotes": "33323",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzMzAyNTE2N15BMl5BanBnXkFtZTcwNzM1NDg2OA@@._V1_SX300.jpg",
		"plot": "A young woman travels to Texas to collect an inheritance; little does she know that an encounter with a chainsaw-wielding killer is part of the reward.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 7 nominations."
	},
	{
		"id": "1594917",
		"imdbID": "tt1594917",
		"title": "Age of the Dragons",
		"year": "2011",
		"rating": "PG-13",
		"runtime": "91 min",
		"genre": "Action, Adventure, Fantasy",
		"released": "2013-12-04",
		"director": "Ryan Little",
		"writer": "Gil Aglaure (story), Anne K. Black (story), McKay Daines (screenplay), Herman Melville (novel)",
		"cast": "Danny Glover, Vinnie Jones, Corey Sevier, Sofia Pernas",
		"metacritic": "",
		"imdbRating": "3.4",
		"imdbVotes": "3801",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjQ2MTg4NjA2OF5BMl5BanBnXkFtZTcwMzY2NzcwOA@@._V1_SX300.jpg",
		"plot": "Herman Melville's classic novel Moby Dick, is recreated in a world where Captain Ahab and his crew search for a Great White Dragon.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1609488",
		"imdbID": "tt1609488",
		"title": "Language of a Broken Heart",
		"year": "2011",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Comedy, Romance",
		"released": "2013-06-07",
		"director": "Rocky Powell",
		"writer": "Juddy Talt",
		"cast": "Juddy Talt, Kate French, Julie White, Ethan Cohn",
		"metacritic": "33",
		"imdbRating": "5.7",
		"imdbVotes": "271",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU2NDk1NDY0OF5BMl5BanBnXkFtZTcwMzIyOTIyMw@@._V1_SX300.jpg",
		"plot": "When a male neurotic best-selling author on love finds his fiancÃ© with another man, he's sent into a tailspin reflecting on his numerous romantic failures only to find hope again with a quirky antiquarian bookseller",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1612319",
		"imdbID": "tt1612319",
		"title": "Re-Kill",
		"year": "2015",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Action, Horror, Sci-Fi",
		"released": "2015-10-16",
		"director": "Valeri Milev",
		"writer": "Michael Hurst",
		"cast": "Bruce Payne, Mark Adams, Scott Adkins, Daniella Alonso",
		"metacritic": "",
		"imdbRating": "5.2",
		"imdbVotes": "1134",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTMxNDk5OTUxMl5BMl5BanBnXkFtZTcwNTMzNjM1NA@@._V1_SX300.jpg",
		"plot": "It's been 5 years since the outbreak that wiped out 85% of the world's population, but the war between Re-Animates (Re-Ans) and Humans wages on. Most of the major cities are still ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1618432",
		"imdbID": "tt1618432",
		"title": "I'm in Love with a Church Girl",
		"year": "2013",
		"rating": "PG",
		"runtime": "118 min",
		"genre": "Drama, Romance",
		"released": "2013-12-06",
		"director": "Steve Race",
		"writer": "Galley Molina",
		"cast": "Zahn McClarnon, Michael Madsen, Stephen Baldwin, Martin Kove",
		"metacritic": "23",
		"imdbRating": "4.3",
		"imdbVotes": "1112",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU3MjA1MjY1NV5BMl5BanBnXkFtZTcwOTMxOTg3OQ@@._V1_SX300.jpg",
		"plot": "Miles Montego (Ja Rule) has it all - cars, boats, good looks, mansion, money, women, but more importantly, he has a past. Miles is a retired high level drug trafficker who is now completely...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1623205",
		"imdbID": "tt1623205",
		"title": "Oz the Great and Powerful",
		"year": "2013",
		"rating": "PG",
		"runtime": "130 min",
		"genre": "Adventure, Family, Fantasy",
		"released": "2013-03-08",
		"director": "Sam Raimi",
		"writer": "Mitchell Kapner (screenplay), David Lindsay-Abaire (screenplay), Mitchell Kapner (screen story), L. Frank Baum (\"Oz\" works)",
		"cast": "James Franco, Mila Kunis, Rachel Weisz, Michelle Williams",
		"metacritic": "44",
		"imdbRating": "6.4",
		"imdbVotes": "169825",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMyMzQ1ODM1MF5BMl5BanBnXkFtZTcwMjE2MTQxOQ@@._V1_SX300.jpg",
		"plot": "A small-time magician is swept away to an enchanted land and is forced into a power struggle between three witches.",
		"language": "English",
		"country": "USA",
		"awards": "5 wins & 31 nominations."
	},
	{
		"id": "1623745",
		"imdbID": "tt1623745",
		"title": "Little Birds",
		"year": "2011",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Drama",
		"released": "2016-01-09",
		"director": "Elgin James",
		"writer": "Elgin James",
		"cast": "Juno Temple, Kay Panabaker, Kate Bosworth, Neal McDonough",
		"metacritic": "41",
		"imdbRating": "6.2",
		"imdbVotes": "3790",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM2MjYwNDQyMV5BMl5BanBnXkFtZTcwOTQ4OTM2Nw@@._V1_SX300.jpg",
		"plot": "Lily and Alison face a life-changing event after they leave their Salton Sea home and follow the boys they meet back to Los Angeles.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 2 nominations."
	},
	{
		"id": "1630529",
		"imdbID": "tt1630529",
		"title": "Clonehunter",
		"year": "2012",
		"rating": "R",
		"runtime": "85 min",
		"genre": "Sci-Fi",
		"released": "2015-04-20",
		"director": "Andrew Bellware",
		"writer": "Eric Steele",
		"cast": "Tzaddi Allick, Jef Betz, Greg Oliver Bodine, H.R. Britton",
		"metacritic": "",
		"imdbRating": "2.5",
		"imdbVotes": "161",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc1ODk0MTQ0Nl5BMl5BanBnXkFtZTgwODM2NDA2MDE@._V1_SX300.jpg",
		"plot": "2525 A.D. Man has colonized the stars. The wealthy and powerful implant their brains in cloned versions of themselves to gain immortality. As a side-effect, occasionally a clone develops ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1639397",
		"imdbID": "tt1639397",
		"title": "Once Upon a Time in Queens",
		"year": "2013",
		"rating": "R",
		"runtime": "98 min",
		"genre": "Comedy, Drama",
		"released": "2013-06-08",
		"director": "Dave Rodriguez",
		"writer": "Dave Rodriguez",
		"cast": "Paul Sorvino, Michael Rapaport, Renee Props, Andrea Kelly",
		"metacritic": "",
		"imdbRating": "6.1",
		"imdbVotes": "281",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYyMzg3MDg1MF5BMl5BanBnXkFtZTgwNTI3NjczMzE@._V1_SX300.jpg",
		"plot": "Recently released from prison, an ex-mafia boss tries not to fall into his old habits, but surviving outside of the mafia is harder than it seems.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1647668",
		"imdbID": "tt1647668",
		"title": "Million Dollar Arm",
		"year": "2014",
		"rating": "PG",
		"runtime": "124 min",
		"genre": "Biography, Drama, Sport",
		"released": "2014-05-16",
		"director": "Craig Gillespie",
		"writer": "Tom McCarthy (screenplay)",
		"cast": "Jon Hamm, Pitobash, Suraj Sharma, Madhur Mittal",
		"metacritic": "56",
		"imdbRating": "7.1",
		"imdbVotes": "32986",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM1OTUwOTA0M15BMl5BanBnXkFtZTgwMTA0Nzk4MjE@._V1_SX300.jpg",
		"plot": "A sports agent stages an unconventional recruitment strategy to get talented Indian cricket players to play Major League Baseball.",
		"language": "English, Hindi",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "1650041",
		"imdbID": "tt1650041",
		"title": "Bloodline",
		"year": "2013",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Horror",
		"released": "2013-09-27",
		"director": "Matt Thompson",
		"writer": "Matt Thompson",
		"cast": "Matt Thompson, Kimberly Alexander, Jesse Kristofferson, Gina Comparetto",
		"metacritic": "",
		"imdbRating": "3.9",
		"imdbVotes": "228",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQxMjc5NjgxNV5BMl5BanBnXkFtZTgwNzAzMDEwMDE@._V1_SX300.jpg",
		"plot": "A seminary student discovers his bloodline is sought by evil.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1650393",
		"imdbID": "tt1650393",
		"title": "C.O.G.",
		"year": "2013",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Comedy, Drama",
		"released": "2013-01-20",
		"director": "Kyle Patrick Alvarez",
		"writer": "Kyle Patrick Alvarez, David Sedaris (essay)",
		"cast": "Jonathan Groff, Tyra Richards, Beth Furumasu, Keiko Green",
		"metacritic": "60",
		"imdbRating": "5.6",
		"imdbVotes": "2858",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTExODkwNTAzODBeQTJeQWpwZ15BbWU3MDAzNzE4OTk@._V1_SX300.jpg",
		"plot": "A cocky young man travels to Oregon to work on an apple farm. Out of his element, he finds his lifestyle and notions being picked apart by everyone who crosses his path.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "1658801",
		"imdbID": "tt1658801",
		"title": "Freeheld",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "103 min",
		"genre": "Biography, Drama, Romance",
		"released": "2015-11-05",
		"director": "Peter Sollett",
		"writer": "Ron Nyswaner (screenplay)",
		"cast": "Steve Carell, Julianne Moore, Michael Shannon, Ellen Page",
		"metacritic": "50",
		"imdbRating": "6.2",
		"imdbVotes": "889",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzM5NTg3NjU1MV5BMl5BanBnXkFtZTgwNzAwMjA3NjE@._V1_SX300.jpg",
		"plot": "New Jersey police lieutenant, Laurel Hester, and her registered domestic partner, Stacie Andree, both battle to secure Hester's pension benefits when she is diagnosed with terminal cancer.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "1661382",
		"imdbID": "tt1661382",
		"title": "Grudge Match",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "113 min",
		"genre": "Comedy, Sport",
		"released": "2013-12-25",
		"director": "Peter Segal",
		"writer": "Tim Kelleher (screenplay), Rodney Rothman (screenplay), Tim Kelleher (story)",
		"cast": "Jim Lampley, Sylvester Stallone, Robert De Niro, Rich Little",
		"metacritic": "35",
		"imdbRating": "6.4",
		"imdbVotes": "43447",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY3NTkxMTgzNV5BMl5BanBnXkFtZTgwNjg0MzE2MDE@._V1_SX300.jpg",
		"plot": "A pair of aging boxing rivals are coaxed out of retirement to fight one final bout -- 30 years after their last match.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "1661820",
		"imdbID": "tt1661820",
		"title": "Cut Bank",
		"year": "2014",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Thriller",
		"released": "2015-04-03",
		"director": "Matt Shakman",
		"writer": "Roberto Patino",
		"cast": "Liam Hemsworth, Teresa Palmer, Billy Bob Thornton, Bruce Dern",
		"metacritic": "44",
		"imdbRating": "6.0",
		"imdbVotes": "6167",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzk2NDg2MDEwNV5BMl5BanBnXkFtZTgwNDk2Mjk0NDE@._V1_SX300.jpg",
		"plot": "A young man's life is unraveled after witnessing a murder that he filmed in his rural town of Cut Bank.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "1662293",
		"imdbID": "tt1662293",
		"title": "Nothing Left to Fear",
		"year": "2013",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Horror",
		"released": "2013-09-26",
		"director": "Anthony Leonardi III",
		"writer": "Jonathan W.C. Mills",
		"cast": "Anne Heche, James Tupper, Ethan Peck, Rebekah Brandes",
		"metacritic": "12",
		"imdbRating": "4.4",
		"imdbVotes": "3802",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU3NjE5NDk2OF5BMl5BanBnXkFtZTgwNjExNzUzMDE@._V1_SX300.jpg",
		"plot": "A family's journey toward a better life is interrupted by an unstable man of the cloth.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1662295",
		"imdbID": "tt1662295",
		"title": "Brawler",
		"year": "2011",
		"rating": "R",
		"runtime": "84 min",
		"genre": "Drama",
		"released": "2013-03-28",
		"director": "Chris Sivertson",
		"writer": "Chris Sivertson (screenplay), Nathan Grubbs (story)",
		"cast": "Nathan Grubbs, Marc Senter, Pell James, Dane Rhodes",
		"metacritic": "",
		"imdbRating": "3.9",
		"imdbVotes": "273",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDQzOTc5NDExNV5BMl5BanBnXkFtZTcwNzI2MzUzOA@@._V1_SX300.jpg",
		"plot": "After a devastating betrayal, two brothers return to the underground fight club scene in New Orleans and prepare to battle to the death.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1663202",
		"imdbID": "tt1663202",
		"title": "The Revenant",
		"year": "2015",
		"rating": "R",
		"runtime": "156 min",
		"genre": "Adventure, Drama, Thriller",
		"released": "2016-01-08",
		"director": "Alejandro González Iñárritu",
		"writer": "Mark L. Smith (screenplay), Alejandro González Iñárritu (screenplay), Michael Punke (based in part on the novel by)",
		"cast": "Leonardo DiCaprio, Tom Hardy, Domhnall Gleeson, Will Poulter",
		"metacritic": "77",
		"imdbRating": "8.3",
		"imdbVotes": "86285",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjU4NDExNDM1NF5BMl5BanBnXkFtZTgwMDIyMTgxNzE@._V1_SX300.jpg",
		"plot": "A frontiersman on a fur trading expedition in the 1820's fights for survival after being mauled by a bear and left for dead by members of his own hunting team.",
		"language": "English, French, Pawnee",
		"country": "USA",
		"awards": "Nominated for 12 Oscars. Another 29 wins & 118 nominations."
	},
	{
		"id": "1663207",
		"imdbID": "tt1663207",
		"title": "Life of Crime",
		"year": "2013",
		"rating": "R",
		"runtime": "98 min",
		"genre": "Comedy, Crime",
		"released": "2014-08-29",
		"director": "Daniel Schechter",
		"writer": "Daniel Schechter (written for the screen by), Elmore Leonard (based on the book \"The Switch\" written by)",
		"cast": "Jennifer Aniston, Yasiin Bey, Isla Fisher, Will Forte",
		"metacritic": "60",
		"imdbRating": "5.8",
		"imdbVotes": "11431",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE0NzQ1OTEwOV5BMl5BanBnXkFtZTgwMTY0MzUxMjE@._V1_SX300.jpg",
		"plot": "Two common criminals get more than they bargained for after kidnapping the wife of a corrupt real-estate developer who shows no interest in paying the $1 million dollar ransom for her safe return.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1666801",
		"imdbID": "tt1666801",
		"title": "The DUFF",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "101 min",
		"genre": "Comedy",
		"released": "2015-02-20",
		"director": "Ari Sandel",
		"writer": "Josh A. Cagan (screenplay), Kody Keplinger (novel)",
		"cast": "Mae Whitman, Robbie Amell, Bella Thorne, Bianca A. Santos",
		"metacritic": "56",
		"imdbRating": "6.6",
		"imdbVotes": "42927",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc3OTg3MDUwN15BMl5BanBnXkFtZTgwMTAwMTkxNDE@._V1_SX300.jpg",
		"plot": "A high school senior instigates a social pecking order revolution after finding out that she has been labeled the DUFF - Designated Ugly Fat Friend - by her prettier, more popular counterparts.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 5 nominations."
	},
	{
		"id": "1681368",
		"imdbID": "tt1681368",
		"title": "A Free Bird",
		"year": "2014",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Comedy",
		"released": "2014-11-01",
		"director": "Gregg Russell",
		"writer": "Gregg Russell",
		"cast": "Russell Durham Comegys, Karen-Eileen Gordon, George Faughnan, Beau Marie",
		"metacritic": "",
		"imdbRating": "7.9",
		"imdbVotes": "53",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODg4MjIxMTE4N15BMl5BanBnXkFtZTcwNDY2NzY1OA@@._V1_SX300.jpg",
		"plot": "All JT wants is his freedom and a cigarette. But these are hard times: the steakhouse just fired him, his car broke down, he's broke. So when his buddies plan to rob the steakhouse - to ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1684548",
		"imdbID": "tt1684548",
		"title": "Axe Giant: The Wrath of Paul Bunyan",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Fantasy, Horror",
		"released": "2013-06-18",
		"director": "Gary Jones",
		"writer": "Jeff Miller (screenplay), Gary Jones (screenplay), Jason Ancona (screenplay), Gary Jones (story), Jeff Miller (story)",
		"cast": "Amber Connor, Joe Estevez, Dan Haggerty, Thomas Downey",
		"metacritic": "",
		"imdbRating": "3.5",
		"imdbVotes": "789",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDYyNDY4NDk3MV5BMl5BanBnXkFtZTgwMzg4NDA2MDE@._V1_SX300.jpg",
		"plot": "Young adults at a first-time offenders' boot camp discover the legend of the giant lumberjack Paul Bunyan is real, but is much more horrifying than they could have imagined.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1690545",
		"imdbID": "tt1690545",
		"title": "All American Zombie Drugs",
		"year": "2010",
		"rating": "PG-13",
		"runtime": "99 min",
		"genre": "Adventure, Comedy, Crime",
		"released": "2013-04-23",
		"director": "Alex Ballar",
		"writer": "Alex Ballar",
		"cast": "Beau Nelson, Wolfgang Weber, Susan Graham, Natalie Irby",
		"metacritic": "",
		"imdbRating": "3.4",
		"imdbVotes": "201",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI0Njk1MDI0OV5BMl5BanBnXkFtZTcwNzQ3NzQxOQ@@._V1_SX300.jpg",
		"plot": "Vinny and Sebastion, two burnouts, going nowhere in small town suburbia and still riding the high of their high-school days, start a business doing the only thing they have ever excelled at...",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 2 nominations."
	},
	{
		"id": "1690953",
		"imdbID": "tt1690953",
		"title": "Despicable Me 2",
		"year": "2013",
		"rating": "PG",
		"runtime": "98 min",
		"genre": "Animation, Comedy, Family",
		"released": "2013-07-03",
		"director": "Pierre Coffin, Chris Renaud",
		"writer": "Cinco Paul, Ken Daurio",
		"cast": "Steve Carell, Kristen Wiig, Benjamin Bratt, Miranda Cosgrove",
		"metacritic": "62",
		"imdbRating": "7.5",
		"imdbVotes": "268401",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjExNjAyNTcyMF5BMl5BanBnXkFtZTgwODQzMjQ3MDE@._V1_SX300.jpg",
		"plot": "When Gru, the world's most super-bad turned super-dad has been recruited by a team of officials to stop lethal muscle and a host of Gru's own, He has to fight back with new gadgetry, cars, and more minion madness.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 2 Oscars. Another 12 wins & 62 nominations."
	},
	{
		"id": "1698641",
		"imdbID": "tt1698641",
		"title": "Alexander and the Terrible, Horrible, No Good, Very Bad Day",
		"year": "2014",
		"rating": "PG",
		"runtime": "81 min",
		"genre": "Comedy, Family",
		"released": "2014-10-10",
		"director": "Miguel Arteta",
		"writer": "Rob Lieber (screenplay), Rob Lieber (screen story), Judith Viorst (book)",
		"cast": "Steve Carell, Jennifer Garner, Ed Oxenbould, Dylan Minnette",
		"metacritic": "54",
		"imdbRating": "6.2",
		"imdbVotes": "26741",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTgxMDMxMTY5OV5BMl5BanBnXkFtZTgwMjY1NzYzMjE@._V1_SX300.jpg",
		"plot": "Alexander's day begins with gum stuck in his hair, followed by more calamities. However, he finds little sympathy from his family and begins to wonder if bad things only happen to him, his mom, dad, brother and sister - who all find themselves living through their own terrible, horrible, no good, very bad day.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 5 nominations."
	},
	{
		"id": "1698648",
		"imdbID": "tt1698648",
		"title": "Girl Most Likely",
		"year": "2012",
		"rating": "PG-13",
		"runtime": "103 min",
		"genre": "Comedy",
		"released": "2013-07-18",
		"director": "Shari Springer Berman, Robert Pulcini",
		"writer": "Michelle Morgan",
		"cast": "Kristen Wiig, Annette Bening, Matt Dillon, Darren Criss",
		"metacritic": "38",
		"imdbRating": "5.8",
		"imdbVotes": "11782",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTEyMDgyNDYwNjReQTJeQWpwZ15BbWU3MDc1MDQwNjk@._V1_SX300.jpg",
		"plot": "A failed New York playwright awkwardly navigates the transition from Next Big Thing to Last Year's News.",
		"language": "English, Romanian",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1698651",
		"imdbID": "tt1698651",
		"title": "American Idiots",
		"year": "2013",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Comedy, Romance",
		"released": "2013-06-18",
		"director": "Robert Taleghany",
		"writer": "Jeffrey T. Schoettlin",
		"cast": "Jeffrey T. Schoettlin, Sean Muramatsu, Caroline D'Amore, Nick Faltas",
		"metacritic": "",
		"imdbRating": "2.2",
		"imdbVotes": "599",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM4NTE1NjU0N15BMl5BanBnXkFtZTcwMzYzMzE2OQ@@._V1_SX300.jpg",
		"plot": "Four friends embark on a cross-country journey to Las Vegas in an old RV to stop a wedding and save a friend from losing the love of his life.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1711425",
		"imdbID": "tt1711425",
		"title": "21 & Over",
		"year": "2013",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Comedy",
		"released": "2013-03-01",
		"director": "Jon Lucas, Scott Moore",
		"writer": "Jon Lucas, Scott Moore",
		"cast": "Miles Teller, Skylar Astin, Justin Chon, Sarah Wright",
		"metacritic": "34",
		"imdbRating": "5.9",
		"imdbVotes": "57720",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI0NTExOTI0N15BMl5BanBnXkFtZTcwMDA0ODE3OA@@._V1_SX300.jpg",
		"plot": "The night before his big medical school interview, a promising student celebrates his 21st birthday with his two best friends.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "1716767",
		"imdbID": "tt1716767",
		"title": "The Last Keepers",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "85 min",
		"genre": "Family, Fantasy",
		"released": "2013-04-25",
		"director": "Maggie Greenwald",
		"writer": "Peter Hutchings, Christina Mengert, Claude Dal Farra (story)",
		"cast": "Aidan Quinn, Virginia Madsen, Zosia Mamet, Olympia Dukakis",
		"metacritic": "",
		"imdbRating": "5.3",
		"imdbVotes": "1092",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjQ5NjcwNzE5OF5BMl5BanBnXkFtZTgwMjg5NTM5MTE@._V1_SX300.jpg",
		"plot": "When the teenage daughter of a reclusive family of artists falls in love with an unusual boy at school, she awakens mysterious powers and discovers ancient family secrets that will change her life forever.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1718158",
		"imdbID": "tt1718158",
		"title": "Generation Um...",
		"year": "2012",
		"rating": "R",
		"runtime": "97 min",
		"genre": "Drama",
		"released": "2013-05-28",
		"director": "Mark Mann",
		"writer": "Mark Mann (screenplay)",
		"cast": "Keanu Reeves, Bojana Novakovic, Daniel Sunjata, Adelaide Clemens",
		"metacritic": "25",
		"imdbRating": "4.0",
		"imdbVotes": "2861",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY2OTk0MzQzNF5BMl5BanBnXkFtZTcwNTQxNTgxOQ@@._V1_SX300.jpg",
		"plot": "Three adults during a single day in New York City, one filled with sex, drugs, and indecision.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1727776",
		"imdbID": "tt1727776",
		"title": "Scouts Guide to the Zombie Apocalypse",
		"year": "2015",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Comedy, Horror",
		"released": "2015-10-30",
		"director": "Christopher Landon",
		"writer": "Carrie Lee Wilson (screenplay), Emi Mochizuki (screenplay), Christopher Landon (screenplay), Lona Williams (story)",
		"cast": "Tye Sheridan, Logan Miller, Joey Morgan, Sarah Dumont",
		"metacritic": "32",
		"imdbRating": "6.3",
		"imdbVotes": "10305",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY4NjczNjE4OV5BMl5BanBnXkFtZTgwODk0MjQ5NjE@._V1_SX300.jpg",
		"plot": "Three scouts, on the eve of their last camp-out, discover the true meaning of friendship when they attempt to save their town from a zombie outbreak.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1731141",
		"imdbID": "tt1731141",
		"title": "Ender's Game",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "114 min",
		"genre": "Action, Sci-Fi",
		"released": "2013-11-01",
		"director": "Gavin Hood",
		"writer": "Gavin Hood (screenplay), Orson Scott Card (based on the book Ender's Game by)",
		"cast": "Asa Butterfield, Harrison Ford, Hailee Steinfeld, Abigail Breslin",
		"metacritic": "51",
		"imdbRating": "6.7",
		"imdbVotes": "174247",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAzMzI5OTgzMl5BMl5BanBnXkFtZTgwMTU5MTAwMDE@._V1_SX300.jpg",
		"plot": "Young Ender Wiggin is recruited by the International Military to lead the fight against the Formics, a genocidal alien race which nearly annihilated the human race in a previous invasion.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 6 nominations."
	},
	{
		"id": "1731701",
		"imdbID": "tt1731701",
		"title": "Barely Lethal",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "96 min",
		"genre": "Action, Adventure, Comedy",
		"released": "2015-04-30",
		"director": "Kyle Newman",
		"writer": "John D'Arco",
		"cast": "Jaime King, Samuel L. Jackson, Madeleine Stack, Eva G. Cooper",
		"metacritic": "44",
		"imdbRating": "5.3",
		"imdbVotes": "8790",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM4MzYyMjI1MV5BMl5BanBnXkFtZTgwMjE0Mzg2NTE@._V1_SX300.jpg",
		"plot": "A teenage special ops agent coveting a \"normal\" adolescence fakes her own death and enrolls in a suburban high school. She quickly learns that surviving the treacherous waters of high school is more challenging than international espionage.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1736049",
		"imdbID": "tt1736049",
		"title": "A Place at the Table",
		"year": "2012",
		"rating": "PG",
		"runtime": "84 min",
		"genre": "Documentary",
		"released": "2013-03-01",
		"director": "Kristi Jacobson, Lori Silverbush",
		"writer": "",
		"cast": "Adam Appelhanz, David Beckmann, Joel Berg, William Booker",
		"metacritic": "68",
		"imdbRating": "6.8",
		"imdbVotes": "910",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTg1NTk5MDU0N15BMl5BanBnXkFtZTcwNzA0ODE4OA@@._V1_SX300.jpg",
		"plot": "A documentary that investigates incidents of hunger experienced by millions of Americans, and proposed solutions to the problem.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "1745784",
		"imdbID": "tt1745784",
		"title": "Girl Meets Boy",
		"year": "2013",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Comedy",
		"released": "2013-06-04",
		"director": "Damion Stephens",
		"writer": "Damion Stephens (screenplay)",
		"cast": "Ben Savage, Anna Pheil, Richard Riehle, Janet Wood",
		"metacritic": "",
		"imdbRating": "3.8",
		"imdbVotes": "169",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAyMjU4Mzc3NV5BMl5BanBnXkFtZTgwMTc3MjIwMDE@._V1_SX300.jpg",
		"plot": "Looking for inspiration, a wild LA Musician and buttoned up novelist (Ben Savage) will unexpectedly end up double booked at a remote cabin retreat. Sparks will fly when this odd couple is ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1747967",
		"imdbID": "tt1747967",
		"title": "Cassadaga",
		"year": "2011",
		"rating": "R",
		"runtime": "108 min",
		"genre": "Horror, Thriller",
		"released": "2013-10-11",
		"director": "Anthony DiBlasi",
		"writer": "Bruce Wood (story), Bruce Wood (screenplay), Scott Poiley (screenplay)",
		"cast": "Kelen Coleman, Kevin Alejandro, Louise Fletcher, Rus Blackwell",
		"metacritic": "32",
		"imdbRating": "5.3",
		"imdbVotes": "2489",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUwNjk4OTI0MF5BMl5BanBnXkFtZTgwNDMzMzUzMDE@._V1_SX300.jpg",
		"plot": "A deaf woman who resurrects the ghost of a murdered young woman is forced by the spirit to a serial killer who turns his female victims into marionette dolls.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1748016",
		"imdbID": "tt1748016",
		"title": "Brother's Keeper",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "118 min",
		"genre": "Drama",
		"released": "2015-05-29",
		"director": "T.J. Amato, Josh Mills",
		"writer": "Briana Hartman, Josh Mills (developer)",
		"cast": "Michael Rooker, Ray Wise, Travis Tritt, W. Earl Brown",
		"metacritic": "",
		"imdbRating": "5.0",
		"imdbVotes": "277",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM2NzE1ODIyMF5BMl5BanBnXkFtZTcwMDkwNDYwNA@@._V1_SX300.jpg",
		"plot": "Identical twins Andy and Pete Goodwynn have always been there for each other. But in a cruel twist of fate-orchestrated by the town's most powerful family-their lives are forever altered. ...",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 3 nominations."
	},
	{
		"id": "1748199",
		"imdbID": "tt1748199",
		"title": "Silver Circle",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "90 min",
		"genre": "Animation, Thriller",
		"released": "2013-03-22",
		"director": "Pasha Roberts",
		"writer": "Steven Schwartz (screenplay)",
		"cast": "De'Lon Grant, Philana Mia, Peter Berkrot, Victor Shopov",
		"metacritic": "21",
		"imdbRating": "6.2",
		"imdbVotes": "63",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTcyODE5NTIzN15BMl5BanBnXkFtZTcwNTEyODMwNA@@._V1_SX300.jpg",
		"plot": "At the center of corruption is the Federal Reserve who has gained enormous amounts of control over America's economy, with disastrous effects beginning to show. Standing opposite, is the ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1748260",
		"imdbID": "tt1748260",
		"title": "Tiger Eyes",
		"year": "2012",
		"rating": "PG-13",
		"runtime": "92 min",
		"genre": "Drama",
		"released": "2013-06-07",
		"director": "Lawrence Blume",
		"writer": "Judy Blume (novel), Lawrence Blume (screenplay)",
		"cast": "Willa Holland, Amy Jo Johnson, Tatanka Means, Elise Eberle",
		"metacritic": "56",
		"imdbRating": "6.4",
		"imdbVotes": "1436",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ5NDg2ODkyMF5BMl5BanBnXkFtZTcwNTEwNjM0OQ@@._V1_SX300.jpg",
		"plot": "After Davey's father is killed in a hold-up, she and her mother and younger brother visit relatives in New Mexico. Here Davey is befriended by a young man who helps her find the strength to carry on and conquer her fears.",
		"language": "English",
		"country": "USA",
		"awards": "4 wins & 1 nomination."
	},
	{
		"id": "1754811",
		"imdbID": "tt1754811",
		"title": "InAPPropriate Comedy",
		"year": "2013",
		"rating": "R",
		"runtime": "83 min",
		"genre": "Comedy",
		"released": "2014-07-17",
		"director": "Vince Offer",
		"writer": "Ken Pringle, Ari Shaffir, Vince Offer, Adrien Brody (additional dialogue written by), Christina Pazsitzky (additional dialogue written by), John Ryan Jr. (additional dialogue written by), Dante (additional dialogue written by)",
		"cast": "Rob Schneider, Michelle Rodriguez, Adrien Brody, Lindsay Lohan",
		"metacritic": "1",
		"imdbRating": "2.9",
		"imdbVotes": "3292",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ3NzAyMDUyOF5BMl5BanBnXkFtZTcwMDMzMDM5OA@@._V1_SX300.jpg",
		"plot": "In this comedy film, a computer tablet full of the world's most hilariously offensive apps breaks through the borders of political correctness, stirring up cultural anarchy.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "1757746",
		"imdbID": "tt1757746",
		"title": "Extracted",
		"year": "2012",
		"rating": "R",
		"runtime": "85 min",
		"genre": "Drama, Sci-Fi",
		"released": "2013-09-09",
		"director": "Nir Paniry",
		"writer": "Nir Paniry, Gabriel Cowan (story), Nir Paniry (story), John Suits (story)",
		"cast": "Sasha Roiz, Jenny Mollen, Dominic Bogart, Richard Riehle",
		"metacritic": "",
		"imdbRating": "6.5",
		"imdbVotes": "9254",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ3MzExNjczOF5BMl5BanBnXkFtZTcwMTE3Mjg4OQ@@._V1_SX300.jpg",
		"plot": "A scientist who has invented a technique to watch people's memories finds himself in a dangerous situation after he's tasked with entering a heroin addict's mind to see whether the man committed murder.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1758795",
		"imdbID": "tt1758795",
		"title": "The To Do List",
		"year": "2013",
		"rating": "R",
		"runtime": "104 min",
		"genre": "Comedy",
		"released": "2013-07-26",
		"director": "Maggie Carey",
		"writer": "Maggie Carey (screenplay)",
		"cast": "Aubrey Plaza, Johnny Simmons, Bill Hader, Alia Shawkat",
		"metacritic": "61",
		"imdbRating": "5.8",
		"imdbVotes": "27796",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODg4ODYxMTk2NV5BMl5BanBnXkFtZTcwNzYxMTI5OQ@@._V1_SX300.jpg",
		"plot": "Feeling pressured to become more sexually experienced before she goes to college, Brandy Klark makes a list of things to accomplish before hitting campus in the fall.",
		"language": "English, Sanskrit",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1761005",
		"imdbID": "tt1761005",
		"title": "Persecuted",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "91 min",
		"genre": "Action, Drama, Mystery",
		"released": "2014-07-18",
		"director": "Daniel Lusko",
		"writer": "Daniel Lusko",
		"cast": "James Remar, Raoul Max Trujillo, Dean Stockwell, Bruce Davison",
		"metacritic": "11",
		"imdbRating": "3.5",
		"imdbVotes": "1092",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzNjg2MTY4N15BMl5BanBnXkFtZTgwNzE1NDc3MTE@._V1_SX300.jpg",
		"plot": "An evangelist finds himself framed for murder and on the run after he refuses to back a senator's proposition calling for sweeping religious reform.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1763288",
		"imdbID": "tt1763288",
		"title": "Stripped",
		"year": "2013",
		"rating": "R",
		"runtime": "80 min",
		"genre": "Comedy, Horror, Thriller",
		"released": "2013-05-14",
		"director": "Mark LaFleur, J.M.R. Luna",
		"writer": "Andrew Caldwell, Josh Cole (story), Nicole Sienna (story)",
		"cast": "Nicole Sienna, Josh Cole, Carson Aune, Alvaro Orlando",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "1208",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY0Njg3ODc4NV5BMl5BanBnXkFtZTgwNjY5MjI1MDE@._V1_SX300.jpg",
		"plot": "Four friends head to Vegas for a 21st birthday in hopes of finding adventure, debauchery and memories that will last them a lifetime. Cameron, the scandalous one of the group decides to ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1763303",
		"imdbID": "tt1763303",
		"title": "The First Time",
		"year": "2012",
		"rating": "PG-13",
		"runtime": "95 min",
		"genre": "Comedy, Drama, Romance",
		"released": "2013-02-07",
		"director": "Jon Kasdan",
		"writer": "Jon Kasdan",
		"cast": "Britt Robertson, Dylan O'Brien, Craig Roberts, Joshua Malina",
		"metacritic": "55",
		"imdbRating": "7.0",
		"imdbVotes": "44530",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMxNDI1OTY5NF5BMl5BanBnXkFtZTcwMDExOTY1OA@@._V1_SX300.jpg",
		"plot": "A shy senior and a down-to-earth junior fall in love over the weekend.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1764215",
		"imdbID": "tt1764215",
		"title": "Bullseye",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "85 min",
		"genre": "Action, Comedy, Crime",
		"released": "2014-06-01",
		"director": "Alex Prister",
		"writer": "Alex Prister",
		"cast": "Steve Rimpici, Tiffany Lloyd, Robert Werner, Aaron Liebman",
		"metacritic": "",
		"imdbRating": "6.0",
		"imdbVotes": "6",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg1NTc0NDg3N15BMl5BanBnXkFtZTcwODMyODQxNA@@._V1_SX300.jpg",
		"plot": "It's the year 1935 and Private Detective Dick Polakowski has recently bankrupted Charlie's Casino, the city's headquarters of organized crime. Charlie Rodriguez and the Charlie Brothers ran...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1764647",
		"imdbID": "tt1764647",
		"title": "Shadow People",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "89 min",
		"genre": "Horror, Thriller",
		"released": "2013-03-19",
		"director": "Matthew Arnold",
		"writer": "Matthew Arnold, Matthew Arnold (story), Travis Rooks (story)",
		"cast": "Dallas Roberts, Alison Eastwood, Anne Dudek, Mariah Bonner",
		"metacritic": "",
		"imdbRating": "5.3",
		"imdbVotes": "2292",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTYwMDk1MzY2N15BMl5BanBnXkFtZTcwNDk5OTU1OQ@@._V1_SX300.jpg",
		"plot": "A radio talk show host unravels a conspiracy about encounters with mysterious beings known as The Shadow People and their role in the unexplained deaths of several hundred victims in the 1980s.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1764666",
		"imdbID": "tt1764666",
		"title": "The Little Engine That Could",
		"year": "2011",
		"rating": "G",
		"runtime": "83 min",
		"genre": "Animation, Family",
		"released": "2015-11-21",
		"director": "Elliot M. Bour",
		"writer": "David Koepp (screenplay), John Kamps (screenplay), Cliff Ruby (screenplay), Elana Lesser (screenplay), David Koepp (screen story), John Kamps (screen story), Watty Piper (book)",
		"cast": "Jodi Benson, Corbin Bleu, Jamie Lee Curtis, Whoopi Goldberg",
		"metacritic": "",
		"imdbRating": "5.5",
		"imdbVotes": "200",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQyOTc4NzYwOF5BMl5BanBnXkFtZTcwNTI1MjM5Nw@@._V1_SX300.jpg",
		"plot": "Featuring an all-star cast, the timeless story comes to life in this all-new, feature-length film filled with fun and adventure!",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "1777595",
		"imdbID": "tt1777595",
		"title": "50 to 1",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "110 min",
		"genre": "Drama",
		"released": "2014-03-21",
		"director": "Jim Wilson",
		"writer": "Faith Conroy, Jim Wilson",
		"cast": "Skeet Ulrich, Christian Kane, William Devane, Madelyn Deutch",
		"metacritic": "37",
		"imdbRating": "6.6",
		"imdbVotes": "1164",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTQ0MDc0NTQ1OV5BMl5BanBnXkFtZTgwNDY2NjU3MDE@._V1_SX300.jpg",
		"plot": "A misfit group of New Mexico cowboys find themselves on the journey of a lifetime when their crooked-footed racehorse qualifies for the Kentucky Derby. Based on the inspiring true story of ...",
		"language": "English, Portuguese",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1783732",
		"imdbID": "tt1783732",
		"title": "John Dies at the End",
		"year": "2012",
		"rating": "R",
		"runtime": "99 min",
		"genre": "Comedy, Horror, Sci-Fi",
		"released": "2013-01-25",
		"director": "Don Coscarelli",
		"writer": "Don Coscarelli (written for the screen by), David Wong (based on the story by)",
		"cast": "Chase Williamson, Rob Mayes, Paul Giamatti, Clancy Brown",
		"metacritic": "53",
		"imdbRating": "6.4",
		"imdbVotes": "28284",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUyNzIyNzc0MV5BMl5BanBnXkFtZTcwOTM5ODg1OA@@._V1_SX300.jpg",
		"plot": "A new street drug that sends its users across time and dimensions has one drawback: some people return as no longer human. Can two college dropouts save humankind from this silent, otherworldly invasion?",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 6 nominations."
	},
	{
		"id": "1786751",
		"imdbID": "tt1786751",
		"title": "CBGB",
		"year": "2013",
		"rating": "R",
		"runtime": "101 min",
		"genre": "Drama, Music",
		"released": "2013-10-11",
		"director": "Randall Miller",
		"writer": "Jody Savin, Randall Miller",
		"cast": "Alan Rickman, Malin Akerman, Justin Bartha, Richard de Klerk",
		"metacritic": "30",
		"imdbRating": "6.5",
		"imdbVotes": "5298",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg1NDcxODY0OV5BMl5BanBnXkFtZTgwOTgwMzQxMDE@._V1_SX300.jpg",
		"plot": "A look at the New York City punk-rock scene and the venerable nightclub, CBGB.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1790825",
		"imdbID": "tt1790825",
		"title": "Murph: The Protector",
		"year": "2013",
		"rating": "PG",
		"runtime": "79 min",
		"genre": "Documentary",
		"released": "2013-03-22",
		"director": "Scott Mactavish",
		"writer": "Scott Mactavish",
		"cast": "John McElhone, Hector Velez Jr., Jeff Widenhofer, Michael P. Murphy",
		"metacritic": "60",
		"imdbRating": "6.7",
		"imdbVotes": "1327",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkzODAwNTc4MV5BMl5BanBnXkFtZTcwMDM1MTAyOQ@@._V1_SX300.jpg",
		"plot": "A documentary based on the honor, courage and commitment of Navy SEAL LT Michael P. Murphy, who gave his life for his men in 2005 and was posthumously awarded the Medal of Honor in 2007.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1790885",
		"imdbID": "tt1790885",
		"title": "Zero Dark Thirty",
		"year": "2012",
		"rating": "R",
		"runtime": "157 min",
		"genre": "Drama, History, Thriller",
		"released": "2013-01-11",
		"director": "Kathryn Bigelow",
		"writer": "Mark Boal",
		"cast": "Jason Clarke, Reda Kateb, Jessica Chastain, Kyle Chandler",
		"metacritic": "95",
		"imdbRating": "7.4",
		"imdbVotes": "207301",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ4OTUyNzcwN15BMl5BanBnXkFtZTcwMTQ1NDE3OA@@._V1_SX300.jpg",
		"plot": "A chronicle of the decade-long hunt for al-Qaeda terrorist leader Osama bin Laden after the September 2001 attacks, and his death at the hands of the Navy S.E.A.L.s Team 6 in May 2011.",
		"language": "English, Arabic",
		"country": "USA",
		"awards": "Won 1 Oscar. Another 83 wins & 157 nominations."
	},
	{
		"id": "1791528",
		"imdbID": "tt1791528",
		"title": "Inherent Vice",
		"year": "2014",
		"rating": "R",
		"runtime": "148 min",
		"genre": "Comedy, Crime, Drama",
		"released": "2015-01-09",
		"director": "Paul Thomas Anderson",
		"writer": "Paul Thomas Anderson (written for the screen by), Thomas Pynchon (based on the novel by)",
		"cast": "Joanna Newsom, Katherine Waterston, Joaquin Phoenix, Jordan Christian Hearn",
		"metacritic": "81",
		"imdbRating": "6.7",
		"imdbVotes": "53062",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI2ODQ2NzUwMl5BMl5BanBnXkFtZTgwNjU3NTE4MjE@._V1_SX300.jpg",
		"plot": "In 1970, drug-fueled Los Angeles private investigator Larry \"Doc\" Sportello investigates the disappearance of a former girlfriend.",
		"language": "English, Japanese",
		"country": "USA",
		"awards": "Nominated for 2 Oscars. Another 14 wins & 78 nominations."
	},
	{
		"id": "1791682",
		"imdbID": "tt1791682",
		"title": "While We're Young",
		"year": "2014",
		"rating": "R",
		"runtime": "97 min",
		"genre": "Comedy, Drama",
		"released": "2015-04-17",
		"director": "Noah Baumbach",
		"writer": "Noah Baumbach",
		"cast": "Naomi Watts, Ben Stiller, Maria Dizzia, Adam Horovitz",
		"metacritic": "76",
		"imdbRating": "6.4",
		"imdbVotes": "24114",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc4MDEzMTA5MF5BMl5BanBnXkFtZTgwODA5MTM0NDE@._V1_SX300.jpg",
		"plot": "A middle-aged couple's career and marriage are overturned when a disarming young couple enters their lives.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 1 nomination."
	},
	{
		"id": "1800241",
		"imdbID": "tt1800241",
		"title": "American Hustle",
		"year": "2013",
		"rating": "R",
		"runtime": "138 min",
		"genre": "Crime, Drama",
		"released": "2013-12-20",
		"director": "David O. Russell",
		"writer": "Eric Warren Singer, David O. Russell",
		"cast": "Christian Bale, Bradley Cooper, Amy Adams, Jeremy Renner",
		"metacritic": "90",
		"imdbRating": "7.3",
		"imdbVotes": "335421",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjkxMTc0MDc4N15BMl5BanBnXkFtZTgwODUyNTI1MDE@._V1_SX300.jpg",
		"plot": "A con man, Irving Rosenfeld, along with his seductive partner Sydney Prosser, is forced to work for a wild FBI agent, Richie DiMaso, who pushes them into a world of Jersey powerbrokers and mafia.",
		"language": "English, Arabic",
		"country": "USA",
		"awards": "Nominated for 10 Oscars. Another 58 wins & 187 nominations."
	},
	{
		"id": "1800246",
		"imdbID": "tt1800246",
		"title": "That Awkward Moment",
		"year": "2014",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Comedy, Romance",
		"released": "2014-01-31",
		"director": "Tom Gormican",
		"writer": "Tom Gormican",
		"cast": "Zac Efron, Miles Teller, Michael B. Jordan, Imogen Poots",
		"metacritic": "36",
		"imdbRating": "6.1",
		"imdbVotes": "70116",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjExODEyMjMwNV5BMl5BanBnXkFtZTgwMTAyODM1MDE@._V1_SX300.jpg",
		"plot": "Three best friends find themselves where we've all been - at that confusing moment in every dating relationship when you have to decide \"So...where is this going?\"",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "1801096",
		"imdbID": "tt1801096",
		"title": "Sexy Evil Genius",
		"year": "2013",
		"rating": "R",
		"runtime": "91 min",
		"genre": "Comedy, Drama, Mystery",
		"released": "2014-10-22",
		"director": "Shawn Piller",
		"writer": "Scott Lew (screenplay)",
		"cast": "Michelle Trachtenberg, Katee Sackhoff, Anthony Michael Hall, Seth Green",
		"metacritic": "",
		"imdbRating": "5.8",
		"imdbVotes": "2993",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIxMTk2Nzg3Nl5BMl5BanBnXkFtZTcwNDE5NDQyOQ@@._V1_SX300.jpg",
		"plot": "A group of guys are drawn to the same bar in downtown Los Angeles by an ex-girlfriend they all have in common.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1806910",
		"imdbID": "tt1806910",
		"title": "Genius on Hold",
		"year": "2012",
		"rating": "PG",
		"runtime": "91 min",
		"genre": "Documentary",
		"released": "2013-03-01",
		"director": "Gregory Marquette",
		"writer": "Gregory Marquette",
		"cast": "Howard Abadinsky, Nathanial Barone, Marco Ceritelli, Sylvester Glaser",
		"metacritic": "66",
		"imdbRating": "6.7",
		"imdbVotes": "103",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDMwNTExMDYwMl5BMl5BanBnXkFtZTcwMzMzNTM1OA@@._V1_SX300.jpg",
		"plot": "The story of Walter L. Shaw, a telecommunications genius, and his son Walter T. Shaw, a ruthless jewel thief, is a metaphor and a symbol for its time - for the twentieth century and for today.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1809398",
		"imdbID": "tt1809398",
		"title": "Unbroken",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "137 min",
		"genre": "Biography, Drama, Sport",
		"released": "2014-12-25",
		"director": "Angelina Jolie",
		"writer": "Joel Coen (screenplay), Ethan Coen (screenplay), Richard LaGravenese (screenplay), William Nicholson (screenplay), Laura Hillenbrand (book)",
		"cast": "Jack O'Connell, Domhnall Gleeson, Garrett Hedlund, Miyavi",
		"metacritic": "59",
		"imdbRating": "7.2",
		"imdbVotes": "89372",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY3ODg2OTgyOF5BMl5BanBnXkFtZTgwODk1OTAwMzE@._V1_SX300.jpg",
		"plot": "After a near-fatal plane crash in WWII, Olympian Louis Zamperini spends a harrowing 47 days in a raft with two fellow crewmen before he's caught by the Japanese navy and sent to a prisoner-of-war camp.",
		"language": "English, Japanese, Italian",
		"country": "USA",
		"awards": "Nominated for 3 Oscars. Another 12 wins & 25 nominations."
	},
	{
		"id": "1814621",
		"imdbID": "tt1814621",
		"title": "Admission",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "107 min",
		"genre": "Comedy, Drama, Romance",
		"released": "2013-03-22",
		"director": "Paul Weitz",
		"writer": "Karen Croner (screenplay), Jean Hanff Korelitz (based on the novel by)",
		"cast": "Tina Fey, Ann Harada, Ben Levin, Dan Levy",
		"metacritic": "48",
		"imdbRating": "5.7",
		"imdbVotes": "27457",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTE2OTkwNzg5Ml5BMl5BanBnXkFtZTcwOTY0NzQ3OA@@._V1_SX300.jpg",
		"plot": "A Princeton admissions officer who is up for a major promotion takes a professional risk after she meets a college-bound alternative school kid who just might be the son she gave up years ago in a secret adoption.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1817273",
		"imdbID": "tt1817273",
		"title": "The Place Beyond the Pines",
		"year": "2012",
		"rating": "R",
		"runtime": "140 min",
		"genre": "Crime, Drama, Thriller",
		"released": "2013-04-19",
		"director": "Derek Cianfrance",
		"writer": "Derek Cianfrance (story), Ben Coccio (story), Derek Cianfrance (screenplay), Ben Coccio (screenplay), Darius Marder (screenplay)",
		"cast": "Ryan Gosling, Craig Van Hook, Eva Mendes, Olga Merediz",
		"metacritic": "68",
		"imdbRating": "7.3",
		"imdbVotes": "177469",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjc1OTEwNjU4N15BMl5BanBnXkFtZTcwNzUzNDIwOQ@@._V1_SX300.jpg",
		"plot": "A motorcycle stunt rider turns to robbing banks as a way to provide for his lover and their newborn child, a decision that puts him on a collision course with an ambitious rookie cop navigating a department ruled by a corrupt detective.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "3 wins & 18 nominations."
	},
	{
		"id": "1817276",
		"imdbID": "tt1817276",
		"title": "A Resurrection",
		"year": "2013",
		"rating": "R",
		"runtime": "89 min",
		"genre": "Horror, Thriller",
		"released": "2013-03-22",
		"director": "Matt Orlando",
		"writer": "Matt Orlando",
		"cast": "Mischa Barton, Devon Sawa, Michael Clarke Duncan, J. Michael Trautmann",
		"metacritic": "",
		"imdbRating": "3.9",
		"imdbVotes": "1376",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODYzMTMyMjQzN15BMl5BanBnXkFtZTcwNjc4NzQyOQ@@._V1_SX300.jpg",
		"plot": "A murdered boys spirit seeks revenge by seeking six souls to live again.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1817771",
		"imdbID": "tt1817771",
		"title": "Freaks of Nature",
		"year": "2015",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Comedy, Horror",
		"released": "2015-10-30",
		"director": "Robbie Pickering",
		"writer": "Oren Uziel (screenplay)",
		"cast": "Nicholas Braun, Mackenzie Davis, Josh Fadem, Denis Leary",
		"metacritic": "",
		"imdbRating": "5.4",
		"imdbVotes": "152",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk2MTMyMTEzN15BMl5BanBnXkFtZTgwNTE0MDYwNzE@._V1_SX300.jpg",
		"plot": "In the town of Dillford, humans, vampires and zombies were all living in peace - until the alien apocalypse arrived. Now three teenagers-one human, one vampire, and one zombie-have to team up to figure out how to get rid of the visitors.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1819601",
		"imdbID": "tt1819601",
		"title": "Miss Dial",
		"year": "2013",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Comedy",
		"released": "2013-02-16",
		"director": "David H. Steinberg",
		"writer": "David H. Steinberg",
		"cast": "Robinne Lee, Sam Jaeger, Jon Huertas, Sara Rue",
		"metacritic": "",
		"imdbRating": "6.2",
		"imdbVotes": "733",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAyNDY3OTI4NV5BMl5BanBnXkFtZTcwNjQyMjIyOQ@@._V1_SX300.jpg",
		"plot": "A consumer affair rep who works from her apartment decides to play hooky one day, and spends her time calling random people, looking for new connections.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "1822381",
		"imdbID": "tt1822381",
		"title": "Évocateur: The Morton Downey Jr. Movie",
		"year": "2012",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Documentary",
		"released": "2013-06-07",
		"director": "Seth Kramer, Daniel A. Miller, Jeremy Newberger",
		"writer": "Daniel A. Miller",
		"cast": "Morton Downey Jr., Glenn Beck, Victoria Jackson, Bob Pittman",
		"metacritic": "70",
		"imdbRating": "6.8",
		"imdbVotes": "724",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDQ3NjcwMzc0Nl5BMl5BanBnXkFtZTcwNzQ1ODYzOQ@@._V1_SX300.jpg",
		"plot": "Before entire networks were built on populist personalities; before reality morphed into a TV genre; the masses fixated on a single, sociopathic star: controversial talk-show host Morton Downey, Jr.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1833835",
		"imdbID": "tt1833835",
		"title": "White T",
		"year": "2013",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Comedy",
		"released": "2013-05-14",
		"director": "Lance Frank",
		"writer": "Blake Phillips, Lance Frank, Chase Alexander",
		"cast": "Jamal Mixon, Jerod Mixon, Eric Roberts, Deion Sanders",
		"metacritic": "",
		"imdbRating": "6.3",
		"imdbVotes": "939",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgyMDUyNjIyM15BMl5BanBnXkFtZTcwMDgyNTg0NA@@._V1_SX300.jpg",
		"plot": "Herbert & Henry (Jerod and Jamal Mixon) are twin brothers with dreams to become the biggest rap stars in the game. Their chance at super-stardom comes after they buy a T-shirt with a ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1833888",
		"imdbID": "tt1833888",
		"title": "Angels Sing",
		"year": "2013",
		"rating": "PG",
		"runtime": "87 min",
		"genre": "Comedy, Drama, Family",
		"released": "2013-03-10",
		"director": "Tim McCanlies",
		"writer": "Lou Berney (screenplay), Turk Pipkin (based on the novel by)",
		"cast": "Harry Connick Jr., Connie Britton, Chandler Canterbury, Fionnula Flanagan",
		"metacritic": "39",
		"imdbRating": "5.7",
		"imdbVotes": "1350",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTEzNzU1MTMxMjNeQTJeQWpwZ15BbWU4MDU3MTI3NDAx._V1_SX300.jpg",
		"plot": "As a child, Michael Walker wished every day could be Christmas. That is, until a tragic accident crushed his holiday spirit. Thirty years later, Michael still can't muster any joy for the ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1836755",
		"imdbID": "tt1836755",
		"title": "Born to Lead: The Sal Aunese Story",
		"year": "2014",
		"rating": "Not Rated",
		"runtime": "110 min",
		"genre": "Documentary, Sport",
		"released": "2014-07-01",
		"director": "George Antonopoulos, Lara Anne Slife",
		"writer": "Scott Balcerek",
		"cast": "Gary Barnett, Eric Bieniemy, Brian Bosworth, Jeff Campbell",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTMzMTA4NTcwMV5BMl5BanBnXkFtZTcwMDk3OTc0NA@@._V1_SX300.jpg",
		"plot": "",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1837709",
		"imdbID": "tt1837709",
		"title": "Winter's Tale",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "118 min",
		"genre": "Drama, Fantasy, Mystery",
		"released": "2014-02-14",
		"director": "Akiva Goldsman",
		"writer": "Akiva Goldsman (screenplay), Mark Helprin (novel)",
		"cast": "Colin Farrell, Matt Bomer, Lucy Griffiths, Michael Crane",
		"metacritic": "31",
		"imdbRating": "6.2",
		"imdbVotes": "38480",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTMyNjI1NTM4N15BMl5BanBnXkFtZTgwNjcwMzc1MDE@._V1_SX300.jpg",
		"plot": "A burglar falls for an heiress as she dies in his arms. When he learns that he has the gift of reincarnation, he sets out to save her.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "1839642",
		"imdbID": "tt1839642",
		"title": "The Face of Love",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "92 min",
		"genre": "Drama, Romance",
		"released": "2013-10-25",
		"director": "Arie Posin",
		"writer": "Matthew McDuffie, Arie Posin",
		"cast": "Annette Bening, Ed Harris, Robin Williams, Jess Weixler",
		"metacritic": "51",
		"imdbRating": "6.1",
		"imdbVotes": "2918",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTUwNjc0NDgxMV5BMl5BanBnXkFtZTgwMzMwNDEzMTE@._V1_SX300.jpg",
		"plot": "A widow falls for a guy who bears a striking resemblance to her late husband.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1840309",
		"imdbID": "tt1840309",
		"title": "Divergent",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "139 min",
		"genre": "Adventure, Mystery, Sci-Fi",
		"released": "2014-03-21",
		"director": "Neil Burger",
		"writer": "Evan Daugherty (screenplay), Vanessa Taylor (screenplay), Veronica Roth (novel)",
		"cast": "Shailene Woodley, Theo James, Ashley Judd, Jai Courtney",
		"metacritic": "48",
		"imdbRating": "6.8",
		"imdbVotes": "312102",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYxMzYwODE4OV5BMl5BanBnXkFtZTgwNDE5MzE2MDE@._V1_SX300.jpg",
		"plot": "In a world divided by factions based on virtues, Tris learns she's Divergent and won't fit in. When she discovers a plot to destroy Divergents, Tris and the mysterious Four must find out what makes Divergents dangerous before it's too late.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "7 wins & 10 nominations."
	},
	{
		"id": "1860213",
		"imdbID": "tt1860213",
		"title": "Dirty Grandpa",
		"year": "2016",
		"rating": "R",
		"runtime": "102 min",
		"genre": "Comedy",
		"released": "2016-01-22",
		"director": "Dan Mazer",
		"writer": "John Phillips (screenplay)",
		"cast": "Zoey Deutch, Robert De Niro, Zac Efron, Julianne Hough",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTEyMDc5NzM1NF5BMl5BanBnXkFtZTgwMjYyODk0NzE@._V1_SX300.jpg",
		"plot": "Right before his wedding, an uptight guy is tricked into driving his grandfather, a perverted former Army general, to Florida for spring break.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1860353",
		"imdbID": "tt1860353",
		"title": "Turbo",
		"year": "2013",
		"rating": "PG",
		"runtime": "96 min",
		"genre": "Animation, Adventure, Comedy",
		"released": "2013-07-17",
		"director": "David Soren",
		"writer": "Darren Lemke (screenplay), Robert D. Siegel (screenplay), David Soren (screenplay), David Soren (story)",
		"cast": "Ryan Reynolds, Paul Giamatti, Michael Peña, Samuel L. Jackson",
		"metacritic": "58",
		"imdbRating": "6.5",
		"imdbVotes": "57858",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA4NTgwMjM5MzheQTJeQWpwZ15BbWU3MDg2ODA1ODk@._V1_SX300.jpg",
		"plot": "A freak accident might just help an everyday garden snail achieve his biggest dream: winning the Indy 500.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 11 nominations."
	},
	{
		"id": "1864405",
		"imdbID": "tt1864405",
		"title": "Low Down",
		"year": "2014",
		"rating": "R",
		"runtime": "114 min",
		"genre": "Biography, Drama, Music",
		"released": "2015-01-27",
		"director": "Jeff Preiss",
		"writer": "Amy Albany (memoir), Topper Lilien (screenplay), Amy Albany (screenplay), Topper Lilien, Amy Albany (memoir), Amy Albany",
		"cast": "John Hawkes, Elle Fanning, Glenn Close, Peter Dinklage",
		"metacritic": "58",
		"imdbRating": "6.2",
		"imdbVotes": "1045",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgyMzgwNjk1MV5BMl5BanBnXkFtZTgwNDcwODI4MjE@._V1_SX300.jpg",
		"plot": "A look at the life of pianist Joe Albany from the perspective of his young daughter, as she watches him contend with his drug addiction during the 1960s and '70s jazz scene.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 3 nominations."
	},
	{
		"id": "1865393",
		"imdbID": "tt1865393",
		"title": "Hellbenders",
		"year": "2012",
		"rating": "R",
		"runtime": "85 min",
		"genre": "Comedy, Horror, Thriller",
		"released": "2013-05-23",
		"director": "J.T. Petty",
		"writer": "J.T. Petty (graphic novel), J.T. Petty (screenplay)",
		"cast": "Clifton Collins Jr., Clancy Brown, Andre Royo, Robyn Rikoon",
		"metacritic": "43",
		"imdbRating": "4.7",
		"imdbVotes": "938",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEzODI4MjQzMl5BMl5BanBnXkFtZTgwNzExNzIzMDE@._V1_SX300.jpg",
		"plot": "The Augustine Interfaith Order of Hellbound Saints, a team of blasphemous ministers who live in a constant state of debauchery, work to drag the worst of demons back to Hell.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1865545",
		"imdbID": "tt1865545",
		"title": "Liars All",
		"year": "2013",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Thriller",
		"released": "2013-08-06",
		"director": "Brian Brightly",
		"writer": "Brian Brightly (screenplay)",
		"cast": "Alice Evans, Matt Lanter, Sara Paxton, Torrance Coombs",
		"metacritic": "",
		"imdbRating": "4.2",
		"imdbVotes": "983",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEzNzg2NDM0OV5BMl5BanBnXkFtZTcwNDIxNjg3Nw@@._V1_SX300.jpg",
		"plot": "On New Year's eve in London, a provocative game spins out of control and ends in murder, the true killer elusive amidst conflicting testimony and hidden motives.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1869425",
		"imdbID": "tt1869425",
		"title": "Filly Brown",
		"year": "2012",
		"rating": "R",
		"runtime": "80 min",
		"genre": "Drama, Music",
		"released": "2013-04-19",
		"director": "Youssef Delara, Michael D. Olmos",
		"writer": "David Bianchi (Writer \"Wisdom\"), Youssef Delara",
		"cast": "Gina Rodriguez, Khool-Aid Rios, Jenni Rivera, Lou Diamond Phillips",
		"metacritic": "57",
		"imdbRating": "5.5",
		"imdbVotes": "894",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU2ODA0OTI4Ml5BMl5BanBnXkFtZTcwMjM5MDkzOQ@@._V1_SX300.jpg",
		"plot": "A promising hip-hop rhymer from Los Angeles finds herself in a gray area when a record producer offers her a compromising shot at stardom.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 4 nominations."
	},
	{
		"id": "1869577",
		"imdbID": "tt1869577",
		"title": "My Dog the Space Traveler",
		"year": "2014",
		"rating": "PG",
		"runtime": "",
		"genre": "",
		"released": "2014-02-21",
		"director": "Robin Christian",
		"writer": "Robin Christian",
		"cast": "Logan Borsari, Santiago Craig, Chris Lemmon, Paul Lillios",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "28",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM2NTIwMTU4Ml5BMl5BanBnXkFtZTcwNjIwMjMzOQ@@._V1_SX300.jpg",
		"plot": "A young boy loses his dog to an anomaly in his backyard, a portal which leads to another dimension of our universe. He must rely on his friends and dysfunctional family to get the dog back ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1869724",
		"imdbID": "tt1869724",
		"title": "The Littlest Angel",
		"year": "2011",
		"rating": "G",
		"runtime": "84 min",
		"genre": "Animation",
		"released": "2013-11-15",
		"director": "Dave Kim",
		"writer": "Sean Catherine Derek (screenplay), Dave Kim (story), Sean Roche (screenplay), Charles Tazewell (book)",
		"cast": "Ed Kelly, Nina Kircher, Clarity Patton, Ron Perlman",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "202",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTc3MjI3MjgxOV5BMl5BanBnXkFtZTcwNTc0NTM0Ng@@._V1_SX300.jpg",
		"plot": "Based on the fifteenth best-selling children's book of all time, The Littlest Angel tells the story of a young boy who arrives in heaven before his time. Home-sick and lonely, he will ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1878942",
		"imdbID": "tt1878942",
		"title": "Date and Switch",
		"year": "2014",
		"rating": "R",
		"runtime": "91 min",
		"genre": "Comedy",
		"released": "2014-02-14",
		"director": "Chris Nelson",
		"writer": "Alan Yang",
		"cast": "Quinn Lord, Nick Offerman, Gary Cole, Megan Mullally",
		"metacritic": "56",
		"imdbRating": "5.8",
		"imdbVotes": "5394",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAwODUzOTQ5Nl5BMl5BanBnXkFtZTgwNzAwMjc5MDE@._V1_SX300.jpg",
		"plot": "Two guys who make a pact to lose their virginity before prom find their friendship tested when one of them comes out of the closet.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1879032",
		"imdbID": "tt1879032",
		"title": "Rapture-Palooza",
		"year": "2013",
		"rating": "R",
		"runtime": "85 min",
		"genre": "Comedy, Fantasy",
		"released": "2013-06-07",
		"director": "Paul Middleditch",
		"writer": "Chris Matheson",
		"cast": "Craig Robinson, Anna Kendrick, John Francis Daley, Rob Corddry",
		"metacritic": "44",
		"imdbRating": "5.2",
		"imdbVotes": "8696",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE3NjM3MzQ2OV5BMl5BanBnXkFtZTcwNTI3MzM1OQ@@._V1_SX300.jpg",
		"plot": "Two teens battle their way through a religious apocalypse on a mission to defeat the Antichrist.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1879078",
		"imdbID": "tt1879078",
		"title": "A Sierra Nevada Gunfight",
		"year": "2013",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Western",
		"released": "2013-05-07",
		"director": "Vernon E. Mortensen",
		"writer": "Johnny Harrington, Vernon E. Mortensen",
		"cast": "Kirk Harris, Ryan Ballance, Michael Madsen, John Savage",
		"metacritic": "",
		"imdbRating": "2.8",
		"imdbVotes": "113",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkyMjM4MzMxOV5BMl5BanBnXkFtZTgwNzQ3NTA2MDE@._V1_SX300.jpg",
		"plot": "Gold miner Roger Hazard brings his twelve year old son Casper to the treacherous gold fields of 1870s California. The two of them work a small mine in the southern fields but when Roger ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1881002",
		"imdbID": "tt1881002",
		"title": "Maggie",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "95 min",
		"genre": "Drama, Horror, Thriller",
		"released": "2015-05-08",
		"director": "Henry Hobson",
		"writer": "John Scott 3",
		"cast": "Arnold Schwarzenegger, Abigail Breslin, Joely Richardson, Douglas M. Griffin",
		"metacritic": "52",
		"imdbRating": "5.6",
		"imdbVotes": "24687",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkyNzk0MTU2Ml5BMl5BanBnXkFtZTgwNDExNzMyNTE@._V1_SX300.jpg",
		"plot": "A teenage girl in the Midwest becomes infected by an outbreak of a disease that slowly turns the infected into cannibalistic zombies. During her transformation, her loving father stays by her side.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "1884369",
		"imdbID": "tt1884369",
		"title": "Noobz",
		"year": "2012",
		"rating": "R",
		"runtime": "97 min",
		"genre": "Comedy",
		"released": "2013-01-25",
		"director": "Blake Freeman",
		"writer": "Blake Freeman, Marvin Willson",
		"cast": "Casper Van Dien, Sabrina Carpenter, Jason Mewes, Moises Arias",
		"metacritic": "",
		"imdbRating": "4.9",
		"imdbVotes": "1891",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM5OTczNjU4MV5BMl5BanBnXkFtZTcwMjE0OTM3OA@@._V1_SX300.jpg",
		"plot": "Four friends hit the road to LA to compete in the Cyberbowl Video Game Championship, but will they be able to compete with the worst hangovers of their lives?",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1885299",
		"imdbID": "tt1885299",
		"title": "Lucky Them",
		"year": "2013",
		"rating": "R",
		"runtime": "97 min",
		"genre": "Drama",
		"released": "2014-04-21",
		"director": "Megan Griffiths",
		"writer": "Huck Botko (screenplay), Caroline Sherman (original idea), Emily Wachtel (screenplay)",
		"cast": "Toni Collette, Thomas Haden Church, Oliver Platt, Ryan Eggold",
		"metacritic": "65",
		"imdbRating": "6.0",
		"imdbVotes": "1865",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM5OTI4ODAzOV5BMl5BanBnXkFtZTgwNTY5OTg2MTE@._V1_SX300.jpg",
		"plot": "A rock journalist is assigned to track down her ex-boyfriend.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "1885300",
		"imdbID": "tt1885300",
		"title": "Best Man Down",
		"year": "2012",
		"rating": "PG-13",
		"runtime": "89 min",
		"genre": "Comedy, Drama",
		"released": "2013-10-03",
		"director": "Ted Koland",
		"writer": "Ted Koland",
		"cast": "Justin Long, Jess Weixler, Tyler Labine, Addison Timlin",
		"metacritic": "36",
		"imdbRating": "6.4",
		"imdbVotes": "7763",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTY0OTAyOTU4NF5BMl5BanBnXkFtZTgwOTkxMTYwMDE@._V1_SX300.jpg",
		"plot": "A newlywed couple cancels their honeymoon and returns to the snowy Midwest to make the funeral arrangements for their best man, who died unexpectedly after their ceremony.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1893326",
		"imdbID": "tt1893326",
		"title": "Scatter My Ashes at Bergdorf's",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "93 min",
		"genre": "Documentary",
		"released": "2013-05-03",
		"director": "Matthew Miele",
		"writer": "Matthew Miele",
		"cast": "Mary-Kate Olsen, Ashley Olsen, William Fichtner, Susan Lucci",
		"metacritic": "55",
		"imdbRating": "6.0",
		"imdbVotes": "576",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI3MjQwNTU4Ml5BMl5BanBnXkFtZTcwNjcyODUzOQ@@._V1_SX300.jpg",
		"plot": "A documentary on the Manhattan department store with interviews from an array of fashion designers, style icons, and celebrities.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1911644",
		"imdbID": "tt1911644",
		"title": "The Call",
		"year": "2013",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Crime, Thriller",
		"released": "2013-03-15",
		"director": "Brad Anderson",
		"writer": "Richard D'Ovidio (screenplay), Richard D'Ovidio (story), Nicole D'Ovidio (story), Jon Bokenkamp (story)",
		"cast": "Halle Berry, Abigail Breslin, Morris Chestnut, Michael Eklund",
		"metacritic": "51",
		"imdbRating": "6.7",
		"imdbVotes": "83698",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjExNDkzNjAwOV5BMl5BanBnXkFtZTcwMDMzMzQwOQ@@._V1_SX300.jpg",
		"plot": "When a veteran 911 operator takes a life-altering call from a teenage girl who has just been abducted, she realizes that she must confront a killer from her past in order to save the girl's life.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 10 nominations."
	},
	{
		"id": "1911658",
		"imdbID": "tt1911658",
		"title": "Penguins of Madagascar",
		"year": "2014",
		"rating": "PG",
		"runtime": "92 min",
		"genre": "Animation, Adventure, Comedy",
		"released": "2014-11-26",
		"director": "Eric Darnell, Simon J. Smith",
		"writer": "Michael Colton (screenplay), John Aboud (screenplay), Brandon Sawyer (screenplay), Alan Schoolcraft (story), Brent Simons (story), Michael Colton (story), John Aboud (story), Eric Darnell (characters), Tom McGrath (characters)",
		"cast": "Tom McGrath, Chris Miller, Christopher Knights, Conrad Vernon",
		"metacritic": "53",
		"imdbRating": "6.7",
		"imdbVotes": "54766",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTEyMDg4MDU4MjdeQTJeQWpwZ15BbWU4MDQyOTc3MjIx._V1_SX300.jpg",
		"plot": "Skipper, Kowalski, Rico and Private join forces with undercover organization The North Wind to stop the villainous Dr. Octavius Brine from destroying the world as we know it.",
		"language": "English",
		"country": "USA",
		"awards": "6 nominations."
	},
	{
		"id": "1911662",
		"imdbID": "tt1911662",
		"title": "Vehicle 19",
		"year": "2013",
		"rating": "R",
		"runtime": "82 min",
		"genre": "Action, Thriller",
		"released": "2013-02-07",
		"director": "Mukunda Michael Dewil",
		"writer": "Mukunda Michael Dewil",
		"cast": "Paul Walker, Naima McLean, Gys de Villiers, Leyla Haidarian",
		"metacritic": "29",
		"imdbRating": "4.9",
		"imdbVotes": "11638",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk0NDU4ODc4OF5BMl5BanBnXkFtZTcwMjIwMTU1OQ@@._V1_SX300.jpg",
		"plot": "In Johannesburg, an American parole breaker unknowingly picks up a rental car that will tie him to a web of corrupt local police.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1916763",
		"imdbID": "tt1916763",
		"title": "Zombex",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Horror, Sci-Fi, Thriller",
		"released": "2013-10-26",
		"director": "Jesse Dayton",
		"writer": "Jesse Dayton",
		"cast": "Lew Temple, David Christopher, Malcolm McDowell, Sid Haig",
		"metacritic": "",
		"imdbRating": "2.1",
		"imdbVotes": "523",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEyMDkxMDIxMF5BMl5BanBnXkFtZTgwOTE2NjM2MDE@._V1_SX300.jpg",
		"plot": "As things are turning around for the city, people must face a disaster of epic proportions. They are dealing with the prospect of losing the people of New Orleans as they turn into the city's walking dead.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1918908",
		"imdbID": "tt1918908",
		"title": "California Scheming",
		"year": "2014",
		"rating": "R",
		"runtime": "99 min",
		"genre": "Thriller",
		"released": "2014-01-31",
		"director": "Marco Weber",
		"writer": "Marco Weber",
		"cast": "Gia Mantegna, Devon Werkheiser, Spencer Daniels, Rachel Seiferth",
		"metacritic": "",
		"imdbRating": "3.6",
		"imdbVotes": "537",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjExOTc4NTk1NF5BMl5BanBnXkFtZTgwODMyMzY0MDE@._V1_SX300.jpg",
		"plot": "A teen seductress pulls three other privileged Malibu kids into her devious scheme, and unforeseen consequences force the group to face their own fears and mortality.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1922685",
		"imdbID": "tt1922685",
		"title": "Phantom",
		"year": "2013",
		"rating": "R",
		"runtime": "98 min",
		"genre": "History, Thriller, War",
		"released": "2013-03-01",
		"director": "Todd Robinson",
		"writer": "Todd Robinson",
		"cast": "Ed Harris, David Duchovny, William Fichtner, Lance Henriksen",
		"metacritic": "40",
		"imdbRating": "5.8",
		"imdbVotes": "11236",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ0OTA5MDgzM15BMl5BanBnXkFtZTcwMDM3NTU3OQ@@._V1_SX300.jpg",
		"plot": "The haunted Captain of a Soviet submarine holds the fate of the world in his hands. Forced to leave his family behind, he is charged with leading a covert mission cloaked in mystery.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1922748",
		"imdbID": "tt1922748",
		"title": "The Investigator",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "101 min",
		"genre": "Drama, Family, Sport",
		"released": "2013-09-13",
		"director": "Curtis Graham",
		"writer": "Richard A. Romano",
		"cast": "Brandon Larracuente, Rebecca Galarza, Richard A. Romano, Nicole Abisinio",
		"metacritic": "",
		"imdbRating": "5.3",
		"imdbVotes": "228",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzE4OTg4NzY5MF5BMl5BanBnXkFtZTgwMTg4MjQwMDE@._V1_SX300.jpg",
		"plot": "A veteran police detective becomes a criminal justice teacher and baseball coach at a local high school, leading him to the most important investigation of his life. Inspired by true events.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "1924273",
		"imdbID": "tt1924273",
		"title": "Ghost Graduation",
		"year": "2012",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Adventure, Comedy, Fantasy",
		"released": "2013-08-01",
		"director": "Javier Ruiz Caldera",
		"writer": "Cristóbal Garrido (screenplay), Adolfo Valor (screenplay)",
		"cast": "Raúl Arévalo, Alexandra Jiménez, Javier Bódalo, Anna Castillo",
		"metacritic": "",
		"imdbRating": "6.3",
		"imdbVotes": "2171",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ2NDQ2OTAzNV5BMl5BanBnXkFtZTgwNzA3MTM5MDE@._V1_SX300.jpg",
		"plot": "A teacher with paranormal abilities helps a group of ghosts graduate high school.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1929263",
		"imdbID": "tt1929263",
		"title": "Heaven Is for Real",
		"year": "2014",
		"rating": "PG",
		"runtime": "99 min",
		"genre": "Drama",
		"released": "2014-04-16",
		"director": "Randall Wallace",
		"writer": "Randall Wallace (screenplay), Chris Parker (screenplay), Todd Burpo (book), Lynn Vincent (book)",
		"cast": "Greg Kinnear, Kelly Reilly, Thomas Haden Church, Connor Corum",
		"metacritic": "47",
		"imdbRating": "5.8",
		"imdbVotes": "19702",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjc3MzYzMTUzNF5BMl5BanBnXkFtZTgwNTYzNzI2MDE@._V1_SX300.jpg",
		"plot": "A small-town father must find the courage and conviction to share his son's extraordinary, life-changing experience with the world.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "1930294",
		"imdbID": "tt1930294",
		"title": "Black Rock",
		"year": "2012",
		"rating": "R",
		"runtime": "83 min",
		"genre": "Horror, Thriller",
		"released": "2013-05-17",
		"director": "Katie Aselton",
		"writer": "Mark Duplass (screenplay), Katie Aselton (story)",
		"cast": "Katie Aselton, Lake Bell, Kate Bosworth, Will Bouvier",
		"metacritic": "46",
		"imdbRating": "4.8",
		"imdbVotes": "6223",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM0NjExNDkwOF5BMl5BanBnXkFtZTcwMDQ3ODQxOQ@@._V1_SX300.jpg",
		"plot": "Three childhood friends set aside their personal issues and reunite for a girls' weekend on a remote island off the coast of Maine. One wrong move turns their weekend getaway into a deadly fight for survival.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1930546",
		"imdbID": "tt1930546",
		"title": "Arthur Newman",
		"year": "2012",
		"rating": "R",
		"runtime": "101 min",
		"genre": "Drama",
		"released": "2013-06-13",
		"director": "Dante Ariola",
		"writer": "Becky Johnston",
		"cast": "Colin Firth, Emily Blunt, Lucas Hedges, Anne Heche",
		"metacritic": "42",
		"imdbRating": "5.6",
		"imdbVotes": "5045",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTEyNzY1NzAzNjZeQTJeQWpwZ15BbWU3MDA5MjcxMzk@._V1_SX300.jpg",
		"plot": "A story of a man who fakes his own death and assumes a new identity in order to escape his life, who then moves in with a woman who is also trying to leave her past behind.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1931602",
		"imdbID": "tt1931602",
		"title": "Very Good Girls",
		"year": "2013",
		"rating": "R",
		"runtime": "91 min",
		"genre": "Drama",
		"released": "2014-06-24",
		"director": "Naomi Foner",
		"writer": "Naomi Foner",
		"cast": "Dakota Fanning, Elizabeth Olsen, Sterling Jones, Lenny Platt",
		"metacritic": "35",
		"imdbRating": "6.0",
		"imdbVotes": "8819",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk5MTA2MzMyN15BMl5BanBnXkFtZTgwODA1NTAyMjE@._V1_SX300.jpg",
		"plot": "Two New York City girls make a pact to lose their virginity during their first summer out of high school. When they both fall for the same street artist, the friends find their connection tested for the first time.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1932718",
		"imdbID": "tt1932718",
		"title": "Thanks for Sharing",
		"year": "2012",
		"rating": "R",
		"runtime": "112 min",
		"genre": "Comedy, Drama",
		"released": "2013-09-14",
		"director": "Stuart Blumberg",
		"writer": "Stuart Blumberg, Matt Winston",
		"cast": "Mark Ruffalo, Tim Robbins, Gwyneth Paltrow, Josh Gad",
		"metacritic": "54",
		"imdbRating": "6.4",
		"imdbVotes": "18511",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA5MzI3ODcxMF5BMl5BanBnXkFtZTcwODY5MTc4OQ@@._V1_SX300.jpg",
		"plot": "A romantic comedy that brings together three disparate characters who are learning to face a challenging and often confusing world as they struggle together against a common demon: sex addiction.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "1932767",
		"imdbID": "tt1932767",
		"title": "What Maisie Knew",
		"year": "2012",
		"rating": "R",
		"runtime": "99 min",
		"genre": "Drama",
		"released": "2013-05-03",
		"director": "Scott McGehee, David Siegel",
		"writer": "Nancy Doyne (screenplay), Carroll Cartwright (screenplay), Henry James (based on the novel by)",
		"cast": "Julianne Moore, Steve Coogan, Alexander Skarsgård, Joanna Vanderham",
		"metacritic": "74",
		"imdbRating": "7.5",
		"imdbVotes": "19792",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY1MDk0MTIzN15BMl5BanBnXkFtZTcwNDM3NzkxOQ@@._V1_SX300.jpg",
		"plot": "In New York City, a young girl is caught in the middle of her parents' bitter custody battle.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 8 nominations."
	},
	{
		"id": "1934172",
		"imdbID": "tt1934172",
		"title": "Heroes of Dirt",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "98 min",
		"genre": "Action, Drama, Sport",
		"released": "2015-09-04",
		"director": "Eric Bugbee",
		"writer": "Kevyn Bashore, Eric Bugbee (story), Eric Bugbee, Jill Bugbee (story), Jill Bugbee, Bob Massey",
		"cast": "Joel Moody, William Martinez, Vivienne VanHorn, Bill Allen",
		"metacritic": "",
		"imdbRating": "7.0",
		"imdbVotes": "44",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTIyMzc3NjMzNl5BMl5BanBnXkFtZTgwNTQzMTQ2MzE@._V1_SX300.jpg",
		"plot": "A self-focused BMX dirt rider aspires to become the next stunt champion and is forced to mentor a troubled teen.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1934458",
		"imdbID": "tt1934458",
		"title": "Under the Bed",
		"year": "2012",
		"rating": "R",
		"runtime": "87 min",
		"genre": "Horror",
		"released": "2013-07-03",
		"director": "Steven C. Miller",
		"writer": "Eric Stolze",
		"cast": "Jonny Weston, Gattlin Griffith, Peter Holden, Musetta Vander",
		"metacritic": "",
		"imdbRating": "4.6",
		"imdbVotes": "1863",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkwODQ0MjEyNl5BMl5BanBnXkFtZTcwNzI3MzI4OQ@@._V1_SX300.jpg",
		"plot": "Two brothers team up to battle a creature under the bed, in what is being described as a \"suburban nightmare\" tale.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1935897",
		"imdbID": "tt1935897",
		"title": "Amityville: The Awakening",
		"year": "2016",
		"rating": "R",
		"runtime": "",
		"genre": "Horror, Thriller",
		"released": "2016-04-15",
		"director": "Franck Khalfoun",
		"writer": "Franck Khalfoun (screenplay)",
		"cast": "Jennifer Jason Leigh, Bella Thorne, Cameron Monaghan, Taylor Spreitler",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc0NzcwMzQ3MF5BMl5BanBnXkFtZTgwOTQ3Nzk1MjE@._V1_SX300.jpg",
		"plot": "A single mother moves her three children into the haunted house not knowing of the house's bloody history.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1935902",
		"imdbID": "tt1935902",
		"title": "The Brass Teapot",
		"year": "2012",
		"rating": "R",
		"runtime": "101 min",
		"genre": "Comedy, Fantasy, Thriller",
		"released": "2013-04-15",
		"director": "Ramaa Mosley",
		"writer": "Tim Macy (screenplay), Ramaa Mosley (story), Tim Macy (story)",
		"cast": "Juno Temple, Michael Angarano, Alexis Bledel, Billy Magnussen",
		"metacritic": "43",
		"imdbRating": "6.4",
		"imdbVotes": "11150",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTEyNDIxOTE3NDheQTJeQWpwZ15BbWU3MDI0ODE5OTg@._V1_SX300.jpg",
		"plot": "When a couple discovers that a brass teapot makes them money whenever they hurt themselves, they must come to terms with how far they are willing to go.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "1939659",
		"imdbID": "tt1939659",
		"title": "Carrie",
		"year": "2013",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Drama, Horror",
		"released": "2013-10-18",
		"director": "Kimberly Peirce",
		"writer": "Lawrence D. Cohen (screenplay), Roberto Aguirre-Sacasa (screenplay), Stephen King (novel)",
		"cast": "Julianne Moore, Chloë Grace Moretz, Gabriella Wilde, Portia Doubleday",
		"metacritic": "53",
		"imdbRating": "6.0",
		"imdbVotes": "102273",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODg2MDU2MjYxNl5BMl5BanBnXkFtZTcwMDQ5MzU0OQ@@._V1_SX300.jpg",
		"plot": "A reimagining of the classic horror tale about Carrie White, a shy girl outcast by her peers and sheltered by her deeply religious mother, who unleashes telekinetic terror on her small town after being pushed too far at her senior prom.",
		"language": "English",
		"country": "USA",
		"awards": "5 wins & 7 nominations."
	},
	{
		"id": "1945044",
		"imdbID": "tt1945044",
		"title": "Exeter",
		"year": "2015",
		"rating": "R",
		"runtime": "91 min",
		"genre": "Horror, Thriller",
		"released": "2015-08-12",
		"director": "Marcus Nispel",
		"writer": "Kirsten McCallion, Kirsten McCallion, Marcus Nispel (story)",
		"cast": "Stephen Lang, Kevin Chapman, Kelly Blatz, Brittany Curran",
		"metacritic": "",
		"imdbRating": "4.6",
		"imdbVotes": "3130",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODA3NjAxMTIzN15BMl5BanBnXkFtZTgwODY0MDM1NTE@._V1_SX300.jpg",
		"plot": "A group of teenagers accidentally release an evil spirit that starts to possess them one by one.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "1945084",
		"imdbID": "tt1945084",
		"title": "Everly",
		"year": "2014",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Action, Thriller",
		"released": "2015-01-23",
		"director": "Joe Lynch",
		"writer": "Yale Hannon (screenplay), Yale Hannon (story), Joe Lynch (story)",
		"cast": "Salma Hayek, Hiroyuki Watanabe, Laura Cepeda, Togo Igawa",
		"metacritic": "35",
		"imdbRating": "5.0",
		"imdbVotes": "10323",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEyNTU4NTE5NV5BMl5BanBnXkFtZTgwNzY4NzIxNDE@._V1_SX300.jpg",
		"plot": "An action/thriller centered on a woman who faces down hitmen sent by her ex, a mob boss, while holed up in her apartment.",
		"language": "English, Japanese",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1946310",
		"imdbID": "tt1946310",
		"title": "Crazy Kind of Love",
		"year": "2013",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Comedy, Drama, Romance",
		"released": "2013-07-09",
		"director": "Sarah Siegel-Magness",
		"writer": "Karen McCullah (screenplay), April Stevens (based on the novel \"Angel Angel\" by), Karen McCullah",
		"cast": "Virginia Madsen, Graham Rogers, Amanda Crew, Zach Gilford",
		"metacritic": "",
		"imdbRating": "5.8",
		"imdbVotes": "1300",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTI1MDAzMTAzOF5BMl5BanBnXkFtZTcwMjEwNDU0OQ@@._V1_SX300.jpg",
		"plot": "A broken family finds their relationships to one another changed by a new arrival in the household.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1946381",
		"imdbID": "tt1946381",
		"title": "Red Sky",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "100 min",
		"genre": "Action, Thriller",
		"released": "2014-03-13",
		"director": "Mario Van Peebles",
		"writer": "Randy Arrington (based on characters by: from the book \"Kerosene Cowboys: Manning the Spare\"), Adam Prince (screenplay), Dave Riggs (story), Nikolay Suslov (story), Mario Van Peebles (screenplay)",
		"cast": "Cam Gigandet, Rachael Leigh Cook, Mario Van Peebles, Jacob Vargas",
		"metacritic": "",
		"imdbRating": "4.1",
		"imdbVotes": "961",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA0NDY5MTcxNzleQTJeQWpwZ15BbWU4MDk0OTUzOTEx._V1_SX300.jpg",
		"plot": "Disgraced Top Gun fighter pilot Butch Masters leads a rogue squad in recovery of a WMD. Masters must navigate a fractured friendship, a love triangle, and must take to the skies to reclaim his military and personal honor.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "1950135",
		"imdbID": "tt1950135",
		"title": "Drunk Wedding",
		"year": "2015",
		"rating": "R",
		"runtime": "81 min",
		"genre": "Comedy",
		"released": "2015-05-22",
		"director": "Nick Weiss",
		"writer": "Anthony Weiss, Nick Weiss",
		"cast": "Nick P. Ross, J.R. Ramirez, Christian Cooke, Bethany Dwyer",
		"metacritic": "",
		"imdbRating": "4.2",
		"imdbVotes": "355",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgwNzIyMTQ3M15BMl5BanBnXkFtZTgwNDM3MDc3NTE@._V1_SX300.jpg",
		"plot": "John and Elissa's perfect destination wedding is derailed when their college friends get drunk on tequila.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1951095",
		"imdbID": "tt1951095",
		"title": "Child of God",
		"year": "2013",
		"rating": "R",
		"runtime": "104 min",
		"genre": "Crime, Drama, Thriller",
		"released": "2014-08-20",
		"director": "James Franco",
		"writer": "James Franco (screenplay), Vince Jolivette (screenplay), Cormac McCarthy (novel)",
		"cast": "James Franco, Tim Blake Nelson, Jim Parrack, Scott Haze",
		"metacritic": "50",
		"imdbRating": "5.4",
		"imdbVotes": "2781",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE1NzAyNTE4Nl5BMl5BanBnXkFtZTgwMDAwNjkxMjE@._V1_SX300.jpg",
		"plot": "A dispossessed, violent man's life is a disastrous attempt to exist outside the social order. Successively deprived of parents and homes and with few other ties, Ballard descends to the level of a cave dweller as he falls deeper into crime and degradation.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "1951181",
		"imdbID": "tt1951181",
		"title": "The Immigrant",
		"year": "2013",
		"rating": "R",
		"runtime": "120 min",
		"genre": "Drama, Romance",
		"released": "2014-05-23",
		"director": "James Gray",
		"writer": "James Gray, Ric Menello",
		"cast": "Marion Cotillard, Joaquin Phoenix, Jeremy Renner, Dagmara Dominczyk",
		"metacritic": "77",
		"imdbRating": "6.6",
		"imdbVotes": "18862",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjQ2OTAyNTUzNl5BMl5BanBnXkFtZTgwMTkxNzA2MTE@._V1_SX300.jpg",
		"plot": "1921. An innocent immigrant woman is tricked into a life of burlesque and vaudeville until a dazzling magician tries to save her and reunite her with her sister who is being held in the confines of Ellis Island.",
		"language": "English, Polish, Latin",
		"country": "USA",
		"awards": "15 wins & 29 nominations."
	},
	{
		"id": "1951261",
		"imdbID": "tt1951261",
		"title": "The Hangover Part III",
		"year": "2013",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Comedy",
		"released": "2013-05-23",
		"director": "Todd Phillips",
		"writer": "Todd Phillips, Craig Mazin, Jon Lucas (characters), Scott Moore (characters)",
		"cast": "Bradley Cooper, Ed Helms, Zach Galifianakis, Justin Bartha",
		"metacritic": "30",
		"imdbRating": "5.9",
		"imdbVotes": "207811",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA0NjE1MzMzODheQTJeQWpwZ15BbWU3MDY4MTQ3Mzk@._V1_SX300.jpg",
		"plot": "When one of their own is kidnapped by an angry gangster, the Wolf Pack must track down Mr. Chow, who has escaped from prison and is on the lam.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 6 nominations."
	},
	{
		"id": "1951264",
		"imdbID": "tt1951264",
		"title": "The Hunger Games: Catching Fire",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "146 min",
		"genre": "Adventure, Sci-Fi, Thriller",
		"released": "2013-11-22",
		"director": "Francis Lawrence",
		"writer": "Simon Beaufoy (screenplay), Michael Arndt (screenplay), Suzanne Collins (novel)",
		"cast": "Jennifer Lawrence, Liam Hemsworth, Jack Quaid, Taylor St. Clair",
		"metacritic": "76",
		"imdbRating": "7.6",
		"imdbVotes": "470012",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTAyMjQ3OTAxMzNeQTJeQWpwZ15BbWU4MDU0NzA1MzAx._V1_SX300.jpg",
		"plot": "Katniss Everdeen and Peeta Mellark become targets of the Capitol after their victory in the 74th Hunger Games sparks a rebellion in the Districts of Panem.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 1 Golden Globe. Another 21 wins & 57 nominations."
	},
	{
		"id": "1951265",
		"imdbID": "tt1951265",
		"title": "The Hunger Games: Mockingjay - Part 1",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "123 min",
		"genre": "Adventure, Sci-Fi, Thriller",
		"released": "2014-11-21",
		"director": "Francis Lawrence",
		"writer": "Peter Craig (screenplay), Danny Strong (screenplay), Suzanne Collins (adaptation), Suzanne Collins (novel)",
		"cast": "Jennifer Lawrence, Josh Hutcherson, Liam Hemsworth, Woody Harrelson",
		"metacritic": "64",
		"imdbRating": "6.7",
		"imdbVotes": "268162",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTcxNDI2NDAzNl5BMl5BanBnXkFtZTgwODM3MTc2MjE@._V1_SX300.jpg",
		"plot": "Katniss Everdeen is in District 13 after she shatters the games forever. Under the leadership of President Coin and the advice of her trusted friends, Katniss spreads her wings as she fights to save Peeta and a nation moved by her courage.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 1 Golden Globe. Another 10 wins & 21 nominations."
	},
	{
		"id": "1959438",
		"imdbID": "tt1959438",
		"title": "Kiss of the Damned",
		"year": "2012",
		"rating": "R",
		"runtime": "97 min",
		"genre": "Drama, Horror, Romance",
		"released": "2013-03-28",
		"director": "Xan Cassavetes",
		"writer": "Xan Cassavetes",
		"cast": "Joséphine de La Baume, Milo Ventimiglia, Roxane Mesquida, Anna Mouglalis",
		"metacritic": "48",
		"imdbRating": "5.5",
		"imdbVotes": "3435",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMyMzg5OTAxNF5BMl5BanBnXkFtZTcwNTcxMzUxOQ@@._V1_SX300.jpg",
		"plot": "The vampire Djuna resists the advances of Paolo, but soon gives in to their passion. When her trouble-making sister unexpectedly comes to visit, Djuna's love is threatened, and the whole vampire community becomes endangered.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 4 nominations."
	},
	{
		"id": "1959490",
		"imdbID": "tt1959490",
		"title": "Noah",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "138 min",
		"genre": "Action, Adventure, Drama",
		"released": "2014-03-28",
		"director": "Darren Aronofsky",
		"writer": "Darren Aronofsky, Ari Handel",
		"cast": "Russell Crowe, Jennifer Connelly, Ray Winstone, Anthony Hopkins",
		"metacritic": "68",
		"imdbRating": "5.8",
		"imdbVotes": "190175",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDE1MTkzNzc0MF5BMl5BanBnXkFtZTgwMjYxNDEyMjE@._V1_SX300.jpg",
		"plot": "A man is chosen by his world's creator to undertake a momentous mission before an apocalyptic flood cleanses the world.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 1 Golden Globe. Another 16 nominations."
	},
	{
		"id": "1965162",
		"imdbID": "tt1965162",
		"title": "Boys of Abu Ghraib",
		"year": "2014",
		"rating": "R",
		"runtime": "102 min",
		"genre": "Drama, Thriller, War",
		"released": "2014-03-28",
		"director": "Luke Moran",
		"writer": "Luke Moran",
		"cast": "Luke Moran, Sean Astin, Sara Paxton, Omid Abtahi",
		"metacritic": "34",
		"imdbRating": "5.3",
		"imdbVotes": "1514",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzE2Nzc2MTE1NF5BMl5BanBnXkFtZTgwNjUyODc5NjE@._V1_SX300.jpg",
		"plot": "An American soldier deployed at Abu Ghraib finds himself behind the walls of the infamous Hard Site, where he develops a secret friendship with an Iraqi detainee.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "1992147",
		"imdbID": "tt1992147",
		"title": "Love Sick Love",
		"year": "2012",
		"rating": "R",
		"runtime": "83 min",
		"genre": "Thriller",
		"released": "2013-04-26",
		"director": "Christian Charles",
		"writer": "Ryan Oxford",
		"cast": "Lindsay Rose Binder, Jim Gaffigan, Dean Kapica, Megan Raye Manzi",
		"metacritic": "28",
		"imdbRating": "4.9",
		"imdbVotes": "458",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYzNjQ4NzMyM15BMl5BanBnXkFtZTcwNjUyMjIyOQ@@._V1_SX300.jpg",
		"plot": "A 'boy meets girl' romance that quickly turns into a twisted thriller. Dori, a sexy siren, traps Norman, a slick New York businessman, and forces him to live through a year of holidays to ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1993391",
		"imdbID": "tt1993391",
		"title": "10 Rules for Sleeping Around",
		"year": "2013",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Comedy, Romance",
		"released": "2014-04-04",
		"director": "Leslie Greif",
		"writer": "Leslie Greif",
		"cast": "Tammin Sursok, Virginia Williams, Chris Marquette, Jesse Bradford",
		"metacritic": "1",
		"imdbRating": "3.7",
		"imdbVotes": "1963",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM5NTQyMDU2MV5BMl5BanBnXkFtZTgwNjQ5ODMyMTE@._V1_SX300.jpg",
		"plot": "A screw ball sex comedy following two couples and their ten rules to a happy healthy and open relationship.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1995341",
		"imdbID": "tt1995341",
		"title": "It's a Disaster",
		"year": "2012",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Comedy, Drama",
		"released": "2013-06-07",
		"director": "Todd Berger",
		"writer": "Todd Berger",
		"cast": "Rachel Boston, Kevin M. Brennan, David Cross, America Ferrera",
		"metacritic": "57",
		"imdbRating": "6.5",
		"imdbVotes": "8220",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQwNjYzMTQ0Ml5BMl5BanBnXkFtZTcwNDUzODM5Nw@@._V1_SX300.jpg",
		"plot": "Four couples meet for Sunday brunch only to discover they are stuck in a house together as the world may be about to end.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins."
	},
	{
		"id": "1995346",
		"imdbID": "tt1995346",
		"title": "Crazy Enough",
		"year": "2012",
		"rating": "PG",
		"runtime": "104 min",
		"genre": "Comedy",
		"released": "2013-04-16",
		"director": "Lance McDaniel",
		"writer": "Sean Lynch, Lance McDaniel",
		"cast": "Chris Kattan, Brooke Anna Leedy, Jonathan Beck Reed, Susana Gibb",
		"metacritic": "",
		"imdbRating": "2.9",
		"imdbVotes": "337",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTg0NDI1Nzk5NF5BMl5BanBnXkFtZTgwNjg3MjIwMDE@._V1_SX300.jpg",
		"plot": "Identical twins separated at birth: One a prominent psychiatrist; the other a life long mental patient. When the doctor gets called to his brother's institution, fate intervenes and the brothers swap places.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "1998163",
		"imdbID": "tt1998163",
		"title": "A Tiger in the Dark: Decadence, Pt 1: Final Conflict",
		"year": "2011",
		"rating": "R",
		"runtime": "172 min",
		"genre": "Drama",
		"released": "2013-08-19",
		"director": "Drew Glick, Ray Persaud, Antonio Joyner",
		"writer": "Drew Glick (screenplay)",
		"cast": "Tod Boulware, Chen Drachman, Patrícia Faolli, Drew Glick",
		"metacritic": "",
		"imdbRating": "8.1",
		"imdbVotes": "127",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTMzNzMxMjcyN15BMl5BanBnXkFtZTcwMjgxNDE3Nw@@._V1_SX300.jpg",
		"plot": "In a final effort to finish what he started Drew will return to the beginning to once and for all end the conflict that began nearly a decade ago. Inspired by true events.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "1999987",
		"imdbID": "tt1999987",
		"title": "Breathe In",
		"year": "2013",
		"rating": "R",
		"runtime": "98 min",
		"genre": "Drama, Romance",
		"released": "2013-07-19",
		"director": "Drake Doremus",
		"writer": "Drake Doremus, Ben York Jones",
		"cast": "Guy Pearce, Felicity Jones, Amy Ryan, Mackenzie Davis",
		"metacritic": "60",
		"imdbRating": "6.4",
		"imdbVotes": "9311",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgwNzY4MDYyN15BMl5BanBnXkFtZTgwODExMjgwMTE@._V1_SX300.jpg",
		"plot": "When a foreign exchange student arrives in a small upstate New York town, she challenges the dynamics of her host family's relationships and alters their lives forever.",
		"language": "English",
		"country": "USA",
		"awards": "3 nominations."
	},
	{
		"id": "2004271",
		"imdbID": "tt2004271",
		"title": "King's Faith",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "108 min",
		"genre": "Drama",
		"released": "2013-04-26",
		"director": "Nicholas DiBella",
		"writer": "Nicholas DiBella, Paul Root",
		"cast": "Lynn Whitfield, Crawford Wilson, James McDaniel, Kayla Compton",
		"metacritic": "",
		"imdbRating": "6.3",
		"imdbVotes": "417",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEyNzIyNDc0NF5BMl5BanBnXkFtZTcwNDYxNjUyOQ@@._V1_SX300.jpg",
		"plot": "When eighteen-year-old Brendan King attempts to leave his turbulent gang life behind him, his past continues to threaten his new-found faith, family, and future.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2004419",
		"imdbID": "tt2004419",
		"title": "Sanatorium",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Horror, Thriller",
		"released": "2013-10-18",
		"director": "Brant Sersen",
		"writer": "Brant Sersen",
		"cast": "Don Fanelli, Charlie Fersko, DJ Hazard, Lauren Hunter",
		"metacritic": "",
		"imdbRating": "4.9",
		"imdbVotes": "489",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIzNjQwNzM3NV5BMl5BanBnXkFtZTgwNTk0MTI4MzE@._V1_SX300.jpg",
		"plot": "In 1955, a insane patient left his room, walking to the children's ward. There he killed three children while they were asleep. Now, a group of paranormal investigators will go into the ...",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2004420",
		"imdbID": "tt2004420",
		"title": "Neighbors",
		"year": "2014",
		"rating": "R",
		"runtime": "97 min",
		"genre": "Comedy",
		"released": "2014-05-09",
		"director": "Nicholas Stoller",
		"writer": "Andrew Jay Cohen, Brendan O'Brien",
		"cast": "Seth Rogen, Rose Byrne, Elise Vargas, Zoey Vargas",
		"metacritic": "68",
		"imdbRating": "6.4",
		"imdbVotes": "193865",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTQ0OTkzODgyNF5BMl5BanBnXkFtZTgwOTA3OTE4MDE@._V1_SX300.jpg",
		"plot": "After they are forced to live next to a fraternity house, a couple with a newborn baby do whatever they can to take them down.",
		"language": "English",
		"country": "USA",
		"awards": "5 wins & 11 nominations."
	},
	{
		"id": "2005164",
		"imdbID": "tt2005164",
		"title": "Breathless",
		"year": "2012",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Comedy, Thriller",
		"released": "2016-01-09",
		"director": "Jesse Baget",
		"writer": "Jesse Baget, Stefania Moscato",
		"cast": "Val Kilmer, Ray Liotta, Gina Gershon, Kelli Giddish",
		"metacritic": "",
		"imdbRating": "4.9",
		"imdbVotes": "1050",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA0OTg2Mzc1M15BMl5BanBnXkFtZTcwMTc3OTMwOA@@._V1_SX300.jpg",
		"plot": "After killing her bank-robber husband, a Texas housewife must dispose of the body and find the loot while avoiding the local sheriff.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2011159",
		"imdbID": "tt2011159",
		"title": "No Good Deed",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "84 min",
		"genre": "Crime, Thriller",
		"released": "2014-09-12",
		"director": "Sam Miller",
		"writer": "Aimee Lagos",
		"cast": "Idris Elba, Taraji P. Henson, Leslie Bibb, Kate del Castillo",
		"metacritic": "26",
		"imdbRating": "5.6",
		"imdbVotes": "11406",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzk0OTc3MDM5MF5BMl5BanBnXkFtZTgwOTMzMDMzMjE@._V1_SX300.jpg",
		"plot": "An unstable escaped convict terrorizes a woman who is alone with her two children.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 2 nominations."
	},
	{
		"id": "2012665",
		"imdbID": "tt2012665",
		"title": "Repentance",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Drama, Horror, Thriller",
		"released": "2014-09-25",
		"director": "Philippe Caland",
		"writer": "Shintaro Shimosawa (screenplay), Philippe Caland (based on the film \"The Gypsy and the Gury\" by)",
		"cast": "Forest Whitaker, Anthony Mackie, Mike Epps, Sanaa Lathan",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "1667",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEyODkzNjUyNl5BMl5BanBnXkFtZTgwNDQwNDM2MDE@._V1_SX300.jpg",
		"plot": "A successful author and spiritual advisor takes on a troubled man as a client, completely unaware that the man's fixation on his mother's death will soon put his life in jeopardy.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2024432",
		"imdbID": "tt2024432",
		"title": "Identity Thief",
		"year": "2013",
		"rating": "R",
		"runtime": "111 min",
		"genre": "Comedy, Crime",
		"released": "2013-02-08",
		"director": "Seth Gordon",
		"writer": "Craig Mazin (screenplay), Jerry Eeten (story), Craig Mazin (story)",
		"cast": "Jason Bateman, Melissa McCarthy, Jon Favreau, Amanda Peet",
		"metacritic": "35",
		"imdbRating": "5.7",
		"imdbVotes": "91391",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY3NzM5MTk2Nl5BMl5BanBnXkFtZTcwMDQ4MjQ3OA@@._V1_SX300.jpg",
		"plot": "Mild mannered businessman Sandy Patterson travels from Denver to Florida to confront the deceptively harmless looking woman who has been living it up after stealing Sandy's identity.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 8 nominations."
	},
	{
		"id": "2024506",
		"imdbID": "tt2024506",
		"title": "Straight A's",
		"year": "2013",
		"rating": "R",
		"runtime": "91 min",
		"genre": "Comedy, Drama",
		"released": "2013-07-18",
		"director": "James Cox",
		"writer": "Dave Cole (screenplay), Dave Cole",
		"cast": "Ryan Phillippe, Anna Paquin, Luke Wilson, Riley Thomas Stewart",
		"metacritic": "",
		"imdbRating": "5.6",
		"imdbVotes": "3437",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY5MjIxNTUzNl5BMl5BanBnXkFtZTcwMzk1NzA3OA@@._V1_SX300.jpg",
		"plot": "Pressured by his deceased mother's ghost to return home to the family he abandoned, a former addict grabs a bag of pills and a sack of marijuana and hits the road to Louisiana.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2025690",
		"imdbID": "tt2025690",
		"title": "The Finest Hours",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "",
		"genre": "Action, Drama, History",
		"released": "2016-01-29",
		"director": "Craig Gillespie",
		"writer": "Scott Silver (screenplay), Paul Tamasy (screenplay), Eric Johnson (screenplay), Casey Sherman (book), Michael J. Tougias (book)",
		"cast": "Chris Pine, Eric Bana, Holliday Grainger, Ben Foster",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTY1MDU1NzYzN15BMl5BanBnXkFtZTgwOTA0MDQyNzE@._V1_SX300.jpg",
		"plot": "The Coast Guard makes a daring rescue attempt off the coast of Cape Cod after a pair of oil tankers are destroyed during a blizzard in 1952.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2027064",
		"imdbID": "tt2027064",
		"title": "Blue Caprice",
		"year": "2013",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Biography, Crime, Drama",
		"released": "2015-05-18",
		"director": "Alexandre Moors",
		"writer": "Alexandre Moors (story), R.F.I. Porto (screenplay), R.F.I. Porto (story)",
		"cast": "Tequan Richmond, April Yvette Thompson, Isaiah Washington, Abner Expósito",
		"metacritic": "76",
		"imdbRating": "6.0",
		"imdbVotes": "4387",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzYwMTcyMzU5OV5BMl5BanBnXkFtZTgwOTAwOTUwMDE@._V1_SX300.jpg",
		"plot": "An abandoned boy is lured to America and drawn into the shadow of a dangerous father figure. Inspired by the real life events that led to the 2002 Beltway sniper attacks.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 10 nominations."
	},
	{
		"id": "2048824",
		"imdbID": "tt2048824",
		"title": "Old Fashioned",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "115 min",
		"genre": "Drama, Romance",
		"released": "2014-09-18",
		"director": "Rik Swartzwelder",
		"writer": "Rik Swartzwelder",
		"cast": "Elizabeth Roberts, Rik Swartzwelder, LeJon Woods, Tyler Hollinger",
		"metacritic": "29",
		"imdbRating": "5.7",
		"imdbVotes": "1101",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjcxNzk4ODM3Nl5BMl5BanBnXkFtZTgwODA4OTI5MzE@._V1_SX300.jpg",
		"plot": "A former frat boy and a free-spirited woman together attempt the impossible: an \"old-fashioned\" courtship in contemporary America.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins."
	},
	{
		"id": "2048865",
		"imdbID": "tt2048865",
		"title": "AWOL-72",
		"year": "2015",
		"rating": "R",
		"runtime": "82 min",
		"genre": "Thriller",
		"released": "2015-09-25",
		"director": "Christian Sesma",
		"writer": "Cecil Chambers, Christian Sesma",
		"cast": "Bokeem Woodbine, Luke Goss, RZA, Louis Mandylor",
		"metacritic": "",
		"imdbRating": "3.8",
		"imdbVotes": "439",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTkyOTM3OTI2N15BMl5BanBnXkFtZTgwNzIxNjk1NDE@._V1_SX300.jpg",
		"plot": "An AWOL marine in possession of secret government information, is a wanted man, pursued by Russian special ops, the LAPD, and a dangerous assassin.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2051879",
		"imdbID": "tt2051879",
		"title": "Europa Report",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "90 min",
		"genre": "Sci-Fi, Thriller",
		"released": "2013-06-27",
		"director": "Sebastián Cordero",
		"writer": "Philip Gelatt",
		"cast": "Daniel Wu, Sharlto Copley, Christian Camargo, Karolina Wydra",
		"metacritic": "68",
		"imdbRating": "6.5",
		"imdbVotes": "48383",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA2OTk5ODkxMl5BMl5BanBnXkFtZTcwODc4MDk0OQ@@._V1_SX300.jpg",
		"plot": "An international crew of astronauts undertakes a privately funded mission to search for life on Jupiter's fourth largest moon.",
		"language": "English, Russian, Chinese",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "2051894",
		"imdbID": "tt2051894",
		"title": "Home Run",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "113 min",
		"genre": "Drama, Sport",
		"released": "2013-04-19",
		"director": "David Boyd",
		"writer": "Brian Brightly, Candace Lee, Eric Newman, Melanie Wistar",
		"cast": "Scott Elrod, Dorian Brown, Charles Henry Wyson, James Devoti",
		"metacritic": "",
		"imdbRating": "5.9",
		"imdbVotes": "2289",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDAzODgwNDY0Nl5BMl5BanBnXkFtZTcwNDQ3NjAxOQ@@._V1_SX300.jpg",
		"plot": "A pro ball player with a substance abuse problem is forced into rehab in his hometown, finding new hope when he gets honest about his checkered past, and takes on coaching duties for a misfit Little League team.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2053423",
		"imdbID": "tt2053423",
		"title": "Revenge for Jolly!",
		"year": "2012",
		"rating": "R",
		"runtime": "81 min",
		"genre": "Comedy, Drama",
		"released": "2013-05-07",
		"director": "Chadd Harbold",
		"writer": "Brian Petsos",
		"cast": "Brian Petsos, Kristen Wiig, Elijah Wood, Oscar Isaac",
		"metacritic": "",
		"imdbRating": "4.5",
		"imdbVotes": "959",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjg4MjgyMTU1MV5BMl5BanBnXkFtZTcwMzUxMjU1OQ@@._V1_SX300.jpg",
		"plot": "A man recruits his cousin to find out who is behind his dog's suspicious death.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2053463",
		"imdbID": "tt2053463",
		"title": "Side Effects",
		"year": "2013",
		"rating": "R",
		"runtime": "106 min",
		"genre": "Crime, Drama, Thriller",
		"released": "2013-02-08",
		"director": "Steven Soderbergh",
		"writer": "Scott Z. Burns",
		"cast": "Rooney Mara, Carmen Pelaez, Marin Ireland, Channing Tatum",
		"metacritic": "75",
		"imdbRating": "7.1",
		"imdbVotes": "142156",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc2MzY0NDAwOF5BMl5BanBnXkFtZTcwMTE1Mzc4OA@@._V1_SX300.jpg",
		"plot": "A young woman's world unravels when a drug prescribed by her psychiatrist has unexpected side effects.",
		"language": "English, French",
		"country": "USA",
		"awards": "4 nominations."
	},
	{
		"id": "2059171",
		"imdbID": "tt2059171",
		"title": "13 Sins",
		"year": "2014",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Horror, Thriller",
		"released": "2014-04-11",
		"director": "Daniel Stamm",
		"writer": "David Birke (screenplay), Daniel Stamm (screenplay), Chookiat Sakveerakul (source Material: \"13: Game of Death\" by), Eakasit Thairaat (source material: \"13: Game of Death\" by)",
		"cast": "Mark Webber, Devon Graye, Tom Bower, Rutina Wesley",
		"metacritic": "44",
		"imdbRating": "6.3",
		"imdbVotes": "21530",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzA0NDIwNjI3OF5BMl5BanBnXkFtZTgwMDMzNzE0MTE@._V1_SX300.jpg",
		"plot": "A cryptic phone call sets off a dangerous game of risks for Elliot, a down-on-his luck salesman. The game promises increasing rewards for completing 13 tasks, each more sinister than the last.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "2059195",
		"imdbID": "tt2059195",
		"title": "Child of God",
		"year": "2013",
		"rating": "R",
		"runtime": "104 min",
		"genre": "Crime, Drama, Thriller",
		"released": "2014-08-20",
		"director": "James Franco",
		"writer": "James Franco (screenplay), Vince Jolivette (screenplay), Cormac McCarthy (novel)",
		"cast": "James Franco, Tim Blake Nelson, Jim Parrack, Scott Haze",
		"metacritic": "50",
		"imdbRating": "5.4",
		"imdbVotes": "2547",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE1NzAyNTE4Nl5BMl5BanBnXkFtZTgwMDAwNjkxMjE@._V1_SX300.jpg",
		"plot": "A dispossessed, violent man's life is a disastrous attempt to exist outside the social order. Successively deprived of parents and homes and with few other ties, Ballard descends to the level of a cave dweller as he falls deeper into crime and degradation.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "2061573",
		"imdbID": "tt2061573",
		"title": "Actor? A Documentary",
		"year": "2014",
		"rating": "Not Rated",
		"runtime": "76 min",
		"genre": "Documentary, Animation",
		"released": "2014-01-17",
		"director": "David Rich",
		"writer": "David Rich",
		"cast": "Ruben Angelo, Danielle McNichol, Brandon Shepard, John Schile",
		"metacritic": "",
		"imdbRating": "8.4",
		"imdbVotes": "17",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA3NDIzMTM5OF5BMl5BanBnXkFtZTcwNzQxMzY0OA@@._V1_SX300.jpg",
		"plot": "We take a look at what it means to be an actor, what it takes to be an actor and ways to make it as an actor. We do this through the use of interviews across the country with striving actors as well as actors who have \"made\" it.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2063666",
		"imdbID": "tt2063666",
		"title": "Hello I Must Be Going",
		"year": "2012",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Comedy, Drama, Romance",
		"released": "2013-01-31",
		"director": "Todd Louiso",
		"writer": "Sarah Koskoff",
		"cast": "Melanie Lynskey, Blythe Danner, John Rubinstein, Sara Chase",
		"metacritic": "62",
		"imdbRating": "6.2",
		"imdbVotes": "4366",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzkzMDc0Nzg5OF5BMl5BanBnXkFtZTcwMDU0MzAyOA@@._V1_SX300.jpg",
		"plot": "Circumstances force a young divorcée to move back in with her parents in suburban Connecticut, where an affair with a younger guy rejuvenates her passion for life",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "2069955",
		"imdbID": "tt2069955",
		"title": "Border Run",
		"year": "2012",
		"rating": "R",
		"runtime": "96 min",
		"genre": "Crime, Thriller",
		"released": "2013-08-28",
		"director": "Gabriela Tagliavini",
		"writer": "Don Fiebiger, Amy Kolquist",
		"cast": "Sharon Stone, Billy Zane, Rosemberg Salgado, Manolo Cardona",
		"metacritic": "",
		"imdbRating": "4.2",
		"imdbVotes": "1359",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAyNDUwOTk5M15BMl5BanBnXkFtZTcwODE3Nzc4OQ@@._V1_SX300.jpg",
		"plot": "A female American reporter searches for her missing brother against the backdrop of violence and human smuggling across the US/Mexican border.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2077851",
		"imdbID": "tt2077851",
		"title": "Sleepwalk with Me",
		"year": "2012",
		"rating": "PG-13",
		"runtime": "81 min",
		"genre": "Comedy",
		"released": "2013-04-04",
		"director": "Mike Birbiglia, Seth Barrish",
		"writer": "Mike Birbiglia (screenplay), Ira Glass (screenplay), Joe Birbiglia (screenplay), Seth Barrish (screenplay), Mike Birbiglia (based on the play \"Sleepwalk With Me\" by)",
		"cast": "Mike Birbiglia, Lauren Ambrose, James Rebhorn, Carol Kane",
		"metacritic": "71",
		"imdbRating": "6.8",
		"imdbVotes": "9309",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM3MDUzMDQwNF5BMl5BanBnXkFtZTcwMDk1NjM4OA@@._V1_SX300.jpg",
		"plot": "A burgeoning stand-up comedian struggles with the stress of a stalled career, a stale relationship, and the wild spurts of severe sleepwalking he is desperate to ignore.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 4 nominations."
	},
	{
		"id": "2078549",
		"imdbID": "tt2078549",
		"title": "SEAL Patrol",
		"year": "2014",
		"rating": "R",
		"runtime": "80 min",
		"genre": "Action, Sci-Fi, Thriller",
		"released": "2014-02-11",
		"director": "Nicolas Aaron Mezzanatto",
		"writer": "Nicolas Aaron Mezzanatto, Joshua Ringle",
		"cast": "Kristina Anapau, James C. Burns, Tina Casciani, Courtney Compton",
		"metacritic": "",
		"imdbRating": "3.6",
		"imdbVotes": "543",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUzNTg2OTAzMV5BMl5BanBnXkFtZTgwMDE0NjAyMTE@._V1_SX300.jpg",
		"plot": "After losing contact with a clandestine energy research facility, a powerful venture capitalist contracts a private team of elite military operatives to retrieve a physicist who holds the key to an unprecedented alternate energy source.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2095713",
		"imdbID": "tt2095713",
		"title": "Missionary",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Drama, Thriller",
		"released": "2013-10-27",
		"director": "Anthony DiBlasi",
		"writer": "Bruce Wood, Scott Poiley",
		"cast": "Dawn Olivieri, Mitch Ryan, Kip Pardue, J. LaRose",
		"metacritic": "48",
		"imdbRating": "5.3",
		"imdbVotes": "451",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIyOTY0MDg2Ml5BMl5BanBnXkFtZTcwMTE3NDU4OQ@@._V1_SX300.jpg",
		"plot": "Katherine is a struggling mother trying to create a better life for her and her son. She meets Elder Brock, a handsome Mormon missionary with a troubled past and they begin an incendiary ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2096672",
		"imdbID": "tt2096672",
		"title": "Dumb and Dumber To",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "109 min",
		"genre": "Comedy",
		"released": "2014-11-14",
		"director": "Bobby Farrelly, Peter Farrelly",
		"writer": "Sean Anders, John Morris, Peter Farrelly, Bobby Farrelly, Bennett Yellin, Mike Cerrone, Bennett Yellin (based on characters created by), Peter Farrelly (based on characters created by), Bobby Farrelly (based on characters created by)",
		"cast": "Jim Carrey, Jeff Daniels, Rob Riggle, Laurie Holden",
		"metacritic": "36",
		"imdbRating": "5.7",
		"imdbVotes": "89273",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYxMzA0MzAyMF5BMl5BanBnXkFtZTgwMjMyNjcwMjE@._V1_SX300.jpg",
		"plot": "Twenty years since their first adventure, Lloyd and Harry go on a road trip to find Harry's newly discovered daughter, who was given up for adoption.",
		"language": "English, Cantonese",
		"country": "USA",
		"awards": "1 win & 6 nominations."
	},
	{
		"id": "2096673",
		"imdbID": "tt2096673",
		"title": "Inside Out",
		"year": "2015",
		"rating": "PG",
		"runtime": "95 min",
		"genre": "Animation, Adventure, Comedy",
		"released": "2015-06-19",
		"director": "Pete Docter, Ronnie Del Carmen",
		"writer": "Pete Docter (original story by), Ronnie Del Carmen (original story by), Pete Docter (screenplay), Meg LeFauve (screenplay), Josh Cooley (screenplay)",
		"cast": "Amy Poehler, Phyllis Smith, Richard Kind, Bill Hader",
		"metacritic": "94",
		"imdbRating": "8.3",
		"imdbVotes": "243897",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTgxMDQwMDk0OF5BMl5BanBnXkFtZTgwNjU5OTg2NDE@._V1_SX300.jpg",
		"plot": "After young Riley is uprooted from her Midwest life and moved to San Francisco, her emotions - Joy, Fear, Anger, Disgust and Sadness - conflict on how best to navigate a new city, house, and school.",
		"language": "English",
		"country": "USA",
		"awards": "Won 1 Golden Globe. Another 28 wins & 77 nominations."
	},
	{
		"id": "2101341",
		"imdbID": "tt2101341",
		"title": "Dead Man Down",
		"year": "2013",
		"rating": "R",
		"runtime": "118 min",
		"genre": "Action, Crime, Drama",
		"released": "2013-03-08",
		"director": "Niels Arden Oplev",
		"writer": "J.H. Wyman",
		"cast": "Colin Farrell, Noomi Rapace, Terrence Howard, Dominic Cooper",
		"metacritic": "39",
		"imdbRating": "6.5",
		"imdbVotes": "52079",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM2NTU5NTIzMF5BMl5BanBnXkFtZTcwNjQ3MTM5OA@@._V1_SX300.jpg",
		"plot": "In New York City, a crime lord's right-hand man is helped by a woman seeking retribution.",
		"language": "English, French, Albanian, Spanish, Hungarian",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2101383",
		"imdbID": "tt2101383",
		"title": "Knight of Cups",
		"year": "2015",
		"rating": "R",
		"runtime": "118 min",
		"genre": "Drama, Romance",
		"released": "2016-03-04",
		"director": "Terrence Malick",
		"writer": "Terrence Malick",
		"cast": "Christian Bale, Cate Blanchett, Natalie Portman, Brian Dennehy",
		"metacritic": "58",
		"imdbRating": "6.1",
		"imdbVotes": "4161",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDQ2NTM3MTAxNV5BMl5BanBnXkFtZTgwNTY1NjgzNDE@._V1_SX300.jpg",
		"plot": "A screenwriter living in LA tries to make sense of the strange events occurring around him.",
		"language": "English, German, Serbian",
		"country": "USA",
		"awards": "2 wins & 2 nominations."
	},
	{
		"id": "2101441",
		"imdbID": "tt2101441",
		"title": "Spring Breakers",
		"year": "2012",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Action, Crime, Drama",
		"released": "2013-03-22",
		"director": "Harmony Korine",
		"writer": "Harmony Korine",
		"cast": "James Franco, Selena Gomez, Vanessa Hudgens, Ashley Benson",
		"metacritic": "63",
		"imdbRating": "5.3",
		"imdbVotes": "103417",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDE3MDQzMDA5OF5BMl5BanBnXkFtZTcwMTUxNTgxOQ@@._V1_SX300.jpg",
		"plot": "Four college girls hold up a restaurant in order to fund their spring break vacation. While partying/drinking/taking drugs they are arrested only to be bailed out by a drug and arms dealer.",
		"language": "English",
		"country": "USA",
		"awards": "11 wins & 26 nominations."
	},
	{
		"id": "2113075",
		"imdbID": "tt2113075",
		"title": "The Inevitable Defeat of Mister & Pete",
		"year": "2013",
		"rating": "R",
		"runtime": "108 min",
		"genre": "Drama",
		"released": "2013-01-25",
		"director": "George Tillman Jr.",
		"writer": "Michael Starrbury",
		"cast": "Skylan Brooks, Ethan Dizon, Jennifer Hudson, Adewale Akinnuoye-Agbaje",
		"metacritic": "61",
		"imdbRating": "7.5",
		"imdbVotes": "3877",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUwMjgyNTE2OV5BMl5BanBnXkFtZTgwNzU1MzgwMDE@._V1_SX300.jpg",
		"plot": "A coming-of-age story about two inner city boys who are left to fend for themselves over the summer after their mothers are taken away by the authorities.",
		"language": "English",
		"country": "USA",
		"awards": "9 nominations."
	},
	{
		"id": "2119474",
		"imdbID": "tt2119474",
		"title": "Maximum Conviction",
		"year": "2012",
		"rating": "R",
		"runtime": "98 min",
		"genre": "Action, Adventure, Thriller",
		"released": "2013-01-12",
		"director": "Keoni Waxman",
		"writer": "Richard Beattie",
		"cast": "Steven Seagal, Steve Austin, Michael Paré, Ian Robison",
		"metacritic": "",
		"imdbRating": "4.9",
		"imdbVotes": "4935",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIyMTM1NTc0NF5BMl5BanBnXkFtZTcwMTQ3MjQ0OA@@._V1_SX300.jpg",
		"plot": "When former black ops operative Cross (Seagal) and his partner Manning (Austin) are assigned to decommission an old prison, they must oversee the arrival of two mysterious female prisoners....",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2122424",
		"imdbID": "tt2122424",
		"title": "Nailbiter",
		"year": "2013",
		"rating": "R",
		"runtime": "82 min",
		"genre": "Horror",
		"released": "2013-05-28",
		"director": "Patrick Rea",
		"writer": "Patrick Rea, Kendal Sinn",
		"cast": "Erin McGrane, Meg Saricks, Emily Boresow, Sally Spurgeon",
		"metacritic": "",
		"imdbRating": "4.2",
		"imdbVotes": "1715",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgzNzY0ODk1MV5BMl5BanBnXkFtZTcwMDM0MzE2OQ@@._V1_SX300.jpg",
		"plot": "The Maguire family is forced to take sudden refuge in a seemingly abandoned storm cellar from a deadly tornado.",
		"language": "English",
		"country": "USA",
		"awards": "4 wins."
	},
	{
		"id": "2123342",
		"imdbID": "tt2123342",
		"title": "Underdogs",
		"year": "2013",
		"rating": "PG",
		"runtime": "102 min",
		"genre": "Drama, Family, Sport",
		"released": "2013-04-06",
		"director": "Doug Dearth",
		"writer": "David Latham (screenplay), Benjamin Suarez (story)",
		"cast": "D.B. Sweeney, William Mapother, Richard Portnow, Logan Huffman",
		"metacritic": "",
		"imdbRating": "5.7",
		"imdbVotes": "707",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQyODM3OTY1OV5BMl5BanBnXkFtZTcwNDg1MDIzOQ@@._V1_SX300.jpg",
		"plot": "Set in rural Ohio, the birthplace of football, a small-town high school football team rises to play their cross-town rival, a perennial powerhouse, while standing up for an entire community.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2123884",
		"imdbID": "tt2123884",
		"title": "3 Nights in the Desert",
		"year": "2014",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Drama",
		"released": "2014-01-04",
		"director": "Gabriel Cowan",
		"writer": "Adam Chanzit (screenplay)",
		"cast": "Wes Bentley, Vincent Piazza, Amber Tamblyn",
		"metacritic": "",
		"imdbRating": "6.2",
		"imdbVotes": "1789",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDM2MjMyMTQ3M15BMl5BanBnXkFtZTgwMDg3OTQxNDE@._V1_SX300.jpg",
		"plot": "THE BIG CHILL meets THE GRADUATE. What could have been? What might have been? Reunions can be exciting, frustrating, exhilarating, nostalgic, one life given over to practicality while ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2139555",
		"imdbID": "tt2139555",
		"title": "Playing It Cool",
		"year": "2014",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Comedy, Romance",
		"released": "2015-05-08",
		"director": "Justin Reardon",
		"writer": "Chris Shafer (screenplay), Paul Vicknair (screenplay)",
		"cast": "Chris Evans, Michelle Monaghan, Topher Grace, Aubrey Plaza",
		"metacritic": "29",
		"imdbRating": "6.0",
		"imdbVotes": "13186",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIwMjA2ODU3NF5BMl5BanBnXkFtZTgwMjk2MDA2NTE@._V1_SX300.jpg",
		"plot": "Unrequited love motivates a guy to write about his experiences.",
		"language": "",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2144820",
		"imdbID": "tt2144820",
		"title": "Stand Your Ground",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "107 min",
		"genre": "Crime, Drama",
		"released": "2014-01-17",
		"director": "Michael McClendon",
		"writer": "Michael McClendon (screenplay), Jackie Carpenter (novel)",
		"cast": "Francine Locke, Drew Matthews, Cameron Arnett, Sandra Elise Williams",
		"metacritic": "",
		"imdbRating": "7.0",
		"imdbVotes": "32",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMyODEyOTMzN15BMl5BanBnXkFtZTgwNzc5ODYxMDE@._V1_SX300.jpg",
		"plot": "A woman struggles with her faith when her son is falsely accused of murder and the odds are stacked against him.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 1 nomination."
	},
	{
		"id": "2155391",
		"imdbID": "tt2155391",
		"title": "The Midnight Game",
		"year": "2013",
		"rating": "R",
		"runtime": "74 min",
		"genre": "Horror, Thriller",
		"released": "2013-03-02",
		"director": "A.D. Calvo",
		"writer": "A.D. Calvo (story), Brett A. Calvo (idea), Rick Dahl (screenplay), Rick Dahl (story)",
		"cast": "Renee Olstead, Shelby Young, Guy Wilson, Valentina de Angelis",
		"metacritic": "",
		"imdbRating": "4.8",
		"imdbVotes": "529",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA0MjM2NzIxOF5BMl5BanBnXkFtZTgwNTQ0MTk4MTE@._V1_SX300.jpg",
		"plot": "After playing a pagan ritual on a dare, a group of high school students find themselves trapped in an endless cycle of their worst fears.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2158531",
		"imdbID": "tt2158531",
		"title": "Holla II",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Comedy, Horror",
		"released": "2013-04-19",
		"director": "H.M. Coakley",
		"writer": "H.M. Coakley",
		"cast": "Vanessa Bell Calloway, Kiely Williams, Greg Cipes, Trae Ireland",
		"metacritic": "",
		"imdbRating": "6.7",
		"imdbVotes": "73",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkyMzUzMzQ0M15BMl5BanBnXkFtZTcwNDg3MjgyOQ@@._V1_SX300.jpg",
		"plot": "After narrowly escaping with her life at the hands of her mentally ill sister Veronica, Monica, with the help of her Mother, Marion, has taken great measures to ensure her safety, including...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2165765",
		"imdbID": "tt2165765",
		"title": "Fear Clinic",
		"year": "2015",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Horror",
		"released": "2015-01-30",
		"director": "Robert Hall",
		"writer": "Aaron Drane, Robert Hall",
		"cast": "Robert Englund, Fiona Dourif, Felisha Terrell, Cleopatra Coleman",
		"metacritic": "",
		"imdbRating": "5.5",
		"imdbVotes": "6372",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ2NjA5MTA3NF5BMl5BanBnXkFtZTgwNDk1MDExMzE@._V1_SX300.jpg",
		"plot": "A doctor works to cure patients suffering from crippling phobias by placing them inside his invention which induces and controls hallucinations.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2166500",
		"imdbID": "tt2166500",
		"title": "Self Storage",
		"year": "2013",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Horror",
		"released": "2013-09-17",
		"director": "Tom DeNucci",
		"writer": "Tom DeNucci",
		"cast": "Eric Roberts, Jonathan Silverman, Michael Berryman, Nick Principe",
		"metacritic": "",
		"imdbRating": "3.1",
		"imdbVotes": "279",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzAyMzA2MTc3Nl5BMl5BanBnXkFtZTgwNzc3MjIwMDE@._V1_SX300.jpg",
		"plot": "The friends of a night watchman, at a highly secured self storage facility, are home from college and looking to party.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2166834",
		"imdbID": "tt2166834",
		"title": "Batman: The Dark Knight Returns, Part 2",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "76 min",
		"genre": "Animation, Action, Crime",
		"released": "2013-01-29",
		"director": "Jay Oliva",
		"writer": "Bob Kane (Batman characters), Jerry Siegel (Superman characters), Joe Shuster (Superman characters), Frank Miller (comic book), Klaus Janson (comic book), Bob Goodman",
		"cast": "Peter Weller, Ariel Winter, Michael Emerson, David Selby",
		"metacritic": "",
		"imdbRating": "8.4",
		"imdbVotes": "24062",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMzMjkxOTc3MV5BMl5BanBnXkFtZTcwNTE0ODAwOQ@@._V1_SX300.jpg",
		"plot": "The Batman has returned after a 10-year absence. The Gotham authorities want to arrest him. An old foe wants a reunion. The Feds want the Man of Tomorrow to put a stop to him.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "2166934",
		"imdbID": "tt2166934",
		"title": "My Man Is a Loser",
		"year": "2014",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Comedy",
		"released": "2014-07-25",
		"director": "Mike Young",
		"writer": "Mike Young",
		"cast": "John Stamos, Sean Young, Tika Sumpter, Diane Guerrero",
		"metacritic": "19",
		"imdbRating": "4.2",
		"imdbVotes": "961",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzcyNjMzMjczOF5BMl5BanBnXkFtZTgwMDExMjk4MTE@._V1_SX300.jpg",
		"plot": "Two married friends employ a single playboy to help them get their mojo back to save their marriages.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2168882",
		"imdbID": "tt2168882",
		"title": "R.A.D.I.C.A.L.S",
		"year": "2014",
		"rating": "G",
		"runtime": "80 min",
		"genre": "Action, Adventure, Family",
		"released": "2014-05-15",
		"director": "Berenika Maciejewicz",
		"writer": "Dillaran Martin (character), Gary Petras",
		"cast": "Michela Crayton, Keith Nagel, Adia Dinh, Tim Taylor",
		"metacritic": "",
		"imdbRating": "4.4",
		"imdbVotes": "35",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY1NzUxNzE3NV5BMl5BanBnXkFtZTgwMDM4MDgwMTE@._V1_SX300.jpg",
		"plot": "Eight kids develop their natural talents to superhero levels to confront a comic-book-inspired villain kidnapping neighborhood dogs to pull off the crime of the century.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2170242",
		"imdbID": "tt2170242",
		"title": "Yellow Day",
		"year": "2015",
		"rating": "PG",
		"runtime": "98 min",
		"genre": "Drama, Family, Fantasy",
		"released": "2015-12-25",
		"director": "Carl Lauten",
		"writer": "G.P. Galle Jr.",
		"cast": "Drew Seeley, Lindsey Shaw, Ashley Boettcher, Akeem Smith",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY1NTIwNDg4OV5BMl5BanBnXkFtZTgwNDEzMzc5NjE@._V1_SX300.jpg",
		"plot": "Yellow Day chronicles a young man's life-changing and inspirational journey through the mysterious Yellow Day. To many, the Yellow Day is simply a fun day celebrating outreach at a kid's ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2170593",
		"imdbID": "tt2170593",
		"title": "St. Vincent",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "102 min",
		"genre": "Comedy, Drama",
		"released": "2014-10-24",
		"director": "Theodore Melfi",
		"writer": "Theodore Melfi (screenplay)",
		"cast": "Bill Murray, Melissa McCarthy, Naomi Watts, Chris O'Dowd",
		"metacritic": "64",
		"imdbRating": "7.3",
		"imdbVotes": "65641",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk5NzI5OTA4MF5BMl5BanBnXkFtZTgwNjc4NTM3MjE@._V1_SX300.jpg",
		"plot": "A young boy whose parents have just divorced finds an unlikely friend and mentor in the misanthropic, bawdy, hedonistic war veteran who lives next door.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "Nominated for 2 Golden Globes. Another 5 wins & 17 nominations."
	},
	{
		"id": "2170667",
		"imdbID": "tt2170667",
		"title": "Wheels",
		"year": "2014",
		"rating": "R",
		"runtime": "115 min",
		"genre": "Drama",
		"released": "2014-09-19",
		"director": "Tim Gagliardo, Donavon Warren",
		"writer": "Donavon Warren",
		"cast": "Donavon Warren, Patrick Hume, Diana Gettinger, Kevin McCorkle",
		"metacritic": "",
		"imdbRating": "8.2",
		"imdbVotes": "700",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM3OTI0MDQ5Ml5BMl5BanBnXkFtZTgwODQwMTk3MjE@._V1_SX300.jpg",
		"plot": "Two suicidal paraplegic junkies hustle their way through the city streets trying to find a reason to live.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2171867",
		"imdbID": "tt2171867",
		"title": "Empire State",
		"year": "2013",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Action, Crime, Drama",
		"released": "2013-08-30",
		"director": "Dito Montiel",
		"writer": "Adam Mazer",
		"cast": "Liam Hemsworth, Michael Angarano, Dwayne Johnson, Paul Ben-Victor",
		"metacritic": "",
		"imdbRating": "5.2",
		"imdbVotes": "13480",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjExOTY4MDEzNF5BMl5BanBnXkFtZTcwNzIyMTY3OQ@@._V1_SX300.jpg",
		"plot": "Two childhood friends plan to rob an armored car depository. An NYPD officer stands in their way.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2172935",
		"imdbID": "tt2172935",
		"title": "Metallica Through the Never",
		"year": "2013",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Music",
		"released": "2013-10-04",
		"director": "Nimród Antal",
		"writer": "Nimród Antal, Kirk Hammett, James Hetfield, Robert Trujillo, Lars Ulrich",
		"cast": "Dane DeHaan, James Hetfield, Lars Ulrich, Kirk Hammett",
		"metacritic": "61",
		"imdbRating": "7.2",
		"imdbVotes": "12600",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjQwNjk5MTk4Ml5BMl5BanBnXkFtZTcwNTgwNDA5OQ@@._V1_SX300.jpg",
		"plot": "Trip, a young roadie for Metallica, is sent on an urgent mission during the band's show. But what seems like a simple assignment turns into a surreal adventure.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 3 nominations."
	},
	{
		"id": "2175184",
		"imdbID": "tt2175184",
		"title": "Total Retribution",
		"year": "2011",
		"rating": "R",
		"runtime": "84 min",
		"genre": "Horror, Sci-Fi, Thriller",
		"released": "2013-02-26",
		"director": "Andrew Bellware",
		"writer": "Montserrat Mendez (story)",
		"cast": "Robin Kurtz, Walter Barnes, Joe Beuerlein, Greg Oliver Bodine",
		"metacritic": "",
		"imdbRating": "2.2",
		"imdbVotes": "320",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA5MDY2MTI5N15BMl5BanBnXkFtZTgwMDU1NjA2MDE@._V1_SX300.jpg",
		"plot": "Trapped on a space station orbiting Earth, a small army of human survivors battle the Undead in order to prevent the destruction of the Earth.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2179226",
		"imdbID": "tt2179226",
		"title": "Absolute Deception",
		"year": "2013",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Action",
		"released": "2013-07-17",
		"director": "Brian Trenchard-Smith",
		"writer": "Jeffrey Schenck (story), Peter Sullivan (story), Kraig Wenman",
		"cast": "Cuba Gooding Jr., Emmanuelle Vaugier, Evert McQueen, Ty Hungerford",
		"metacritic": "",
		"imdbRating": "4.2",
		"imdbVotes": "1110",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODg1MTcyNDk3N15BMl5BanBnXkFtZTgwMzAyMTA1MTE@._V1_SX300.jpg",
		"plot": "A widowed reporter recruits the help of a federal agent to investigate her late husband's secrets, but the two become the target of unknown attackers.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2191701",
		"imdbID": "tt2191701",
		"title": "Grown Ups 2",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "101 min",
		"genre": "Comedy",
		"released": "2013-07-12",
		"director": "Dennis Dugan",
		"writer": "Fred Wolf, Adam Sandler, Tim Herlihy, Adam Sandler (based on characters created by), Fred Wolf (based on characters created by)",
		"cast": "Adam Sandler, Kevin James, Chris Rock, David Spade",
		"metacritic": "19",
		"imdbRating": "5.4",
		"imdbVotes": "101521",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgwNTI2MDI0OF5BMl5BanBnXkFtZTcwMTk5MDg0OQ@@._V1_SX300.jpg",
		"plot": "After moving his family back to his hometown to be with his friends and their kids, Lenny finds out that between old bullies, new bullies, schizo bus drivers, drunk cops on skis, and 400 costumed party crashers sometimes crazy follows you.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "4 wins & 15 nominations."
	},
	{
		"id": "2199571",
		"imdbID": "tt2199571",
		"title": "Run All Night",
		"year": "2015",
		"rating": "R",
		"runtime": "114 min",
		"genre": "Action, Crime, Drama",
		"released": "2015-03-13",
		"director": "Jaume Collet-Serra",
		"writer": "Brad Ingelsby",
		"cast": "Liam Neeson, Ed Harris, Joel Kinnaman, Boyd Holbrook",
		"metacritic": "59",
		"imdbRating": "6.6",
		"imdbVotes": "63597",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU2ODI3ODEyOV5BMl5BanBnXkFtZTgwMTM3NTQzNDE@._V1_SX300.jpg",
		"plot": "Mobster and hit man Jimmy Conlon has one night to figure out where his loyalties lie: with his estranged son, Mike, whose life is in danger, or his longtime best friend, mob boss Shawn Maguire, who wants Mike to pay for the death of his own son.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2229499",
		"imdbID": "tt2229499",
		"title": "Don Jon",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Comedy, Drama, Romance",
		"released": "2013-09-27",
		"director": "Joseph Gordon-Levitt",
		"writer": "Joseph Gordon-Levitt",
		"cast": "Joseph Gordon-Levitt, Scarlett Johansson, Julianne Moore, Tony Danza",
		"metacritic": "66",
		"imdbRating": "6.6",
		"imdbVotes": "180885",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQxNTc3NDM2MF5BMl5BanBnXkFtZTcwNzQ5NTQ3OQ@@._V1._CR28,28.649993896484375,1271,1991.0000305175781_SX89_AL_.jpg_V1_SX300.jpg",
		"plot": "A New Jersey guy dedicated to his family, friends, and church, develops unrealistic expectations from watching porn and works to find happiness and intimacy with his potential true love.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 24 nominations."
	},
	{
		"id": "2229511",
		"imdbID": "tt2229511",
		"title": "Wer",
		"year": "2013",
		"rating": "R",
		"runtime": "89 min",
		"genre": "Action, Horror, Mystery",
		"released": "2014-08-19",
		"director": "William Brent Bell",
		"writer": "William Brent Bell (screenplay), Matthew Peterman (screenplay)",
		"cast": "A.J. Cook, Sebastian Roché, Vik Sahay, Stephanie Lemelin",
		"metacritic": "",
		"imdbRating": "5.9",
		"imdbVotes": "5203",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDM2MDYxODE2Ml5BMl5BanBnXkFtZTgwMjcxMjc3MTE@._V1_SX300.jpg",
		"plot": "A defense attorney begins to suspect that there might be more to her client, who is charged with the murders of a vacationing family, than meets the eye.",
		"language": "English, French",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2230358",
		"imdbID": "tt2230358",
		"title": "Curse of Chucky",
		"year": "2013",
		"rating": "R",
		"runtime": "97 min",
		"genre": "Crime, Horror",
		"released": "2013-09-24",
		"director": "Don Mancini",
		"writer": "Don Mancini (characters), Don Mancini",
		"cast": "Chantal Quesnelle, Fiona Dourif, Jordan Gavaris, Danielle Bisutti",
		"metacritic": "",
		"imdbRating": "5.6",
		"imdbVotes": "21685",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUwNTA1OTQ0Nl5BMl5BanBnXkFtZTgwNjg4MDA0MDE@._V1_SX300.jpg",
		"plot": "After her mother's mysterious death, Nica begins to suspect that the talking, red-haired doll her visiting niece has been playing with may be the key to recent bloodshed and chaos.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 1 nomination."
	},
	{
		"id": "2234155",
		"imdbID": "tt2234155",
		"title": "The Internship",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "119 min",
		"genre": "Comedy",
		"released": "2013-06-07",
		"director": "Shawn Levy",
		"writer": "Vince Vaughn (screenplay), Jared Stern (screenplay), Vince Vaughn (story)",
		"cast": "Vince Vaughn, Owen Wilson, Rose Byrne, Aasif Mandvi",
		"metacritic": "42",
		"imdbRating": "6.3",
		"imdbVotes": "151101",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM1MzczMDgwOV5BMl5BanBnXkFtZTcwMDM4NjM2OQ@@._V1_SX300.jpg",
		"plot": "Two salesmen whose careers have been torpedoed by the digital age find their way into a coveted internship at Google, where they must compete with a group of young, tech-savvy geniuses for a shot at employment.",
		"language": "English, Tagalog, Cantonese, Mandarin, Spanish",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2234457",
		"imdbID": "tt2234457",
		"title": "Templar Nation",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "84 min",
		"genre": "Adventure, Thriller",
		"released": "2013-07-23",
		"director": "Brian Vance, Liliana Corona",
		"writer": "Allen Johnson (screenplay)",
		"cast": "Erik Estrada, Richard Dutcher, Joseph James, Jaisaac",
		"metacritic": "",
		"imdbRating": "3.7",
		"imdbVotes": "97",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg4ODgxMzkwM15BMl5BanBnXkFtZTcwNzU0MTI2OQ@@._V1_SX300.jpg",
		"plot": "After an archaeologist and his students excavate a Templar Knight's tomb, they are thrown into the middle of an ancient blood feud. They must either follow the Templar's ancient path or ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2235108",
		"imdbID": "tt2235108",
		"title": "Dear White People",
		"year": "2014",
		"rating": "R",
		"runtime": "108 min",
		"genre": "Comedy, Drama",
		"released": "2014-12-04",
		"director": "Justin Simien",
		"writer": "Justin Simien (screenplay)",
		"cast": "Tyler James Williams, Tessa Thompson, Kyle Gallner, Teyonah Parris",
		"metacritic": "79",
		"imdbRating": "6.3",
		"imdbVotes": "17014",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMzMjc5MjIzNV5BMl5BanBnXkFtZTgwNTY4OTQ2MjE@._V1_SX300.jpg",
		"plot": "The lives of four black students at an Ivy League college.",
		"language": "English",
		"country": "USA",
		"awards": "14 wins & 24 nominations."
	},
	{
		"id": "2235902",
		"imdbID": "tt2235902",
		"title": "Geography Club",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "84 min",
		"genre": "Comedy",
		"released": "2014-02-05",
		"director": "Gary Entin",
		"writer": "Edmund Entin (screenplay), Brent Hartinger (novel)",
		"cast": "Cameron Deane Stewart, Justin Deeley, Meaghan Martin, Wesley Eure",
		"metacritic": "57",
		"imdbRating": "6.5",
		"imdbVotes": "3629",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTEwNzk2MjIxNTZeQTJeQWpwZ15BbWU4MDM1MDE4MjAx._V1_SX300.jpg",
		"plot": "At Goodkind High School, a group of students with varying sexual orientations form an after-school club as a discreet way to share their feelings and experiences.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 4 nominations."
	},
	{
		"id": "2239832",
		"imdbID": "tt2239832",
		"title": "Think Like a Man Too",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "106 min",
		"genre": "Comedy, Romance",
		"released": "2014-06-20",
		"director": "Tim Story",
		"writer": "Keith Merryman (screenplay), David A. Newman (screenplay), Steve Harvey (book)",
		"cast": "Adam Brody, Michael Ealy, Jerry Ferrara, Meagan Good",
		"metacritic": "38",
		"imdbRating": "5.7",
		"imdbVotes": "13978",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE2NjMxNjU1OF5BMl5BanBnXkFtZTgwMTI1OTgxMTE@._V1_SX300.jpg",
		"plot": "All the couples are back for a wedding in Las Vegas, but plans for a romantic weekend go awry when their various misadventures get them into some compromising situations that threaten to derail the big event.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 4 nominations."
	},
	{
		"id": "2245084",
		"imdbID": "tt2245084",
		"title": "Big Hero 6",
		"year": "2014",
		"rating": "PG",
		"runtime": "102 min",
		"genre": "Animation, Action, Adventure",
		"released": "2014-11-07",
		"director": "Don Hall, Chris Williams",
		"writer": "Jordan Roberts (screenplay), Robert L. Baird (screenplay), Daniel Gerson (screenplay), Man of Action (Big Hero 6 team and characters created by), Steven T. Seagle (Big Hero 6 team and characters created by), Joseph Mateo (head of story), Paul Briggs (head of story)",
		"cast": "Scott Adsit, Ryan Potter, Daniel Henney, T.J. Miller",
		"metacritic": "74",
		"imdbRating": "7.9",
		"imdbVotes": "240755",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI4MTIzODU2NV5BMl5BanBnXkFtZTgwMjE0NDAwMjE@._V1_SX300.jpg",
		"plot": "The special bond that develops between plus-sized inflatable robot Baymax, and prodigy Hiro Hamada, who team up with a group of friends to form a band of high-tech heroes.",
		"language": "English",
		"country": "USA",
		"awards": "Won 1 Oscar. Another 12 wins & 53 nominations."
	},
	{
		"id": "2247476",
		"imdbID": "tt2247476",
		"title": "When the Game Stands Tall",
		"year": "2014",
		"rating": "PG",
		"runtime": "115 min",
		"genre": "Drama, Sport",
		"released": "2014-08-22",
		"director": "Thomas Carter",
		"writer": "Scott Marshall Smith (screenplay), Scott Marshall Smith (story), David Zelon (story), Neil Hayes (book)",
		"cast": "Jim Caviezel, Michael Chiklis, Alexander Ludwig, Clancy Brown",
		"metacritic": "41",
		"imdbRating": "6.6",
		"imdbVotes": "11363",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ5NDMzOTI3MV5BMl5BanBnXkFtZTgwMjU4MTMyMjE@._V1_SX300.jpg",
		"plot": "The journey of legendary football coach Bob Ladouceur, who took the De La Salle High School Spartans from obscurity to a 151-game winning streak that shattered all records for any American sport.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2258345",
		"imdbID": "tt2258345",
		"title": "Fading Gigolo",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Comedy",
		"released": "2014-04-09",
		"director": "John Turturro",
		"writer": "John Turturro",
		"cast": "John Turturro, Woody Allen, Vanessa Paradis, Liev Schreiber",
		"metacritic": "58",
		"imdbRating": "6.2",
		"imdbVotes": "18146",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzMjU3NjY0Nl5BMl5BanBnXkFtZTgwMTQ1NDM5MDE@._V1_SX300.jpg",
		"plot": "Fioravante decides to become a professional Don Juan as a way of making money to help his cash-strapped friend, Murray. With Murray acting as his \"manager\", the duo quickly finds themselves caught up in the crosscurrents of love and money.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 1 nomination."
	},
	{
		"id": "2265050",
		"imdbID": "tt2265050",
		"title": "A Short History of Decay",
		"year": "2014",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Comedy",
		"released": "2015-02-25",
		"director": "Michael Maren",
		"writer": "Michael Maren",
		"cast": "Emmanuelle Chriqui, Bryan Greenberg, Kathleen Rose Perkins, Harris Yulin",
		"metacritic": "54",
		"imdbRating": "6.1",
		"imdbVotes": "309",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkyOTg1MzE2NF5BMl5BanBnXkFtZTgwMTg3MTQ3MTE@._V1_SX300.jpg",
		"plot": "A comedy from an original script by Michael Maren, about a failed Brooklyn writer, Nathan Fisher, played by Bryan Greenberg, who visits his ailing parents in Florida. His mother (Lavin) has...",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2265080",
		"imdbID": "tt2265080",
		"title": "Red Wing",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "108 min",
		"genre": "Drama, Romance",
		"released": "2015-01-14",
		"director": "Will Wallace",
		"writer": "Kathleen Orillion (screenplay), George Sand (based on The Country Waif (François le Champi) by)",
		"cast": "Glen Powell, Bill Paxton, Luke Perry, Joelle Carter",
		"metacritic": "",
		"imdbRating": "6.9",
		"imdbVotes": "151",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMzMDQ3ODcwMF5BMl5BanBnXkFtZTcwNzUzOTM2OQ@@._V1_SX300.jpg",
		"plot": "A socially thought-provoking and stirring love story based on the French novella, 'François Le Champi' by George Sand.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2272336",
		"imdbID": "tt2272336",
		"title": "Ghost Team One",
		"year": "2013",
		"rating": "R",
		"runtime": "84 min",
		"genre": "Comedy, Horror",
		"released": "2013-01-20",
		"director": "Ben Peyser, Scott Rutherford",
		"writer": "Andrew Knauer, Arthur Pielli",
		"cast": "Carlos Santos, J.R. Villarreal, Fernanda Romero, Tony Cavalero",
		"metacritic": "21",
		"imdbRating": "4.5",
		"imdbVotes": "1765",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTYwODQ3NzUyOV5BMl5BanBnXkFtZTgwNjAxNDcyMDE@._V1_SX300.jpg",
		"plot": "Two roommates deathly afraid of ghosts both fall in love with a girl who believes their home is haunted.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2273657",
		"imdbID": "tt2273657",
		"title": "True Story",
		"year": "2015",
		"rating": "R",
		"runtime": "99 min",
		"genre": "Crime, Drama, Mystery",
		"released": "2015-04-17",
		"director": "Rupert Goold",
		"writer": "Rupert Goold (screenplay), David Kajganich (screenplay), Michael Finkel (based on the book by)",
		"cast": "Jonah Hill, James Franco, Felicity Jones, Maria Dizzia",
		"metacritic": "50",
		"imdbRating": "6.3",
		"imdbVotes": "27381",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTAzNTc5MTA0NzleQTJeQWpwZ15BbWU4MDU1MDM2NzMx._V1_SX300.jpg",
		"plot": "When disgraced New York Times reporter Michael Finkel meets accused killer Christian Longo - who has taken on Finkel's identity - his investigation morphs into a game of cat-and-mouse.",
		"language": "English, Ibo",
		"country": "USA",
		"awards": "3 nominations."
	},
	{
		"id": "2274172",
		"imdbID": "tt2274172",
		"title": "The Contractor",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "87 min",
		"genre": "Crime, Drama, Thriller",
		"released": "2013-09-10",
		"director": "Sean Olson",
		"writer": "Bradford Holt (screenplay), Sean Olson (screenplay), Jeffrey Schenck (story), Peter Sullivan (screenplay), Peter Sullivan (story)",
		"cast": "Danny Trejo, Christina Cox, Brad Rowe, Taylor Spreitler",
		"metacritic": "",
		"imdbRating": "3.8",
		"imdbVotes": "510",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk1NTg3NDM0NF5BMl5BanBnXkFtZTgwNjMyNjcwMDE@._V1_SX300.jpg",
		"plot": "Elizabeth Chase is busy remodeling her new home with her husband and daughter. She hires a contractor, Javier, to help. But soon, Elizabeth starts to grow suspicious of Javier and learns that he'd targeted the family all along.",
		"language": "",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2274570",
		"imdbID": "tt2274570",
		"title": "Bad Milo",
		"year": "2013",
		"rating": "R",
		"runtime": "85 min",
		"genre": "Comedy, Horror",
		"released": "2013-08-29",
		"director": "Jacob Vaughan",
		"writer": "Benjamin Hayes, Jacob Vaughan",
		"cast": "Ken Marino, Gillian Jacobs, Mary Kay Place, Claudia Choi",
		"metacritic": "62",
		"imdbRating": "5.7",
		"imdbVotes": "4925",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzNTA5MTEwN15BMl5BanBnXkFtZTcwMDk1ODU5OQ@@._V1_SX300.jpg",
		"plot": "A horror comedy centered on a guy who learns that his unusual stomach problems are being caused by a demon living in his intestines.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 3 nominations."
	},
	{
		"id": "2275471",
		"imdbID": "tt2275471",
		"title": "A Perfect Man",
		"year": "2013",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Drama",
		"released": "2013-10-31",
		"director": "Kees Van Oostrum",
		"writer": "Larry Brand, Peter Elkoff",
		"cast": "Jeanne Tripplehorn, Liev Schreiber, Joelle Carter, Louise Fletcher",
		"metacritic": "31",
		"imdbRating": "5.2",
		"imdbVotes": "1407",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQyNjI5Nzc5N15BMl5BanBnXkFtZTgwODE4MTA1MDE@._V1_SX300.jpg",
		"plot": "A womanizing husband inadvertently falls back in love with his wife over the phone when she pretends to be another woman.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2276480",
		"imdbID": "tt2276480",
		"title": "A Little Game",
		"year": "2014",
		"rating": "PG",
		"runtime": "92 min",
		"genre": "Adventure, Family",
		"released": "2014-04-26",
		"director": "Evan Oppenheimer",
		"writer": "Evan Oppenheimer",
		"cast": "Fina Strazza, Ralph Macchio, F. Murray Abraham, Janeane Garofalo",
		"metacritic": "",
		"imdbRating": "6.5",
		"imdbVotes": "197",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM3MzU4MzY0Ml5BMl5BanBnXkFtZTgwOTkyNjQyNzE@._V1_SX300.jpg",
		"plot": "Ostracized at her posh new uptown school and shaken by the death of her beloved grandmother, a 10 year-old downtown girl finds an unlikely mentor in the form of an irascible chess-master, ...",
		"language": "English",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "2279233",
		"imdbID": "tt2279233",
		"title": "Reunion 108",
		"year": "2013",
		"rating": "R",
		"runtime": "118 min",
		"genre": "Comedy",
		"released": "2013-10-25",
		"director": "James Suttles, Billy Sample",
		"writer": "Billy Sample",
		"cast": "Justin Grace, Jack Mulcahy, Kera O'Bryon, Faron Salisbury",
		"metacritic": "",
		"imdbRating": "7.7",
		"imdbVotes": "30",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTEyODc4OTc0ODNeQTJeQWpwZ15BbWU3MDIxODA5ODg@._V1_SX300.jpg",
		"plot": "Two generations of professional baseball players return for a reunion game at one of their minor league stops en route to the big leagues. Unbeknownst to them, the owner of the club, on his...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2279339",
		"imdbID": "tt2279339",
		"title": "Love the Coopers",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "107 min",
		"genre": "Comedy",
		"released": "2015-11-13",
		"director": "Jessie Nelson",
		"writer": "Steven Rogers (screenplay)",
		"cast": "Diane Keaton, John Goodman, Ed Helms, Alex Borstein",
		"metacritic": "31",
		"imdbRating": "5.8",
		"imdbVotes": "3278",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE4NTkyODk4NF5BMl5BanBnXkFtZTgwNjY0NzkxNzE@._V1_SX300.jpg",
		"plot": "When four generations of the Cooper clan come together for their annual Christmas Eve celebration, a series of unexpected visitors and unlikely events turn the night upside down, leading them all toward a surprising rediscovery of family bonds and the spirit of the holiday.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2279373",
		"imdbID": "tt2279373",
		"title": "The SpongeBob Movie: Sponge Out of Water",
		"year": "2015",
		"rating": "PG",
		"runtime": "92 min",
		"genre": "Animation, Adventure, Comedy",
		"released": "2015-02-06",
		"director": "Paul Tibbitt, Mike Mitchell",
		"writer": "Glenn Berger (screenplay), Jonathan Aibel (screenplay), Stephen Hillenburg (story), Paul Tibbitt (story), Stephen Hillenburg (series \"SpongeBob SquarePants\")",
		"cast": "Antonio Banderas, Eric Bauza, Tim Conway, Eddie Deezen",
		"metacritic": "62",
		"imdbRating": "6.1",
		"imdbVotes": "29949",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjYyNDczNTE0MF5BMl5BanBnXkFtZTgwNjkzNDYxMzE@._V1_SX300.jpg",
		"plot": "When a diabolical pirate above the sea steals the secret Krabby Patty formula, SpongeBob and his nemesis Plankton must team up in order to get it back.",
		"language": "English",
		"country": "USA",
		"awards": "4 nominations."
	},
	{
		"id": "2281587",
		"imdbID": "tt2281587",
		"title": "Muppets Most Wanted",
		"year": "2014",
		"rating": "PG",
		"runtime": "107 min",
		"genre": "Adventure, Comedy, Crime",
		"released": "2014-03-21",
		"director": "James Bobin",
		"writer": "James Bobin, Nicholas Stoller, Jim Henson (based on)",
		"cast": "Ricky Gervais, Ty Burrell, Tina Fey, Steve Whitmire",
		"metacritic": "61",
		"imdbRating": "6.5",
		"imdbVotes": "22763",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA2OTc0MzAxMDVeQTJeQWpwZ15BbWU4MDUyOTgxNDIx._V1_SX300.jpg",
		"plot": "While on a grand world tour, The Muppets find themselves wrapped into an European jewel-heist caper headed by a Kermit the Frog look-alike and his dastardly sidekick.",
		"language": "English, German",
		"country": "USA",
		"awards": "3 wins & 8 nominations."
	},
	{
		"id": "2282016",
		"imdbID": "tt2282016",
		"title": "The Possession of Michael King",
		"year": "2014",
		"rating": "R",
		"runtime": "83 min",
		"genre": "Horror",
		"released": "2014-08-22",
		"director": "David Jung",
		"writer": "David Jung (screenplay), David Jung (story), Tedi Sarafian (story)",
		"cast": "Shane Johnson, Ella Anderson, Cara Pifko, Krystal Alvarez",
		"metacritic": "34",
		"imdbRating": "5.7",
		"imdbVotes": "8075",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTUzMzUxNzU4OF5BMl5BanBnXkFtZTgwNzUyMTcxMjE@._V1_SX300.jpg",
		"plot": "Michael King (Shane Johnson), who doesn't believe in God or the Devil. Following the sudden death of his wife, Michael decides to make his next film about the search for the existence of ...",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2287030",
		"imdbID": "tt2287030",
		"title": "Making the Rules",
		"year": "2014",
		"rating": "R",
		"runtime": "78 min",
		"genre": "Drama, Romance",
		"released": "2014-05-06",
		"director": "Jimbo Lee",
		"writer": "Jimbo Lee",
		"cast": "Jaime Pressly, Robin Thicke, Tygh Runyan, Joey Lauren Adams",
		"metacritic": "",
		"imdbRating": "3.3",
		"imdbVotes": "212",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkyMjUxMzUzN15BMl5BanBnXkFtZTgwMzk4NTg0MTE@._V1_SX300.jpg",
		"plot": "After cutting her hand a workaholic chef is forced to do nothing for the summer. As the heat rises she faces daily boredom with her husband and the temptation of an ex-boyfriend.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2287214",
		"imdbID": "tt2287214",
		"title": "Dracula: The Dark Prince",
		"year": "2013",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Action, Fantasy",
		"released": "2013-10-15",
		"director": "Pearry Reginald Teo",
		"writer": "Nicole Jones-Dion, Steven Paul, Pearry Reginald Teo",
		"cast": "Luke Roberts, Jon Voight, Kelly Wenham, Ben Robson",
		"metacritic": "",
		"imdbRating": "3.7",
		"imdbVotes": "1249",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg1OTIxOTE3MV5BMl5BanBnXkFtZTgwNTMwNzA2MDE@._V1_SX300.jpg",
		"plot": "In his search for the Lightbringer, Dracula crosses paths with a beautiful crusader named Alina who bears a remarkable resemblance to his murdered bride. One look at her and Dracula is ...",
		"language": "English, Romanian",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2292959",
		"imdbID": "tt2292959",
		"title": "The Canyons",
		"year": "2013",
		"rating": "R",
		"runtime": "99 min",
		"genre": "Drama, Thriller",
		"released": "2013-08-02",
		"director": "Paul Schrader",
		"writer": "Bret Easton Ellis",
		"cast": "Lindsay Lohan, James Deen, Nolan Gerard Funk, Amanda Brooks",
		"metacritic": "36",
		"imdbRating": "3.9",
		"imdbVotes": "8125",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkyMjk5NDA0OF5BMl5BanBnXkFtZTgwODEwNjU0MDE@._V1_SX300.jpg",
		"plot": "When Christian, an LA trust-fund kid with casual ties to Hollywood, learns of a secret affair between Tara and the lead of his film project, Ryan, he spirals out of control, and his cruel mind games escalate into an act of bloody violence.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 2 nominations."
	},
	{
		"id": "2293060",
		"imdbID": "tt2293060",
		"title": "Americons",
		"year": "2015",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Action, Biography, Crime",
		"released": "2015-01-23",
		"director": "Theo Avgerinos",
		"writer": "Beau Martin Williams (writer,  co-creator), Matt Funke (creator)",
		"cast": "Beau Martin Williams, Matt Funke, Trai Byers, Michael Masini",
		"metacritic": "25",
		"imdbRating": "6.8",
		"imdbVotes": "60",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA3Nzc5ODEwNF5BMl5BanBnXkFtZTgwNTY0NDA5MzE@._V1_SX300.jpg",
		"plot": "Raving through realty on the eve of the economic collapse. A high-velocity journey of an unsuspecting mortgage broker swallowed up in the sex, greed and over indulgence of the mid 2000's Real Estate boom.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2304646",
		"imdbID": "tt2304646",
		"title": "A Place at the Table",
		"year": "2012",
		"rating": "PG",
		"runtime": "84 min",
		"genre": "Documentary",
		"released": "2013-03-01",
		"director": "Kristi Jacobson, Lori Silverbush",
		"writer": "",
		"cast": "Adam Appelhanz, David Beckmann, Joel Berg, William Booker",
		"metacritic": "68",
		"imdbRating": "6.8",
		"imdbVotes": "880",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTg1NTk5MDU0N15BMl5BanBnXkFtZTcwNzA0ODE4OA@@._V1_SX300.jpg",
		"plot": "A documentary that investigates incidents of hunger experienced by millions of Americans, and proposed solutions to the problem.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "2304933",
		"imdbID": "tt2304933",
		"title": "The 5th Wave",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "112 min",
		"genre": "Action, Adventure, Sci-Fi",
		"released": "2016-01-22",
		"director": "J Blakeson",
		"writer": "Susannah Grant (screenplay), Akiva Goldsman (screenplay), Jeff Pinkner (screenplay), Rick Yancey (novel)",
		"cast": "Chloë Grace Moretz, Matthew Zuk, Gabriela Lopez, Bailey Anne Borders",
		"metacritic": "",
		"imdbRating": "5.9",
		"imdbVotes": "1840",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjQwOTc0Mzg3Nl5BMl5BanBnXkFtZTgwOTg3NjI2NzE@._V1_SX300.jpg",
		"plot": "Four waves of increasingly deadly alien attacks have left most of Earth decimated. Cassie is on the run, desperately trying to save her younger brother.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2309260",
		"imdbID": "tt2309260",
		"title": "The Gallows",
		"year": "2015",
		"rating": "R",
		"runtime": "81 min",
		"genre": "Horror, Thriller",
		"released": "2015-07-10",
		"director": "Travis Cluff, Chris Lofing",
		"writer": "Travis Cluff, Chris Lofing",
		"cast": "Reese Mishler, Pfeifer Brown, Ryan Shoos, Cassidy Gifford",
		"metacritic": "30",
		"imdbRating": "4.3",
		"imdbVotes": "10011",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU2MTMyOTkwM15BMl5BanBnXkFtZTgwOTQzNjc3NTE@._V1_SX300.jpg",
		"plot": "20 years after a horrific accident during a small town school play, students at the school resurrect the failed show in a misguided attempt to honor the anniversary of the tragedy - but soon discover that some things are better left alone.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2310109",
		"imdbID": "tt2310109",
		"title": "Small Time",
		"year": "2014",
		"rating": "R",
		"runtime": "104 min",
		"genre": "Drama",
		"released": "2014-04-18",
		"director": "Joel Surnow",
		"writer": "Joel Surnow",
		"cast": "Christopher Meloni, Devon Bostick, Dean Norris, Bridget Moynahan",
		"metacritic": "54",
		"imdbRating": "6.0",
		"imdbVotes": "1022",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU1Njc0Mjk1Nl5BMl5BanBnXkFtZTgwNjI4MzcxMTE@._V1_SX300.jpg",
		"plot": "A young guy decides to skip college in favor of joining his father on the lot of his used-car business.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2317524",
		"imdbID": "tt2317524",
		"title": "12 Rounds 2: Reloaded",
		"year": "2013",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Action, Adventure, Thriller",
		"released": "2013-06-04",
		"director": "Roel Reiné",
		"writer": "David Benullo",
		"cast": "Randy Orton, Tom Stevens, Brian Markinson, Venus Terzo",
		"metacritic": "",
		"imdbRating": "5.4",
		"imdbVotes": "3603",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkwNzA3MjM2NV5BMl5BanBnXkFtZTcwNjI5ODQ0OQ@@._V1._CR47,86.16667175292969,810,1017.0000152587891_SY132_CR8,0,89,132_AL_.jpg_V1_SX300.jpg",
		"plot": "WWE Wrestler Randy Orton portrays Nick Malloy, an Emergency Medical Technician (EMT) who finds himself caught in a deadly 12-round game of cat and mouse with a vigilante tied to the ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2318092",
		"imdbID": "tt2318092",
		"title": "Endless Love",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "104 min",
		"genre": "Drama, Romance",
		"released": "2014-02-14",
		"director": "Shana Feste",
		"writer": "Shana Feste (screenplay), Joshua Safran (screenplay), Scott Spencer (novel)",
		"cast": "Alex Pettyfer, Gabriella Wilde, Bruce Greenwood, Joely Richardson",
		"metacritic": "30",
		"imdbRating": "6.3",
		"imdbVotes": "28764",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTYzNDU1MzEyN15BMl5BanBnXkFtZTgwOTYwMTU0MDE@._V1_SX300.jpg",
		"plot": "The story of a privileged girl and a charismatic boy whose instant desire sparks a love affair made only more reckless by parents trying to keep them apart.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2318527",
		"imdbID": "tt2318527",
		"title": "Hell Baby",
		"year": "2013",
		"rating": "R",
		"runtime": "98 min",
		"genre": "Comedy, Horror",
		"released": "2014-03-01",
		"director": "Robert Ben Garant, Thomas Lennon",
		"writer": "Robert Ben Garant (screenplay), Thomas Lennon (screenplay)",
		"cast": "Rob Corddry, Leslie Bibb, Alex Berg, Keegan-Michael Key",
		"metacritic": "41",
		"imdbRating": "4.8",
		"imdbVotes": "7241",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzAwODI0MzAwOF5BMl5BanBnXkFtZTcwODkzMTc4OQ@@._V1_SX300.jpg",
		"plot": "An expectant couple who moves into the most haunted house in New Orleans call upon the services of the Vatican's elite exorcism team to save them from a demonic baby.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2349144",
		"imdbID": "tt2349144",
		"title": "Mississippi Grind",
		"year": "2015",
		"rating": "R",
		"runtime": "108 min",
		"genre": "Drama",
		"released": "2015-08-13",
		"director": "Anna Boden, Ryan Fleck",
		"writer": "Anna Boden, Ryan Fleck",
		"cast": "Ben Mendelsohn, Yvonne Landry, Anthony Howard, Ryan Reynolds",
		"metacritic": "77",
		"imdbRating": "6.4",
		"imdbVotes": "5491",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE3NTE3NzY2MV5BMl5BanBnXkFtZTgwNTY3NDIzNjE@._V1_SX300.jpg",
		"plot": "Down on his luck and facing financial hardship, Gerry teams up with younger charismatic poker player, Curtis, in an attempt to change his luck. The two set off on a road trip through the South with visions of winning back what's been lost.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 2 nominations."
	},
	{
		"id": "2357788",
		"imdbID": "tt2357788",
		"title": "Bridegroom",
		"year": "2013",
		"rating": "R",
		"runtime": "80 min",
		"genre": "Documentary",
		"released": "2013-11-19",
		"director": "Linda Bloodworth-Thomason",
		"writer": "",
		"cast": "Cindy Bitney, David Crone, Jessica Mitchell, Lizzy Mohl",
		"metacritic": "85",
		"imdbRating": "8.1",
		"imdbVotes": "2998",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQyNzQ2NjI0N15BMl5BanBnXkFtZTgwNTc5NjA0MDE@._V1_SX300.jpg",
		"plot": "Shane Bitney Crone's plans to marry Tom Bridegroom in California after the same-sex marriage law is passed takes a tragic turn when his partner of six years accidentally dies and Tom's family refuses Shane from attending the funeral.",
		"language": "English",
		"country": "USA",
		"awards": "8 wins & 2 nominations."
	},
	{
		"id": "2358925",
		"imdbID": "tt2358925",
		"title": "Unfinished Business",
		"year": "2015",
		"rating": "R",
		"runtime": "91 min",
		"genre": "Comedy",
		"released": "2015-03-06",
		"director": "Ken Scott",
		"writer": "Steve Conrad",
		"cast": "Vince Vaughn, Tom Wilkinson, Dave Franco, Sienna Miller",
		"metacritic": "32",
		"imdbRating": "5.4",
		"imdbVotes": "19636",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjg5NzU5ODE5OV5BMl5BanBnXkFtZTgwMjM1MjE2NDE@._V1_SX300.jpg",
		"plot": "A hard-working small business owner and his two associates travel to Europe to close the most important deal of their lives. But what began as a routine business trip goes off the rails in every way imaginable - and unimaginable.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2359307",
		"imdbID": "tt2359307",
		"title": "Squatters",
		"year": "2014",
		"rating": "R",
		"runtime": "102 min",
		"genre": "Drama",
		"released": "2014-05-13",
		"director": "Martin Weisz",
		"writer": "Justin Shilton",
		"cast": "Nancy Travis, Liana Mendoza, Gia Mantegna, Richard Dreyfuss",
		"metacritic": "",
		"imdbRating": "5.7",
		"imdbVotes": "1127",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA0NzcxNjM1MTZeQTJeQWpwZ15BbWU4MDg2MjYyODEx._V1_SX300.jpg",
		"plot": "Home early from their vacation, a wealthy Pacific Palisades family discovers a pair of homeless young drifters who were squatting in their home.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2359427",
		"imdbID": "tt2359427",
		"title": "Linsanity",
		"year": "2013",
		"rating": "PG",
		"runtime": "89 min",
		"genre": "Documentary, Biography, Sport",
		"released": "2013-10-02",
		"director": "Evan Leong",
		"writer": "Aaron Strongoni (narration writer)",
		"cast": "Daniel Dae Kim, Jeremy Lin, Ming Yao, Joseph Lin",
		"metacritic": "52",
		"imdbRating": "7.4",
		"imdbVotes": "1592",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAxNzU4ODM3Nl5BMl5BanBnXkFtZTgwNTIwMTEyMDE@._V1_SX300.jpg",
		"plot": "The life story of basketball sensation, Jeremy Lin.",
		"language": "English, Mandarin",
		"country": "USA",
		"awards": "2 wins & 1 nomination."
	},
	{
		"id": "2362354",
		"imdbID": "tt2362354",
		"title": "Spirit of Love: The Mike Glenn Story",
		"year": "2013",
		"rating": "PG",
		"runtime": "99 min",
		"genre": "Family, Sport",
		"released": "2014-08-01",
		"director": "Darla Rae",
		"writer": "Darla Rae (screenplay)",
		"cast": "Michael Adams, Willie Brown Jr., Neil Brown, Abbey Burkholder",
		"metacritic": "",
		"imdbRating": "8.1",
		"imdbVotes": "54",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI0MzM0MDk3M15BMl5BanBnXkFtZTcwMDQ3Nzc0OA@@._V1_SX300.jpg",
		"plot": "NBA player Mike \"Stinger\" Glenn plays himself in this wonderful film inspired by his real life Basketball camps for the Deaf & Hard of Hearing...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2364841",
		"imdbID": "tt2364841",
		"title": "Runner Runner",
		"year": "2013",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Crime, Thriller",
		"released": "2013-10-04",
		"director": "Brad Furman",
		"writer": "Brian Koppelman, David Levien",
		"cast": "Justin Timberlake, Ben Affleck, Gemma Arterton, Anthony Mackie",
		"metacritic": "36",
		"imdbRating": "5.6",
		"imdbVotes": "49603",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU5OTA0MjI4Ml5BMl5BanBnXkFtZTgwMTgxOTQwMDE@._V1_SX300.jpg",
		"plot": "When a poor college student who cracks an online poker game goes bust, he arranges a face-to-face with the man he thinks cheated him, a sly offshore entrepreneur.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2364949",
		"imdbID": "tt2364949",
		"title": "Touchy Feely",
		"year": "2013",
		"rating": "R",
		"runtime": "89 min",
		"genre": "Drama",
		"released": "2014-03-01",
		"director": "Lynn Shelton",
		"writer": "Lynn Shelton",
		"cast": "Rosemarie DeWitt, Amber Wolfe Wollam, Josh Pais, Ellen Page",
		"metacritic": "55",
		"imdbRating": "5.3",
		"imdbVotes": "2831",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjc1NjIyMzk5M15BMl5BanBnXkFtZTcwMDk2NjE3OQ@@._V1_SX300.jpg",
		"plot": "A massage therapist is unable to do her job when stricken with a mysterious and sudden aversion to bodily contact. Meanwhile, her uptight brother's floundering dental practice receives new life when clients seek out his healing touch.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2377322",
		"imdbID": "tt2377322",
		"title": "Deliver Us from Evil",
		"year": "2014",
		"rating": "R",
		"runtime": "118 min",
		"genre": "Horror, Mystery, Thriller",
		"released": "2014-07-02",
		"director": "Scott Derrickson",
		"writer": "Scott Derrickson (screenplay), Paul Harris Boardman (screenplay), Ralph Sarchie (book), Lisa Collier Cool (book)",
		"cast": "Eric Bana, Édgar Ramírez, Olivia Munn, Chris Coy",
		"metacritic": "40",
		"imdbRating": "6.2",
		"imdbVotes": "50440",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE2MDMwNTY2MF5BMl5BanBnXkFtZTgwMjQ5MDE5MTE@._V1_SX300.jpg",
		"plot": "New York police officer Ralph Sarchie investigates a series of crimes. He joins forces with an unconventional priest, schooled in the rites of exorcism, to combat the possessions that are terrorizing their city.",
		"language": "English, Spanish, Latin, Italian",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "2378401",
		"imdbID": "tt2378401",
		"title": "Meet the Patels",
		"year": "2014",
		"rating": "PG",
		"runtime": "88 min",
		"genre": "Documentary, Comedy, Romance",
		"released": "2015-09-11",
		"director": "Geeta Patel, Ravi Patel",
		"writer": "Matthew Hamachek, Billy McMillin, Geeta Patel, Ravi Patel",
		"cast": "Chandar Abboy, Renita Abboy, Rishika Advani, Rali Amin",
		"metacritic": "70",
		"imdbRating": "7.4",
		"imdbVotes": "277",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAxNzM3NjE4M15BMl5BanBnXkFtZTgwMDg3NjMzNjE@._V1_SX300.jpg",
		"plot": "An Indian-American man who is about to turn 30 gets help from his parents and extended family to start looking for a wife in the traditional Indian way.",
		"language": "English, Gujarati",
		"country": "USA",
		"awards": "3 wins & 3 nominations."
	},
	{
		"id": "2395427",
		"imdbID": "tt2395427",
		"title": "Avengers: Age of Ultron",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "141 min",
		"genre": "Action, Adventure, Sci-Fi",
		"released": "2015-05-01",
		"director": "Joss Whedon",
		"writer": "Joss Whedon, Stan Lee (Marvel comics), Jack Kirby (Marvel comics)",
		"cast": "Robert Downey Jr., Chris Hemsworth, Mark Ruffalo, Chris Evans",
		"metacritic": "66",
		"imdbRating": "7.6",
		"imdbVotes": "370909",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU4MDU3NDQ5Ml5BMl5BanBnXkFtZTgwOTU5MDUxNTE@._V1_SX300.jpg",
		"plot": "When Tony Stark and Bruce Banner try to jump-start a dormant peacekeeping program called Ultron, things go horribly wrong and it's up to Earth's Mightiest Heroes to stop the villainous Ultron from enacting his terrible plans.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 12 nominations."
	},
	{
		"id": "2396566",
		"imdbID": "tt2396566",
		"title": "Twenty Feet from Stardom",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "91 min",
		"genre": "Documentary, Music",
		"released": "2013-07-26",
		"director": "Morgan Neville",
		"writer": "",
		"cast": "Lou Adler, Stephanie 'Stevvi' Alexander, Patti Austin, Chris Botti",
		"metacritic": "83",
		"imdbRating": "7.4",
		"imdbVotes": "8941",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQxNDY2NjMwNF5BMl5BanBnXkFtZTcwNzExMDg0OQ@@._V1_SX300.jpg",
		"plot": "Backup singers live in a world that lies just beyond the spotlight. Their voices bring harmony to the biggest bands in popular music, but we've had no idea who these singers are or what lives they lead, until now.",
		"language": "English",
		"country": "USA",
		"awards": "Won 1 Oscar. Another 19 wins & 24 nominations."
	},
	{
		"id": "2401097",
		"imdbID": "tt2401097",
		"title": "Tracers",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "94 min",
		"genre": "Action, Crime, Drama",
		"released": "2015-03-20",
		"director": "Daniel Benmayor",
		"writer": "Matt Johnson (screenplay), T.J. Scott (story), Kevin Lund (story), Matt Johnson (story)",
		"cast": "Taylor Lautner, Marie Avgeropoulos, Adam Rayner, Rafi Gavron",
		"metacritic": "45",
		"imdbRating": "5.6",
		"imdbVotes": "11699",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzc2NDQ2MDU5N15BMl5BanBnXkFtZTgwMDc2MjE3MzE@._V1_SX300.jpg",
		"plot": "Wanted by the Chinese mafia, a New York City bike messenger escapes into the world of parkour after meeting a beautiful stranger.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "2415458",
		"imdbID": "tt2415458",
		"title": "The Wolfpack",
		"year": "2015",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Documentary, Biography",
		"released": "2015-07-10",
		"director": "Crystal Moselle",
		"writer": "",
		"cast": "Bhagavan Angulo, Govinda Angulo, Jagadisa Angulo, Krsna Angulo",
		"metacritic": "75",
		"imdbRating": "7.1",
		"imdbVotes": "4316",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzg2NjE5OTQwNl5BMl5BanBnXkFtZTgwNjYwNDk2NTE@._V1_SX300.jpg",
		"plot": "Locked away from society in an apartment on the Lower East Side of Manhattan, the Angulo brothers learn about the outside world through the films that they watch. Nicknamed, 'The Wolfpack,'...",
		"language": "English",
		"country": "USA",
		"awards": "5 wins & 9 nominations."
	},
	{
		"id": "2415464",
		"imdbID": "tt2415464",
		"title": "Hansel & Gretel",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "90 min",
		"genre": "Horror",
		"released": "2013-01-08",
		"director": "Anthony C. Ferrante",
		"writer": "Jose Prendes (screenplay)",
		"cast": "Dee Wallace, Stephanie Greco, Brent Lydic, Jasper Cole",
		"metacritic": "",
		"imdbRating": "2.7",
		"imdbVotes": "2660",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY5NjczNzAyMl5BMl5BanBnXkFtZTcwNjcxNDQ5OA@@._V1_SX300.jpg",
		"plot": "In this modern retelling of the classic horror tale, teen siblings are enslaved by a psychotic recluse within her gruesome house of horrors in the woods.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2420166",
		"imdbID": "tt2420166",
		"title": "The World Made Straight",
		"year": "2015",
		"rating": "R",
		"runtime": "119 min",
		"genre": "Drama",
		"released": "2015-01-09",
		"director": "David Burris",
		"writer": "Shane Danielsen (screenplay), Shane Danielsen, Ron Rash (novel)",
		"cast": "Noah Wyle, Jeremy Irvine, Minka Kelly, Adelaide Clemens",
		"metacritic": "48",
		"imdbRating": "5.4",
		"imdbVotes": "1225",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ0MjgxMzExNl5BMl5BanBnXkFtZTgwMTkwNjI0MzE@._V1_SX300.jpg",
		"plot": "In a rural Appalachian community haunted by the legacy of a Civil War massacre, a rebellious young man struggles to escape the violence that would bind him to the past.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2436386",
		"imdbID": "tt2436386",
		"title": "Project Almanac",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "106 min",
		"genre": "Sci-Fi, Thriller",
		"released": "2015-01-30",
		"director": "Dean Israelite",
		"writer": "Jason Pagan, Andrew Deutschman",
		"cast": "Jonny Weston, Sofia Black-D'Elia, Sam Lerner, Allen Evangelista",
		"metacritic": "47",
		"imdbRating": "6.4",
		"imdbVotes": "49426",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUxMjQ2NjI4OV5BMl5BanBnXkFtZTgwODc2NjUwNDE@._V1_SX300.jpg",
		"plot": "A group of teens discover secret plans of a time machine, and construct one. However, things start to get out of control.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2447952",
		"imdbID": "tt2447952",
		"title": "Ares 11",
		"year": "2013",
		"rating": "Not Rated",
		"runtime": "89 min",
		"genre": "Drama, Sci-Fi, Thriller",
		"released": "2014-10-15",
		"director": "Robert Goodrich",
		"writer": "Robert Goodrich",
		"cast": "Eric Bell, HavreDe Hill, David Hyland, Jack James",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU1MTI5OTk5NF5BMl5BanBnXkFtZTgwODU2ODY4MjE@._V1_SX300.jpg",
		"plot": "Four crew members of a military spacecraft are faced with an unfathomable dilemma after their ship is attacked, leaving them only enough air for two of them to return to base alive. In a ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2481480",
		"imdbID": "tt2481480",
		"title": "Rob the Mob",
		"year": "2014",
		"rating": "R",
		"runtime": "104 min",
		"genre": "Crime, Drama",
		"released": "2014-03-15",
		"director": "Raymond De Felitta",
		"writer": "Jonathan Fernandez",
		"cast": "Michael Pitt, Nina Arianda, Andy Garcia, Ray Romano",
		"metacritic": "63",
		"imdbRating": "6.3",
		"imdbVotes": "7978",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE4MTE4MTEyNl5BMl5BanBnXkFtZTgwMjIwNTgwMTE@._V1_SX300.jpg",
		"plot": "A Queens couple who specialize in robbing mafia social clubs stumble upon a score bigger than they could ever imagine, becoming targets of both the mob and the FBI in the process.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2481496",
		"imdbID": "tt2481496",
		"title": "Mercy",
		"year": "2014",
		"rating": "R",
		"runtime": "79 min",
		"genre": "Horror, Thriller",
		"released": "2014-10-07",
		"director": "Peter Cornwell",
		"writer": "Stephen King (short story \"Gramma\"), Matt Greenberg (screenplay)",
		"cast": "Dylan McDermott, Chandler Riggs, Frances O'Connor, Mark Duplass",
		"metacritic": "",
		"imdbRating": "5.0",
		"imdbVotes": "2796",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzODMyNDYxOF5BMl5BanBnXkFtZTgwMTA2NTU5MjE@._V1_SX300.jpg",
		"plot": "A single mom and her two boys help take care of their grandmother with mystical powers.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2503358",
		"imdbID": "tt2503358",
		"title": "Speak No Evil",
		"year": "2013",
		"rating": "R",
		"runtime": "74 min",
		"genre": "Horror",
		"released": "2015-10-08",
		"director": "Roze",
		"writer": "Roze",
		"cast": "Gabrielle Stone, Olivia Cavender, Carl Jensen IV, Sean Wesley",
		"metacritic": "",
		"imdbRating": "3.8",
		"imdbVotes": "388",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY4NjQ0NjEzMF5BMl5BanBnXkFtZTgwMTQwNzczMzE@._V1_SX300.jpg",
		"plot": "When all the children in a small town become possessed, one mother refuses to believe that her daughter is lost to the devil and will do whatever it takes to keep her alive.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2503944",
		"imdbID": "tt2503944",
		"title": "Burnt",
		"year": "2015",
		"rating": "R",
		"runtime": "101 min",
		"genre": "Comedy, Drama",
		"released": "2015-10-30",
		"director": "John Wells",
		"writer": "Steven Knight (screenplay), Michael Kalesniko (story)",
		"cast": "Bradley Cooper, Sienna Miller, Daniel Brühl, Riccardo Scamarcio",
		"metacritic": "42",
		"imdbRating": "6.7",
		"imdbVotes": "7592",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjEzNTk2OTEwNF5BMl5BanBnXkFtZTgwNzExMTg0NjE@._V1_SX300.jpg",
		"plot": "Adam Jones (Bradley Cooper) is a chef who destroyed his career with drugs and diva behavior. He cleans up and returns to London, determined to redeem himself by spearheading a top restaurant that can gain three Michelin stars.",
		"language": "English, French",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "2503954",
		"imdbID": "tt2503954",
		"title": "Broken Horses",
		"year": "2015",
		"rating": "R",
		"runtime": "101 min",
		"genre": "Action, Crime, Drama",
		"released": "2015-04-10",
		"director": "Vidhu Vinod Chopra",
		"writer": "Vidhu Vinod Chopra, Abhijat Joshi",
		"cast": "Anton Yelchin, Chris Marquette, Vincent D'Onofrio, María Valverde",
		"metacritic": "32",
		"imdbRating": "5.7",
		"imdbVotes": "1153",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTEyODkzODExMzReQTJeQWpwZ15BbWU4MDU0NjM2NzQx._V1_SX300.jpg",
		"plot": "The bonds of brotherhood, the laws of loyalty, and the futility of violence in the shadows of the US Mexico border gang wars.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2505818",
		"imdbID": "tt2505818",
		"title": "An Evergreen Christmas",
		"year": "2014",
		"rating": "PG",
		"runtime": "98 min",
		"genre": "Family, Music, Romance",
		"released": "2014-11-04",
		"director": "Jeremy Culver",
		"writer": "Jeremy Culver, Morgen Culver",
		"cast": "Robert Loggia, Naomi Judd, Booboo Stewart, Charleene Closshey",
		"metacritic": "",
		"imdbRating": "5.6",
		"imdbVotes": "154",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE2NTM4MTI1N15BMl5BanBnXkFtZTgwMDgwMTA5MjE@._V1_SX300.jpg",
		"plot": "Leaving her seemingly glamorous Hollywood life on hold, Evie Lee is forced to return to her small hometown of Balsam Falls, Tennessee and her family's once-thriving Christmas tree farm to ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2507280",
		"imdbID": "tt2507280",
		"title": "Mr. Jones",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "84 min",
		"genre": "Drama, Horror, Thriller",
		"released": "2014-05-02",
		"director": "Karl Mueller",
		"writer": "Karl Mueller",
		"cast": "Jon Foster, Sarah Jones, Mark Steger, Faran Tahir",
		"metacritic": "38",
		"imdbRating": "4.6",
		"imdbVotes": "2656",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA3NzIxOTA4MTFeQTJeQWpwZ15BbWU4MDY4NjQxMzEx._V1_SX300.jpg",
		"plot": "A young couple moves to the woods and soon finds their nightmares and reality colliding.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2509298",
		"imdbID": "tt2509298",
		"title": "Ephraim's Rescue",
		"year": "2013",
		"rating": "PG",
		"runtime": "99 min",
		"genre": "Adventure, Drama, History",
		"released": "2013-05-31",
		"director": "T.C. Christensen",
		"writer": "T.C. Christensen",
		"cast": "Darin Southam, Richard Benedict, James Gaisford, Koleman Stinger",
		"metacritic": "",
		"imdbRating": "6.0",
		"imdbVotes": "453",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA1NTc0MjcwOV5BMl5BanBnXkFtZTcwMDg1NTM1OQ@@._V1_SX300.jpg",
		"plot": "By listening to and following his heart, Ephraim Hanks finds his way in life and eventually provides relief and rescue to the suffering Martin Handcart Company. Based on a true story.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2510028",
		"imdbID": "tt2510028",
		"title": "Frontera",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "103 min",
		"genre": "Drama",
		"released": "2014-07-31",
		"director": "Michael Berry",
		"writer": "Michael Berry, Louis Moulinet",
		"cast": "Ed Harris, Michael Peña, Eva Longoria, Amy Madigan",
		"metacritic": "58",
		"imdbRating": "6.5",
		"imdbVotes": "5009",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQwOTA2NTM3OV5BMl5BanBnXkFtZTgwMDY1OTU5MTE@._V1_SX300.jpg",
		"plot": "A former Arizona sheriff's wife is killed while riding on their ranch property. It would appear a Mexican man illegally crossing into the US is at fault. As the former and the current sheriff search for answers, lives are changed forever.",
		"language": "English, Spanish, Persian",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2510894",
		"imdbID": "tt2510894",
		"title": "Hotel Transylvania 2",
		"year": "2015",
		"rating": "PG",
		"runtime": "89 min",
		"genre": "Animation, Comedy, Family",
		"released": "2015-09-25",
		"director": "Genndy Tartakovsky",
		"writer": "Robert Smigel, Adam Sandler",
		"cast": "Adam Sandler, Andy Samberg, Selena Gomez, Kevin James",
		"metacritic": "44",
		"imdbRating": "6.8",
		"imdbVotes": "27836",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEzNzc4NzEyMV5BMl5BanBnXkFtZTgwMTAxMDQ2NTE@._V1_SX300.jpg",
		"plot": "Dracula and his friends try to bring out the monster in his half human, half vampire grandson in order to keep Mavis from leaving the hotel.",
		"language": "English",
		"country": "USA",
		"awards": "3 nominations."
	},
	{
		"id": "2511428",
		"imdbID": "tt2511428",
		"title": "Cold Comes the Night",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Crime, Drama, Thriller",
		"released": "2014-01-10",
		"director": "Tze Chun",
		"writer": "Tze Chun, Osgood Perkins, Nick Simon",
		"cast": "Alice Eve, Ursula Parker, Logan Marshall-Green, Sarah Sokolovic",
		"metacritic": "37",
		"imdbRating": "5.7",
		"imdbVotes": "6670",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA4MTIzNTc2NTZeQTJeQWpwZ15BbWU4MDE0ODM4OTAx._V1_SX300.jpg",
		"plot": "A struggling motel owner and her daughter are taken hostage by a nearly blind career criminal to be his eyes as he attempts to retrieve his cash package from a crooked cop.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2512236",
		"imdbID": "tt2512236",
		"title": "Rumors of Wars",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "89 min",
		"genre": "Drama, Sci-Fi, Thriller",
		"released": "2014-05-02",
		"director": "Paul Tomborello",
		"writer": "Paul Tomborello (screenplay), Phillip Abraham",
		"cast": "Ben Davies, Jennifer Cooper, Eric Roberts, Michael Joiner",
		"metacritic": "",
		"imdbRating": "4.2",
		"imdbVotes": "286",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYwMzI0MzgwNV5BMl5BanBnXkFtZTgwNzYzNjM1MjE@._V1_SX300.jpg",
		"plot": "A student keeps a journal while a one world government takes over the world. Years later, a soldier finds her journal and questions everything he believes.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2537176",
		"imdbID": "tt2537176",
		"title": "I Spit on Your Grave 2",
		"year": "2013",
		"rating": "R",
		"runtime": "106 min",
		"genre": "Crime, Horror, Thriller",
		"released": "2014-01-19",
		"director": "Steven R. Monroe",
		"writer": "Neil Elman (screenplay), Thomas Fenton (screenplay)",
		"cast": "Jemma Dallender, Joe Absolom, Yavor Baharov, George Zlatarev",
		"metacritic": "",
		"imdbRating": "5.7",
		"imdbVotes": "16689",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc1Nzk3NjM0M15BMl5BanBnXkFtZTgwMjM5MzYyMDE@._V1_SX300.jpg",
		"plot": "When Katie innocently accepts an offer to have new photos taken for her portfolio, the experience quickly turns into a nightmare of rape, torture and kidnapping. Now, she will have to find the strength to exact her brutal revenge.",
		"language": "English, Bulgarian",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2547172",
		"imdbID": "tt2547172",
		"title": "Larry Gaye: Renegade Male Flight Attendant",
		"year": "2015",
		"rating": "R",
		"runtime": "99 min",
		"genre": "Comedy",
		"released": "2015-06-05",
		"director": "Sam Friedlander",
		"writer": "Mike Sikowitz, Mike Sikowitz",
		"cast": "Mark Feuerstein, Jessica Lowndes, Stanley Tucci, Christopher Fitzgerald",
		"metacritic": "",
		"imdbRating": "4.6",
		"imdbVotes": "469",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg4NDg1OTE4MF5BMl5BanBnXkFtZTgwMzU5NzA3NTE@._V1_SX300.jpg",
		"plot": "A self-anointed 'renegade' male flight attendant must save the day when the airline he works for tries to eliminate flight attendants as a cost-cutting measure.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2547210",
		"imdbID": "tt2547210",
		"title": "Born to Race: Fast Track",
		"year": "2014",
		"rating": "PG",
		"runtime": "94 min",
		"genre": "Action",
		"released": "2014-06-26",
		"director": "Alex Ranarivelo",
		"writer": "Steve Sarno (screenplay), Steve Sarno (story), Alex Ranarivelo (story), Ali Afshar (story), George Shamieh (story)",
		"cast": "Brett Davern, Beau Mirchoff, Bill Sage, Sharon Lawrence",
		"metacritic": "",
		"imdbRating": "5.4",
		"imdbVotes": "1294",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDEyNjIwMTEyMV5BMl5BanBnXkFtZTgwMjU0Njg5MTE@._V1_SX300.jpg",
		"plot": "Danny Krueger is a twenty-year old street racer who plays by his own rules. After winning a scholarship to the prestigious Fast Lane Racing Academy, Danny finds himself competing against ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2555426",
		"imdbID": "tt2555426",
		"title": "Company of Heroes",
		"year": "2013",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Action, War",
		"released": "2013-02-26",
		"director": "Don Michael Paul",
		"writer": "David Reed (screenplay), Danny Bilson (story), Paul De Meo (story)",
		"cast": "Tom Sizemore, Chad Michael Collins, Vinnie Jones, Dimitri Diatchenko",
		"metacritic": "",
		"imdbRating": "5.1",
		"imdbVotes": "4688",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQyMTY1Mjg3NF5BMl5BanBnXkFtZTcwMjc0NTY4OA@@._V1._CR13,16.166671752929688,601,748_SY132_CR8,0,89,132_AL_.jpg_V1_SX300.jpg",
		"plot": "American soldiers lost behind enemy lines during the WWII make a horrific discovery: Hitler has a super bomb in development. Against all odds, they set out to find the scientist in charge of the program who is looking to defect.",
		"language": "English, German",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2555652",
		"imdbID": "tt2555652",
		"title": "Forever",
		"year": "2015",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Drama",
		"released": "2015-09-25",
		"director": "Tatia Pilieva",
		"writer": "Gill Dennis, Tatia Pilieva",
		"cast": "Deborah Ann Woll, Luke Grimes, John Diehl, Rhys Coiro",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "160",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTk2Mjc2MzI2M15BMl5BanBnXkFtZTgwNTc5NDc3NjE@._V1_SX300.jpg",
		"plot": "Alice is a young investigative reporter. She suffers a sorrowful loss but finds an enigmatic commune where she starts to find her will to live and love again.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2557276",
		"imdbID": "tt2557276",
		"title": "Against the Sun",
		"year": "2014",
		"rating": "PG",
		"runtime": "100 min",
		"genre": "Adventure",
		"released": "2015-01-23",
		"director": "Brian Falk",
		"writer": "Brian Falk, Mark David Keegan",
		"cast": "Garret Dillahunt, Tom Felton, Jake Abel, Nadia Parra",
		"metacritic": "43",
		"imdbRating": "6.5",
		"imdbVotes": "2662",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTk5MjU0NTg3Nl5BMl5BanBnXkFtZTgwNTI3NTUzMzE@._V1_SX300.jpg",
		"plot": "A WWII pilot, bombardier, and radioman find themselves adrift on a lifeboat without food or water after being forced to ditch their plane during a scouting mission.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2557490",
		"imdbID": "tt2557490",
		"title": "A Million Ways to Die in the West",
		"year": "2014",
		"rating": "R",
		"runtime": "116 min",
		"genre": "Comedy, Western",
		"released": "2014-05-30",
		"director": "Seth MacFarlane",
		"writer": "Seth MacFarlane, Alec Sulkin, Wellesley Wild",
		"cast": "Seth MacFarlane, Charlize Theron, Amanda Seyfried, Liam Neeson",
		"metacritic": "44",
		"imdbRating": "6.1",
		"imdbVotes": "126592",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ0NDcyNjg0MV5BMl5BanBnXkFtZTgwMzk4NTA4MTE@._V1_SX300.jpg",
		"plot": "As a cowardly farmer begins to fall for the mysterious new woman in town, he must put his new-found courage to the test when her husband, a notorious gun-slinger, announces his arrival.",
		"language": "English, Navajo, Mandarin",
		"country": "USA",
		"awards": "6 nominations."
	},
	{
		"id": "2561546",
		"imdbID": "tt2561546",
		"title": "The Town That Dreaded Sundown",
		"year": "2014",
		"rating": "R",
		"runtime": "86 min",
		"genre": "Horror, Thriller",
		"released": "2014-10-17",
		"director": "Alfonso Gomez-Rejon",
		"writer": "Roberto Aguirre-Sacasa (screenplay), Earl E. Smith",
		"cast": "Addison Timlin, Veronica Cartwright, Anthony Anderson, Travis Tope",
		"metacritic": "47",
		"imdbRating": "5.6",
		"imdbVotes": "8401",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUwNzUyNjEwM15BMl5BanBnXkFtZTgwOTk3MTc2MjE@._V1_SX300.jpg",
		"plot": "65 years after a masked serial killer terrorized the small town of Texarkana, the so-called 'moonlight murders' begin again. Is it a copycat or something even more sinister? A lonely high school girl, with dark secrets of her own, may be the key to catching him.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "2561572",
		"imdbID": "tt2561572",
		"title": "Get Hard",
		"year": "2015",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Comedy, Crime",
		"released": "2015-03-27",
		"director": "Etan Cohen",
		"writer": "Jay Martel (screenplay), Ian Roberts (screenplay), Etan Cohen (screenplay), Adam McKay (story), Jay Martel (story), Ian Roberts (story)",
		"cast": "Will Ferrell, Kevin Hart, Craig T. Nelson, Alison Brie",
		"metacritic": "34",
		"imdbRating": "6.1",
		"imdbVotes": "66673",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc3OTc1NjM0M15BMl5BanBnXkFtZTgwNjAyMzE1MzE@._V1_SX300.jpg",
		"plot": "When millionaire James King is jailed for fraud and bound for San Quentin, he turns to Darnell Lewis to prep him to go behind bars.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2562232",
		"imdbID": "tt2562232",
		"title": "Birdman or (The Unexpected Virtue of Ignorance)",
		"year": "2014",
		"rating": "R",
		"runtime": "119 min",
		"genre": "Comedy, Drama",
		"released": "2014-11-14",
		"director": "Alejandro González Iñárritu",
		"writer": "Alejandro González Iñárritu, Nicolás Giacobone, Alexander Dinelaris, Armando Bo, Raymond Carver (play)",
		"cast": "Michael Keaton, Emma Stone, Kenny Chin, Jamahl Garrison-Lowe",
		"metacritic": "88",
		"imdbRating": "7.8",
		"imdbVotes": "348804",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODAzNDMxMzAxOV5BMl5BanBnXkFtZTgwMDMxMjA4MjE@._V1_SX300.jpg",
		"plot": "Illustrated upon the progress of his latest Broadway play, a former popular actor's struggle to cope with his current life as a wasted actor is shown.",
		"language": "English",
		"country": "USA",
		"awards": "Won 4 Oscars. Another 169 wins & 248 nominations."
	},
	{
		"id": "2620736",
		"imdbID": "tt2620736",
		"title": "Jug Face",
		"year": "2013",
		"rating": "R",
		"runtime": "81 min",
		"genre": "Drama, Horror, Thriller",
		"released": "2013-07-08",
		"director": "Chad Crawford Kinkle",
		"writer": "Chad Crawford Kinkle",
		"cast": "Sean Bridgers, Lauren Ashley Carter, Kaitlin Cullum, Larry Fessenden",
		"metacritic": "58",
		"imdbRating": "5.2",
		"imdbVotes": "4875",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI2ODI0Nzg2Nl5BMl5BanBnXkFtZTcwNzM4MzU2OQ@@._V1_SX300.jpg",
		"plot": "Jug Face tells the story of a pregnant teen trying to escape a backwoods community when she discovers that she may be sacrificed to a creature in a pit.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2621126",
		"imdbID": "tt2621126",
		"title": "Mindless Behavior: All Around the World",
		"year": "2013",
		"rating": "G",
		"runtime": "86 min",
		"genre": "Documentary",
		"released": "2013-03-15",
		"director": "Steven Goldfried",
		"writer": "",
		"cast": "Myles Brown, Princeton, Prodigy, Ray Ray",
		"metacritic": "",
		"imdbRating": "6.8",
		"imdbVotes": "368",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYwNDU3MDE5N15BMl5BanBnXkFtZTcwMzI0NzcxOQ@@._V1_SX300.jpg",
		"plot": "A documentary that follows the R&B/hip-hop boy band as they travel across the US on their first major headlining tour.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2631862",
		"imdbID": "tt2631862",
		"title": "House Party: Tonight's the Night",
		"year": "2013",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Comedy",
		"released": "2013-07-23",
		"director": "Darin Scott",
		"writer": "Don D. Scott",
		"cast": "Jeremy Boado, Alanka Craffert, Raja Fenske, Zac Goodspeed",
		"metacritic": "",
		"imdbRating": "4.3",
		"imdbVotes": "540",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk1NzY4MDQ0Nl5BMl5BanBnXkFtZTgwODI3NzA2MDE@._V1_SX300.jpg",
		"plot": "Chris is ready to head to college. But he'll leave his best friend and the girl he's had a crush on since 2nd grade. So he throws one last party that turns into a hilarious disaster.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2635006",
		"imdbID": "tt2635006",
		"title": "The Retrieval",
		"year": "2013",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Drama, History, Western",
		"released": "2014-04-02",
		"director": "Chris Eska",
		"writer": "Chris Eska",
		"cast": "Ashton Sanders, Tishuan Scott, Keston John, Bill Oberst Jr.",
		"metacritic": "75",
		"imdbRating": "6.5",
		"imdbVotes": "1712",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjU3Mzk3MjU4Nl5BMl5BanBnXkFtZTgwNDQzOTczMTE@._V1_SX300.jpg",
		"plot": "On the outskirts of the U.S. Civil War, a boy is sent north by his bounty hunter gang to retrieve a wanted man.",
		"language": "English",
		"country": "USA",
		"awards": "9 wins & 3 nominations."
	},
	{
		"id": "2674040",
		"imdbID": "tt2674040",
		"title": "Keep on Keepin' On",
		"year": "2014",
		"rating": "R",
		"runtime": "84 min",
		"genre": "Documentary",
		"released": "2015-03-05",
		"director": "Alan Hicks",
		"writer": "Davis Coombe, Alan Hicks",
		"cast": "Candy, Terri Lyne Carrington, Quincy Cavers, Bill Cosby",
		"metacritic": "77",
		"imdbRating": "7.6",
		"imdbVotes": "629",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIxOTU3MjU4Nl5BMl5BanBnXkFtZTgwMjc4OTI5MzE@._V1_SX300.jpg",
		"plot": "A documentary that follows jazz legend Clark Terry over four years to document the mentorship between Terry and 23-year-old blind piano prodigy Justin Kauflin as the young man prepares to compete in an elite, international competition.",
		"language": "English",
		"country": "USA",
		"awards": "14 wins & 8 nominations."
	},
	{
		"id": "2734660",
		"imdbID": "tt2734660",
		"title": "A Haunted House",
		"year": "2013",
		"rating": "R",
		"runtime": "86 min",
		"genre": "Comedy, Horror",
		"released": "2013-01-11",
		"director": "Michael Tiddes",
		"writer": "Marlon Wayans, Rick Alvarez",
		"cast": "Marlon Wayans, Marlene Forte, Essence Atkins, David Koechner",
		"metacritic": "20",
		"imdbRating": "5.1",
		"imdbVotes": "32401",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTM1ODgyOTI0NF5BMl5BanBnXkFtZTcwODgyMDY3OA@@._V1_SX300.jpg",
		"plot": "Malcolm and Kisha move into their dream home, but soon learn a demon also resides there. When Kisha becomes possessed, Malcolm - determined to keep his sex life on track - turns to a priest, a psychic, and a team of ghost-busters for help.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "2752688",
		"imdbID": "tt2752688",
		"title": "Rosewater",
		"year": "2014",
		"rating": "R",
		"runtime": "103 min",
		"genre": "Biography, Drama",
		"released": "2014-11-27",
		"director": "Jon Stewart",
		"writer": "Jon Stewart (screenplay), Maziar Bahari (book), Aimee Molloy (book)",
		"cast": "Gael García Bernal, Kim Bodnia, Dimitri Leonidas, Haluk Bilginer",
		"metacritic": "67",
		"imdbRating": "6.6",
		"imdbVotes": "7339",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjY1NjQ1NjMzNl5BMl5BanBnXkFtZTgwNzU0Mjc1MjE@._V1_SX300.jpg",
		"plot": "Iranian-Canadian journalist Maziar Bahari is detained by Iranian forces who brutally interrogate him under suspicion that he is a spy.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "2752736",
		"imdbID": "tt2752736",
		"title": "The Stream",
		"year": "2013",
		"rating": "PG",
		"runtime": "82 min",
		"genre": "Adventure, Comedy, Family",
		"released": "2013-10-15",
		"director": "Estlin Feigley",
		"writer": "Colin Costello (screenplay), Colin Costello, Estlin Feigley (based on an idea by)",
		"cast": "Mario Lopez, Christopher Gorham, Kelly Rutherford, Rainn Wilson",
		"metacritic": "",
		"imdbRating": "6.8",
		"imdbVotes": "49",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMwMDg0Mzc3OF5BMl5BanBnXkFtZTgwMjM5NDM5MjE@._V1_SX300.jpg",
		"plot": "A long time ago... in the summer of 1981, a tragedy of epic proportions (a broken plastic bat) sends five friends on an epic adventure to the mall. All they have to do is follow The Stream and back.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2752758",
		"imdbID": "tt2752758",
		"title": "Devil's Due",
		"year": "2014",
		"rating": "R",
		"runtime": "89 min",
		"genre": "Horror, Mystery",
		"released": "2014-01-17",
		"director": "Matt Bettinelli-Olpin, Tyler Gillett",
		"writer": "Lindsay Devlin",
		"cast": "Allison Miller, Zach Gilford, Sam Anderson, Roger Payano",
		"metacritic": "34",
		"imdbRating": "4.0",
		"imdbVotes": "13335",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc5MjE0OTY2M15BMl5BanBnXkFtZTgwNzExNTU1MDE@._V1_SX300.jpg",
		"plot": "After a mysterious, lost night on their honeymoon, a newlywed couple finds themselves dealing with an earlier-than-planned pregnancy.",
		"language": "English, Spanish, Latin",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "2756032",
		"imdbID": "tt2756032",
		"title": "The One I Love",
		"year": "2014",
		"rating": "R",
		"runtime": "91 min",
		"genre": "Comedy, Drama, Romance",
		"released": "2014-08-08",
		"director": "Charlie McDowell",
		"writer": "Justin Lader",
		"cast": "Mark Duplass, Elisabeth Moss, Ted Danson, Kiana Cason",
		"metacritic": "66",
		"imdbRating": "7.1",
		"imdbVotes": "20117",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgzODMyMjcyOV5BMl5BanBnXkFtZTgwMTAyMjMyMjE@._V1_SX300.jpg",
		"plot": "A troubled couple vacate to a beautiful getaway, but bizarre circumstances further complicate their situation.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 2 nominations."
	},
	{
		"id": "2765808",
		"imdbID": "tt2765808",
		"title": "Headshop",
		"year": "2013",
		"rating": "Unrated",
		"runtime": "60 min",
		"genre": "Crime",
		"released": "2013-04-30",
		"director": "",
		"writer": "",
		"cast": "Shaun Green, Staci Harmon, April Hunsucker, Sommers Kelly",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEyODg2ODUzM15BMl5BanBnXkFtZTcwNjU0NzA2OQ@@._V1_SX300.jpg",
		"plot": "",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2766790",
		"imdbID": "tt2766790",
		"title": "Small Town Santa",
		"year": "2014",
		"rating": "PG",
		"runtime": "86 min",
		"genre": "Comedy",
		"released": "2014-12-01",
		"director": "Joel Paul Reisig",
		"writer": "David Higlen",
		"cast": "Dean Cain, Christine Lakin, Sophie Bolen, Derek Brandon",
		"metacritic": "",
		"imdbRating": "4.1",
		"imdbVotes": "133",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQyMjQxMjI5MF5BMl5BanBnXkFtZTgwODAxMDA3MjE@._V1_SX300.jpg",
		"plot": "On the eve of Christmas, Sheriff Rick Langston has lost his holiday spirit. But when he arrests a home intruder claiming to be Santa Claus, his world gets turned upside-down ! With the help...",
		"language": "English",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "2784512",
		"imdbID": "tt2784512",
		"title": "Zombeavers",
		"year": "2014",
		"rating": "R",
		"runtime": "77 min",
		"genre": "Comedy, Horror",
		"released": "2015-03-20",
		"director": "Jordan Rubin",
		"writer": "Al Kaplan (screenplay), Jordan Rubin (screenplay), Jon Kaplan (screenplay)",
		"cast": "Rachel Melvin, Cortney Palm, Lexi Atkins, Hutch Dano",
		"metacritic": "44",
		"imdbRating": "4.8",
		"imdbVotes": "9945",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTMzMzc4ODc1M15BMl5BanBnXkFtZTgwMTM0MTgxMTE@._V1_SX300.jpg",
		"plot": "A fun weekend turns into madness and horror for a bunch of groupies looking for fun in a beaver infested swamp.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2784678",
		"imdbID": "tt2784678",
		"title": "Top Five",
		"year": "2014",
		"rating": "R",
		"runtime": "102 min",
		"genre": "Comedy, Romance",
		"released": "2014-12-12",
		"director": "Chris Rock",
		"writer": "Chris Rock",
		"cast": "Chris Rock, Rosario Dawson, J.B. Smoove, Gabrielle Union",
		"metacritic": "81",
		"imdbRating": "6.5",
		"imdbVotes": "19281",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIzNTg4ODM3OV5BMl5BanBnXkFtZTgwMTk0MjkxMzE@._V1_SX300.jpg",
		"plot": "A comedian tries to make it as a serious actor when his reality-TV star fiancée talks him into broadcasting their wedding on her TV show.",
		"language": "English",
		"country": "USA",
		"awards": "7 wins & 19 nominations."
	},
	{
		"id": "2785390",
		"imdbID": "tt2785390",
		"title": "America: Imagine the World Without Her",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "105 min",
		"genre": "Documentary",
		"released": "2014-07-02",
		"director": "Dinesh D'Souza, John Sullivan",
		"writer": "Dinesh D'Souza, John Sullivan, Bruce Schooley",
		"cast": "Dinesh D'Souza, Barack Obama, Josh Bonzie, Rich Bentz",
		"metacritic": "15",
		"imdbRating": "5.6",
		"imdbVotes": "4985",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM0MjgyOTQ4NF5BMl5BanBnXkFtZTgwOTQ1NzQ3MTE@._V1_SX300.jpg",
		"plot": "A story that questions the shaming of the US through revisionist history, lies and omissions by educational institutions, political organizations, Alinsky, Barack Obama, Hillary Clinton and other progressives to destroy America.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2787874",
		"imdbID": "tt2787874",
		"title": "As Night Comes",
		"year": "2014",
		"rating": "R",
		"runtime": "103 min",
		"genre": "Crime, Drama",
		"released": "2014-11-14",
		"director": "Richard Zelniker",
		"writer": "Ryan Koehn, Richard Zelniker",
		"cast": "Luke Baines, Myko Olivier, Evanne Friedmann, Stacia Hitt",
		"metacritic": "",
		"imdbRating": "4.0",
		"imdbVotes": "148",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ2Mzg4MjI4OF5BMl5BanBnXkFtZTgwMjkwMTk3MjE@._V1_SX300.jpg",
		"plot": "Troubled seventeen-year-old Sean Holloway falls in with a group of teenage outcasts called \"The Misfits,\" known around town for their petty crimes and vandalism. But things begin to spiral ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2788710",
		"imdbID": "tt2788710",
		"title": "The Interview",
		"year": "2014",
		"rating": "R",
		"runtime": "112 min",
		"genre": "Action, Comedy",
		"released": "2014-12-24",
		"director": "Evan Goldberg, Seth Rogen",
		"writer": "Dan Sterling (screenplay), Seth Rogen (story), Evan Goldberg (story), Dan Sterling (story)",
		"cast": "James Franco, Seth Rogen, Lizzy Caplan, Randall Park",
		"metacritic": "52",
		"imdbRating": "6.7",
		"imdbVotes": "230009",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzMTcwMzgyMV5BMl5BanBnXkFtZTgwMzAyMzQ2MzE@._V1_SX300.jpg",
		"plot": "Dave Skylark and producer Aaron Rapoport run the celebrity tabloid show \"Skylark Tonight.\" When they land an interview with a surprise fan, North Korean dictator Kim Jong-un, they are recruited by the CIA to turn their trip to Pyongyang into an assassination mission.",
		"language": "English, Korean",
		"country": "USA",
		"awards": "1 win & 3 nominations."
	},
	{
		"id": "2788716",
		"imdbID": "tt2788716",
		"title": "Welcome to Me",
		"year": "2014",
		"rating": "R",
		"runtime": "87 min",
		"genre": "Comedy, Drama",
		"released": "2015-05-01",
		"director": "Shira Piven",
		"writer": "Eliot Laurence (screenplay)",
		"cast": "Kristen Wiig, Wes Bentley, Linda Cardellini, Joan Cusack",
		"metacritic": "67",
		"imdbRating": "5.9",
		"imdbVotes": "10872",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA0NTAyNTYwNDheQTJeQWpwZ15BbWU4MDY2ODcyNTQx._V1_SX300.jpg",
		"plot": "When Alice Klieg wins the Mega-Millions lottery, she immediately quits her psychiatric meds and buys her own talk show.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 1 nomination."
	},
	{
		"id": "2799166",
		"imdbID": "tt2799166",
		"title": "The Pyramid",
		"year": "2014",
		"rating": "R",
		"runtime": "89 min",
		"genre": "Action, Adventure, Horror",
		"released": "2014-12-05",
		"director": "Grégory Levasseur",
		"writer": "Daniel Meersand, Nick Simon",
		"cast": "Ashley Hinshaw, Denis O'Hare, James Buckley, Christa Nicola",
		"metacritic": "24",
		"imdbRating": "4.7",
		"imdbVotes": "14769",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAxODg2Mzc5OV5BMl5BanBnXkFtZTgwOTUxNTQ1MjE@._V1_SX300.jpg",
		"plot": "An archaeological team attempts to unlock the secrets of a lost pyramid only to find themselves hunted by an insidious creature.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2800038",
		"imdbID": "tt2800038",
		"title": "Atlas Shrugged: Who Is John Galt?",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "99 min",
		"genre": "Drama, Mystery, Sci-Fi",
		"released": "2014-09-12",
		"director": "James Manera",
		"writer": "James Manera (screenplay), Harmon Kaslow (screenplay), John Aglialoro (screenplay), Ayn Rand (novel)",
		"cast": "Kristoffer Polaha, Laura Regan, Peter Mackenzie, Greg Germann",
		"metacritic": "9",
		"imdbRating": "4.4",
		"imdbVotes": "1717",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg2ODk3OTcwOF5BMl5BanBnXkFtZTgwMjgzNzM2NDE@._V1_SX300.jpg",
		"plot": "Approaching collapse, the nation's economy is quickly eroding. As crime and fear take over the countryside, the government continues to exert its brutal force against the nation's most ...",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2815072",
		"imdbID": "tt2815072",
		"title": "Indigenous",
		"year": "2014",
		"rating": "R",
		"runtime": "86 min",
		"genre": "Horror",
		"released": "2015-03-25",
		"director": "Alastair Orr",
		"writer": "",
		"cast": "Zachary Soetenga, Lindsey McKeon, Sofia Pernas, Pierson Fode",
		"metacritic": "",
		"imdbRating": "4.2",
		"imdbVotes": "840",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA4Mjk5MzMyOF5BMl5BanBnXkFtZTgwNjI4MzQ0NzE@._V1_SX300.jpg",
		"plot": "American Tourists travel to Panama and have a very terrifying experience.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2815966",
		"imdbID": "tt2815966",
		"title": "After The Fall",
		"year": "2014",
		"rating": "R",
		"runtime": "110 min",
		"genre": "Crime, Drama",
		"released": "2014-12-12",
		"director": "Saar Klein",
		"writer": "Saar Klein, Joe Conway",
		"cast": "Wes Bentley, Vinessa Shaw, Haley Bennett, Jason Isaacs",
		"metacritic": "36",
		"imdbRating": "5.1",
		"imdbVotes": "607",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIxODc5NDU1OF5BMl5BanBnXkFtZTgwNDUzMDgzMzE@._V1_SX300.jpg",
		"plot": "A suburban father and husband embraces a life of crime in order to support his family.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 5 nominations."
	},
	{
		"id": "2848292",
		"imdbID": "tt2848292",
		"title": "Pitch Perfect 2",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "115 min",
		"genre": "Comedy, Music",
		"released": "2015-05-15",
		"director": "Elizabeth Banks",
		"writer": "Kay Cannon, Mickey Rapkin (characters)",
		"cast": "Anna Kendrick, Rebel Wilson, Hailee Steinfeld, Brittany Snow",
		"metacritic": "63",
		"imdbRating": "6.5",
		"imdbVotes": "81169",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk0Mzg4NDYyOF5BMl5BanBnXkFtZTgwOTM2ODg2NTE@._V1_SX300.jpg",
		"plot": "After a humiliating command performance at The Kennedy Center, the Barden Bellas enter an international competition that no American group has ever won in order to regain their status and right to perform.",
		"language": "English",
		"country": "USA",
		"awards": "5 wins & 6 nominations."
	},
	{
		"id": "2848324",
		"imdbID": "tt2848324",
		"title": "Touched With Fire",
		"year": "2015",
		"rating": "R",
		"runtime": "110 min",
		"genre": "Drama, Romance",
		"released": "2016-02-12",
		"director": "Paul Dalio",
		"writer": "Paul Dalio",
		"cast": "Katie Holmes, Luke Kirby, Christine Lahti, Griffin Dunne",
		"metacritic": "",
		"imdbRating": "6.7",
		"imdbVotes": "65",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc1NTE0MTAzNV5BMl5BanBnXkFtZTgwNzczNzU0NzE@._V1_SX300.jpg",
		"plot": "Two manic depressives meet in a psychiatric hospital and begin a romance that brings out all of the beauty and horror of their condition.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2855042",
		"imdbID": "tt2855042",
		"title": "Blackhat",
		"year": "2015",
		"rating": "R",
		"runtime": "133 min",
		"genre": "Action, Crime, Drama",
		"released": "2015-01-16",
		"director": "Michael Mann",
		"writer": "Morgan Davis Foehl",
		"cast": "Chris Hemsworth, Leehom Wang, Wei Tang, Viola Davis",
		"metacritic": "51",
		"imdbRating": "5.4",
		"imdbVotes": "33605",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg1NDUyMzk5NV5BMl5BanBnXkFtZTgwOTk1NzUxMzE@._V1_SX300.jpg",
		"plot": "A furloughed convict and his American and Chinese partners hunt a high-level cybercrime network from Chicago to Los Angeles to Hong Kong to Jakarta.",
		"language": "English, Mandarin, Spanish",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2866296",
		"imdbID": "tt2866296",
		"title": "The Watsons Go to Birmingham",
		"year": "2013",
		"rating": "PG",
		"runtime": "87 min",
		"genre": "Family, History",
		"released": "2013-09-20",
		"director": "Kenny Leon",
		"writer": "Caliope Brattlestreet (screenplay), Stephen Glantz (screenplay), Tonya Lewis Lee (screenplay)",
		"cast": "Bryce Clyde Jenkins, Harrison Knight, Skai Jackson, Anika Noni Rose",
		"metacritic": "",
		"imdbRating": "6.2",
		"imdbVotes": "412",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM3MTE0Mzk4N15BMl5BanBnXkFtZTgwMTM3MjQ0MDE@._V1_SX300.jpg",
		"plot": "The Watsons set out on a family road trip where their experiences give them a newfound courage to stand up for what is right and helps them grow stronger as a family in the process.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 5 nominations."
	},
	{
		"id": "2869728",
		"imdbID": "tt2869728",
		"title": "Ride Along 2",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "",
		"genre": "Action, Comedy",
		"released": "2016-01-15",
		"director": "Tim Story",
		"writer": "Greg Coolidge (characters), Phil Hay (screenplay), Matt Manfredi (screenplay)",
		"cast": "Olivia Munn, Glen Powell, Kevin Hart, Ice Cube",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU4ODAzMzcxOV5BMl5BanBnXkFtZTgwODkxMDI1NjE@._V1_SX300.jpg",
		"plot": "As his wedding day approaches, Ben heads to Miami with his soon-to-be brother-in-law James to bring down a drug dealer who's supplying the dealers of Atlanta with product.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2872718",
		"imdbID": "tt2872718",
		"title": "Nightcrawler",
		"year": "2014",
		"rating": "R",
		"runtime": "117 min",
		"genre": "Crime, Thriller",
		"released": "2014-10-31",
		"director": "Dan Gilroy",
		"writer": "Dan Gilroy",
		"cast": "Jake Gyllenhaal, Michael Papajohn, Marco Rodríguez, Bill Paxton",
		"metacritic": "76",
		"imdbRating": "7.9",
		"imdbVotes": "260092",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM5NjkzMjE5MV5BMl5BanBnXkFtZTgwNTMzNTk4MjE@._V1_SX300.jpg",
		"plot": "When Louis Bloom, a driven man desperate for work, muscles into the world of L.A. crime journalism, he blurs the line between observer and participant to become the star of his own story. Aiding him in his effort is Nina, a TV-news veteran.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 1 Oscar. Another 37 wins & 108 nominations."
	},
	{
		"id": "2881698",
		"imdbID": "tt2881698",
		"title": "Skinwalker Ranch",
		"year": "2013",
		"rating": "R",
		"runtime": "86 min",
		"genre": "Biography, Horror, Mystery",
		"released": "2013-10-30",
		"director": "Devin McGinn, Steve Berg",
		"writer": "Steve Berg (story), Ken Bretschneider (story), Devin McGinn (story), Murphy Michaels (story), Adam Ohler",
		"cast": "Britani Bateman, Taylor Bateman, Steve Berg, Michael Black",
		"metacritic": "",
		"imdbRating": "5.1",
		"imdbVotes": "2793",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA1OTIyMjU5Nl5BMl5BanBnXkFtZTgwMDc3MTYyMDE@._V1_SX300.jpg",
		"plot": "A scientific research team investigates and documents the supernatural phenomena surrounding the disappearance of a cattle ranchers 10 year old son. Inspired by true events that shocked the paranormal community around the world.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2883434",
		"imdbID": "tt2883434",
		"title": "Black or White",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "121 min",
		"genre": "Drama",
		"released": "2015-01-30",
		"director": "Mike Binder",
		"writer": "Mike Binder",
		"cast": "Kevin Costner, Octavia Spencer, Jillian Estell, Bill Burr",
		"metacritic": "45",
		"imdbRating": "6.6",
		"imdbVotes": "6662",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYyMzE2NTE5MV5BMl5BanBnXkFtZTgwNDI3ODI2MzE@._V1_SX300.jpg",
		"plot": "A grieving widower is drawn into a custody battle over his granddaughter, whom he helped raise her entire life.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 2 nominations."
	},
	{
		"id": "2883512",
		"imdbID": "tt2883512",
		"title": "Chef",
		"year": "2014",
		"rating": "R",
		"runtime": "114 min",
		"genre": "Comedy, Drama",
		"released": "2014-05-30",
		"director": "Jon Favreau",
		"writer": "Jon Favreau",
		"cast": "Jon Favreau, John Leguizamo, Bobby Cannavale, Emjay Anthony",
		"metacritic": "68",
		"imdbRating": "7.3",
		"imdbVotes": "124877",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY5NTYzNTA1M15BMl5BanBnXkFtZTgwODIwODU1MTE@._V1_SX300.jpg",
		"plot": "A chef who loses his restaurant job starts up a food truck in an effort to reclaim his creative promise, while piecing back together his estranged family.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "2884206",
		"imdbID": "tt2884206",
		"title": "I Origins",
		"year": "2014",
		"rating": "R",
		"runtime": "106 min",
		"genre": "Drama, Romance, Sci-Fi",
		"released": "2014-09-19",
		"director": "Mike Cahill",
		"writer": "Mike Cahill",
		"cast": "Michael Pitt, Steven Yeun, Astrid Bergès-Frisbey, Brit Marling",
		"metacritic": "57",
		"imdbRating": "7.3",
		"imdbVotes": "66147",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ0MTAwMDI1OF5BMl5BanBnXkFtZTgwNjUwMTA2MTE@._V1_SX300.jpg",
		"plot": "A molecular biologist and his laboratory partner uncover evidence that may fundamentally change society as we know it.",
		"language": "English, Hindi",
		"country": "USA",
		"awards": "2 wins & 3 nominations."
	},
	{
		"id": "2888010",
		"imdbID": "tt2888010",
		"title": "Black or White",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "121 min",
		"genre": "Drama",
		"released": "2015-01-30",
		"director": "Mike Binder",
		"writer": "Mike Binder",
		"cast": "Kevin Costner, Octavia Spencer, Jillian Estell, Bill Burr",
		"metacritic": "45",
		"imdbRating": "6.6",
		"imdbVotes": "6410",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYyMzE2NTE5MV5BMl5BanBnXkFtZTgwNDI3ODI2MzE@._V1_SX300.jpg",
		"plot": "A grieving widower is drawn into a custody battle over his granddaughter, whom he helped raise her entire life.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "2891174",
		"imdbID": "tt2891174",
		"title": "99 Homes",
		"year": "2014",
		"rating": "R",
		"runtime": "112 min",
		"genre": "Drama",
		"released": "2015-10-09",
		"director": "Ramin Bahrani",
		"writer": "Ramin Bahrani (story), Ramin Bahrani, Amir Naderi, Bahareh Azimi (story)",
		"cast": "Laura Dern, Andrew Garfield, Michael Shannon, Clancy Brown",
		"metacritic": "76",
		"imdbRating": "7.2",
		"imdbVotes": "3801",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgyODExMDc0M15BMl5BanBnXkFtZTgwMjY2ODg4NTE@._V1_SX300.jpg",
		"plot": "A recently unemployed single father struggles to get back his foreclosed home by working for the real estate broker who is the source of his frustration.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 1 Golden Globe. Another 8 wins & 13 nominations."
	},
	{
		"id": "2907898",
		"imdbID": "tt2907898",
		"title": "No Ordinary Hero: The SuperDeafy Movie",
		"year": "2013",
		"rating": "PG",
		"runtime": "79 min",
		"genre": "Comedy, Drama, Family",
		"released": "2013-10-01",
		"director": "Troy Kotsur",
		"writer": "John Maucere (based on a character created by), Taly Ravid",
		"cast": "John Maucere, Michelle Nunes, Zane Hencker, James Leo Ryan",
		"metacritic": "",
		"imdbRating": "7.6",
		"imdbVotes": "72",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjk3MjYzOTcyN15BMl5BanBnXkFtZTcwMzM5NjI3OQ@@._V1_SX300.jpg",
		"plot": "A deaf actor who plays a superhero on a TV show must look beyond the cape to inspire a deaf boy to believe in himself.",
		"language": "English, American Sign Language",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2908446",
		"imdbID": "tt2908446",
		"title": "Insurgent",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "119 min",
		"genre": "Adventure, Sci-Fi, Thriller",
		"released": "2015-03-20",
		"director": "Robert Schwentke",
		"writer": "Brian Duffield (screenplay), Akiva Goldsman (screenplay), Mark Bomback (screenplay), Veronica Roth (novel)",
		"cast": "Kate Winslet, Jai Courtney, Mekhi Phifer, Shailene Woodley",
		"metacritic": "42",
		"imdbRating": "6.3",
		"imdbVotes": "124460",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgxOTYxMTg3OF5BMl5BanBnXkFtZTgwMDgyMzA2NDE@._V1_SX300.jpg",
		"plot": "Beatrice Prior must confront her inner demons and continue her fight against a powerful alliance which threatens to tear her society apart with the help from others on her side.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 6 nominations."
	},
	{
		"id": "2924352",
		"imdbID": "tt2924352",
		"title": "Hayride 2",
		"year": "2015",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Action, Horror, Thriller",
		"released": "2015-03-06",
		"director": "Terron R. Parsons",
		"writer": "Terron R. Parsons",
		"cast": "Sherri Eakin, Jeremy Sande, Jeremy Ivy, Corlandos Scott",
		"metacritic": "",
		"imdbRating": "2.9",
		"imdbVotes": "439",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM1MDk4NzQzN15BMl5BanBnXkFtZTgwNDM0OTQzNDE@._V1_SX300.jpg",
		"plot": "The end of one journey only marks the beginning of another as Detective Loomis returns to uncover the truth behind the Legend of Pitchfork.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2925642",
		"imdbID": "tt2925642",
		"title": "Kids for Cash",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "102 min",
		"genre": "Documentary, Crime, Drama",
		"released": "2015-08-01",
		"director": "Robert May",
		"writer": "",
		"cast": "Charlie Balasavage, Joanne Balasavage, Justin Bodnar, Lisa Griffiths",
		"metacritic": "75",
		"imdbRating": "7.1",
		"imdbVotes": "879",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQxNTI0OTUyMl5BMl5BanBnXkFtZTgwNDc2Mjk3MDE@._V1_SX300.jpg",
		"plot": "Kids For Cash is a riveting look behind the notorious judicial scandal that rocked the nation. Beyond the millions paid and high stakes corruption, Kids For Cash exposes a shocking American...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2933474",
		"imdbID": "tt2933474",
		"title": "Superfast!",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "99 min",
		"genre": "Comedy",
		"released": "2015-04-03",
		"director": "Jason Friedberg, Aaron Seltzer",
		"writer": "Jason Friedberg, Aaron Seltzer",
		"cast": "Alex Ashbaugh, Dale Pavinski, Lili Mirojnick, Andrea Navedo",
		"metacritic": "",
		"imdbRating": "4.0",
		"imdbVotes": "5487",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjM3MjQxNjkxM15BMl5BanBnXkFtZTgwMDIyMTA0NDE@._V1_SX300.jpg",
		"plot": "Undercover cop Lucas White joins Vin Serento's LA gang of illegal street racers. They are fast and they are furious and they plan to double cross LA crime kingpin Juan Carlos de la Sol who hides his cash in a downtown Taco Bell. The gang's outrageous plan is as daring as it is ridiculous and will see them towing the whole damn restaurant, at crazy speeds.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2933544",
		"imdbID": "tt2933544",
		"title": "5 Flights Up",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "92 min",
		"genre": "Drama",
		"released": "2015-05-08",
		"director": "Richard Loncraine",
		"writer": "Charlie Peters (screenplay), Jill Ciment (book)",
		"cast": "Morgan Freeman, Diane Keaton, Cynthia Nixon, Carrie Preston",
		"metacritic": "55",
		"imdbRating": "6.1",
		"imdbVotes": "3444",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ5MzU3MzgwN15BMl5BanBnXkFtZTgwNjM2NDQ3NDE@._V1_SX300.jpg",
		"plot": "A long-time married couple who've spent their lives together in the same New York apartment become overwhelmed by personal and real estate-related issues when they plan to move away.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2937254",
		"imdbID": "tt2937254",
		"title": "Balls Out",
		"year": "2014",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Comedy, Sport",
		"released": "2015-06-19",
		"director": "Andrew Disney",
		"writer": "Bradley Jackson",
		"cast": "Jake Lacy, Nikki Reed, Kate McKinnon, Beck Bennett",
		"metacritic": "58",
		"imdbRating": "4.5",
		"imdbVotes": "734",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTk5ODI5MzM0N15BMl5BanBnXkFtZTgwMjM5NzA3NTE@._V1_SX300.jpg",
		"plot": "With marriage, graduation, and the real world looming on the horizon, fifth year senior Caleb Fuller reassembles the ol' team of misfits for one last epic run in Intramural football.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2937696",
		"imdbID": "tt2937696",
		"title": "Everybody Wants Some",
		"year": "2016",
		"rating": "R",
		"runtime": "",
		"genre": "Comedy",
		"released": "2016-04-15",
		"director": "Richard Linklater",
		"writer": "Richard Linklater",
		"cast": "Zoey Deutch, Tyler Hoechlin, Ryan Guzman, Glen Powell",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk2NDcyNDE5N15BMl5BanBnXkFtZTgwNDA0MzQ1NzE@._V1_SX300.jpg",
		"plot": "A group of college baseball players navigate their way through the freedoms and responsibilities of unsupervised adulthood.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2948356",
		"imdbID": "tt2948356",
		"title": "Zootopia",
		"year": "2016",
		"rating": "PG",
		"runtime": "",
		"genre": "Animation, Action, Adventure",
		"released": "2016-03-04",
		"director": "Byron Howard, Rich Moore, Jared Bush",
		"writer": "Jared Bush (screenplay), Phil Johnston (screenplay), Byron Howard (story), Rich Moore (story), Jared Bush (story)",
		"cast": "Idris Elba, Ginnifer Goodwin, Jason Bateman, Alan Tudyk",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTMyMjEyNzIzMV5BMl5BanBnXkFtZTgwNzIyNjU0NzE@._V1_SX300.jpg",
		"plot": "In the animal city of Zootopia, a fast-talking fox who's trying to make it big goes on the run when he's framed for a crime he didn't commit. Zootopia's top cop, a self-righteous rabbit, is...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2948606",
		"imdbID": "tt2948606",
		"title": "Assassin's Game",
		"year": "2015",
		"rating": "R",
		"runtime": "83 min",
		"genre": "Action",
		"released": "2015-05-26",
		"director": "Anoop Rangi",
		"writer": "",
		"cast": "Tom Sizemore, Vivica A. Fox, Bai Ling, Mark Mikita",
		"metacritic": "",
		"imdbRating": "3.3",
		"imdbVotes": "83",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ4MTcxMTQyNl5BMl5BanBnXkFtZTgwMjAzMjAxNTE@._V1_SX300.jpg",
		"plot": "When a team of assassins botches a hit, legendary hitman Vet Jones gets an ultimatum from his former boss - kill the target or his son dies.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2948652",
		"imdbID": "tt2948652",
		"title": "Wayward: The Prodigal Son",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "93 min",
		"genre": "Action, Drama, Romance",
		"released": "2014-11-07",
		"director": "Rob Diamond",
		"writer": "Rob Diamond",
		"cast": "Landon Henneman, Blake Webb, Rob Diamond, Pam Eichner",
		"metacritic": "",
		"imdbRating": "6.8",
		"imdbVotes": "43",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMxMTczNTQ0Nl5BMl5BanBnXkFtZTgwMTYyOTcxMTE@._V1_SX300.jpg",
		"plot": "A dying father's last wish is to bring his rebellious son back home and into his loving and forgiving arms and reunite his family once again.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2955096",
		"imdbID": "tt2955096",
		"title": "Happy Christmas",
		"year": "2014",
		"rating": "R",
		"runtime": "82 min",
		"genre": "Comedy, Drama",
		"released": "2014-06-26",
		"director": "Joe Swanberg",
		"writer": "Joe Swanberg (screenplay)",
		"cast": "Anna Kendrick, Melanie Lynskey, Mark Webber, Lena Dunham",
		"metacritic": "70",
		"imdbRating": "5.6",
		"imdbVotes": "5194",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ4MTY5NDAwM15BMl5BanBnXkFtZTgwNTUwOTEwMjE@._V1_SX300.jpg",
		"plot": "After a break up, Jenny moves in with writer Kelly, her filmmaker husband, and their child. Despite a rocky start, Jenny's influence helps Kelly realize that an evolution in her life, career and relationship is necessary for her happiness.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "2959634",
		"imdbID": "tt2959634",
		"title": "Louder Than Words",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "95 min",
		"genre": "Drama, Family",
		"released": "2014-07-01",
		"director": "Anthony Fabian",
		"writer": "Benjamin Chapin",
		"cast": "David Duchovny, Adelaide Kane, Hope Davis, Timothy Hutton",
		"metacritic": "29",
		"imdbRating": "5.9",
		"imdbVotes": "692",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ2NjU0MjMyOF5BMl5BanBnXkFtZTgwOTAwMjIxMjE@._V1_SX300.jpg",
		"plot": "After the unexpected death of their daughter, a couple work to build a state of the art children's hospital where families are welcomed into the healing process.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2960470",
		"imdbID": "tt2960470",
		"title": "Why We Ride",
		"year": "2013",
		"rating": "PG",
		"runtime": "89 min",
		"genre": "Documentary, Family, History",
		"released": "2014-05-30",
		"director": "Bryan H. Carroll",
		"writer": "Bryan H. Carroll (story), Chris Hampel (story), Chris Hampel, James Walker (story)",
		"cast": "Jim Adams, Ernie Alexander, Kenny Alexander, Jay Allen",
		"metacritic": "",
		"imdbRating": "7.7",
		"imdbVotes": "538",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzNTEwMDQ5MV5BMl5BanBnXkFtZTgwMzU2NjM2MDE@._V1_SX300.jpg",
		"plot": "The passion of the riders and the soul of their machines.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "2962876",
		"imdbID": "tt2962876",
		"title": "The Road Within",
		"year": "2014",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Comedy, Drama",
		"released": "2015-06-04",
		"director": "Gren Wells",
		"writer": "Gren Wells",
		"cast": "Zoë Kravitz, Robert Patrick, Dev Patel, Robert Sheehan",
		"metacritic": "31",
		"imdbRating": "7.0",
		"imdbVotes": "6553",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU3NDgwNDUzMl5BMl5BanBnXkFtZTgwMjQ0NDA5NDE@._V1_SX300.jpg",
		"plot": "A young man with Tourette's Syndrome embarks on a road trip with his recently-deceased mother's ashes.",
		"language": "English",
		"country": "USA",
		"awards": "9 wins & 8 nominations."
	},
	{
		"id": "2963232",
		"imdbID": "tt2963232",
		"title": "The Hunters",
		"year": "2013",
		"rating": "PG",
		"runtime": "85 min",
		"genre": "Adventure",
		"released": "2013-10-25",
		"director": "Nisha Ganatra",
		"writer": "Matthew Huffman (screenplay), Matthew Huffman (story), Jeff Schechter (screenplay), Joshua Williamson (graphic novel)",
		"cast": "Robbie Amell, Alexa PenaVega, Victor Garber, Kira Clavell",
		"metacritic": "",
		"imdbRating": "4.9",
		"imdbVotes": "2362",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjMyODY5MTM0NV5BMl5BanBnXkFtZTgwNTMxODA2MDE@._V1_SX300.jpg",
		"plot": "A family of archeologists hunt down artifacts from fairy tales that have been hidden around the globe.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2966934",
		"imdbID": "tt2966934",
		"title": "Under the Electric Sky",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "85 min",
		"genre": "Documentary, Music",
		"released": "2014-05-29",
		"director": "Dan Cutforth, Jane Lipsitz",
		"writer": "",
		"cast": "Calvin Harris, Avicii, Tiësto, Fatboy Slim",
		"metacritic": "42",
		"imdbRating": "6.3",
		"imdbVotes": "423",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM4NDg0MTkwMF5BMl5BanBnXkFtZTgwNTgxOTU3MTE@._V1_SX300.jpg",
		"plot": "Beginning in 1997 with a few thousand revelers in Los Angeles, the Electric Daisy Carnival has become the largest dance music event in North America. Known for its over the top displays of ...",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "2967224",
		"imdbID": "tt2967224",
		"title": "Hot Pursuit",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "87 min",
		"genre": "Action, Comedy, Crime",
		"released": "2015-05-08",
		"director": "Anne Fletcher",
		"writer": "David Feeney, John Quaintance",
		"cast": "Reese Witherspoon, Sofía Vergara, Matthew Del Negro, Michael Mosley",
		"metacritic": "31",
		"imdbRating": "5.1",
		"imdbVotes": "27611",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzc0MDk0NDMwM15BMl5BanBnXkFtZTgwNTIzMjE1NTE@._V1_SX300.jpg",
		"plot": "An uptight and by-the-book cop tries to protect the outgoing widow of a drug boss as they race through Texas pursued by crooked cops and murderous gunmen.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": "4 nominations."
	},
	{
		"id": "2980472",
		"imdbID": "tt2980472",
		"title": "Just Before I Go",
		"year": "2014",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Comedy, Drama",
		"released": "2015-04-24",
		"director": "Courteney Cox",
		"writer": "David Flebotte",
		"cast": "Seann William Scott, Olivia Thirlby, Garret Dillahunt, Kate Walsh",
		"metacritic": "24",
		"imdbRating": "6.4",
		"imdbVotes": "11898",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTE5MDA0NTk4MV5BMl5BanBnXkFtZTgwNTY1MDUyNTE@._V1_SX300.jpg",
		"plot": "On the verge of giving up on life, a guy travels to his hometown to make amends.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2980706",
		"imdbID": "tt2980706",
		"title": "Planes: Fire & Rescue",
		"year": "2014",
		"rating": "PG",
		"runtime": "83 min",
		"genre": "Animation, Adventure, Comedy",
		"released": "2014-07-18",
		"director": "Roberts Gannaway",
		"writer": "Roberts Gannaway (story), Jeffrey M. Howard (story)",
		"cast": "Dane Cook, Ed Harris, Julie Bowen, Curtis Armstrong",
		"metacritic": "48",
		"imdbRating": "5.9",
		"imdbVotes": "11310",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTcwMjY4NDM4OF5BMl5BanBnXkFtZTgwMDIxNDU2MTE@._V1_SX300.jpg",
		"plot": "When Dusty learns that his engine is damaged and he may never race again, he joins a forest fire and rescue unit to be trained as a firefighter, or else his air strip will be shut down.",
		"language": "English",
		"country": "USA",
		"awards": "6 nominations."
	},
	{
		"id": "2992538",
		"imdbID": "tt2992538",
		"title": "Guardian Angel",
		"year": "2014",
		"rating": "R",
		"runtime": "86 min",
		"genre": "Action, Drama",
		"released": "2014-10-17",
		"director": "Vahik Pirhamzei",
		"writer": "Vahik Pirhamzei",
		"cast": "Vahik Pirhamzei, Bokeem Woodbine, Justine Wachsberger, Colin Cunningham",
		"metacritic": "",
		"imdbRating": "7.7",
		"imdbVotes": "34",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA3MjQ1MzkwOTVeQTJeQWpwZ15BbWU4MDMzODg5NzIx._V1_SX300.jpg",
		"plot": "After the tragic death of his wife, Ray becomes personally responsible for the safety of Vicki, an aspiring model, when due to her father's embezzlement, she is targeted by a human trafficker and vicious criminal.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "2992552",
		"imdbID": "tt2992552",
		"title": "Seal Team Eight: Behind Enemy Lines",
		"year": "2014",
		"rating": "R",
		"runtime": "98 min",
		"genre": "Action, Drama, War",
		"released": "2014-04-01",
		"director": "Roel Reiné",
		"writer": "Brendan Cowles, Shane Kuhn, Roel Reiné (story)",
		"cast": "Tom Sizemore, Lex Shrapnel, Anthony Oseyemi, Michael Everson",
		"metacritic": "",
		"imdbRating": "4.5",
		"imdbVotes": "2195",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQxMTc1NjA0MF5BMl5BanBnXkFtZTgwODAwOTgyMTE@._V1_SX300.jpg",
		"plot": "Tom Sizemore stars in the most explosive Behind Enemy Lines yet! Seal Team 8 must fight their way through the Congo to defuse one of the greatest threats the world has ever known.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3003470",
		"imdbID": "tt3003470",
		"title": "Christmas for a Dollar",
		"year": "2013",
		"rating": "PG",
		"runtime": "101 min",
		"genre": "Drama, Family",
		"released": "2013-12-15",
		"director": "John Lyde",
		"writer": "Sally Meyer (screenplay), Gale Sears (based on the book: 'Christmas for a Dollar' by), Ben Sowards (based on the book: 'Christmas for a Dollar' by)",
		"cast": "Brian Krause, Nancy Stafford, Danielle Chuchran, Heather Beers",
		"metacritic": "",
		"imdbRating": "6.9",
		"imdbVotes": "137",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA0NTE3Mjk5Ml5BMl5BanBnXkFtZTgwODU3NTkxNzE@._V1_SX300.jpg",
		"plot": "America is in the midst of the Depression, and the Kamp family is struggling to get by, especially after Mrs. Kamp's untimely death. Now little Ruthie, with her mother gone and her father ...",
		"language": "English",
		"country": "USA",
		"awards": "2 wins."
	},
	{
		"id": "3014666",
		"imdbID": "tt3014666",
		"title": "Moms' Night Out",
		"year": "2014",
		"rating": "PG",
		"runtime": "98 min",
		"genre": "Comedy",
		"released": "2014-05-09",
		"director": "Andrew Erwin, Jon Erwin",
		"writer": "Jon Erwin, Andrea Gyertson Nasfell",
		"cast": "Sarah Drew, Sean Astin, Patricia Heaton, Trace Adkins",
		"metacritic": "25",
		"imdbRating": "5.4",
		"imdbVotes": "9707",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgxMzgwMDM4OF5BMl5BanBnXkFtZTgwNjk4NjcyMTE@._V1_SX300.jpg",
		"plot": "Hardworking mom Allyson has a crazy night out with her friends, while their husbands watch their children.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3044702",
		"imdbID": "tt3044702",
		"title": "The Adventures of RoboRex",
		"year": "2014",
		"rating": "PG",
		"runtime": "87 min",
		"genre": "Family, Sci-Fi",
		"released": "2014-10-17",
		"director": "Stephen Shimek",
		"writer": "Kristi Shimek, Stephen Shimek",
		"cast": "Ben Browder, Kalvin Stinger, Ethan Phillips, Maggie Scott",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "142",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzc4OTEwNTkxOV5BMl5BanBnXkFtZTgwNzg2ODczMDE@._V1_SX300.jpg",
		"plot": "James Miller has only one friend in the world, his beloved Labrador Retriever, Rex. But when a strange capsule lands in the his backyard and a robot dog emerges, his life will never be the ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3059816",
		"imdbID": "tt3059816",
		"title": "The Wannabe",
		"year": "2015",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Crime, Drama, Mystery",
		"released": "2015-12-04",
		"director": "Nick Sandow",
		"writer": "Nick Sandow",
		"cast": "Patricia Arquette, Michael Imperioli, David Zayas, Vincent Piazza",
		"metacritic": "49",
		"imdbRating": "5.2",
		"imdbVotes": "522",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE0MTI3MzYwNl5BMl5BanBnXkFtZTgwMzQ3MDAyNzE@._V1_SX300.jpg",
		"plot": "Obsessed with mob culture, and desperate to fit in, Thomas sets out to fix the 1992 trial of John Gotti. He believes if the plan is executed, it will put him at the center of all that he ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3060952",
		"imdbID": "tt3060952",
		"title": "Justice League: War",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "79 min",
		"genre": "Animation, Action, Adventure",
		"released": "2014-02-04",
		"director": "Jay Oliva",
		"writer": "Heath Corson (adaptation), Heath Corson (screenplay), Bill Finger (characters), Geoff Johns (comic book), Geoff Johns, Jim Lee (characters), Scott Williams (characters)",
		"cast": "Sean Astin, Zach Callison, Christopher Gorham, Justin Kirk",
		"metacritic": "",
		"imdbRating": "7.2",
		"imdbVotes": "14182",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ1ODc1MTMwNl5BMl5BanBnXkFtZTgwNDgyMjU5MDE@._V1_SX300.jpg",
		"plot": "The world's finest heroes found the Justice League in order to stop an alien invasion of Earth.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3062742",
		"imdbID": "tt3062742",
		"title": "Break Point",
		"year": "2014",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Comedy, Sport",
		"released": "2015-07-21",
		"director": "Jay Karas",
		"writer": "Gene Hong (story), Gene Hong, Gene Hong, Jeremy Sisto (story), Jeremy Sisto",
		"cast": "Jeremy Sisto, David Walton, Adam DeVine, Joshua Rush",
		"metacritic": "57",
		"imdbRating": "6.0",
		"imdbVotes": "520",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzOTYwMzA4NF5BMl5BanBnXkFtZTgwMDQyODIzNjE@._V1_SX300.jpg",
		"plot": "Two estranged brothers reunite to make an improbable run at a grand slam tennis tournament.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "3063516",
		"imdbID": "tt3063516",
		"title": "Jackass Presents: Bad Grandpa",
		"year": "2013",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Comedy",
		"released": "2013-10-25",
		"director": "Jeff Tremaine",
		"writer": "Johnny Knoxville (screenplay), Spike Jonze (screenplay), Jeff Tremaine (screenplay), Johnny Knoxville (story), Spike Jonze (story), Jeff Tremaine (story), Fax Bahr (story), Adam Small (story)",
		"cast": "Johnny Knoxville, Jackson Nicoll, Greg Harris, Georgina Cates",
		"metacritic": "54",
		"imdbRating": "6.6",
		"imdbVotes": "74719",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg4NjIwMTI5OV5BMl5BanBnXkFtZTgwNjU1MTMyMDE@._V1_SX300.jpg",
		"plot": "86-year-old Irving Zisman takes a trip from Nebraska to North Carolina to take his 8 year-old grandson, Billy, back to his real father.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 1 Oscar. Another 1 win & 8 nominations."
	},
	{
		"id": "3073898",
		"imdbID": "tt3073898",
		"title": "108 Stitches",
		"year": "2014",
		"rating": "R",
		"runtime": "118 min",
		"genre": "Comedy, Romance, Sport",
		"released": "2014-09-12",
		"director": "David Rountree",
		"writer": "Josh Blue (additional material), Jake Katofsky (head writer), Jeff Katofsky (contributing writer), David Rountree (head writer)",
		"cast": "Bruce Davison, Erin Cahill, Kate Vernon, Ryan Carlberg",
		"metacritic": "",
		"imdbRating": "7.5",
		"imdbVotes": "78",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk4OTYzMzk0MV5BMl5BanBnXkFtZTgwNzg4NDA0MjE@._V1_SX300.jpg",
		"plot": "With baseball being the last thing on these player's minds, and dealing with one of the longest losing streaks in college history, the team of misfits comes to the realization that the ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3079380",
		"imdbID": "tt3079380",
		"title": "Spy",
		"year": "2015",
		"rating": "R",
		"runtime": "119 min",
		"genre": "Action, Comedy, Crime",
		"released": "2015-06-05",
		"director": "Paul Feig",
		"writer": "Paul Feig",
		"cast": "Jude Law, Raad Rawi, Melissa McCarthy, Jessica Chaffin",
		"metacritic": "75",
		"imdbRating": "7.1",
		"imdbVotes": "122728",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjI5OTQ0MDQxM15BMl5BanBnXkFtZTgwMzcwNjMyNTE@._V1_SX300.jpg",
		"plot": "A desk-bound CIA analyst volunteers to go undercover to infiltrate the world of a deadly arms dealer, and prevent diabolical global disaster.",
		"language": "English, French, Italian, German",
		"country": "USA",
		"awards": "Nominated for 2 Golden Globes. Another 4 nominations."
	},
	{
		"id": "3082826",
		"imdbID": "tt3082826",
		"title": "Kelly & Cal",
		"year": "2014",
		"rating": "R",
		"runtime": "111 min",
		"genre": "Comedy, Drama",
		"released": "2014-03-07",
		"director": "Jen McGowan",
		"writer": "Amy Lowe Starbin",
		"cast": "Juliette Lewis, Jonny Weston, Josh Hopkins, Cybill Shepherd",
		"metacritic": "64",
		"imdbRating": "6.2",
		"imdbVotes": "1012",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA3OTI1NjczNV5BMl5BanBnXkFtZTgwMzY4NDc0MjE@._V1_SX300.jpg",
		"plot": "Kelly, a punk-rocker turned suburban mom, is nostalgic for a life she can no longer have and uncertain of a future she doesn't yet fit in. Seventeen-year-old Cal is frustrated at his lack ...",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "3084028",
		"imdbID": "tt3084028",
		"title": "See You in Valhalla",
		"year": "2015",
		"rating": "R",
		"runtime": "82 min",
		"genre": "Comedy, Drama",
		"released": "2015-04-24",
		"director": "Jarret Tarnol",
		"writer": "Brent Tarnol",
		"cast": "Sarah Hyland, Bret Harrison, Steve Howey, Odeya Rush",
		"metacritic": "28",
		"imdbRating": "5.3",
		"imdbVotes": "1097",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUzMzc3OTQ4NV5BMl5BanBnXkFtZTgwODc2NDMwNTE@._V1_SX300.jpg",
		"plot": "After the bizarre death of her brother, Johana Burwood must return home after four years, to face her strange siblings, her out of touch father and her very touchy past.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3089388",
		"imdbID": "tt3089388",
		"title": "Tim's Vermeer",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "80 min",
		"genre": "Documentary, History",
		"released": "2013-10-03",
		"director": "Teller",
		"writer": "Penn Jillette, Teller",
		"cast": "Tim Jenison, Penn Jillette, Martin Mull, Philip Steadman",
		"metacritic": "76",
		"imdbRating": "7.8",
		"imdbVotes": "5482",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc1MjgxNDU5OV5BMl5BanBnXkFtZTgwMTcwMzQ4MDE@._V1_SX300.jpg",
		"plot": "Inventor Tim Jenison seeks to understand the painting techniques used by Dutch Master Johannes Vermeer.",
		"language": "English, Dutch",
		"country": "USA",
		"awards": "Nominated for 1 BAFTA Film Award. Another 1 win & 5 nominations."
	},
	{
		"id": "3090252",
		"imdbID": "tt3090252",
		"title": "Dinosaur 13",
		"year": "2014",
		"rating": "PG",
		"runtime": "95 min",
		"genre": "Documentary",
		"released": "2014-08-15",
		"director": "Todd Douglas Miller",
		"writer": "",
		"cast": "Stan Adelstein, Lanice Archer, Robert Bakker, Philip Currie",
		"metacritic": "66",
		"imdbRating": "7.1",
		"imdbVotes": "2470",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQxMzQ2NTE5Nl5BMl5BanBnXkFtZTgwMzI5OTA4MTE@._V1_SX300.jpg",
		"plot": "A documentary about the discovery of the largest Tyrannosaurus Rex fossil ever found.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "3093522",
		"imdbID": "tt3093522",
		"title": "Cymbeline",
		"year": "2014",
		"rating": "R",
		"runtime": "98 min",
		"genre": "Drama",
		"released": "2015-03-13",
		"director": "Michael Almereyda",
		"writer": "Michael Almereyda (screenplay), William Shakespeare (play)",
		"cast": "Ethan Hawke, Ed Harris, Milla Jovovich, John Leguizamo",
		"metacritic": "54",
		"imdbRating": "3.9",
		"imdbVotes": "2314",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjc5NjkyMjEwNV5BMl5BanBnXkFtZTgwMzQ0NzA3NDE@._V1_SX300.jpg",
		"plot": "A gritty story of a take-no-prisoners war between dirty cops and an outlaw biker gang. A drug kingpin is driven to desperate measures.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3094252",
		"imdbID": "tt3094252",
		"title": "Echoes of War",
		"year": "2015",
		"rating": "R",
		"runtime": "100 min",
		"genre": "Drama, Thriller, Western",
		"released": "2015-04-15",
		"director": "Kane Senes",
		"writer": "John Chriss, Kane Senes",
		"cast": "James Badge Dale, Ethan Embry, William Forsythe, Maika Monroe",
		"metacritic": "41",
		"imdbRating": "6.1",
		"imdbVotes": "1204",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODU3MTMyODc3OF5BMl5BanBnXkFtZTgwMDYzODg5NDE@._V1_SX300.jpg",
		"plot": "A Civil War veteran returns home to the quiet countryside, only to find himself embroiled in a conflict between his family and the brutish cattle rancher harassing them.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3099498",
		"imdbID": "tt3099498",
		"title": "Tusk",
		"year": "2014",
		"rating": "R",
		"runtime": "102 min",
		"genre": "Comedy, Drama, Horror",
		"released": "2014-09-19",
		"director": "Kevin Smith",
		"writer": "Kevin Smith",
		"cast": "Michael Parks, Justin Long, Genesis Rodriguez, Haley Joel Osment",
		"metacritic": "55",
		"imdbRating": "5.4",
		"imdbVotes": "27727",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI4Nzk1NjkyNl5BMl5BanBnXkFtZTgwMjk4OTUxMjE@._V1_SX300.jpg",
		"plot": "When podcaster Wallace Bryton goes missing in the backwoods of Manitoba while interviewing a mysterious seafarer named Howard Howe, his best friend Teddy and girlfriend Allison team with an ex-cop to look for him.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 4 nominations."
	},
	{
		"id": "3106120",
		"imdbID": "tt3106120",
		"title": "See No Evil 2",
		"year": "2014",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Horror",
		"released": "2014-10-21",
		"director": "Jen Soska, Sylvia Soska",
		"writer": "Nathan Brookes, Bobby Lee Darby",
		"cast": "Glenn Jacobs, Danielle Harris, Katharine Isabelle, Chelan Simmons",
		"metacritic": "",
		"imdbRating": "4.8",
		"imdbVotes": "3415",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk5NTAzNjI4MV5BMl5BanBnXkFtZTgwNjE5NTMzMjE@._V1_SX300.jpg",
		"plot": "A group of friends pays a late-night visit to the city morgue to surprise Amy (Harris) on her birthday. But the surprise is on them when the one-eyed corpse of brutal psychopath Jacob ...",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3107070",
		"imdbID": "tt3107070",
		"title": "Believe Me",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "93 min",
		"genre": "Comedy, Drama",
		"released": "2015-09-16",
		"director": "Will Bakke",
		"writer": "Michael B. Allen, Will Bakke",
		"cast": "Alex Russell, Zachary Knighton, Johanna Braddy, Miles Fisher",
		"metacritic": "48",
		"imdbRating": "4.9",
		"imdbVotes": "833",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU4MTUwNTI5NV5BMl5BanBnXkFtZTgwMzE0Njg5MTE@._V1_SX300.jpg",
		"plot": "Desperate, broke, and out of ideas, four college seniors start a fake charity to embezzle money for tuition.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3109200",
		"imdbID": "tt3109200",
		"title": "Dude, Where's My Dog?!",
		"year": "2014",
		"rating": "PG",
		"runtime": "82 min",
		"genre": "Family",
		"released": "2014-06-17",
		"director": "Stephen Langford",
		"writer": "Stephen Langford",
		"cast": "Nic Birdsall, Gabriela Castillo, Taisha Monique Clark, Trish Cook",
		"metacritic": "",
		"imdbRating": "3.4",
		"imdbVotes": "74",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjY1MzQ3Nzg3M15BMl5BanBnXkFtZTgwMTYxNTY2MTE@._V1_SX300.jpg",
		"plot": "A young tween named Ray is left at home to watch the family dog, Harry, to prove to his parents that he is not, as they say, \"irresponsible.\" But, before he knows it, curious Harry runs out...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3110982",
		"imdbID": "tt3110982",
		"title": "Sins of Our Youth",
		"year": "2014",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Drama, Thriller",
		"released": "2014-07-31",
		"director": "Gary Entin",
		"writer": "Edmund Entin",
		"cast": "Lucas Till, Joel Courtney, Mitchel Musso, Ally Sheedy",
		"metacritic": "",
		"imdbRating": "7.0",
		"imdbVotes": "44",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI3NjIyMDM4NV5BMl5BanBnXkFtZTgwNzQ1NjIxMjE@._V1_SX300.jpg",
		"plot": "Sins of Our Youth is the story of four teenagers who accidentally murder a younger boy while shooting off assault weapons recreationally and the perilous decisions they make in the wake of the murder.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3112900",
		"imdbID": "tt3112900",
		"title": "Salomé",
		"year": "2013",
		"rating": "R",
		"runtime": "81 min",
		"genre": "Drama",
		"released": "2014-09-21",
		"director": "Al Pacino",
		"writer": "Oscar Wilde",
		"cast": "Kevin Anderson, Jessica Chastain, Ralph Guzzo, Roxanne Hart",
		"metacritic": "",
		"imdbRating": "7.1",
		"imdbVotes": "788",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU3MDUyMDQxM15BMl5BanBnXkFtZTgwMTI0NTM1MTE@._V1_SX300.jpg",
		"plot": "The Biblical story of Salome, a girl who agrees to perform the \"dance of the seven veils\" in return for John the Baptist's head on a silver platter.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3130734",
		"imdbID": "tt3130734",
		"title": "Phantom Halo",
		"year": "2014",
		"rating": "R",
		"runtime": "87 min",
		"genre": "Crime, Drama, Thriller",
		"released": "2015-06-19",
		"director": "Antonia Bogdanovich",
		"writer": "Antonia Bogdanovich, Antonia Bogdanovich, Anne Heffron, Anne Heffron",
		"cast": "Luke Kleintank, Thomas Brodie-Sangster, Rebecca Romijn, Clare Grant",
		"metacritic": "37",
		"imdbRating": "5.1",
		"imdbVotes": "420",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkxMjMzNTM0M15BMl5BanBnXkFtZTgwNjc2NjY3NTE@._V1_SX300.jpg",
		"plot": "Brothers Samuel and Beckett Emerson are barely scraping by. Their father, Warren, continues to gamble and drink away any money they bring home. With all the havoc that is constantly going ...",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3137764",
		"imdbID": "tt3137764",
		"title": "Staten Island Summer",
		"year": "2015",
		"rating": "R",
		"runtime": "108 min",
		"genre": "Comedy",
		"released": "2015-06-30",
		"director": "Rhys Thomas",
		"writer": "Colin Jost",
		"cast": "Graham Phillips, Zack Pearlman, Ashley Greene, Bobby Moynihan",
		"metacritic": "41",
		"imdbRating": "5.6",
		"imdbVotes": "3023",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUzOTQwNDA0OF5BMl5BanBnXkFtZTgwMDE1NDQxNjE@._V1_SX300.jpg",
		"plot": "Pals Danny and Frank spend the summer after high school working as lifeguards while figuring out their future.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3138104",
		"imdbID": "tt3138104",
		"title": "The Hungover Games",
		"year": "2014",
		"rating": "R",
		"runtime": "85 min",
		"genre": "Comedy",
		"released": "2014-02-18",
		"director": "Josh Stolberg",
		"writer": "Kyle Barnett Anderson (screenplay), Kyle Barnett Anderson (story), David Bernstein (screenplay), David Bernstein (story), Jamie Kennedy (story)",
		"cast": "Ross Nathan, Sam Pancake, Ben Begley, Herbert Russell",
		"metacritic": "",
		"imdbRating": "3.7",
		"imdbVotes": "7363",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk0NjM3MDk3NV5BMl5BanBnXkFtZTgwNTEzNTY3MDE@._V1_SX300.jpg",
		"plot": "After celebrating Doug's upcoming wedding in a cut rate hotel in Laughlin, NV, hungover guys Bradley, Ed and Zach wake up in a futuristic dystopia, having lost their pal, Doug. With the ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3138192",
		"imdbID": "tt3138192",
		"title": "Mostly Ghostly: Have You Met My Ghoulfriend?",
		"year": "2014",
		"rating": "PG",
		"runtime": "90 min",
		"genre": "Family",
		"released": "2015-02-05",
		"director": "Peter Hewitt",
		"writer": "Rich Correll (screenplay), R.L. Stine (story)",
		"cast": "Bella Thorne, Anastasia Baranova, Madison Pettis, Eric Allan Kramer",
		"metacritic": "",
		"imdbRating": "4.6",
		"imdbVotes": "459",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI3Nzc1OTE2Ml5BMl5BanBnXkFtZTgwNDE4MTI1MjE@._V1_SX300.jpg",
		"plot": "Bella Thorne (Shake It Up!, Frienemies), Madison Pettis (Lab Rats, Beverly Hills Chihuahua 3) and Ryan Ochoa (Pair of Kings, The Perfect Game) lead an ensemble cast in this spook-tacular ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3138376",
		"imdbID": "tt3138376",
		"title": "Joy Ride 3",
		"year": "2014",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Horror, Thriller",
		"released": "2014-06-09",
		"director": "Declan O'Brien",
		"writer": "Clay Tarver (based on the characters created by), J.J. Abrams (based on the characters created by), Declan O'Brien",
		"cast": "Ken Kirzinger, Jesse Hutch, Benjamin Hollingsworth, Gianpaolo Venuta",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "2817",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQwODc4NTg1MV5BMl5BanBnXkFtZTgwNzA4NzU3MTE@._V1_SX300.jpg",
		"plot": "A group of hotheaded street racers are on their way to the Road Rally 1000. As they drive through a desolate shortcut on the way to the race, a man starts tracking, teasing and torturing them until the end of the road.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3139072",
		"imdbID": "tt3139072",
		"title": "Son of Batman",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "74 min",
		"genre": "Animation, Action, Adventure",
		"released": "2014-05-06",
		"director": "Ethan Spaulding",
		"writer": "Bob Kane (characters), Grant Morrison (comic book), Andy Kubert (graphic novel illustrator), James Robinson (story), Joe R. Lansdale (screenplay)",
		"cast": "Jason O'Mara, Stuart Allan, Thomas Gibson, Morena Baccarin",
		"metacritic": "",
		"imdbRating": "6.6",
		"imdbVotes": "10134",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc4MDY3NDU3MF5BMl5BanBnXkFtZTgwODQ2MjU2MTE@._V1_SX300.jpg",
		"plot": "Batman learns he has a violent, unruly pre-teen son, secretly raised by the terrorist group the League of Assassins.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "3139086",
		"imdbID": "tt3139086",
		"title": "Batman: Assault on Arkham",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "76 min",
		"genre": "Animation, Action, Crime",
		"released": "2014-07-29",
		"director": "Jay Oliva, Ethan Spaulding",
		"writer": "Heath Corson, Bob Kane (characters)",
		"cast": "Kevin Conroy, Neal McDonough, Hynden Walch, Matthew Gray Gubler",
		"metacritic": "",
		"imdbRating": "7.4",
		"imdbVotes": "13658",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTAxMDY2OTA2NzReQTJeQWpwZ15BbWU4MDg1NDk1MzIx._V1_SX300.jpg",
		"plot": "Batman works desperately to find a bomb planted by the Joker while Amanda Waller hires her newly formed Suicide Squad to break into Arkham Asylum to recover vital information stolen by the Riddler.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 2 nominations."
	},
	{
		"id": "3139764",
		"imdbID": "tt3139764",
		"title": "Unsullied",
		"year": "2014",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Action, Horror, Thriller",
		"released": "2015-08-28",
		"director": "Simeon Rice",
		"writer": "John Nodilo, John Nodilo (screenplay), John Nodilo, Simeon Rice, Simeon Rice",
		"cast": "Rusty Joiner, Murray Gray, James Gaudioso, Erin Boyes",
		"metacritic": "42",
		"imdbRating": "5.7",
		"imdbVotes": "84",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIyMTQyNTIxN15BMl5BanBnXkFtZTgwMjk5NzcyNjE@._V1_SX300.jpg",
		"plot": "Follows Reagan, a track star, who is kidnapped by a pair of sociopaths after her car breaks down on a deserted road.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3149360",
		"imdbID": "tt3149360",
		"title": "Lucky Dog",
		"year": "2014",
		"rating": "PG",
		"runtime": "88 min",
		"genre": "Family",
		"released": "2014-08-29",
		"director": "Michael Feifer",
		"writer": "Michael Feifer",
		"cast": "Bryce Johnson, Boti Bliss, David DeLuise, Cat Deeley",
		"metacritic": "",
		"imdbRating": "5.5",
		"imdbVotes": "20",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIxMzY3NjEyOF5BMl5BanBnXkFtZTgwODg0NjkxMDE@._V1_SX300.jpg",
		"plot": "Lucky Dog is a paw'some and fun live action movie for the whole family! Lucky's owner Travis (Bryce Johnson, \"Pretty Little Liars\") is a divorced father of two, dedicated to his great kids,...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3149900",
		"imdbID": "tt3149900",
		"title": "The Hunted",
		"year": "2013",
		"rating": "PG-13",
		"runtime": "89 min",
		"genre": "Thriller",
		"released": "2014-09-09",
		"director": "Josh Stewart",
		"writer": "Josh Stewart",
		"cast": "Josh Stewart, Skipp Sudduth, Katherine Von Till, Ronnie Gene Blevins",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "771",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODkwMDY1MzI4Ml5BMl5BanBnXkFtZTgwNjAyNDMzMDE@._V1_SX300.jpg",
		"plot": "Chasing their dream of landing their own hunting show, two hunters head into the dense, secluded mountains of West Virginia only to realize they are not alone.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3150574",
		"imdbID": "tt3150574",
		"title": "Underdog Kids",
		"year": "2015",
		"rating": "PG",
		"runtime": "94 min",
		"genre": "Action, Family",
		"released": "2015-07-07",
		"director": "Phillip Rhee",
		"writer": "Phillip Rhee",
		"cast": "Phillip Rhee, Mirelly Taylor, Max Gail, Adam Irigoyen",
		"metacritic": "",
		"imdbRating": "4.3",
		"imdbVotes": "224",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA1MDM2MTk5M15BMl5BanBnXkFtZTgwNTAyNzU5NTE@._V1_SX300.jpg",
		"plot": "Inner city kids from a poor neighborhood go up against the undefeated Beverly Hills Junior National Karate Team.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3152624",
		"imdbID": "tt3152624",
		"title": "Trainwreck",
		"year": "2015",
		"rating": "R",
		"runtime": "125 min",
		"genre": "Comedy, Romance",
		"released": "2015-07-17",
		"director": "Judd Apatow",
		"writer": "Amy Schumer",
		"cast": "Colin Quinn, Devin Fabry, Carla Oudin, Amy Schumer",
		"metacritic": "75",
		"imdbRating": "6.4",
		"imdbVotes": "57909",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ4MjgwNTMyOV5BMl5BanBnXkFtZTgwMTc1MjI0NDE@._V1_SX300.jpg",
		"plot": "Having thought that monogamy was never possible, a commitment-phobic career woman may have to face her fears when she meets a good guy.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 2 Golden Globes. Another 1 win & 6 nominations."
	},
	{
		"id": "3154310",
		"imdbID": "tt3154310",
		"title": "Walt Before Mickey",
		"year": "2015",
		"rating": "PG",
		"runtime": "120 min",
		"genre": "Biography, Drama",
		"released": "2015-08-14",
		"director": "Khoa Le",
		"writer": "Arthur L. Bernstein, Armando Gutierrez, Timothy Susanin (book), Diane Disney (foreword), Frank Licari (additional writing)",
		"cast": "Jodie Sweetin, Jon Heder, David Henrie, Thomas Ian Nicholas",
		"metacritic": "",
		"imdbRating": "6.6",
		"imdbVotes": "353",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI1NDc1ODAyNF5BMl5BanBnXkFtZTgwODM3NTc2NTE@._V1_SX300.jpg",
		"plot": "Based on the book \"Walt Before Mickey\" covers the early years of Walt Disney's career.",
		"language": "English, Spanish",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3159194",
		"imdbID": "tt3159194",
		"title": "The Legend of Mortamuth Stanley",
		"year": "2013",
		"rating": "Unrated",
		"runtime": "60 min",
		"genre": "Horror",
		"released": "2013-09-07",
		"director": "David Dietrich",
		"writer": "David Dietrich",
		"cast": "Michael Petranech, April Schluneger, Brian Sheridan, Glenn Norgren",
		"metacritic": "",
		"imdbRating": "4.3",
		"imdbVotes": "7",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg0ODE1MjE1Ml5BMl5BanBnXkFtZTgwNjI1NjkxMDE@._V1_SX300.jpg",
		"plot": "The story of the Mortamuth Stanley murders is made into a creepy-nightmarish movie by a director who has an obsession with killing his actors.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3165608",
		"imdbID": "tt3165608",
		"title": "Justin Bieber's Believe",
		"year": "2013",
		"rating": "PG",
		"runtime": "92 min",
		"genre": "Documentary, Music",
		"released": "2013-12-25",
		"director": "Jon M. Chu",
		"writer": "Sarah Landman",
		"cast": "Justin Bieber, Scooter Braun, Ryan Good, Usher Raymond",
		"metacritic": "39",
		"imdbRating": "1.6",
		"imdbVotes": "16782",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjgzMDgxNjU1Ml5BMl5BanBnXkFtZTgwMDc3NTI2MDE@._V1_SX300.jpg",
		"plot": "A backstage and on-stage look at Justin Bieber during his rise to super stardom.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3165612",
		"imdbID": "tt3165612",
		"title": "Sleeping with Other People",
		"year": "2015",
		"rating": "R",
		"runtime": "101 min",
		"genre": "Comedy",
		"released": "2015-08-12",
		"director": "Leslye Headland",
		"writer": "Leslye Headland",
		"cast": "Alison Brie, Jason Sudeikis, Jordan Carlos, Margarita Levieva",
		"metacritic": "64",
		"imdbRating": "6.5",
		"imdbVotes": "7720",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUyMzQwNjEyNV5BMl5BanBnXkFtZTgwMzYwMzgwNjE@._V1_SX300.jpg",
		"plot": "A good-natured womanizer and a serial cheater form a platonic relationship that helps reform them in ways, while a mutual attraction sets in.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3168808",
		"imdbID": "tt3168808",
		"title": "A Murder in the Park",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "91 min",
		"genre": "Documentary, Crime, History",
		"released": "2015-06-26",
		"director": "Christopher S. Rech, Brandon Kimber",
		"writer": "",
		"cast": "Dexter Hammett, Joseph Alex, Jason Patrick, Denny Castiglione",
		"metacritic": "70",
		"imdbRating": "6.7",
		"imdbVotes": "186",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTQ2MjY0NDMxN15BMl5BanBnXkFtZTgwODQxMDQwNjE@._V1_SX300.jpg",
		"plot": "Documentary filmmakers assert that Anthony Porter - a former death-row inmate who was spared the death penalty thanks to the efforts of a college journalism program - was actually guilty, and an innocent man was sent to prison.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3172532",
		"imdbID": "tt3172532",
		"title": "The Diary of a Teenage Girl",
		"year": "2015",
		"rating": "R",
		"runtime": "102 min",
		"genre": "Drama, Romance",
		"released": "2015-08-28",
		"director": "Marielle Heller",
		"writer": "Phoebe Gloeckner (novel), Marielle Heller (screenplay)",
		"cast": "Bel Powley, Willie, Kristen Wiig, Abby Wait",
		"metacritic": "87",
		"imdbRating": "7.0",
		"imdbVotes": "4586",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE4MTQ3NTgwOF5BMl5BanBnXkFtZTgwMDQ3NTc5NTE@._V1_SX300.jpg",
		"plot": "A teen artist living in 1970s San Francisco enters into an affair with her mother's boyfriend.",
		"language": "English",
		"country": "USA",
		"awards": "8 wins & 26 nominations."
	},
	{
		"id": "3174376",
		"imdbID": "tt3174376",
		"title": "Before I Wake",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "",
		"genre": "Horror, Thriller",
		"released": "2016-04-08",
		"director": "Mike Flanagan",
		"writer": "Mike Flanagan, Jeff Howard",
		"cast": "Thomas Jane, Jacob Tremblay, Kate Bosworth, Annabeth Gish",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIwMDE3MTMyMl5BMl5BanBnXkFtZTgwMjc2NjY3NTE@._V1_SX300.jpg",
		"plot": "A young couple adopt an orphaned child whose dreams - and nightmares - manifest physically as he sleeps.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3195742",
		"imdbID": "tt3195742",
		"title": "Journey to the South Pacific",
		"year": "2013",
		"rating": "G",
		"runtime": "40 min",
		"genre": "Documentary",
		"released": "2013-11-27",
		"director": "Stephen Judson, Greg MacGillivray",
		"writer": "Stephen Judson",
		"cast": "Ferdiel Ballamu, Cate Blanchett, Menas Mambasar, Jawi Mayor",
		"metacritic": "",
		"imdbRating": "7.1",
		"imdbVotes": "70",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUyMjEzNjA5NF5BMl5BanBnXkFtZTgwOTk5MTYyMTE@._V1_SX300.jpg",
		"plot": "An underwater voyage to Indonesia to learn about its inhabitants such as giant rays and whale sharks as well as efforts being made in the region for ocean conservation.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3196830",
		"imdbID": "tt3196830",
		"title": "Just Let Go",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "106 min",
		"genre": "Drama",
		"released": "2015-10-09",
		"director": "Christopher S. Clark, Patrick Henry Parker",
		"writer": "Christopher S. Clark, Vance Mellen (screenplay), Vance Mellen, Patrick Henry Parker, Chris Stuart Williams (book)",
		"cast": "Henry Ian Cusick, Brenda Vaccaro, Sam Sorbo, Jacob Buster",
		"metacritic": "",
		"imdbRating": "7.5",
		"imdbVotes": "28",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDY2NzQxNzQ2MV5BMl5BanBnXkFtZTgwNDQzNTE5NTE@._V1_SX300.jpg",
		"plot": "After surviving a drunk driving accident that killed his pregnant wife and two kids, Chris Williams struggles to 'just let go' and forgive the young man who caused it.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3198500",
		"imdbID": "tt3198500",
		"title": "Art Gods",
		"year": "2013",
		"rating": "Not Rated",
		"runtime": "72 min",
		"genre": "Documentary, Biography, History",
		"released": "2013-12-01",
		"director": "Strephon Taylor",
		"writer": "Strephon Taylor",
		"cast": "Ernie Fosselius",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA2MTQwOTg0MTReQTJeQWpwZ15BbWU4MDM1MjM2NDAx._V1_SX300.jpg",
		"plot": "The beginning of the Tower Records art department. Interviews with the original artists that created the unique Tower Records display look.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3200980",
		"imdbID": "tt3200980",
		"title": "Where Hope Grows",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "95 min",
		"genre": "Drama",
		"released": "2015-05-15",
		"director": "Chris Dowling",
		"writer": "Chris Dowling",
		"cast": "Danica McKellar, Brooke Burns, McKaley Miller, Kerr Smith",
		"metacritic": "41",
		"imdbRating": "6.5",
		"imdbVotes": "1460",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY1MjUxOTU0OF5BMl5BanBnXkFtZTgwMDYxNTQ0NDE@._V1_SX300.jpg",
		"plot": "A baseball player whose professional career was cut short due to his personal problems is suddenly awakened and invigorated by a young-man with Down syndrome who works at the local grocery store.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3201722",
		"imdbID": "tt3201722",
		"title": "Lumberjack Man",
		"year": "2015",
		"rating": "R",
		"runtime": "105 min",
		"genre": "Comedy, Horror",
		"released": "2015-10-16",
		"director": "Josh Bear",
		"writer": "Josh Bear (story), Bill Muehl (story), Ed Kuehnel (screenplay), Matt Entin (screenplay), Matt Entin, Ed Kuehnel",
		"cast": "Michael Madsen, Ciara Flynn, Jarrett King, Brina Palencia",
		"metacritic": "",
		"imdbRating": "4.3",
		"imdbVotes": "275",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY4NTkzOTEzOF5BMl5BanBnXkFtZTgwOTgxNzI1MDE@._V1_SX300.jpg",
		"plot": "As the staff of Good Friends Church Camp prepares for a spring break filled with \"Fun Under the Son\", a demon logger rises from his sap boiler to wreak his vengeance and feast on flapjacks soaked in the blood of his victims.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3202708",
		"imdbID": "tt3202708",
		"title": "Salvation Street",
		"year": "2015",
		"rating": "PG",
		"runtime": "86 min",
		"genre": "Family",
		"released": "2015-11-13",
		"director": "Ralph E. Portillo",
		"writer": "Rick Joseph, Israel Matos, Israel Matos",
		"cast": "Joe Pacheco, Catherine Lidstone, Israel Matos, Olivia Rose Keegan",
		"metacritic": "",
		"imdbRating": "5.3",
		"imdbVotes": "33",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgyMjc5NTQyM15BMl5BanBnXkFtZTgwNDc0MDQ0MzE@._V1_SX300.jpg",
		"plot": "One day, one moment, one idea can change lives. Noah Davis is a Pastor in an affluent community. Depressed after losing his wife to illness, he is contacted by an old friend who has opened ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3210376",
		"imdbID": "tt3210376",
		"title": "Holiday Road Trip",
		"year": "2013",
		"rating": "PG",
		"runtime": "88 min",
		"genre": "Comedy, Drama, Romance",
		"released": "2013-12-01",
		"director": "Fred Olen Ray",
		"writer": "Hanz Wasserburger, Fred Olen Ray",
		"cast": "Patrick Muldoon, Ashley Scott, Kip Pardue, George Hamilton",
		"metacritic": "",
		"imdbRating": "5.8",
		"imdbVotes": "220",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIzNjIwMTkyOF5BMl5BanBnXkFtZTgwNjg4MzUyNzE@._V1_SX300.jpg",
		"plot": "Two feuding pet shop employees fall for each other while escorting a celebrity dog on a Christmas promotional tour.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3210686",
		"imdbID": "tt3210686",
		"title": "Son of God",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "138 min",
		"genre": "Biography, Drama, Fantasy",
		"released": "2014-02-28",
		"director": "Christopher Spencer",
		"writer": "Richard Bedser, Christopher Spencer, Colin Swash, Nic Young",
		"cast": "Sebastian Knapp, Paul Knops, Darcie Lincoln, David Rintoul",
		"metacritic": "37",
		"imdbRating": "5.5",
		"imdbVotes": "14691",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA3NjQ2ODYwN15BMl5BanBnXkFtZTgwNTQ0NDc2MDE@._V1_SX300.jpg",
		"plot": "The life story of Jesus is told from his humble birth through his teachings, crucifixion and ultimate resurrection.",
		"language": "English, Hebrew",
		"country": "USA",
		"awards": "2 wins & 1 nomination."
	},
	{
		"id": "3210984",
		"imdbID": "tt3210984",
		"title": "Dear Secret Santa",
		"year": "2013",
		"rating": "PG",
		"runtime": "88 min",
		"genre": "Comedy, Romance",
		"released": "2013-11-30",
		"director": "Peter Sullivan",
		"writer": "Peter Sullivan, Hanz Wasserburger",
		"cast": "Tatyana Ali, Bill Cobbs, Jordin Sparks, Ernie Hudson",
		"metacritic": "",
		"imdbRating": "6.3",
		"imdbVotes": "292",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg4Njk3MTI4Ml5BMl5BanBnXkFtZTgwNDA5NjMzMTE@._V1_SX300.jpg",
		"plot": "Beverly Hills banker/workaholic JENNIFER comes home to her small Northern California town just before Christmas when her dad, TED , takes a bad fall while putting up decorations. While home...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3210998",
		"imdbID": "tt3210998",
		"title": "Matthew 18",
		"year": "2014",
		"rating": "R",
		"runtime": "101 min",
		"genre": "Thriller",
		"released": "2014-11-14",
		"director": "Roy Belfrey",
		"writer": "Roy Belfrey",
		"cast": "Denise Baker, Irina Balushka, Lanore VanBuren Belfrey, Sanya Belfrey",
		"metacritic": "",
		"imdbRating": "3.6",
		"imdbVotes": "74",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIyMzU3ODg5Nl5BMl5BanBnXkFtZTgwNDM4MDYwMzE@._V1_SX300.jpg",
		"plot": "The story centers around the subject of African American culture, what goes on in the grassroots of the church community and even within the households and fabric of the culture. The film, ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3212904",
		"imdbID": "tt3212904",
		"title": "Curve",
		"year": "2015",
		"rating": "R",
		"runtime": "86 min",
		"genre": "Horror, Thriller",
		"released": "2015-10-14",
		"director": "Iain Softley",
		"writer": "Kimberly Lofstrom Johnson (story), Kimberly Lofstrom Johnson (screenplay), Lee Patterson (screenplay)",
		"cast": "Julianne Hough, Teddy Sears, Penelope Mitchell, Madalyn Horcher",
		"metacritic": "",
		"imdbRating": "5.4",
		"imdbVotes": "982",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTgzNzQxMTg0MF5BMl5BanBnXkFtZTgwNTkyMDkzNzE@._V1_SX300.jpg",
		"plot": "A young woman becomes trapped in her car after a hitchhiker causes her to have an automobile accident.",
		"language": "",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3214608",
		"imdbID": "tt3214608",
		"title": "Rob the Mob",
		"year": "2014",
		"rating": "R",
		"runtime": "104 min",
		"genre": "Crime, Drama",
		"released": "2014-03-15",
		"director": "Raymond De Felitta",
		"writer": "Jonathan Fernandez",
		"cast": "Michael Pitt, Nina Arianda, Andy Garcia, Ray Romano",
		"metacritic": "63",
		"imdbRating": "6.3",
		"imdbVotes": "8058",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE4MTE4MTEyNl5BMl5BanBnXkFtZTgwMjIwNTgwMTE@._V1_SX300.jpg",
		"plot": "A Queens couple who specialize in robbing mafia social clubs stumble upon a score bigger than they could ever imagine, becoming targets of both the mob and the FBI in the process.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3231054",
		"imdbID": "tt3231054",
		"title": "Risen",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "107 min",
		"genre": "Action, Adventure, Drama",
		"released": "2016-02-19",
		"director": "Kevin Reynolds",
		"writer": "Kevin Reynolds (screenplay), Paul Aiello (screenplay), Paul Aiello (story)",
		"cast": "Tom Felton, Joseph Fiennes, Cliff Curtis, Peter Firth",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTAzNjQ1Mzk2MjNeQTJeQWpwZ15BbWU4MDU0MDk1Mjcx._V1_SX300.jpg",
		"plot": "Follows the epic Biblical story of the Resurrection, as told through the eyes of a non-believer. Clavius, a powerful Roman Military Tribune, and his aide Lucius, are tasked with solving the...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3246210",
		"imdbID": "tt3246210",
		"title": "A Long Way Off",
		"year": "2014",
		"rating": "PG",
		"runtime": "105 min",
		"genre": "Drama, Family, Romance",
		"released": "2014-06-06",
		"director": "Michael Davis, John Errington",
		"writer": "Jon Macy, Gerald McGlothlin",
		"cast": "Robert Davi, John Diehl, Edie McClurg, Zoe Myers",
		"metacritic": "",
		"imdbRating": "5.4",
		"imdbVotes": "88",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY1NzYzMzAzNF5BMl5BanBnXkFtZTgwMDQ1MjA0MTE@._V1_SX300.jpg",
		"plot": "A modern day version of The Prodigal Son Parable",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "3248600",
		"imdbID": "tt3248600",
		"title": "The Squeeze",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "95 min",
		"genre": "Comedy, Drama, Sport",
		"released": "2015-04-17",
		"director": "Terry Jastrow",
		"writer": "Terry Jastrow, Terry Jastrow",
		"cast": "Jeremy Sumpter, Katherine LaNasa, David O'Donnell, Jillian Murray",
		"metacritic": "26",
		"imdbRating": "5.3",
		"imdbVotes": "351",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYyNjMwNjM2Ml5BMl5BanBnXkFtZTgwNTMyMDA5NDE@._V1_SX300.jpg",
		"plot": "A humble young man with uncommon skills from a small southern town gets caught up in high stakes golf matches between big-time gamblers until the game becomes life and death.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3250032",
		"imdbID": "tt3250032",
		"title": "Sex, Death and Bowling",
		"year": "2015",
		"rating": "R",
		"runtime": "92 min",
		"genre": "Comedy, Drama, Family",
		"released": "2015-10-30",
		"director": "Ally Walker",
		"writer": "Ally Walker (story), Ally Walker, Ally Walker",
		"cast": "Drea de Matteo, Selma Blair, Adrian Grenier, Mary Lynn Rajskub",
		"metacritic": "",
		"imdbRating": "5.4",
		"imdbVotes": "37",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI3ODUyNDk3OV5BMl5BanBnXkFtZTgwNzc5NDc3NjE@._V1_SX300.jpg",
		"plot": "Eli McAllister, our eleven-year-old hero, is on a quest. He is also setting out to win The Fiesta Cup, a local bowling tournament. Joining him is his famous fashion designer uncle, Sean McAllister.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3276924",
		"imdbID": "tt3276924",
		"title": "Heist",
		"year": "2015",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Action, Crime, Thriller",
		"released": "2015-11-13",
		"director": "Scott Mann",
		"writer": "Stephen Cyrus Sepher (original screenplay by), Stephen Cyrus Sepher (story), Max Adams (screenplay)",
		"cast": "Summer Altice, Gina Carano, Robert De Niro, Jeffrey Dean Morgan",
		"metacritic": "37",
		"imdbRating": "6.1",
		"imdbVotes": "7147",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEzNTkyMDE3NV5BMl5BanBnXkFtZTgwMTM2MDY4NjE@._V1_SX300.jpg",
		"plot": "A father is without the means to pay for his daughter's medical treatment. As a last resort, he partners with a greedy co-worker to rob a casino. When things go awry they're forced to hijack a city bus.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3277624",
		"imdbID": "tt3277624",
		"title": "Creative Control",
		"year": "2015",
		"rating": "R",
		"runtime": "97 min",
		"genre": "Drama",
		"released": "2015-03-14",
		"director": "Benjamin Dickinson",
		"writer": "Micah Bloomberg, Benjamin Dickinson",
		"cast": "Benjamin Dickinson, Nora Zehetner, Dan Gill, Alexia Rasmussen",
		"metacritic": "",
		"imdbRating": "7.5",
		"imdbVotes": "42",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY1NzY2NDQzMl5BMl5BanBnXkFtZTgwMDE3MDY2NDE@._V1_SX300.jpg",
		"plot": "In near future Brooklyn, an ad executive uses a new Augmented Reality technology to conduct an affair with his best friend's girlfriend...sort of.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 1 nomination."
	},
	{
		"id": "3279176",
		"imdbID": "tt3279176",
		"title": "Suburban Gothic",
		"year": "2014",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Comedy, Horror, Romance",
		"released": "2015-01-30",
		"director": "Richard Bates Jr.",
		"writer": "Richard Bates Jr., Mark Bruner",
		"cast": "Matthew Gray Gubler, Kat Dennings, Ray Wise, Barbara Niven",
		"metacritic": "49",
		"imdbRating": "5.5",
		"imdbVotes": "1885",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk5NzYyNDYwOV5BMl5BanBnXkFtZTgwNzk5NDQ0NTE@._V1_SX300.jpg",
		"plot": "Raymond has a prestigious MBA, but he can't find work. He can channel the paranormal, but chatting with a cute girl mystifies him. Kicked out of his big city apartment, Raymond returns home...",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "3283950",
		"imdbID": "tt3283950",
		"title": "The Adventures of Pepper and Paula",
		"year": "2015",
		"rating": "PG",
		"runtime": "93 min",
		"genre": "Family",
		"released": "2015-04-11",
		"director": "Kevin Nations, Robin Nations",
		"writer": "Richard Dane Scott",
		"cast": "Alexandria DeBerry, Donny Boaz, Sandy Garza, Larry Jack Dotson",
		"metacritic": "",
		"imdbRating": "6.8",
		"imdbVotes": "44",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzOTg0MDEzNV5BMl5BanBnXkFtZTgwNzI4MjA3NDE@._V1_SX300.jpg",
		"plot": "Based on the true life adventures of Pistol Packin Paula and her dog, Pepper.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3307800",
		"imdbID": "tt3307800",
		"title": "The Dog Who Saved Easter",
		"year": "2014",
		"rating": "PG",
		"runtime": "87 min",
		"genre": "Family",
		"released": "2014-03-18",
		"director": "Sean Olson",
		"writer": "Michael Ciminera (screenplay), Michael Ciminera (story), Richard Gnolfo (screenplay), Richard Gnolfo (story), Sean Olson (screenplay), Jeffrey Schenck (story), Peter Sullivan (screenplay), Peter Sullivan (story)",
		"cast": "Dean Cain, Elisa Donovan, Beverley Mitchell, Patrick Muldoon",
		"metacritic": "",
		"imdbRating": "4.3",
		"imdbVotes": "97",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk0NDEzNDIxM15BMl5BanBnXkFtZTgwOTQzNjQ2MDE@._V1_SX300.jpg",
		"plot": "It's Easter and everyone's favorite K-9 is back! The Bannisters are heading out on a family cruise and sending Zeus to doggie day care. Everything is going according to plan until the ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3317208",
		"imdbID": "tt3317208",
		"title": "Anesthesia",
		"year": "2015",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Drama, Thriller",
		"released": "2016-01-08",
		"director": "Tim Blake Nelson",
		"writer": "Tim Blake Nelson",
		"cast": "David Aaron Baker, Derrick Baskin, Jacqueline Baum, Lisa Benavides-Nelson",
		"metacritic": "58",
		"imdbRating": "6.1",
		"imdbVotes": "299",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNDUyMjgxNzQ4NV5BMl5BanBnXkFtZTgwNzkzMDA1NzE@._V1_SX300.jpg",
		"plot": "Multiple lives intersect in the aftermath of the violent mugging of a Columbia University philosophy professor.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3322940",
		"imdbID": "tt3322940",
		"title": "Annabelle",
		"year": "2014",
		"rating": "R",
		"runtime": "99 min",
		"genre": "Horror, Mystery",
		"released": "2014-10-03",
		"director": "John R. Leonetti",
		"writer": "Gary Dauberman",
		"cast": "Annabelle Wallis, Ward Horton, Tony Amendola, Alfre Woodard",
		"metacritic": "37",
		"imdbRating": "5.4",
		"imdbVotes": "72249",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM2MTYyMzk1OV5BMl5BanBnXkFtZTgwNDg2MjMyMjE@._V1_SX300.jpg",
		"plot": "A couple begins to experience terrifying supernatural occurrences involving a vintage doll shortly after their home is invaded by satanic cultists.",
		"language": "English",
		"country": "USA",
		"awards": "6 nominations."
	},
	{
		"id": "3333334",
		"imdbID": "tt3333334",
		"title": "The World Made Straight",
		"year": "2015",
		"rating": "R",
		"runtime": "119 min",
		"genre": "Drama",
		"released": "2015-01-09",
		"director": "David Burris",
		"writer": "Shane Danielsen (screenplay), Shane Danielsen, Ron Rash (novel)",
		"cast": "Noah Wyle, Jeremy Irvine, Minka Kelly, Adelaide Clemens",
		"metacritic": "48",
		"imdbRating": "5.4",
		"imdbVotes": "1180",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ0MjgxMzExNl5BMl5BanBnXkFtZTgwMTkwNjI0MzE@._V1_SX300.jpg",
		"plot": "In a rural Appalachian community haunted by the legacy of a Civil War massacre, a rebellious young man struggles to escape the violence that would bind him to the past.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3359872",
		"imdbID": "tt3359872",
		"title": "Doc Holliday's Revenge",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "84 min",
		"genre": "Western",
		"released": "2014-06-01",
		"director": "David DeCoteau",
		"writer": "Rolfe Kanefsky",
		"cast": "William McNamara, Eric Roberts, Tom Berenger, Ashley Hayes",
		"metacritic": "",
		"imdbRating": "3.4",
		"imdbVotes": "101",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc0OTMxNzg2M15BMl5BanBnXkFtZTgwOTQzOTUwMjE@._V1_SX300.jpg",
		"plot": "In 1882, Joseph and Elizabeth Cooley head west to reunite with Elizabeth's family and are stranded in a logging camp just outside Tucson. Then, a wounded Indian stumbles into their camp and...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3374210",
		"imdbID": "tt3374210",
		"title": "Shadow Bound",
		"year": "2013",
		"rating": "Unrated",
		"runtime": "20 min",
		"genre": "Horror",
		"released": "2013-10-31",
		"director": "",
		"writer": "Nathan Shelton (creator)",
		"cast": "Nathan Shelton, Shawn Young, Sam Long, Kevin Keppy",
		"metacritic": "",
		"imdbRating": "8.9",
		"imdbVotes": "51",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUwMzI2MTE1NV5BMl5BanBnXkFtZTgwOTQzMTg5MDE@._V1_SX300.jpg",
		"plot": "Famed horror writer, Jack Pickman, returns to his childhood home of Veritas and soon finds himself embroiled in a terrifying mystery.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3385398",
		"imdbID": "tt3385398",
		"title": "La Bare",
		"year": "2014",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Documentary",
		"released": "2014-01-19",
		"director": "Joe Manganiello",
		"writer": "",
		"cast": "Dorman Dye, Joe Manganiello, Dawn Rochelle, Nick Soto",
		"metacritic": "55",
		"imdbRating": "6.0",
		"imdbVotes": "280",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU5MTAxMTQ2M15BMl5BanBnXkFtZTgwNDMzNjYzMjE@._V1_SX300.jpg",
		"plot": "An insider's look at the history, lives and culture of the most popular male strip club in the world, La Bare Dallas.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3404072",
		"imdbID": "tt3404072",
		"title": "To Know God",
		"year": "2014",
		"rating": "Not Rated",
		"runtime": "",
		"genre": "",
		"released": "2014-01-01",
		"director": "Stefan Sims",
		"writer": "Sarah Robb Purcell",
		"cast": "Mary Anderle, Jenny Cippola, Colby Clifford, Ashley Frey",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ5NzE0NzgxNV5BMl5BanBnXkFtZTgwODkzODI4MDE@._V1_SX300.jpg",
		"plot": "",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3408000",
		"imdbID": "tt3408000",
		"title": "Penthouse North",
		"year": "2013",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Drama, Mystery, Thriller",
		"released": "2014-01-04",
		"director": "Joseph Ruben",
		"writer": "David Loughery",
		"cast": "Michelle Monaghan, Michael Keaton, Barry Sloane, Andrew W. Walker",
		"metacritic": "",
		"imdbRating": "5.5",
		"imdbVotes": "2528",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkxNTI3NzMwMV5BMl5BanBnXkFtZTgwMTM0NTIwMzE@._V1_SX300.jpg",
		"plot": "A reclusive, blind photojournalist lives quietly in a New York penthouse, until a smooth but sadistic criminal looking for a hidden fortune enters her life.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3421204",
		"imdbID": "tt3421204",
		"title": "Horse Camp",
		"year": "2014",
		"rating": "PG",
		"runtime": "108 min",
		"genre": "Family",
		"released": "2015-01-10",
		"director": "Joel Paul Reisig",
		"writer": "Joel Paul Reisig",
		"cast": "Annelyse Ahmad, Syndney Anderson, Bonnie Ball, Hunter Ball",
		"metacritic": "",
		"imdbRating": "6.0",
		"imdbVotes": "27",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzIwNTcyNzg0Ml5BMl5BanBnXkFtZTgwMDA5MDk1NDE@._V1_SX300.jpg",
		"plot": "When Kathy arrives at horse camp, she realizes that she must deal with Stacy, the resident mean girl. As competition heats up, Kathy learns to recognize the true value of real friendship.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3458236",
		"imdbID": "tt3458236",
		"title": "Lambert & Stamp",
		"year": "2014",
		"rating": "R",
		"runtime": "117 min",
		"genre": "Documentary, Biography, History",
		"released": "2015-04-03",
		"director": "James D. Cooper",
		"writer": "",
		"cast": "Richard Barnes, Ritchie Blackmore, Heather Daltrey, Roger Daltrey",
		"metacritic": "75",
		"imdbRating": "6.5",
		"imdbVotes": "393",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzM2OTEyNTUwOF5BMl5BanBnXkFtZTgwMDU5Nzk4NDE@._V1_SX300.jpg",
		"plot": "A documentary that reveals how the unlikely partnership between aspiring filmmakers Christopher Stamp and Kit Lambert produced one of the greatest rock bands in history: The Who.",
		"language": "German, French, English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3486392",
		"imdbID": "tt3486392",
		"title": "Jingle All the Way 2",
		"year": "2014",
		"rating": "PG",
		"runtime": "93 min",
		"genre": "Comedy, Family",
		"released": "2014-12-02",
		"director": "Alex Zamm",
		"writer": "Randy Kornfield (based on \"Jingle All the Way\" written by), Stephen Mazur",
		"cast": "Larry the Cable Guy, Brian Stepanek, Anthony Carelli, Kennedi Clements",
		"metacritic": "",
		"imdbRating": "3.8",
		"imdbVotes": "1047",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzg5MjI0Mzg1MF5BMl5BanBnXkFtZTgwNDExNzYxMzE@._V1_SX300.jpg",
		"plot": "Larry's daughter wants only one thing for Christmas - a talking bear. His daughter's step-dad intends to make sure that Larry can't get one.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3499458",
		"imdbID": "tt3499458",
		"title": "The Walking Deceased",
		"year": "2015",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Comedy",
		"released": "2015-03-20",
		"director": "Scott Dow",
		"writer": "Tim Ogletree",
		"cast": "Tim Ogletree, Joey Oglesby, Troy Ogletree, Dave Sheridan",
		"metacritic": "9",
		"imdbRating": "3.3",
		"imdbVotes": "1832",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ5NTE5OTI2MV5BMl5BanBnXkFtZTgwNzc1NzY1NDE@._V1_SX300.jpg",
		"plot": "When a police officer wakes up in a hospital to find out he is in the middle of a zombie apocalypse, he will do anything to find his family, even sacrifice Twitter.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3500918",
		"imdbID": "tt3500918",
		"title": "SEE: An Art Road Trip",
		"year": "2013",
		"rating": "PG",
		"runtime": "75 min",
		"genre": "Documentary, Adventure",
		"released": "2013-09-01",
		"director": "Glenn Holsten, Bo Bartlett, Betsy Eby",
		"writer": "Bo Bartlett, Betsy Eby",
		"cast": "Bo Bartlett, Betsy Eby",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM2MzkwNjI3OV5BMl5BanBnXkFtZTgwMjgwMDI2MTE@._V1_SX300.jpg",
		"plot": "Artists Bo Bartlett and Betsy Eby set off to make a film about seeing. They travel the country, stumbling upon art sites, characters and luminaries. But then the unexpected happens, sending...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3501702",
		"imdbID": "tt3501702",
		"title": "Til Death Do Us Part",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "90 min",
		"genre": "Horror, Thriller",
		"released": "2014-10-30",
		"director": "Marcus J. Mosley",
		"writer": "Marcus J. Mosley",
		"cast": "Paige Ball, William Conklin, Benisha Dorris, Joe Hammerstone",
		"metacritic": "",
		"imdbRating": "5.4",
		"imdbVotes": "8",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg2MzQwMDc3Ml5BMl5BanBnXkFtZTgwODM5NTk0MTE@._V1_SX300.jpg",
		"plot": "Meg Alexander and her groom to be Derrick Logan prepare for their wedding day, but as their big day gets closer, paranormal activities soon start when Meg brings her dead mother's wedding dress into their home.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3518012",
		"imdbID": "tt3518012",
		"title": "Best of Enemies",
		"year": "2015",
		"rating": "R",
		"runtime": "87 min",
		"genre": "Documentary, History, News",
		"released": "2015-07-31",
		"director": "Robert Gordon, Morgan Neville",
		"writer": "Robert Gordon, Morgan Neville",
		"cast": "Paul Newman, John Lithgow, Kelsey Grammer, Gore Vidal",
		"metacritic": "77",
		"imdbRating": "7.7",
		"imdbVotes": "1954",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA0MzA1ODA5NF5BMl5BanBnXkFtZTgwMDc3OTU5NTE@._V1_SX300.jpg",
		"plot": "A documentary on the series of televised debates in 1968 between liberal Gore Vidal and conservative William F. Buckley.",
		"language": "English",
		"country": "USA",
		"awards": "5 wins & 18 nominations."
	},
	{
		"id": "3525346",
		"imdbID": "tt3525346",
		"title": "Bad Ass 3: Bad Asses on the Bayou",
		"year": "2015",
		"rating": "R",
		"runtime": "85 min",
		"genre": "Action, Drama",
		"released": "2015-03-06",
		"director": "Craig Moss",
		"writer": "Craig Moss",
		"cast": "Danny Trejo, Danny Glover, John Amos, Loni Love",
		"metacritic": "",
		"imdbRating": "5.3",
		"imdbVotes": "1065",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzA2OTcxNjk2OF5BMl5BanBnXkFtZTgwMTgwNDUxNDE@._V1_SX300.jpg",
		"plot": "Frank Vega and Bernie Pope return, this time to Louisiana in an attempt to find a kidnapped friend.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3528666",
		"imdbID": "tt3528666",
		"title": "The Marine 4: Moving Target",
		"year": "2015",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Action, Thriller",
		"released": "2015-04-10",
		"director": "William Kaufman",
		"writer": "Alan B. McElroy, Scott Wiper (based on characters created by), Declan O'Brien (based on characters created by)",
		"cast": "Mike 'The Miz' Mizanin, Josh Blacker, Matthew MacCaull, Danielle Moinet",
		"metacritic": "",
		"imdbRating": "5.2",
		"imdbVotes": "1569",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTc0MzA1MDQyN15BMl5BanBnXkFtZTgwMDA1Mzk2NDE@._V1_SX300.jpg",
		"plot": "Jake Carter is assigned to protect a \"high-value package,\" a beautiful whistleblower trying to expose a corrupt army defense contractor.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3529656",
		"imdbID": "tt3529656",
		"title": "Meadowland",
		"year": "2015",
		"rating": "R",
		"runtime": "105 min",
		"genre": "Drama",
		"released": "2015-04-17",
		"director": "Reed Morano",
		"writer": "Chris Rossi",
		"cast": "Olivia Wilde, Juno Temple, Luke Wilson, Giovanni Ribisi",
		"metacritic": "67",
		"imdbRating": "6.0",
		"imdbVotes": "1150",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUyMzgyNDU1M15BMl5BanBnXkFtZTgwOTU4Njg4NjE@._V1_SX300.jpg",
		"plot": "In the hazy aftermath of an unimaginable loss, Sarah and Phil come unhinged, recklessly ignoring the repercussions. Phil starts to lose sight of his morals; Sarah takes off on a potentially disastrous journey, falling deeper into her own fever dream.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "3530002",
		"imdbID": "tt3530002",
		"title": "The Night Before",
		"year": "2015",
		"rating": "R",
		"runtime": "101 min",
		"genre": "Comedy",
		"released": "2015-11-20",
		"director": "Jonathan Levine",
		"writer": "Jonathan Levine (screenplay), Kyle Hunter (screenplay), Ariel Shaffir (screenplay), Evan Goldberg (screenplay), Jonathan Levine (story)",
		"cast": "Joseph Gordon-Levitt, Seth Rogen, Anthony Mackie, Jillian Bell",
		"metacritic": "58",
		"imdbRating": "7.2",
		"imdbVotes": "7664",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkyNDY1ODQwNV5BMl5BanBnXkFtZTgwNzA2MjUwNzE@._V1_SX300.jpg",
		"plot": "On Christmas eve, three lifelong friends, two of whom are Jewish, spend the night in New York City looking for the Holy Grail of Christmas parties.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3534282",
		"imdbID": "tt3534282",
		"title": "Don Verdean",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "90 min",
		"genre": "Comedy",
		"released": "2015-12-11",
		"director": "Jared Hess",
		"writer": "Jared Hess, Jerusha Hess",
		"cast": "Sam Rockwell, Amy Ryan, Will Forte, Danny McBride",
		"metacritic": "39",
		"imdbRating": "5.4",
		"imdbVotes": "643",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTAzODQyMjM3NTleQTJeQWpwZ15BbWU4MDc2NDY5MDcx._V1_SX300.jpg",
		"plot": "A self-professed biblical archaeologist who has fallen on hard times starts to bend the truth in order to continue inspiring the faithful.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3534842",
		"imdbID": "tt3534842",
		"title": "Finders Keepers",
		"year": "2014",
		"rating": "R",
		"runtime": "84 min",
		"genre": "Thriller",
		"released": "2014-10-18",
		"director": "Alexander Yellen",
		"writer": "Jeffrey Schenck (story), Peter Sullivan (screenplay), Peter Sullivan (story)",
		"cast": "Steve Austin, Tobin Bell, Aaron Christopher, Mark DeCarlo",
		"metacritic": "",
		"imdbRating": "4.4",
		"imdbVotes": "1506",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA2NDM2OTY3MF5BMl5BanBnXkFtZTgwNjY0NDAxMzE@._V1_SX300.jpg",
		"plot": "A divorced mother of one is thrown into turmoil when her young daughter becomes obsessed with an evil doll left behind by the previous occupants of their new home.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3564200",
		"imdbID": "tt3564200",
		"title": "Tooken",
		"year": "2015",
		"rating": "R",
		"runtime": "80 min",
		"genre": "Comedy",
		"released": "2015-05-26",
		"director": "John Asher",
		"writer": "Cameron Van Hoy, John Asher",
		"cast": "Lee Tergesen, Reno Wilson, Lauren Stamile, Joyce Bulifant",
		"metacritic": "",
		"imdbRating": "3.7",
		"imdbVotes": "659",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ2OTc3Mzk1OV5BMl5BanBnXkFtZTgwNjU3NzM5MzE@._V1_SX300.jpg",
		"plot": "Tooken - The spoof on the popular Taken franchise.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3565344",
		"imdbID": "tt3565344",
		"title": "Steve Jobs",
		"year": "2015",
		"rating": "R",
		"runtime": "122 min",
		"genre": "Biography, Drama",
		"released": "2015-10-23",
		"director": "Danny Boyle",
		"writer": "Aaron Sorkin (screenplay), Walter Isaacson (book)",
		"cast": "Michael Fassbender, Kate Winslet, Seth Rogen, Jeff Daniels",
		"metacritic": "82",
		"imdbRating": "7.7",
		"imdbVotes": "16155",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE0NTA2MTEwOV5BMl5BanBnXkFtZTgwNzg4NzU2NjE@._V1_SX300.jpg",
		"plot": "Steve Jobs takes us behind the scenes of the digital revolution, to paint a portrait of the man at its epicenter. The story unfolds backstage at three iconic product launches, ending in 1998 with the unveiling of the iMac.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 4 Golden Globes. Another 1 win & 17 nominations."
	},
	{
		"id": "3567200",
		"imdbID": "tt3567200",
		"title": "The Great Invisible",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "92 min",
		"genre": "Documentary",
		"released": "2014-03-09",
		"director": "Margaret Brown",
		"writer": "",
		"cast": "Meccah Boynton-Brown, Doug Brown, Bob Cavnar, Brent Coon",
		"metacritic": "72",
		"imdbRating": "6.6",
		"imdbVotes": "339",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYzMTUxNzYwMl5BMl5BanBnXkFtZTgwNzE5NjM5MjE@._V1_SX300.jpg",
		"plot": "A documentary on the Deepwater Horizon oil rig explosion as seen through the eyes of oil executives, survivors and Gulf Coast residents who experienced it first-hand and then were left to pick up the pieces while the world moved on.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 5 nominations."
	},
	{
		"id": "3567288",
		"imdbID": "tt3567288",
		"title": "The Visit",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "94 min",
		"genre": "Horror, Thriller",
		"released": "2015-09-11",
		"director": "M. Night Shyamalan",
		"writer": "M. Night Shyamalan (screenplay)",
		"cast": "Olivia DeJonge, Ed Oxenbould, Deanna Dunagan, Peter McRobbie",
		"metacritic": "55",
		"imdbRating": "6.3",
		"imdbVotes": "40590",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg3OTM2OTc5MV5BMl5BanBnXkFtZTgwMjMxNDM0NTE@._V1_SX300.jpg",
		"plot": "Two siblings become incredibly frightened by their grandparents disturbing behavior, while visiting them on vacation.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "3577980",
		"imdbID": "tt3577980",
		"title": "The Drive III",
		"year": "2014",
		"rating": "Not Rated",
		"runtime": "30 min",
		"genre": "Drama",
		"released": "2014-02-28",
		"director": "Scott Shaw",
		"writer": "Scott Shaw",
		"cast": "Scott Shaw",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY1OTYzNTUyN15BMl5BanBnXkFtZTgwNjIxNDk1MTE@._V1_SX300.jpg",
		"plot": "A Scott Shaw Zen Film Mind Ride.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3591436",
		"imdbID": "tt3591436",
		"title": "Night Owls",
		"year": "2015",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Comedy, Drama",
		"released": "2015-03-13",
		"director": "Charles Hood",
		"writer": "Seth Goldsmith, Charles Hood",
		"cast": "Adam Pally, Rosa Salazar, Rob Huebel, Tony Hale",
		"metacritic": "73",
		"imdbRating": "5.8",
		"imdbVotes": "308",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjgxNjYzNTkyMV5BMl5BanBnXkFtZTgwMjI3NjQyNTE@._V1_SX300.jpg",
		"plot": "After workaholic Kevin has a drunken one night stand with the beautiful train-wreck Madeline, he's horrified to discover that she's actually his boss' jilted ex-mistress. When she takes a ...",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 1 nomination."
	},
	{
		"id": "3602106",
		"imdbID": "tt3602106",
		"title": "Street",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "",
		"genre": "Action",
		"released": "2015-06-16",
		"director": "Bradford May",
		"writer": "Brandi Ellis, Tye Lombardi, Brett R. Miller",
		"cast": "Mindy Robinson, Mark Ryan, John Hennigan, Sean Stewart",
		"metacritic": "",
		"imdbRating": "6.9",
		"imdbVotes": "12",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODI2OTU4MTg4OV5BMl5BanBnXkFtZTgwNjIxMzQ5NDE@._V1_SX300.jpg",
		"plot": "Remo Street is a young fighter who comes from a world where nothing is easy, so when he is faced with the opportunity to train with a world class coach, he has to choose between the long ...",
		"language": "",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3604950",
		"imdbID": "tt3604950",
		"title": "Sophia Grace & Rosie's Royal Adventure",
		"year": "2014",
		"rating": "G",
		"runtime": "70 min",
		"genre": "Adventure, Comedy, Family",
		"released": "2014-05-20",
		"director": "Brian Levant",
		"writer": "Erik Patterson, Jessica Scott",
		"cast": "Sophia Grace Brownlee, Rosie McClelland, Jacqui Achilleas, Rory Acton Burnell",
		"metacritic": "",
		"imdbRating": "4.2",
		"imdbVotes": "309",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODE4OTQ2Njk2OF5BMl5BanBnXkFtZTgwOTcyMjg3MTE@._V1_SX300.jpg",
		"plot": "Sophia Grace and Rosie are sent to Switzelvania by The Ellen DeGeneres Show as special correspondents tasked with covering the coronation of a new queen.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3628584",
		"imdbID": "tt3628584",
		"title": "Barbershop: The Next Cut",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "",
		"genre": "Comedy",
		"released": "2016-04-15",
		"director": "Malcolm D. Lee",
		"writer": "Kenya Barris, Tracy Oliver, Mark Brown (characters)",
		"cast": "Nicki Minaj, Ice Cube, Common, Regina Hall",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzUxMzM5MjIxNF5BMl5BanBnXkFtZTgwMDk1NzMzNzE@._V1_SX300.jpg",
		"plot": "It's been more than 10 years since our last appointment at Calvin's Barbershop. Calvin and his longtime crew are still there, but the shop has undergone some major changes. Most noticeably, our once male-dominated sanctuary is now co-ed.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3640682",
		"imdbID": "tt3640682",
		"title": "I Smile Back",
		"year": "2015",
		"rating": "R",
		"runtime": "85 min",
		"genre": "Drama",
		"released": "2015-11-06",
		"director": "Adam Salky",
		"writer": "Paige Dylan, Paige Dylan, Amy Koppelman, Amy Koppelman",
		"cast": "Josh Charles, Skylar Gaertner, Shayne Coleman, Sarah Silverman",
		"metacritic": "59",
		"imdbRating": "5.9",
		"imdbVotes": "1491",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTk0NDQ3MzgxOF5BMl5BanBnXkFtZTgwMDAzMjExNzE@._V1_SX300.jpg",
		"plot": "Laney Brooks does bad things. Married with kids, she takes the drugs she wants, sleeps with the men she wants, disappears when she wants. Now, with the destruction of her family looming, ...",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 5 nominations."
	},
	{
		"id": "3660770",
		"imdbID": "tt3660770",
		"title": "Monkey Kingdom",
		"year": "2015",
		"rating": "G",
		"runtime": "81 min",
		"genre": "Documentary",
		"released": "2015-04-17",
		"director": "Mark Linfield, Alastair Fothergill",
		"writer": "",
		"cast": "Tina Fey",
		"metacritic": "72",
		"imdbRating": "7.3",
		"imdbVotes": "1801",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMzIxNDc1MDg0MF5BMl5BanBnXkFtZTgwNTI3ODE4MzE@._V1_SX300.jpg",
		"plot": "A nature documentary that follows a newborn monkey and its mother as they struggle to survive within the competitive social hierarchy of the Temple Troop, a dynamic group of monkeys who ...",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3661298",
		"imdbID": "tt3661298",
		"title": "Septembers of Shiraz",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "110 min",
		"genre": "Thriller",
		"released": "2015-09-15",
		"director": "Wayne Blair",
		"writer": "Dalia Sofer (novel), Hanna Weg",
		"cast": "Salma Hayek, Shohreh Aghdashloo, Adrien Brody, Gabriella Wright",
		"metacritic": "",
		"imdbRating": "6.6",
		"imdbVotes": "88",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTgyNTI3NjM0OF5BMl5BanBnXkFtZTgwNTY4MTQ3NjE@._V1_SX300.jpg",
		"plot": "Prior to the Iranian revolution it was a place where people of all religions were allowed to flourish. This is the story of a prosperous Jewish family who abandon everything before they are consumed by the passions of revolutionaries.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3675568",
		"imdbID": "tt3675568",
		"title": "Merchants of Doubt",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "96 min",
		"genre": "Documentary",
		"released": "2014-12-12",
		"director": "Robert Kenner",
		"writer": "Erik M. Conway (original book), Robert Kenner, Naomi Oreskes (original book), Kim Roberts",
		"cast": "Patricia Callahan, Matthew Crawford, Stanton A. Glantz, James Hansen",
		"metacritic": "70",
		"imdbRating": "7.6",
		"imdbVotes": "1820",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA0MDMzMzU2ODJeQTJeQWpwZ15BbWU4MDQxMTE4NTQx._V1_SX300.jpg",
		"plot": "A documentary that looks at pundits-for-hire who present themselves as scientific authorities as they speak about topics like toxic chemicals, pharmaceuticals and climate change.",
		"language": "English",
		"country": "USA",
		"awards": "3 nominations."
	},
	{
		"id": "3677412",
		"imdbID": "tt3677412",
		"title": "An Open Secret",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "99 min",
		"genre": "Documentary",
		"released": "2015-06-01",
		"director": "Amy Berg",
		"writer": "Amy Berg, Lorien Haynes, Billy McMillin",
		"cast": "Evan Henzi, Michael Egan III, Mark Ryan, Joey Coleman",
		"metacritic": "66",
		"imdbRating": "7.0",
		"imdbVotes": "123",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUwMzI0NzY2Nl5BMl5BanBnXkFtZTgwMzQ2NjQ1NTE@._V1_SX300.jpg",
		"plot": "An investigation into accusations of teenagers being sexually abused within the film industry.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3687186",
		"imdbID": "tt3687186",
		"title": "Heaven Knows What",
		"year": "2014",
		"rating": "R",
		"runtime": "94 min",
		"genre": "Drama",
		"released": "2015-05-29",
		"director": "Ben Safdie, Joshua Safdie",
		"writer": "Ronald Bronstein (screenplay), Arielle Holmes (inspired by a book written by), Joshua Safdie (screenplay)",
		"cast": "Buddy Duress, Ron Braunstein, Buddy Duress, Eleonore Hendricks",
		"metacritic": "75",
		"imdbRating": "6.2",
		"imdbVotes": "1256",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg2ODQzNzgzN15BMl5BanBnXkFtZTgwMzkxOTY2NTE@._V1_SX300.jpg",
		"plot": "Harley loves Ilya. He gives her life purpose and sets her passion ablaze. So, when he asks her to prove her love by slitting her wrists, she obliges with only mild hesitation, perhaps because of her other all-consuming love: heroin.",
		"language": "English",
		"country": "USA",
		"awards": "5 wins & 10 nominations."
	},
	{
		"id": "3687398",
		"imdbID": "tt3687398",
		"title": "The Runner",
		"year": "2015",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Drama",
		"released": "2015-08-07",
		"director": "Austin Stark",
		"writer": "Austin Stark",
		"cast": "Sarah Paulson, Nicolas Cage, Connie Nielsen, Peter Fonda",
		"metacritic": "39",
		"imdbRating": "4.6",
		"imdbVotes": "2163",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkyMDkwNDIyMV5BMl5BanBnXkFtZTgwNDU1OTEwNjE@._V1_SX300.jpg",
		"plot": "In the aftermath of the 2010 BP oil spill, an idealistic but flawed politician is forced to confront his dysfunctional life after his career is destroyed in a sex scandal.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3690558",
		"imdbID": "tt3690558",
		"title": "Dakota's Summer",
		"year": "2014",
		"rating": "PG",
		"runtime": "91 min",
		"genre": "Drama, Family",
		"released": "2014-04-01",
		"director": "Timothy Armstrong",
		"writer": "Timothy Armstrong, Timothy Armstrong",
		"cast": "Haley Ramm, Bryan Dechart, Glynn Turman, Emily Bett Rickards",
		"metacritic": "",
		"imdbRating": "5.5",
		"imdbVotes": "176",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODg3MDY2ODMxMV5BMl5BanBnXkFtZTgwNTk0OTg5MDE@._V1_SX300.jpg",
		"plot": "Dakota's Summer tells the story of Dakota Rose's personal journey navigating life and the rodeo circuit after she receives surprising news about her birth almost 18 years ago.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3695244",
		"imdbID": "tt3695244",
		"title": "WARx2",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "117 min",
		"genre": "Documentary",
		"released": "2014-06-13",
		"director": "Bernie Olaf",
		"writer": "",
		"cast": "Betty Adams, Kendall Allen, John Amos, Jessica Anthony",
		"metacritic": "",
		"imdbRating": "9.4",
		"imdbVotes": "2215",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTY3MzI1Mjk3Ml5BMl5BanBnXkFtZTgwMzExMzQ1NTE@._V1_SX300.jpg",
		"plot": "Over 30,000 U.S soldiers committed suicide since 2008.Over 8,000 U.S military veterans committed suicides in the year 2013; and 20,000 soldiers tried to commit suicide in 2013.The Unseen ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3699508",
		"imdbID": "tt3699508",
		"title": "Jarhead 2: Field of Fire",
		"year": "2014",
		"rating": "R",
		"runtime": "103 min",
		"genre": "Action, Drama, War",
		"released": "2014-08-08",
		"director": "Don Michael Paul",
		"writer": "Berkeley Anderson, Ellis Black",
		"cast": "Cole Hauser, Josh Kelly, Danielle Savre, Bokeem Woodbine",
		"metacritic": "",
		"imdbRating": "5.5",
		"imdbVotes": "2820",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNzUxMTA4Njg0M15BMl5BanBnXkFtZTgwMjcxMDUzMjE@._V1_SX300.jpg",
		"plot": "Battle-scarred and disillusioned by the war, Corporal Chris Merrimette is put in charge of a unit whose next mission is to resupply a remote outpost on the edge of Taliban-controlled ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3707514",
		"imdbID": "tt3707514",
		"title": "A Horse Tale",
		"year": "2015",
		"rating": "G",
		"runtime": "85 min",
		"genre": "Family",
		"released": "2015-11-17",
		"director": "Brad Keller",
		"writer": "Lori Twichell",
		"cast": "Charisma Carpenter, Patrick Muldoon, Dominique Swain, Mandalynn Carlson",
		"metacritic": "",
		"imdbRating": "6.5",
		"imdbVotes": "6",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjgwNDU3NTkwNF5BMl5BanBnXkFtZTgwOTkyNzAxNzE@._V1_SX300.jpg",
		"plot": "Uptight city accountant Michael Thompson is hired to help a family save their stable before the bank shuts them down. Michael reluctantly agrees, but as he searches for ways to save a family's legacy, he finds something he never expected.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3713166",
		"imdbID": "tt3713166",
		"title": "Unfriended",
		"year": "2014",
		"rating": "R",
		"runtime": "83 min",
		"genre": "Horror, Mystery, Thriller",
		"released": "2015-04-17",
		"director": "Levan Gabriadze",
		"writer": "Nelson Greaves",
		"cast": "Heather Sossaman, Matthew Bohrer, Courtney Halverson, Shelley Hennig",
		"metacritic": "59",
		"imdbRating": "5.8",
		"imdbVotes": "35445",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUwNzg3Mzg1OV5BMl5BanBnXkFtZTgwMDY2NTAwNDE@._V1_SX300.jpg",
		"plot": "A group of online chat room friends find themselves haunted by a mysterious, supernatural force using the account of their dead friend.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 2 nominations."
	},
	{
		"id": "3729920",
		"imdbID": "tt3729920",
		"title": "The Disappearance of Eleanor Rigby: Them",
		"year": "2014",
		"rating": "R",
		"runtime": "123 min",
		"genre": "Drama",
		"released": "2014-09-12",
		"director": "Ned Benson",
		"writer": "Ned Benson",
		"cast": "James McAvoy, Jessica Chastain, Nina Arianda, Viola Davis",
		"metacritic": "57",
		"imdbRating": "6.3",
		"imdbVotes": "7196",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjM3MDY1NTM5M15BMl5BanBnXkFtZTgwODM0ODkyMjE@._V1_SX300.jpg",
		"plot": "One couple's story as they try to reclaim the life and love they once knew and pick up the pieces of a past that may be too far gone.",
		"language": "English",
		"country": "USA",
		"awards": "2 wins & 8 nominations."
	},
	{
		"id": "3745906",
		"imdbID": "tt3745906",
		"title": "The Hive",
		"year": "2015",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Horror, Sci-Fi, Thriller",
		"released": "2015-09-14",
		"director": "David Yarovesky",
		"writer": "Will Honley, David Yarovesky",
		"cast": "Steve Agee, Elya Baskin, Gabriel Basso, Talitha Bateman",
		"metacritic": "",
		"imdbRating": "5.1",
		"imdbVotes": "766",
		"poster": "http://ia.media-imdb.com/images/M/MV5BODI2NTAwMDg5OF5BMl5BanBnXkFtZTgwNjQ5Mzc2MjE@._V1_SX300.jpg",
		"plot": "A young man suffering from amnesia must dig deep into the far reaches of his mind to remember who he is and save the love of his life before a virus that has infected him takes over.",
		"language": "English, Russian",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3746298",
		"imdbID": "tt3746298",
		"title": "Vendetta",
		"year": "2015",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Action, Drama",
		"released": "2015-06-12",
		"director": "Jen Soska, Sylvia Soska",
		"writer": "Justin Shady",
		"cast": "Dean Cain, Paul Wight, Michael Eklund, Benjamin Hollingsworth",
		"metacritic": "",
		"imdbRating": "4.8",
		"imdbVotes": "1541",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE5ODkzNzI0Nl5BMl5BanBnXkFtZTgwMzcyODQ1NTE@._V1_SX300.jpg",
		"plot": "A detective pushed beyond his limits will stop at nothing for vengeance. When his wife is killed by a criminal that he put away, Mason, a hard-nosed detective, deliberately gets arrested in order to get revenge. While inside, Mason discovers a new criminal enterprise that those behind it would kill to protect.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3766394",
		"imdbID": "tt3766394",
		"title": "Hello, My Name Is Doris",
		"year": "2015",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Comedy, Drama",
		"released": "2016-03-11",
		"director": "Michael Showalter",
		"writer": "Laura Terruso (screenplay), Michael Showalter (screenplay), Laura Terruso (short film \"Doris & the Intern\")",
		"cast": "Sally Field, Max Greenfield, Beth Behrs, Wendi McLendon-Covey",
		"metacritic": "",
		"imdbRating": "7.6",
		"imdbVotes": "118",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg0NTM3MTI1MF5BMl5BanBnXkFtZTgwMTAzNTAzNzE@._V1_SX300.jpg",
		"plot": "A self-help seminar inspires a sixty-something woman to romantically pursue her younger co-worker.",
		"language": "English",
		"country": "USA",
		"awards": "1 win."
	},
	{
		"id": "3794860",
		"imdbID": "tt3794860",
		"title": "Donald G. Jackson: Confessions",
		"year": "2014",
		"rating": "Not Rated",
		"runtime": "38 min",
		"genre": "Documentary",
		"released": "2014-06-10",
		"director": "Scott Shaw",
		"writer": "",
		"cast": "Donald G. Jackson, Conrad Brooks",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA1NzI3NTYxOF5BMl5BanBnXkFtZTgwNjM4NTQyMjE@._V1_SX300.jpg",
		"plot": "Listen to the words of Donald G. Jackson as he discusses his evolution through the independent film industry, from his first film to his last, and how filmmaking lead him to Cinematic Enlightenment.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3799694",
		"imdbID": "tt3799694",
		"title": "The Nice Guys",
		"year": "2016",
		"rating": "R",
		"runtime": "",
		"genre": "Crime, Mystery, Thriller",
		"released": "2016-05-20",
		"director": "Shane Black",
		"writer": "Shane Black, Anthony Bagarozzi",
		"cast": "Ryan Gosling, Matt Bomer, Russell Crowe, Kim Basinger",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjcwNDA5MDYyNl5BMl5BanBnXkFtZTgwNjg0NDkzNzE@._V1_SX300.jpg",
		"plot": "A private eye investigates the apparent suicide of a fading porn star in 1970s Los Angeles and uncovers a conspiracy.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3801438",
		"imdbID": "tt3801438",
		"title": "Grumpy Cat's Worst Christmas Ever",
		"year": "2014",
		"rating": "G",
		"runtime": "85 min",
		"genre": "Adventure, Comedy",
		"released": "2014-11-29",
		"director": "Tim Hill",
		"writer": "Tim Hill, Jeff Morris",
		"cast": "Grumpy Cat, Megan Charpentier, Daniel Roebuck, Russell Peters",
		"metacritic": "",
		"imdbRating": "5.2",
		"imdbVotes": "1551",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEwMTY3ODkxMV5BMl5BanBnXkFtZTgwNzMyODgxMzE@._V1_SX300.jpg",
		"plot": "Grumpy Cat is a lonely cat living in a mall pet shop. Because she never gets chosen by customers, she develops a sour outlook on life...until one day during the holidays, a very special 12-...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3813310",
		"imdbID": "tt3813310",
		"title": "Cop Car",
		"year": "2015",
		"rating": "R",
		"runtime": "88 min",
		"genre": "Thriller",
		"released": "2015-08-07",
		"director": "Jon Watts",
		"writer": "Jon Watts, Christopher D. Ford",
		"cast": "Kevin Bacon, James Freedson-Jackson, Hays Wellford, Camryn Manheim",
		"metacritic": "66",
		"imdbRating": "6.2",
		"imdbVotes": "15834",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTMyMDc5OTUwMl5BMl5BanBnXkFtZTgwMjEwNjc3NTE@._V1_SX300.jpg",
		"plot": "A small town sheriff sets out to find the two kids who have taken his car on a joy ride.",
		"language": "English",
		"country": "USA",
		"awards": "1 win & 2 nominations."
	},
	{
		"id": "3815706",
		"imdbID": "tt3815706",
		"title": "Hyacinth",
		"year": "2014",
		"rating": "Unrated",
		"runtime": "46 min",
		"genre": "Documentary",
		"released": "2014-11-02",
		"director": "Rod Pitman",
		"writer": "Rod Pitman",
		"cast": "Max Schwartz",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg2MTc3MzEyMF5BMl5BanBnXkFtZTgwMDY1NjIxMjE@._V1_SX300.jpg",
		"plot": "In 1964 poets Elizabeth Buckner, Jim Morrison and Max Schwartz made a film called \"First Love\". In the spring of 2002 Schwartz talks about first love, pictures, and poetry as a message of change for the future of mankind.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3817848",
		"imdbID": "tt3817848",
		"title": "Turtle Power: The Definitive History of the Teenage Mutant Ninja Turtles",
		"year": "2014",
		"rating": "PG",
		"runtime": "98 min",
		"genre": "Documentary",
		"released": "2014-08-12",
		"director": "Randall Lobb",
		"writer": "Randall Lobb",
		"cast": "Peter Laird, Kevin Eastman, Mark Askwith, Richard Rosenbaum",
		"metacritic": "",
		"imdbRating": "7.0",
		"imdbVotes": "554",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTU1OTAxODYwOV5BMl5BanBnXkFtZTgwODM0ODY0MjE@._V1_SX300.jpg",
		"plot": "The history of the Teenage Mutant Ninja Turtle franchise.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3836512",
		"imdbID": "tt3836512",
		"title": "Ratter",
		"year": "2015",
		"rating": "R",
		"runtime": "80 min",
		"genre": "Drama, Thriller",
		"released": "2015-01-24",
		"director": "Branden Kramer",
		"writer": "Branden Kramer",
		"cast": "Ashley Benson, Matt McGorry, Kaili Vernoff, Rebecca Naomi Jones",
		"metacritic": "",
		"imdbRating": "7.4",
		"imdbVotes": "85",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE4ODYyMTE1M15BMl5BanBnXkFtZTgwMzczNzcyNDE@._V1_SX300.jpg",
		"plot": "Emma, a graduate student living alone in NYC, is being watched by a stalker who hacks into the technology that surrounds her - laptop, cell phone, and other web connected devices. This ...",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "3859304",
		"imdbID": "tt3859304",
		"title": "The Bronze",
		"year": "2015",
		"rating": "R",
		"runtime": "108 min",
		"genre": "Comedy, Drama",
		"released": "2016-03-18",
		"director": "Bryan Buckley",
		"writer": "Melissa Rauch, Winston Rauch",
		"cast": "Melissa Rauch, Gary Cole, Haley Lu Richardson, Thomas Middleditch",
		"metacritic": "45",
		"imdbRating": "5.9",
		"imdbVotes": "284",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUxMzI2Mzc5Ml5BMl5BanBnXkFtZTgwODQzOTU2NzE@._V1_SX300.jpg",
		"plot": "A foul-mouthed former gymnastics bronze medalist must fight for her local celebrity status when a new young athlete's star rises in town.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "3862750",
		"imdbID": "tt3862750",
		"title": "The Perfect Guy",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "100 min",
		"genre": "Drama, Thriller",
		"released": "2015-09-11",
		"director": "David M. Rosenthal",
		"writer": "Alan B. McElroy (story), Tyger Williams (screenplay)",
		"cast": "Sanaa Lathan, Michael Ealy, Morris Chestnut, L. Scott Caldwell",
		"metacritic": "36",
		"imdbRating": "5.3",
		"imdbVotes": "3958",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA4NzcwMTkzMF5BMl5BanBnXkFtZTgwMDAwNDUxNjE@._V1_SX300.jpg",
		"plot": "After breaking up with her boyfriend, a professional woman gets involved with a man who seems almost too good to be true.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "3874418",
		"imdbID": "tt3874418",
		"title": "Warrior Princess",
		"year": "2014",
		"rating": "R",
		"runtime": "95 min",
		"genre": "Action, War",
		"released": "2014-09-16",
		"director": "Shuudertsetseg Baatarsuren",
		"writer": "Shuudertsetseg Baatarsuren",
		"cast": "Batmend Baast, Otgonjargal Davaasuren, Myagmarnaran Gombo, Myagmar Mondoon",
		"metacritic": "",
		"imdbRating": "4.4",
		"imdbVotes": "115",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNjczMjMyMTU4OV5BMl5BanBnXkFtZTgwMjMxMzQzMjE@._V1_SX300.jpg",
		"plot": "A monk renounces his role to become King after his brother is killed. His new Queen is forced to choose sides between her husband and her father from a rival land, which eventually leads to an all out war for sovereignty.",
		"language": "English, Mongolian",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3877296",
		"imdbID": "tt3877296",
		"title": "The Cokeville Miracle",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "94 min",
		"genre": "Drama, Family, History",
		"released": "2015-06-05",
		"director": "T.C. Christensen",
		"writer": "T.C. Christensen",
		"cast": "Nathan Stevens, Jasen Wade, Caitlin E.J. Meyer, Mason D. Davis",
		"metacritic": "",
		"imdbRating": "4.7",
		"imdbVotes": "954",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ1OTkzOTQ2M15BMl5BanBnXkFtZTgwMTkzMjQwNTE@._V1_SX300.jpg",
		"plot": "Children who were held hostage in their elementary school tell stories of miraculous things, but many adults are skeptical that the Cokeville Miracle ever truly happened.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3882018",
		"imdbID": "tt3882018",
		"title": "Cocked",
		"year": "2015",
		"rating": "M",
		"runtime": "49 min",
		"genre": "Comedy, Drama",
		"released": "2015-01-15",
		"director": "Jordan Vogt-Roberts",
		"writer": "Samuel Baum, Sam Shaw",
		"cast": "Sam Trammell, Jason Lee, Laura Fraser, Dreama Walker",
		"metacritic": "",
		"imdbRating": "7.2",
		"imdbVotes": "579",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg2NDEzMzExNF5BMl5BanBnXkFtZTgwMDgxMjk5MzE@._V1_SX300.jpg",
		"plot": "The Paxsons are a broken family working together - and against each other - in the most quintessentially American business, the business of guns.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3882082",
		"imdbID": "tt3882082",
		"title": "The Boy",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "",
		"genre": "Horror, Thriller",
		"released": "2016-01-22",
		"director": "William Brent Bell",
		"writer": "Stacey Menear",
		"cast": "Lauren Cohan, Rupert Evans, Ben Robson, Diana Hardcastle",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ1NzAwNTg1M15BMl5BanBnXkFtZTgwNDQwOTQ0NzE@._V1_SX300.jpg",
		"plot": "An American nanny is shocked that her new English family's boy is actually a life-sized doll. After violating a list of strict rules, disturbing events make her believe that the doll is really alive.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3884528",
		"imdbID": "tt3884528",
		"title": "Batkid Begins",
		"year": "2015",
		"rating": "PG",
		"runtime": "87 min",
		"genre": "Documentary, Biography, Family",
		"released": "2015-06-26",
		"director": "Dana Nachman",
		"writer": "Kurt Kuenne, Dana Nachman",
		"cast": "Teresa Clovicko, Audrey Copper, Katie Cotton, James Coyne",
		"metacritic": "63",
		"imdbRating": "6.0",
		"imdbVotes": "850",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTg3MTAxMjczM15BMl5BanBnXkFtZTgwNjc3MzY3NTE@._V1_SX300.jpg",
		"plot": "On one day, in one city, the world comes together to grant one 5 year old cancer patient his wish. Batkid Begins looks at the 'why' of this flash phenomenon.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 1 nomination."
	},
	{
		"id": "3946300",
		"imdbID": "tt3946300",
		"title": "Bastard",
		"year": "2015",
		"rating": "R",
		"runtime": "82 min",
		"genre": "Horror",
		"released": "2015-10-16",
		"director": "Powell Robinson, Patrick Robert Young",
		"writer": "Patrick Robert Young",
		"cast": "Rebekah Kennedy, Ellis Greer, Dan Creed, Will Tranfo",
		"metacritic": "",
		"imdbRating": "4.6",
		"imdbVotes": "234",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTczNTUwMjI3MF5BMl5BanBnXkFtZTgwNDM3Mjc0MjE@._V1_SX300.jpg",
		"plot": "Five strangers - newlywed serial killers, a suicidal cop, and two runaways - become suspect and victim when a masked murderer makes its presence known in an isolated mountain town.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "3951298",
		"imdbID": "tt3951298",
		"title": "Army Dog",
		"year": "2016",
		"rating": "PG",
		"runtime": "90 min",
		"genre": "Action",
		"released": "2016-01-12",
		"director": "Ezra Kemp",
		"writer": "Kirk Harris, Vernon E. Mortensen, Adrienne Thorne",
		"cast": "Casper Van Dien, Grace Van Dien, Stelio Savante, Annemarie Pazmino",
		"metacritic": "",
		"imdbRating": "6.6",
		"imdbVotes": "12",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTU1NzgxMDcxN15BMl5BanBnXkFtZTgwODY0OTkzNzE@._V1_SX300.jpg",
		"plot": "A brave Army dog returns to the U.S., where he helps his heroic handler bond with his resentful daughter on a camping trip despite danger lurking around every corner.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4019560",
		"imdbID": "tt4019560",
		"title": "Exposed",
		"year": "2016",
		"rating": "R",
		"runtime": "102 min",
		"genre": "Drama",
		"released": "2016-01-22",
		"director": "Declan Dale",
		"writer": "Gee Malik Linton (screenplay), Declan Dale",
		"cast": "Ana de Armas, Gabe Vargas, Sandy Tejada, Ariel Pacheco",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjAwMzk1MDI1OF5BMl5BanBnXkFtZTgwMDYxODkzNzE@._V1_SX300.jpg",
		"plot": "After witnessing a miracle, a young Latina woman experiences strange things as a police detective searches for the truth behind his partner's death.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4026562",
		"imdbID": "tt4026562",
		"title": "Hollows Grove",
		"year": "2014",
		"rating": "R",
		"runtime": "81 min",
		"genre": "Horror",
		"released": "2014-10-21",
		"director": "Craig Efros",
		"writer": "Craig Efros",
		"cast": "Mykelti Williamson, Lance Henriksen, Matthew Carey, Sunkrish Bala",
		"metacritic": "",
		"imdbRating": "4.8",
		"imdbVotes": "615",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTAwMDk0NjUxNzFeQTJeQWpwZ15BbWU4MDUzNDk5OTIx._V1_SX300.jpg",
		"plot": "A young filmmaker documents his ghost-hunting, reality show friends as their routine investigation of an abandoned orphanage turns into a nightmare from which they can't escape.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4046784",
		"imdbID": "tt4046784",
		"title": "Maze Runner: The Scorch Trials",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "132 min",
		"genre": "Action, Sci-Fi, Thriller",
		"released": "2015-09-18",
		"director": "Wes Ball",
		"writer": "T.S. Nowlin (screenplay), James Dashner (novel)",
		"cast": "Dylan O'Brien, Ki Hong Lee, Kaya Scodelario, Thomas Brodie-Sangster",
		"metacritic": "43",
		"imdbRating": "6.4",
		"imdbVotes": "99021",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE3MDU2NzQyMl5BMl5BanBnXkFtZTgwMzQxMDQ3NTE@._V1_SX300.jpg",
		"plot": "After having escaped the Maze, the Gladers now face a new set of challenges on the open roads of a desolate landscape filled with unimaginable obstacles.",
		"language": "English",
		"country": "USA",
		"awards": "1 nomination."
	},
	{
		"id": "4053864",
		"imdbID": "tt4053864",
		"title": "T-Rex",
		"year": "2014",
		"rating": "R",
		"runtime": "82 min",
		"genre": "Drama",
		"released": "2014-09-27",
		"director": "Mickey Reece",
		"writer": "Mickey Reece, John Selvidge",
		"cast": "Sheridan McMichael, Jean Keef, R. Dustin Sanchez, John Selvidge",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzMTIxNDI5N15BMl5BanBnXkFtZTgwNjI3ODY4MjE@._V1_SX300.jpg",
		"plot": "In the wake of local car salesman Marty Dickens' mysterious death a chain of events is set in motion that destabilizes the lives of several people in a Midwestern city. This black and white...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4062896",
		"imdbID": "tt4062896",
		"title": "Rodeo Girl",
		"year": "2016",
		"rating": "PG",
		"runtime": "108 min",
		"genre": "Family",
		"released": "2016-01-05",
		"director": "Joel Paul Reisig",
		"writer": "Tricia Hopper (screenwriter), Aletha Rodgers (screenwriter)",
		"cast": "Kevin Sorbo, Sophie Bolen, Derek Brandon, Kylie Hart",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTY2MTI1Mjk2OV5BMl5BanBnXkFtZTgwMzg4OTM2NzE@._V1_SX300.jpg",
		"plot": "Shipped off to her American dad's ranch for the summer, a teen and her horse Lucky Lad compete for a spot at the National Youth Rodeo.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4065450",
		"imdbID": "tt4065450",
		"title": "H8R",
		"year": "2014",
		"rating": "Not Rated",
		"runtime": "46 min",
		"genre": "Comedy",
		"released": "2014-09-25",
		"director": "Matthew Walker",
		"writer": "Matthew Walker",
		"cast": "Matthew Walker",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjEwNDM3NzY2NV5BMl5BanBnXkFtZTgwNjM0NjU5MjE@._V1_SX300.jpg",
		"plot": "H8R is Matt Walker's debut comedy special, shot live at the world famous Ice House Comedy Club in Pasadena, CA. This comedy special lets you see what it's like growing up as a ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4097016",
		"imdbID": "tt4097016",
		"title": "Unsullied",
		"year": "2014",
		"rating": "R",
		"runtime": "93 min",
		"genre": "Action, Horror, Thriller",
		"released": "2015-08-28",
		"director": "Simeon Rice",
		"writer": "John Nodilo, John Nodilo (screenplay), John Nodilo, Simeon Rice, Simeon Rice",
		"cast": "Rusty Joiner, Murray Gray, James Gaudioso, Erin Boyes",
		"metacritic": "42",
		"imdbRating": "5.7",
		"imdbVotes": "84",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjIyMTQyNTIxN15BMl5BanBnXkFtZTgwMjk5NzcyNjE@._V1_SX300.jpg",
		"plot": "Follows Reagan, a track star, who is kidnapped by a pair of sociopaths after her car breaks down on a deserted road.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4137324",
		"imdbID": "tt4137324",
		"title": "Magician: The Astonishing Life and Work of Orson Welles",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "91 min",
		"genre": "Documentary",
		"released": "2014-10-17",
		"director": "Chuck Workman",
		"writer": "",
		"cast": "William Alland, Reggie Armour, Richard Benjamin, Peter Bogdanovich",
		"metacritic": "67",
		"imdbRating": "6.7",
		"imdbVotes": "431",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTkxMjk5MjMxOF5BMl5BanBnXkFtZTgwNTk2MTMxMzE@._V1_SX300.jpg",
		"plot": "A look at the life and work of the great theatre, radio and film artist.",
		"language": "English",
		"country": "USA",
		"awards": "2 nominations."
	},
	{
		"id": "4150316",
		"imdbID": "tt4150316",
		"title": "Frozen in Time",
		"year": "2014",
		"rating": "G",
		"runtime": "46 min",
		"genre": "Animation, Adventure, Family",
		"released": "2014-11-01",
		"director": "Alex Leung",
		"writer": "Melissa Rundle",
		"cast": "Edward Asner, Drake Bell, Valin Shinyei, Mira Sorvino",
		"metacritic": "",
		"imdbRating": "5.8",
		"imdbVotes": "46",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ0OTA2NDg3OV5BMl5BanBnXkFtZTgwMDY1MjE0MzE@._V1_SX300.jpg",
		"plot": "Patty and Eric Purtle visit their Grandfather for Christmas. After accidentally breaking a clock in his workshop, they then find themselves repeating Christmas Eve. together they must fix time and make Christmas enjoyable for their family.",
		"language": "",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4151192",
		"imdbID": "tt4151192",
		"title": "The Condemned 2",
		"year": "2015",
		"rating": "R",
		"runtime": "90 min",
		"genre": "Action, Thriller",
		"released": "2015-11-06",
		"director": "Roel Reiné",
		"writer": "Alan B. McElroy",
		"cast": "Randy Orton, Eric Roberts, Wes Studi, Steven Michael Quezada",
		"metacritic": "",
		"imdbRating": "4.2",
		"imdbVotes": "773",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ3MDg2Mzc0MF5BMl5BanBnXkFtZTgwODk0ODM5NjE@._V1_SX300.jpg",
		"plot": "A former bounty hunter who finds himself on the run as part of a revamped Condemned tournament, in which convicts are forced to fight each other to the death as part of a game that's broadcast to the public.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4183692",
		"imdbID": "tt4183692",
		"title": "Woodlawn",
		"year": "2015",
		"rating": "PG",
		"runtime": "123 min",
		"genre": "Drama, Sport",
		"released": "2015-10-16",
		"director": "Andrew Erwin, Jon Erwin",
		"writer": "Jon Erwin, Quinton Peeples",
		"cast": "Sean Astin, Nic Bishop, Caleb Castille, Sherri Shepherd",
		"metacritic": "57",
		"imdbRating": "6.3",
		"imdbVotes": "1426",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTA0ODM5MTM5MTleQTJeQWpwZ15BbWU4MDAwNzk1NDYx._V1_SX300.jpg",
		"plot": "A gifted high school football player must learn to embrace his talent and his faith as he battles racial tensions on and off the field.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4189442",
		"imdbID": "tt4189442",
		"title": "Expelled",
		"year": "2014",
		"rating": "PG-13",
		"runtime": "85 min",
		"genre": "Comedy",
		"released": "2014-12-16",
		"director": "Alex Goyette",
		"writer": "Alex Goyette",
		"cast": "Cameron Dallas, Matt Shively, Lia Marie Johnson, Marcus Johns",
		"metacritic": "",
		"imdbRating": "5.0",
		"imdbVotes": "3682",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI0MDY2MTIxOV5BMl5BanBnXkFtZTgwNjM4NTM0MzE@._V1_SX300.jpg",
		"plot": "Felix is a legendary prankster who gets expelled from his high school and, with the help of his friends, will stop at nothing to hide it from his parents.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4191054",
		"imdbID": "tt4191054",
		"title": "Strange Magic",
		"year": "2015",
		"rating": "PG",
		"runtime": "99 min",
		"genre": "Animation, Family, Fantasy",
		"released": "2015-01-23",
		"director": "Gary Rydstrom",
		"writer": "Irene Mecchi (screenplay), Gary Rydstrom (screenplay), George Lucas (story), David Berenbaum (screenplay)",
		"cast": "Alan Cumming, Evan Rachel Wood, Elijah Kelley, Meredith Anne Bull",
		"metacritic": "25",
		"imdbRating": "5.7",
		"imdbVotes": "4941",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjA0NjU3MTU5OF5BMl5BanBnXkFtZTgwMTYyMDQ3MzE@._V1_SX300.jpg",
		"plot": "Goblins, elves, fairies and imps, and their misadventures sparked by the battle over a powerful potion.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4209354",
		"imdbID": "tt4209354",
		"title": "Under Wraps",
		"year": "2014",
		"rating": "PG",
		"runtime": "45 min",
		"genre": "Animation",
		"released": "2014-10-01",
		"director": "Gordon Crum",
		"writer": "Alison Ross, Melissa Rundle (concept by)",
		"cast": "Drake Bell, Brenda Crichlow, Brian Drummond, Kazumi Evans",
		"metacritic": "",
		"imdbRating": "5.5",
		"imdbVotes": "30",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQ4NTA2MTIwMF5BMl5BanBnXkFtZTgwNjEwODUyNDE@._V1_SX300.jpg",
		"plot": "A curious young boy accidentally turns his parents into mummies - and releases an ancient curse.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4246856",
		"imdbID": "tt4246856",
		"title": "Wildflower",
		"year": "2016",
		"rating": "PG-13",
		"runtime": "92 min",
		"genre": "Drama, Thriller",
		"released": "2016-03-01",
		"director": "Nicholas DiBella",
		"writer": "Nicholas DiBella",
		"cast": "Nathalia Ramos, Cody Longo, Alex Steele, Benjamin Ashbrook",
		"metacritic": "",
		"imdbRating": "",
		"imdbVotes": "",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjI2NDkzNDMwMl5BMl5BanBnXkFtZTgwMzE1OTAzNzE@._V1_SX300.jpg",
		"plot": "When a college student starts having a reoccurring nightmare, she begins to believe that it's a suppressed memory. Her search to find the answers forces her to confront her past traumas, ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4270516",
		"imdbID": "tt4270516",
		"title": "Grandma",
		"year": "2015",
		"rating": "R",
		"runtime": "79 min",
		"genre": "Comedy, Drama",
		"released": "2015-09-18",
		"director": "Paul Weitz",
		"writer": "Paul Weitz",
		"cast": "Lily Tomlin, Julia Garner, Marcia Gay Harden, Judy Greer",
		"metacritic": "77",
		"imdbRating": "7.1",
		"imdbVotes": "1676",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjExMDE2OTIxM15BMl5BanBnXkFtZTgwMDY5NzAyNjE@._V1_SX300.jpg",
		"plot": "A teenager facing an unplanned pregnancy seeks help from her acerbic grandmother, a woman who is long estranged from her daughter.",
		"language": "English",
		"country": "USA",
		"awards": "Nominated for 1 Golden Globe. Another 2 wins & 3 nominations."
	},
	{
		"id": "4273494",
		"imdbID": "tt4273494",
		"title": "Rise of the Entrepreneur: The Search for a Better Way",
		"year": "2014",
		"rating": "G",
		"runtime": "52 min",
		"genre": "Documentary",
		"released": "2014-11-20",
		"director": "Joe Kenemore",
		"writer": "Eric Worre",
		"cast": "Eric Worre, Robert Kiyosaki, Harry Dent, Paul Zane Pilzer",
		"metacritic": "",
		"imdbRating": "8.4",
		"imdbVotes": "71",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTQzMTk3MzUxNF5BMl5BanBnXkFtZTgwOTUyMTI3MzE@._V1_SX300.jpg",
		"plot": "The world is changing faster than ever. Technology is accelerating, job security is declining and income inequality is increasing. People are overworked and underpaid. With less time and ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4288636",
		"imdbID": "tt4288636",
		"title": "James White",
		"year": "2015",
		"rating": "R",
		"runtime": "85 min",
		"genre": "Drama",
		"released": "2015-11-13",
		"director": "Josh Mond",
		"writer": "Josh Mond",
		"cast": "Christopher Abbott, Cynthia Nixon, Scott Mescudi, Ron Livingston",
		"metacritic": "83",
		"imdbRating": "7.5",
		"imdbVotes": "473",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE4MzU2NjEwN15BMl5BanBnXkFtZTgwNDQyMDE3NjE@._V1_SX300.jpg",
		"plot": "James, a twenty-something New Yorker, struggles to take control of his self-destructive behavior in the face of momentous family challenges.",
		"language": "English",
		"country": "USA",
		"awards": "7 wins & 12 nominations."
	},
	{
		"id": "4337690",
		"imdbID": "tt4337690",
		"title": "90 Minutes in Heaven",
		"year": "2015",
		"rating": "PG-13",
		"runtime": "121 min",
		"genre": "Drama",
		"released": "2015-09-11",
		"director": "Michael Polish",
		"writer": "Don Piper (book), Michael Polish (screenplay)",
		"cast": "Hayden Christensen, Kate Bosworth, Hudson Meek, Bobby Batson",
		"metacritic": "28",
		"imdbRating": "4.5",
		"imdbVotes": "1399",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMjE5ODE3Mjc1MF5BMl5BanBnXkFtZTgwNzAwMzAyNjE@._V1_SX300.jpg",
		"plot": "A man involved in a horrific car crash is pronounced dead, only to come back to life an hour and a half later, claiming to have seen Heaven.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4386242",
		"imdbID": "tt4386242",
		"title": "R.L. Stine's Monsterville: The Cabinet of Souls",
		"year": "2015",
		"rating": "PG",
		"runtime": "85 min",
		"genre": "Comedy",
		"released": "2015-09-29",
		"director": "Peter DeLuise",
		"writer": "Billy Brown, Dan Angel",
		"cast": "Dove Cameron, Braeden Lemasters, Katherine McNamara, Casey Dubois",
		"metacritic": "",
		"imdbRating": "5.9",
		"imdbVotes": "599",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYxNTQ2NDM0NV5BMl5BanBnXkFtZTgwMjU5OTg0NjE@._V1_SX300.jpg",
		"plot": "Teenage friends must resist the spell of an evil showman staging a house of horrors show in their small town.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4405668",
		"imdbID": "tt4405668",
		"title": "War Room",
		"year": "2015",
		"rating": "PG",
		"runtime": "120 min",
		"genre": "Drama",
		"released": "2015-08-28",
		"director": "Alex Kendrick",
		"writer": "Alex Kendrick, Stephen Kendrick",
		"cast": "Karen Abercrombie, Priscilla C. Shirer, T.C. Stallings, Tenae Downing",
		"metacritic": "26",
		"imdbRating": "6.1",
		"imdbVotes": "5719",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTYyNTUxMjQwNF5BMl5BanBnXkFtZTgwNDY5MDIwNTE@._V1_SX300.jpg",
		"plot": "A seemingly perfect family looks to fix their problems with the help of Miss Clara, an older, wiser woman.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4425064",
		"imdbID": "tt4425064",
		"title": "Steve Jobs: The Man in the Machine",
		"year": "2015",
		"rating": "R",
		"runtime": "128 min",
		"genre": "Documentary",
		"released": "2015-09-04",
		"director": "Alex Gibney",
		"writer": "",
		"cast": "Steve Jobs",
		"metacritic": "72",
		"imdbRating": "6.7",
		"imdbVotes": "2534",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUwMzAyMjgyNV5BMl5BanBnXkFtZTgwOTU3ODUzNjE@._V1_SX300.jpg",
		"plot": "A look at the personal and private life of the late Apple CEO, Steve Jobs.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4475244",
		"imdbID": "tt4475244",
		"title": "Pitching Love and Catching Faith",
		"year": "2015",
		"rating": "PG",
		"runtime": "91 min",
		"genre": "Romance",
		"released": "2015-02-06",
		"director": "Randolph Sternberg, Rebecca Sternberg",
		"writer": "Randolph Sternberg, Rebecca Sternberg",
		"cast": "Courtney Beavers, Derek Boone, Shawn Carter, Nicole Casper",
		"metacritic": "",
		"imdbRating": "6.5",
		"imdbVotes": "6",
		"poster": "http://ia.media-imdb.com/images/M/MV5BYjA4MzNjMTktNWM4Ni00OTZmLTlkZTktNTRkY2Y0NjQ4OGU1XkEyXkFqcGdeQXVyMzM4MjM0Nzg@._V1_SX300.jpg",
		"plot": "Heather an attractive, competitive, softball player, sweet and sassy-who is used to winning...but with guys she tends to strike out once they find out she's not their type. He's a ...",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "4594834",
		"imdbID": "tt4594834",
		"title": "Chi-Raq",
		"year": "2015",
		"rating": "R",
		"runtime": "127 min",
		"genre": "Drama",
		"released": "2015-12-04",
		"director": "Spike Lee",
		"writer": "Kevin Willmott, Spike Lee, Aristophanes (play)",
		"cast": "Nick Cannon, Teyonah Parris, Wesley Snipes, Angela Bassett",
		"metacritic": "77",
		"imdbRating": "5.6",
		"imdbVotes": "2203",
		"poster": "http://ia.media-imdb.com/images/M/MV5BNTMwNzkxMDUxN15BMl5BanBnXkFtZTgwOTM5NjQzNzE@._V1_SX300.jpg",
		"plot": "A modern day adaptation of the ancient Greek play Lysistrata by Aristophanes, set against the backdrop of gang violence in Chicago.",
		"language": "English",
		"country": "USA",
		"awards": "3 wins & 12 nominations."
	},
	{
		"id": "4761668",
		"imdbID": "tt4761668",
		"title": "Visions",
		"year": "2015",
		"rating": "R",
		"runtime": "82 min",
		"genre": "Horror, Thriller",
		"released": "2016-01-19",
		"director": "Kevin Greutert",
		"writer": "L.D. Goffigan, Lucas Sussman (screenplay), Lucas Sussman",
		"cast": "Isla Fisher, Jim Parsons, Anson Mount, Eva Longoria",
		"metacritic": "",
		"imdbRating": "5.2",
		"imdbVotes": "2604",
		"poster": "http://ia.media-imdb.com/images/M/MV5BOTM4OTY3NTcwMV5BMl5BanBnXkFtZTgwMDY5MjE1NjE@._V1_SX300.jpg",
		"plot": "After moving to a vineyard to start a new life with her husband, a pregnant woman begins to experience terrifying visions.",
		"language": "English",
		"country": "USA",
		"awards": ""
	},
	{
		"id": "5079382",
		"imdbID": "tt5079382",
		"title": "Froning: The Fittest Man in History",
		"year": "2015",
		"rating": "PG",
		"runtime": "99 min",
		"genre": "Documentary",
		"released": "2015-10-02",
		"director": "Heber Cannon",
		"writer": "Heber Cannon, Heber Cannon, Charlie Dube, Sean Woodland",
		"cast": "Rich Froning, Dan Bailey, Dave Castro, Matt Fraser",
		"metacritic": "",
		"imdbRating": "7.6",
		"imdbVotes": "71",
		"poster": "http://ia.media-imdb.com/images/M/MV5BMTUzMDM2NDIxMV5BMl5BanBnXkFtZTgwMzQ0MTg5NjE@._V1_SX300.jpg",
		"plot": "Rich Froning Jr. is a legend in CrossFit and the Sport of Fitness. In this biopic, take a look at his childhood, follow his quest for a fourth CrossFit Games title, and see him as a son, a husband and a new father.",
		"language": "English",
		"country": "USA",
		"awards": ""
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/movies.json
 ** module id = 188
 ** module chunks = 0
 **/